/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.busable = (function() {

    /**
     * Namespace busable.
     * @exports busable
     * @namespace
     */
    var busable = {};

    busable.api = (function() {

        /**
         * Namespace api.
         * @memberof busable
         * @namespace
         */
        var api = {};

        api.NormalizedShiftBatsResponse = (function() {

            /**
             * Properties of a NormalizedShiftBatsResponse.
             * @memberof busable.api
             * @interface INormalizedShiftBatsResponse
             * @property {Array.<busable.IShiftBat>|null} [data] NormalizedShiftBatsResponse data
             * @property {busable.api.IIncludedEntities|null} [included] NormalizedShiftBatsResponse included
             * @property {busable.api.IResponseMeta|null} [meta] NormalizedShiftBatsResponse meta
             */

            /**
             * Constructs a new NormalizedShiftBatsResponse.
             * @memberof busable.api
             * @classdesc Normalized response for /api/my-duties and /api/duties endpoints
             * 
             * Uses busable.ShiftBat from shift-bats.proto, but with embedded entities stripped out.
             * In normalized responses, only ID fields are populated (route_id, stop_id, etc.)
             * and the actual entity objects are in the 'included' section.
             * 
             * Example:
             * GET /api/my-duties?driverId=123&limit=20
             * Accept: application/x-protobuf
             * @implements INormalizedShiftBatsResponse
             * @constructor
             * @param {busable.api.INormalizedShiftBatsResponse=} [properties] Properties to set
             */
            function NormalizedShiftBatsResponse(properties) {
                this.data = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * NormalizedShiftBatsResponse data.
             * @member {Array.<busable.IShiftBat>} data
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @instance
             */
            NormalizedShiftBatsResponse.prototype.data = $util.emptyArray;

            /**
             * NormalizedShiftBatsResponse included.
             * @member {busable.api.IIncludedEntities|null|undefined} included
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @instance
             */
            NormalizedShiftBatsResponse.prototype.included = null;

            /**
             * NormalizedShiftBatsResponse meta.
             * @member {busable.api.IResponseMeta|null|undefined} meta
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @instance
             */
            NormalizedShiftBatsResponse.prototype.meta = null;

            /**
             * Creates a new NormalizedShiftBatsResponse instance using the specified properties.
             * @function create
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {busable.api.INormalizedShiftBatsResponse=} [properties] Properties to set
             * @returns {busable.api.NormalizedShiftBatsResponse} NormalizedShiftBatsResponse instance
             */
            NormalizedShiftBatsResponse.create = function create(properties) {
                return new NormalizedShiftBatsResponse(properties);
            };

            /**
             * Encodes the specified NormalizedShiftBatsResponse message. Does not implicitly {@link busable.api.NormalizedShiftBatsResponse.verify|verify} messages.
             * @function encode
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {busable.api.INormalizedShiftBatsResponse} message NormalizedShiftBatsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NormalizedShiftBatsResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.data != null && message.data.length)
                    for (var i = 0; i < message.data.length; ++i)
                        $root.busable.ShiftBat.encode(message.data[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.included != null && Object.hasOwnProperty.call(message, "included"))
                    $root.busable.api.IncludedEntities.encode(message.included, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.meta != null && Object.hasOwnProperty.call(message, "meta"))
                    $root.busable.api.ResponseMeta.encode(message.meta, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified NormalizedShiftBatsResponse message, length delimited. Does not implicitly {@link busable.api.NormalizedShiftBatsResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {busable.api.INormalizedShiftBatsResponse} message NormalizedShiftBatsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NormalizedShiftBatsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a NormalizedShiftBatsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.NormalizedShiftBatsResponse} NormalizedShiftBatsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NormalizedShiftBatsResponse.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.NormalizedShiftBatsResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.data && message.data.length))
                                message.data = [];
                            message.data.push($root.busable.ShiftBat.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.included = $root.busable.api.IncludedEntities.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.meta = $root.busable.api.ResponseMeta.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a NormalizedShiftBatsResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.NormalizedShiftBatsResponse} NormalizedShiftBatsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NormalizedShiftBatsResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a NormalizedShiftBatsResponse message.
             * @function verify
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            NormalizedShiftBatsResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.data != null && message.hasOwnProperty("data")) {
                    if (!Array.isArray(message.data))
                        return "data: array expected";
                    for (var i = 0; i < message.data.length; ++i) {
                        var error = $root.busable.ShiftBat.verify(message.data[i]);
                        if (error)
                            return "data." + error;
                    }
                }
                if (message.included != null && message.hasOwnProperty("included")) {
                    var error = $root.busable.api.IncludedEntities.verify(message.included);
                    if (error)
                        return "included." + error;
                }
                if (message.meta != null && message.hasOwnProperty("meta")) {
                    var error = $root.busable.api.ResponseMeta.verify(message.meta);
                    if (error)
                        return "meta." + error;
                }
                return null;
            };

            /**
             * Creates a NormalizedShiftBatsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.NormalizedShiftBatsResponse} NormalizedShiftBatsResponse
             */
            NormalizedShiftBatsResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.NormalizedShiftBatsResponse)
                    return object;
                var message = new $root.busable.api.NormalizedShiftBatsResponse();
                if (object.data) {
                    if (!Array.isArray(object.data))
                        throw TypeError(".busable.api.NormalizedShiftBatsResponse.data: array expected");
                    message.data = [];
                    for (var i = 0; i < object.data.length; ++i) {
                        if (typeof object.data[i] !== "object")
                            throw TypeError(".busable.api.NormalizedShiftBatsResponse.data: object expected");
                        message.data[i] = $root.busable.ShiftBat.fromObject(object.data[i]);
                    }
                }
                if (object.included != null) {
                    if (typeof object.included !== "object")
                        throw TypeError(".busable.api.NormalizedShiftBatsResponse.included: object expected");
                    message.included = $root.busable.api.IncludedEntities.fromObject(object.included);
                }
                if (object.meta != null) {
                    if (typeof object.meta !== "object")
                        throw TypeError(".busable.api.NormalizedShiftBatsResponse.meta: object expected");
                    message.meta = $root.busable.api.ResponseMeta.fromObject(object.meta);
                }
                return message;
            };

            /**
             * Creates a plain object from a NormalizedShiftBatsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {busable.api.NormalizedShiftBatsResponse} message NormalizedShiftBatsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            NormalizedShiftBatsResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.data = [];
                if (options.defaults) {
                    object.included = null;
                    object.meta = null;
                }
                if (message.data && message.data.length) {
                    object.data = [];
                    for (var j = 0; j < message.data.length; ++j)
                        object.data[j] = $root.busable.ShiftBat.toObject(message.data[j], options);
                }
                if (message.included != null && message.hasOwnProperty("included"))
                    object.included = $root.busable.api.IncludedEntities.toObject(message.included, options);
                if (message.meta != null && message.hasOwnProperty("meta"))
                    object.meta = $root.busable.api.ResponseMeta.toObject(message.meta, options);
                return object;
            };

            /**
             * Converts this NormalizedShiftBatsResponse to JSON.
             * @function toJSON
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            NormalizedShiftBatsResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for NormalizedShiftBatsResponse
             * @function getTypeUrl
             * @memberof busable.api.NormalizedShiftBatsResponse
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            NormalizedShiftBatsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.NormalizedShiftBatsResponse";
            };

            return NormalizedShiftBatsResponse;
        })();

        api.NormalizedRoutesResponse = (function() {

            /**
             * Properties of a NormalizedRoutesResponse.
             * @memberof busable.api
             * @interface INormalizedRoutesResponse
             * @property {Array.<busable.IRoute>|null} [data] NormalizedRoutesResponse data
             * @property {busable.api.IIncludedEntities|null} [included] NormalizedRoutesResponse included
             * @property {busable.api.IResponseMeta|null} [meta] NormalizedRoutesResponse meta
             */

            /**
             * Constructs a new NormalizedRoutesResponse.
             * @memberof busable.api
             * @classdesc Normalized response for /api/routes endpoint
             * 
             * Uses busable.Route from routes.proto, but with embedded entities stripped out.
             * Stop objects in services are left empty, only stop IDs are populated.
             * 
             * Example:
             * GET /api/routes?hydrate=true&limit=20
             * Accept: application/x-protobuf
             * @implements INormalizedRoutesResponse
             * @constructor
             * @param {busable.api.INormalizedRoutesResponse=} [properties] Properties to set
             */
            function NormalizedRoutesResponse(properties) {
                this.data = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * NormalizedRoutesResponse data.
             * @member {Array.<busable.IRoute>} data
             * @memberof busable.api.NormalizedRoutesResponse
             * @instance
             */
            NormalizedRoutesResponse.prototype.data = $util.emptyArray;

            /**
             * NormalizedRoutesResponse included.
             * @member {busable.api.IIncludedEntities|null|undefined} included
             * @memberof busable.api.NormalizedRoutesResponse
             * @instance
             */
            NormalizedRoutesResponse.prototype.included = null;

            /**
             * NormalizedRoutesResponse meta.
             * @member {busable.api.IResponseMeta|null|undefined} meta
             * @memberof busable.api.NormalizedRoutesResponse
             * @instance
             */
            NormalizedRoutesResponse.prototype.meta = null;

            /**
             * Creates a new NormalizedRoutesResponse instance using the specified properties.
             * @function create
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {busable.api.INormalizedRoutesResponse=} [properties] Properties to set
             * @returns {busable.api.NormalizedRoutesResponse} NormalizedRoutesResponse instance
             */
            NormalizedRoutesResponse.create = function create(properties) {
                return new NormalizedRoutesResponse(properties);
            };

            /**
             * Encodes the specified NormalizedRoutesResponse message. Does not implicitly {@link busable.api.NormalizedRoutesResponse.verify|verify} messages.
             * @function encode
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {busable.api.INormalizedRoutesResponse} message NormalizedRoutesResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NormalizedRoutesResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.data != null && message.data.length)
                    for (var i = 0; i < message.data.length; ++i)
                        $root.busable.Route.encode(message.data[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.included != null && Object.hasOwnProperty.call(message, "included"))
                    $root.busable.api.IncludedEntities.encode(message.included, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.meta != null && Object.hasOwnProperty.call(message, "meta"))
                    $root.busable.api.ResponseMeta.encode(message.meta, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified NormalizedRoutesResponse message, length delimited. Does not implicitly {@link busable.api.NormalizedRoutesResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {busable.api.INormalizedRoutesResponse} message NormalizedRoutesResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            NormalizedRoutesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a NormalizedRoutesResponse message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.NormalizedRoutesResponse} NormalizedRoutesResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NormalizedRoutesResponse.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.NormalizedRoutesResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.data && message.data.length))
                                message.data = [];
                            message.data.push($root.busable.Route.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.included = $root.busable.api.IncludedEntities.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.meta = $root.busable.api.ResponseMeta.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a NormalizedRoutesResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.NormalizedRoutesResponse} NormalizedRoutesResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            NormalizedRoutesResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a NormalizedRoutesResponse message.
             * @function verify
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            NormalizedRoutesResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.data != null && message.hasOwnProperty("data")) {
                    if (!Array.isArray(message.data))
                        return "data: array expected";
                    for (var i = 0; i < message.data.length; ++i) {
                        var error = $root.busable.Route.verify(message.data[i]);
                        if (error)
                            return "data." + error;
                    }
                }
                if (message.included != null && message.hasOwnProperty("included")) {
                    var error = $root.busable.api.IncludedEntities.verify(message.included);
                    if (error)
                        return "included." + error;
                }
                if (message.meta != null && message.hasOwnProperty("meta")) {
                    var error = $root.busable.api.ResponseMeta.verify(message.meta);
                    if (error)
                        return "meta." + error;
                }
                return null;
            };

            /**
             * Creates a NormalizedRoutesResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.NormalizedRoutesResponse} NormalizedRoutesResponse
             */
            NormalizedRoutesResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.NormalizedRoutesResponse)
                    return object;
                var message = new $root.busable.api.NormalizedRoutesResponse();
                if (object.data) {
                    if (!Array.isArray(object.data))
                        throw TypeError(".busable.api.NormalizedRoutesResponse.data: array expected");
                    message.data = [];
                    for (var i = 0; i < object.data.length; ++i) {
                        if (typeof object.data[i] !== "object")
                            throw TypeError(".busable.api.NormalizedRoutesResponse.data: object expected");
                        message.data[i] = $root.busable.Route.fromObject(object.data[i]);
                    }
                }
                if (object.included != null) {
                    if (typeof object.included !== "object")
                        throw TypeError(".busable.api.NormalizedRoutesResponse.included: object expected");
                    message.included = $root.busable.api.IncludedEntities.fromObject(object.included);
                }
                if (object.meta != null) {
                    if (typeof object.meta !== "object")
                        throw TypeError(".busable.api.NormalizedRoutesResponse.meta: object expected");
                    message.meta = $root.busable.api.ResponseMeta.fromObject(object.meta);
                }
                return message;
            };

            /**
             * Creates a plain object from a NormalizedRoutesResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {busable.api.NormalizedRoutesResponse} message NormalizedRoutesResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            NormalizedRoutesResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.data = [];
                if (options.defaults) {
                    object.included = null;
                    object.meta = null;
                }
                if (message.data && message.data.length) {
                    object.data = [];
                    for (var j = 0; j < message.data.length; ++j)
                        object.data[j] = $root.busable.Route.toObject(message.data[j], options);
                }
                if (message.included != null && message.hasOwnProperty("included"))
                    object.included = $root.busable.api.IncludedEntities.toObject(message.included, options);
                if (message.meta != null && message.hasOwnProperty("meta"))
                    object.meta = $root.busable.api.ResponseMeta.toObject(message.meta, options);
                return object;
            };

            /**
             * Converts this NormalizedRoutesResponse to JSON.
             * @function toJSON
             * @memberof busable.api.NormalizedRoutesResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            NormalizedRoutesResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for NormalizedRoutesResponse
             * @function getTypeUrl
             * @memberof busable.api.NormalizedRoutesResponse
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            NormalizedRoutesResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.NormalizedRoutesResponse";
            };

            return NormalizedRoutesResponse;
        })();

        api.StopsResponse = (function() {

            /**
             * Properties of a StopsResponse.
             * @memberof busable.api
             * @interface IStopsResponse
             * @property {Array.<busable.IStop>|null} [items] StopsResponse items
             * @property {busable.api.IResponseMeta|null} [meta] StopsResponse meta
             */

            /**
             * Constructs a new StopsResponse.
             * @memberof busable.api
             * @classdesc Standard (non-normalized) response for /api/stops endpoint
             * 
             * Uses busable.Stop from stops.proto which already includes route summaries.
             * Note: Stops endpoint doesn't use normalization since stops are
             * the primary entity and don't have deeply nested entities.
             * @implements IStopsResponse
             * @constructor
             * @param {busable.api.IStopsResponse=} [properties] Properties to set
             */
            function StopsResponse(properties) {
                this.items = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * StopsResponse items.
             * @member {Array.<busable.IStop>} items
             * @memberof busable.api.StopsResponse
             * @instance
             */
            StopsResponse.prototype.items = $util.emptyArray;

            /**
             * StopsResponse meta.
             * @member {busable.api.IResponseMeta|null|undefined} meta
             * @memberof busable.api.StopsResponse
             * @instance
             */
            StopsResponse.prototype.meta = null;

            /**
             * Creates a new StopsResponse instance using the specified properties.
             * @function create
             * @memberof busable.api.StopsResponse
             * @static
             * @param {busable.api.IStopsResponse=} [properties] Properties to set
             * @returns {busable.api.StopsResponse} StopsResponse instance
             */
            StopsResponse.create = function create(properties) {
                return new StopsResponse(properties);
            };

            /**
             * Encodes the specified StopsResponse message. Does not implicitly {@link busable.api.StopsResponse.verify|verify} messages.
             * @function encode
             * @memberof busable.api.StopsResponse
             * @static
             * @param {busable.api.IStopsResponse} message StopsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StopsResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.items != null && message.items.length)
                    for (var i = 0; i < message.items.length; ++i)
                        $root.busable.Stop.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.meta != null && Object.hasOwnProperty.call(message, "meta"))
                    $root.busable.api.ResponseMeta.encode(message.meta, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified StopsResponse message, length delimited. Does not implicitly {@link busable.api.StopsResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.StopsResponse
             * @static
             * @param {busable.api.IStopsResponse} message StopsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            StopsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a StopsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.StopsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.StopsResponse} StopsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StopsResponse.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.StopsResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.items && message.items.length))
                                message.items = [];
                            message.items.push($root.busable.Stop.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.meta = $root.busable.api.ResponseMeta.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a StopsResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.StopsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.StopsResponse} StopsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            StopsResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a StopsResponse message.
             * @function verify
             * @memberof busable.api.StopsResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            StopsResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.items != null && message.hasOwnProperty("items")) {
                    if (!Array.isArray(message.items))
                        return "items: array expected";
                    for (var i = 0; i < message.items.length; ++i) {
                        var error = $root.busable.Stop.verify(message.items[i]);
                        if (error)
                            return "items." + error;
                    }
                }
                if (message.meta != null && message.hasOwnProperty("meta")) {
                    var error = $root.busable.api.ResponseMeta.verify(message.meta);
                    if (error)
                        return "meta." + error;
                }
                return null;
            };

            /**
             * Creates a StopsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.StopsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.StopsResponse} StopsResponse
             */
            StopsResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.StopsResponse)
                    return object;
                var message = new $root.busable.api.StopsResponse();
                if (object.items) {
                    if (!Array.isArray(object.items))
                        throw TypeError(".busable.api.StopsResponse.items: array expected");
                    message.items = [];
                    for (var i = 0; i < object.items.length; ++i) {
                        if (typeof object.items[i] !== "object")
                            throw TypeError(".busable.api.StopsResponse.items: object expected");
                        message.items[i] = $root.busable.Stop.fromObject(object.items[i]);
                    }
                }
                if (object.meta != null) {
                    if (typeof object.meta !== "object")
                        throw TypeError(".busable.api.StopsResponse.meta: object expected");
                    message.meta = $root.busable.api.ResponseMeta.fromObject(object.meta);
                }
                return message;
            };

            /**
             * Creates a plain object from a StopsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.StopsResponse
             * @static
             * @param {busable.api.StopsResponse} message StopsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            StopsResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.items = [];
                if (options.defaults)
                    object.meta = null;
                if (message.items && message.items.length) {
                    object.items = [];
                    for (var j = 0; j < message.items.length; ++j)
                        object.items[j] = $root.busable.Stop.toObject(message.items[j], options);
                }
                if (message.meta != null && message.hasOwnProperty("meta"))
                    object.meta = $root.busable.api.ResponseMeta.toObject(message.meta, options);
                return object;
            };

            /**
             * Converts this StopsResponse to JSON.
             * @function toJSON
             * @memberof busable.api.StopsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            StopsResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for StopsResponse
             * @function getTypeUrl
             * @memberof busable.api.StopsResponse
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            StopsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.StopsResponse";
            };

            return StopsResponse;
        })();

        api.IncludedEntities = (function() {

            /**
             * Properties of an IncludedEntities.
             * @memberof busable.api
             * @interface IIncludedEntities
             * @property {Array.<busable.IRoute>|null} [routes] IncludedEntities routes
             * @property {Array.<busable.IStop>|null} [stops] IncludedEntities stops
             * @property {Array.<busable.IRoute>|null} [deadruns] IncludedEntities deadruns
             * @property {Array.<busable.ISchedule>|null} [schedules] IncludedEntities schedules
             * @property {Array.<busable.ITransfer>|null} [transfers] IncludedEntities transfers
             */

            /**
             * Constructs a new IncludedEntities.
             * @memberof busable.api
             * @classdesc Container for all referenced entities in a normalized response
             * Uses maps for O(1) lookup by ID on the client side
             * 
             * Reuses existing message types from other proto files:
             * - busable.Route (from routes.proto)
             * - busable.Stop (from stops.proto)
             * - busable.Schedule (from schedules.proto)
             * - busable.Transfer (from transfers.proto)
             * @implements IIncludedEntities
             * @constructor
             * @param {busable.api.IIncludedEntities=} [properties] Properties to set
             */
            function IncludedEntities(properties) {
                this.routes = [];
                this.stops = [];
                this.deadruns = [];
                this.schedules = [];
                this.transfers = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * IncludedEntities routes.
             * @member {Array.<busable.IRoute>} routes
             * @memberof busable.api.IncludedEntities
             * @instance
             */
            IncludedEntities.prototype.routes = $util.emptyArray;

            /**
             * IncludedEntities stops.
             * @member {Array.<busable.IStop>} stops
             * @memberof busable.api.IncludedEntities
             * @instance
             */
            IncludedEntities.prototype.stops = $util.emptyArray;

            /**
             * IncludedEntities deadruns.
             * @member {Array.<busable.IRoute>} deadruns
             * @memberof busable.api.IncludedEntities
             * @instance
             */
            IncludedEntities.prototype.deadruns = $util.emptyArray;

            /**
             * IncludedEntities schedules.
             * @member {Array.<busable.ISchedule>} schedules
             * @memberof busable.api.IncludedEntities
             * @instance
             */
            IncludedEntities.prototype.schedules = $util.emptyArray;

            /**
             * IncludedEntities transfers.
             * @member {Array.<busable.ITransfer>} transfers
             * @memberof busable.api.IncludedEntities
             * @instance
             */
            IncludedEntities.prototype.transfers = $util.emptyArray;

            /**
             * Creates a new IncludedEntities instance using the specified properties.
             * @function create
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {busable.api.IIncludedEntities=} [properties] Properties to set
             * @returns {busable.api.IncludedEntities} IncludedEntities instance
             */
            IncludedEntities.create = function create(properties) {
                return new IncludedEntities(properties);
            };

            /**
             * Encodes the specified IncludedEntities message. Does not implicitly {@link busable.api.IncludedEntities.verify|verify} messages.
             * @function encode
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {busable.api.IIncludedEntities} message IncludedEntities message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IncludedEntities.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.routes != null && message.routes.length)
                    for (var i = 0; i < message.routes.length; ++i)
                        $root.busable.Route.encode(message.routes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.stops != null && message.stops.length)
                    for (var i = 0; i < message.stops.length; ++i)
                        $root.busable.Stop.encode(message.stops[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.deadruns != null && message.deadruns.length)
                    for (var i = 0; i < message.deadruns.length; ++i)
                        $root.busable.Route.encode(message.deadruns[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.schedules != null && message.schedules.length)
                    for (var i = 0; i < message.schedules.length; ++i)
                        $root.busable.Schedule.encode(message.schedules[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.transfers != null && message.transfers.length)
                    for (var i = 0; i < message.transfers.length; ++i)
                        $root.busable.Transfer.encode(message.transfers[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified IncludedEntities message, length delimited. Does not implicitly {@link busable.api.IncludedEntities.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {busable.api.IIncludedEntities} message IncludedEntities message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            IncludedEntities.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an IncludedEntities message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.IncludedEntities} IncludedEntities
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IncludedEntities.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.IncludedEntities();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.routes && message.routes.length))
                                message.routes = [];
                            message.routes.push($root.busable.Route.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            if (!(message.stops && message.stops.length))
                                message.stops = [];
                            message.stops.push($root.busable.Stop.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            if (!(message.deadruns && message.deadruns.length))
                                message.deadruns = [];
                            message.deadruns.push($root.busable.Route.decode(reader, reader.uint32()));
                            break;
                        }
                    case 4: {
                            if (!(message.schedules && message.schedules.length))
                                message.schedules = [];
                            message.schedules.push($root.busable.Schedule.decode(reader, reader.uint32()));
                            break;
                        }
                    case 5: {
                            if (!(message.transfers && message.transfers.length))
                                message.transfers = [];
                            message.transfers.push($root.busable.Transfer.decode(reader, reader.uint32()));
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an IncludedEntities message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.IncludedEntities} IncludedEntities
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            IncludedEntities.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an IncludedEntities message.
             * @function verify
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            IncludedEntities.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.routes != null && message.hasOwnProperty("routes")) {
                    if (!Array.isArray(message.routes))
                        return "routes: array expected";
                    for (var i = 0; i < message.routes.length; ++i) {
                        var error = $root.busable.Route.verify(message.routes[i]);
                        if (error)
                            return "routes." + error;
                    }
                }
                if (message.stops != null && message.hasOwnProperty("stops")) {
                    if (!Array.isArray(message.stops))
                        return "stops: array expected";
                    for (var i = 0; i < message.stops.length; ++i) {
                        var error = $root.busable.Stop.verify(message.stops[i]);
                        if (error)
                            return "stops." + error;
                    }
                }
                if (message.deadruns != null && message.hasOwnProperty("deadruns")) {
                    if (!Array.isArray(message.deadruns))
                        return "deadruns: array expected";
                    for (var i = 0; i < message.deadruns.length; ++i) {
                        var error = $root.busable.Route.verify(message.deadruns[i]);
                        if (error)
                            return "deadruns." + error;
                    }
                }
                if (message.schedules != null && message.hasOwnProperty("schedules")) {
                    if (!Array.isArray(message.schedules))
                        return "schedules: array expected";
                    for (var i = 0; i < message.schedules.length; ++i) {
                        var error = $root.busable.Schedule.verify(message.schedules[i]);
                        if (error)
                            return "schedules." + error;
                    }
                }
                if (message.transfers != null && message.hasOwnProperty("transfers")) {
                    if (!Array.isArray(message.transfers))
                        return "transfers: array expected";
                    for (var i = 0; i < message.transfers.length; ++i) {
                        var error = $root.busable.Transfer.verify(message.transfers[i]);
                        if (error)
                            return "transfers." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an IncludedEntities message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.IncludedEntities} IncludedEntities
             */
            IncludedEntities.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.IncludedEntities)
                    return object;
                var message = new $root.busable.api.IncludedEntities();
                if (object.routes) {
                    if (!Array.isArray(object.routes))
                        throw TypeError(".busable.api.IncludedEntities.routes: array expected");
                    message.routes = [];
                    for (var i = 0; i < object.routes.length; ++i) {
                        if (typeof object.routes[i] !== "object")
                            throw TypeError(".busable.api.IncludedEntities.routes: object expected");
                        message.routes[i] = $root.busable.Route.fromObject(object.routes[i]);
                    }
                }
                if (object.stops) {
                    if (!Array.isArray(object.stops))
                        throw TypeError(".busable.api.IncludedEntities.stops: array expected");
                    message.stops = [];
                    for (var i = 0; i < object.stops.length; ++i) {
                        if (typeof object.stops[i] !== "object")
                            throw TypeError(".busable.api.IncludedEntities.stops: object expected");
                        message.stops[i] = $root.busable.Stop.fromObject(object.stops[i]);
                    }
                }
                if (object.deadruns) {
                    if (!Array.isArray(object.deadruns))
                        throw TypeError(".busable.api.IncludedEntities.deadruns: array expected");
                    message.deadruns = [];
                    for (var i = 0; i < object.deadruns.length; ++i) {
                        if (typeof object.deadruns[i] !== "object")
                            throw TypeError(".busable.api.IncludedEntities.deadruns: object expected");
                        message.deadruns[i] = $root.busable.Route.fromObject(object.deadruns[i]);
                    }
                }
                if (object.schedules) {
                    if (!Array.isArray(object.schedules))
                        throw TypeError(".busable.api.IncludedEntities.schedules: array expected");
                    message.schedules = [];
                    for (var i = 0; i < object.schedules.length; ++i) {
                        if (typeof object.schedules[i] !== "object")
                            throw TypeError(".busable.api.IncludedEntities.schedules: object expected");
                        message.schedules[i] = $root.busable.Schedule.fromObject(object.schedules[i]);
                    }
                }
                if (object.transfers) {
                    if (!Array.isArray(object.transfers))
                        throw TypeError(".busable.api.IncludedEntities.transfers: array expected");
                    message.transfers = [];
                    for (var i = 0; i < object.transfers.length; ++i) {
                        if (typeof object.transfers[i] !== "object")
                            throw TypeError(".busable.api.IncludedEntities.transfers: object expected");
                        message.transfers[i] = $root.busable.Transfer.fromObject(object.transfers[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an IncludedEntities message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {busable.api.IncludedEntities} message IncludedEntities
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            IncludedEntities.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.routes = [];
                    object.stops = [];
                    object.deadruns = [];
                    object.schedules = [];
                    object.transfers = [];
                }
                if (message.routes && message.routes.length) {
                    object.routes = [];
                    for (var j = 0; j < message.routes.length; ++j)
                        object.routes[j] = $root.busable.Route.toObject(message.routes[j], options);
                }
                if (message.stops && message.stops.length) {
                    object.stops = [];
                    for (var j = 0; j < message.stops.length; ++j)
                        object.stops[j] = $root.busable.Stop.toObject(message.stops[j], options);
                }
                if (message.deadruns && message.deadruns.length) {
                    object.deadruns = [];
                    for (var j = 0; j < message.deadruns.length; ++j)
                        object.deadruns[j] = $root.busable.Route.toObject(message.deadruns[j], options);
                }
                if (message.schedules && message.schedules.length) {
                    object.schedules = [];
                    for (var j = 0; j < message.schedules.length; ++j)
                        object.schedules[j] = $root.busable.Schedule.toObject(message.schedules[j], options);
                }
                if (message.transfers && message.transfers.length) {
                    object.transfers = [];
                    for (var j = 0; j < message.transfers.length; ++j)
                        object.transfers[j] = $root.busable.Transfer.toObject(message.transfers[j], options);
                }
                return object;
            };

            /**
             * Converts this IncludedEntities to JSON.
             * @function toJSON
             * @memberof busable.api.IncludedEntities
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            IncludedEntities.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for IncludedEntities
             * @function getTypeUrl
             * @memberof busable.api.IncludedEntities
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            IncludedEntities.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.IncludedEntities";
            };

            return IncludedEntities;
        })();

        api.ResponseMeta = (function() {

            /**
             * Properties of a ResponseMeta.
             * @memberof busable.api
             * @interface IResponseMeta
             * @property {number|null} [limit] ResponseMeta limit
             * @property {string|null} [lastEvaluatedId] ResponseMeta lastEvaluatedId
             * @property {string|null} [regionId] ResponseMeta regionId
             * @property {string|null} [operatorKey] ResponseMeta operatorKey
             * @property {string|null} [operatorId] ResponseMeta operatorId
             * @property {number|null} [count] ResponseMeta count
             * @property {boolean|null} [hasMore] ResponseMeta hasMore
             * @property {string|null} [requestId] ResponseMeta requestId
             * @property {number|Long|null} [timestamp] ResponseMeta timestamp
             */

            /**
             * Constructs a new ResponseMeta.
             * @memberof busable.api
             * @classdesc Metadata included in all API responses
             * @implements IResponseMeta
             * @constructor
             * @param {busable.api.IResponseMeta=} [properties] Properties to set
             */
            function ResponseMeta(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ResponseMeta limit.
             * @member {number} limit
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.limit = 0;

            /**
             * ResponseMeta lastEvaluatedId.
             * @member {string} lastEvaluatedId
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.lastEvaluatedId = "";

            /**
             * ResponseMeta regionId.
             * @member {string} regionId
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.regionId = "";

            /**
             * ResponseMeta operatorKey.
             * @member {string} operatorKey
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.operatorKey = "";

            /**
             * ResponseMeta operatorId.
             * @member {string} operatorId
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.operatorId = "";

            /**
             * ResponseMeta count.
             * @member {number} count
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.count = 0;

            /**
             * ResponseMeta hasMore.
             * @member {boolean} hasMore
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.hasMore = false;

            /**
             * ResponseMeta requestId.
             * @member {string} requestId
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.requestId = "";

            /**
             * ResponseMeta timestamp.
             * @member {number|Long} timestamp
             * @memberof busable.api.ResponseMeta
             * @instance
             */
            ResponseMeta.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new ResponseMeta instance using the specified properties.
             * @function create
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {busable.api.IResponseMeta=} [properties] Properties to set
             * @returns {busable.api.ResponseMeta} ResponseMeta instance
             */
            ResponseMeta.create = function create(properties) {
                return new ResponseMeta(properties);
            };

            /**
             * Encodes the specified ResponseMeta message. Does not implicitly {@link busable.api.ResponseMeta.verify|verify} messages.
             * @function encode
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {busable.api.IResponseMeta} message ResponseMeta message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResponseMeta.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.limit);
                if (message.lastEvaluatedId != null && Object.hasOwnProperty.call(message, "lastEvaluatedId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.lastEvaluatedId);
                if (message.regionId != null && Object.hasOwnProperty.call(message, "regionId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.regionId);
                if (message.operatorKey != null && Object.hasOwnProperty.call(message, "operatorKey"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.operatorKey);
                if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.operatorId);
                if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.count);
                if (message.hasMore != null && Object.hasOwnProperty.call(message, "hasMore"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.hasMore);
                if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.requestId);
                if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int64(message.timestamp);
                return writer;
            };

            /**
             * Encodes the specified ResponseMeta message, length delimited. Does not implicitly {@link busable.api.ResponseMeta.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {busable.api.IResponseMeta} message ResponseMeta message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ResponseMeta.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ResponseMeta message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.ResponseMeta} ResponseMeta
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResponseMeta.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.ResponseMeta();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.limit = reader.int32();
                            break;
                        }
                    case 2: {
                            message.lastEvaluatedId = reader.string();
                            break;
                        }
                    case 3: {
                            message.regionId = reader.string();
                            break;
                        }
                    case 4: {
                            message.operatorKey = reader.string();
                            break;
                        }
                    case 5: {
                            message.operatorId = reader.string();
                            break;
                        }
                    case 6: {
                            message.count = reader.int32();
                            break;
                        }
                    case 7: {
                            message.hasMore = reader.bool();
                            break;
                        }
                    case 8: {
                            message.requestId = reader.string();
                            break;
                        }
                    case 9: {
                            message.timestamp = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ResponseMeta message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.ResponseMeta} ResponseMeta
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ResponseMeta.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ResponseMeta message.
             * @function verify
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ResponseMeta.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.limit != null && message.hasOwnProperty("limit"))
                    if (!$util.isInteger(message.limit))
                        return "limit: integer expected";
                if (message.lastEvaluatedId != null && message.hasOwnProperty("lastEvaluatedId"))
                    if (!$util.isString(message.lastEvaluatedId))
                        return "lastEvaluatedId: string expected";
                if (message.regionId != null && message.hasOwnProperty("regionId"))
                    if (!$util.isString(message.regionId))
                        return "regionId: string expected";
                if (message.operatorKey != null && message.hasOwnProperty("operatorKey"))
                    if (!$util.isString(message.operatorKey))
                        return "operatorKey: string expected";
                if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                    if (!$util.isString(message.operatorId))
                        return "operatorId: string expected";
                if (message.count != null && message.hasOwnProperty("count"))
                    if (!$util.isInteger(message.count))
                        return "count: integer expected";
                if (message.hasMore != null && message.hasOwnProperty("hasMore"))
                    if (typeof message.hasMore !== "boolean")
                        return "hasMore: boolean expected";
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    if (!$util.isString(message.requestId))
                        return "requestId: string expected";
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                        return "timestamp: integer|Long expected";
                return null;
            };

            /**
             * Creates a ResponseMeta message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.ResponseMeta} ResponseMeta
             */
            ResponseMeta.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.ResponseMeta)
                    return object;
                var message = new $root.busable.api.ResponseMeta();
                if (object.limit != null)
                    message.limit = object.limit | 0;
                if (object.lastEvaluatedId != null)
                    message.lastEvaluatedId = String(object.lastEvaluatedId);
                if (object.regionId != null)
                    message.regionId = String(object.regionId);
                if (object.operatorKey != null)
                    message.operatorKey = String(object.operatorKey);
                if (object.operatorId != null)
                    message.operatorId = String(object.operatorId);
                if (object.count != null)
                    message.count = object.count | 0;
                if (object.hasMore != null)
                    message.hasMore = Boolean(object.hasMore);
                if (object.requestId != null)
                    message.requestId = String(object.requestId);
                if (object.timestamp != null)
                    if ($util.Long)
                        (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                    else if (typeof object.timestamp === "string")
                        message.timestamp = parseInt(object.timestamp, 10);
                    else if (typeof object.timestamp === "number")
                        message.timestamp = object.timestamp;
                    else if (typeof object.timestamp === "object")
                        message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a ResponseMeta message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {busable.api.ResponseMeta} message ResponseMeta
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ResponseMeta.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.limit = 0;
                    object.lastEvaluatedId = "";
                    object.regionId = "";
                    object.operatorKey = "";
                    object.operatorId = "";
                    object.count = 0;
                    object.hasMore = false;
                    object.requestId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.timestamp = options.longs === String ? "0" : 0;
                }
                if (message.limit != null && message.hasOwnProperty("limit"))
                    object.limit = message.limit;
                if (message.lastEvaluatedId != null && message.hasOwnProperty("lastEvaluatedId"))
                    object.lastEvaluatedId = message.lastEvaluatedId;
                if (message.regionId != null && message.hasOwnProperty("regionId"))
                    object.regionId = message.regionId;
                if (message.operatorKey != null && message.hasOwnProperty("operatorKey"))
                    object.operatorKey = message.operatorKey;
                if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                    object.operatorId = message.operatorId;
                if (message.count != null && message.hasOwnProperty("count"))
                    object.count = message.count;
                if (message.hasMore != null && message.hasOwnProperty("hasMore"))
                    object.hasMore = message.hasMore;
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    object.requestId = message.requestId;
                if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                    if (typeof message.timestamp === "number")
                        object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                    else
                        object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                return object;
            };

            /**
             * Converts this ResponseMeta to JSON.
             * @function toJSON
             * @memberof busable.api.ResponseMeta
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ResponseMeta.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ResponseMeta
             * @function getTypeUrl
             * @memberof busable.api.ResponseMeta
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ResponseMeta.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.ResponseMeta";
            };

            return ResponseMeta;
        })();

        api.LegacyShiftBatsResponse = (function() {

            /**
             * Properties of a LegacyShiftBatsResponse.
             * @memberof busable.api
             * @interface ILegacyShiftBatsResponse
             * @property {Array.<busable.IShiftBat>|null} [items] LegacyShiftBatsResponse items
             * @property {busable.api.IResponseMeta|null} [meta] LegacyShiftBatsResponse meta
             */

            /**
             * Constructs a new LegacyShiftBatsResponse.
             * @memberof busable.api
             * @classdesc Legacy response format with embedded entities (normalize=false)
             * Kept for backwards compatibility
             * 
             * Uses busable.ShiftBat from shift-bats.proto with all embedded entities populated
             * @implements ILegacyShiftBatsResponse
             * @constructor
             * @param {busable.api.ILegacyShiftBatsResponse=} [properties] Properties to set
             */
            function LegacyShiftBatsResponse(properties) {
                this.items = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LegacyShiftBatsResponse items.
             * @member {Array.<busable.IShiftBat>} items
             * @memberof busable.api.LegacyShiftBatsResponse
             * @instance
             */
            LegacyShiftBatsResponse.prototype.items = $util.emptyArray;

            /**
             * LegacyShiftBatsResponse meta.
             * @member {busable.api.IResponseMeta|null|undefined} meta
             * @memberof busable.api.LegacyShiftBatsResponse
             * @instance
             */
            LegacyShiftBatsResponse.prototype.meta = null;

            /**
             * Creates a new LegacyShiftBatsResponse instance using the specified properties.
             * @function create
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {busable.api.ILegacyShiftBatsResponse=} [properties] Properties to set
             * @returns {busable.api.LegacyShiftBatsResponse} LegacyShiftBatsResponse instance
             */
            LegacyShiftBatsResponse.create = function create(properties) {
                return new LegacyShiftBatsResponse(properties);
            };

            /**
             * Encodes the specified LegacyShiftBatsResponse message. Does not implicitly {@link busable.api.LegacyShiftBatsResponse.verify|verify} messages.
             * @function encode
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {busable.api.ILegacyShiftBatsResponse} message LegacyShiftBatsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LegacyShiftBatsResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.items != null && message.items.length)
                    for (var i = 0; i < message.items.length; ++i)
                        $root.busable.ShiftBat.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.meta != null && Object.hasOwnProperty.call(message, "meta"))
                    $root.busable.api.ResponseMeta.encode(message.meta, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LegacyShiftBatsResponse message, length delimited. Does not implicitly {@link busable.api.LegacyShiftBatsResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {busable.api.ILegacyShiftBatsResponse} message LegacyShiftBatsResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LegacyShiftBatsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LegacyShiftBatsResponse message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.LegacyShiftBatsResponse} LegacyShiftBatsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LegacyShiftBatsResponse.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.LegacyShiftBatsResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.items && message.items.length))
                                message.items = [];
                            message.items.push($root.busable.ShiftBat.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.meta = $root.busable.api.ResponseMeta.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LegacyShiftBatsResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.LegacyShiftBatsResponse} LegacyShiftBatsResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LegacyShiftBatsResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LegacyShiftBatsResponse message.
             * @function verify
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LegacyShiftBatsResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.items != null && message.hasOwnProperty("items")) {
                    if (!Array.isArray(message.items))
                        return "items: array expected";
                    for (var i = 0; i < message.items.length; ++i) {
                        var error = $root.busable.ShiftBat.verify(message.items[i]);
                        if (error)
                            return "items." + error;
                    }
                }
                if (message.meta != null && message.hasOwnProperty("meta")) {
                    var error = $root.busable.api.ResponseMeta.verify(message.meta);
                    if (error)
                        return "meta." + error;
                }
                return null;
            };

            /**
             * Creates a LegacyShiftBatsResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.LegacyShiftBatsResponse} LegacyShiftBatsResponse
             */
            LegacyShiftBatsResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.LegacyShiftBatsResponse)
                    return object;
                var message = new $root.busable.api.LegacyShiftBatsResponse();
                if (object.items) {
                    if (!Array.isArray(object.items))
                        throw TypeError(".busable.api.LegacyShiftBatsResponse.items: array expected");
                    message.items = [];
                    for (var i = 0; i < object.items.length; ++i) {
                        if (typeof object.items[i] !== "object")
                            throw TypeError(".busable.api.LegacyShiftBatsResponse.items: object expected");
                        message.items[i] = $root.busable.ShiftBat.fromObject(object.items[i]);
                    }
                }
                if (object.meta != null) {
                    if (typeof object.meta !== "object")
                        throw TypeError(".busable.api.LegacyShiftBatsResponse.meta: object expected");
                    message.meta = $root.busable.api.ResponseMeta.fromObject(object.meta);
                }
                return message;
            };

            /**
             * Creates a plain object from a LegacyShiftBatsResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {busable.api.LegacyShiftBatsResponse} message LegacyShiftBatsResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LegacyShiftBatsResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.items = [];
                if (options.defaults)
                    object.meta = null;
                if (message.items && message.items.length) {
                    object.items = [];
                    for (var j = 0; j < message.items.length; ++j)
                        object.items[j] = $root.busable.ShiftBat.toObject(message.items[j], options);
                }
                if (message.meta != null && message.hasOwnProperty("meta"))
                    object.meta = $root.busable.api.ResponseMeta.toObject(message.meta, options);
                return object;
            };

            /**
             * Converts this LegacyShiftBatsResponse to JSON.
             * @function toJSON
             * @memberof busable.api.LegacyShiftBatsResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LegacyShiftBatsResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LegacyShiftBatsResponse
             * @function getTypeUrl
             * @memberof busable.api.LegacyShiftBatsResponse
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LegacyShiftBatsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.LegacyShiftBatsResponse";
            };

            return LegacyShiftBatsResponse;
        })();

        api.LegacyRoutesResponse = (function() {

            /**
             * Properties of a LegacyRoutesResponse.
             * @memberof busable.api
             * @interface ILegacyRoutesResponse
             * @property {Array.<busable.IRoute>|null} [items] LegacyRoutesResponse items
             * @property {busable.api.IResponseMeta|null} [meta] LegacyRoutesResponse meta
             */

            /**
             * Constructs a new LegacyRoutesResponse.
             * @memberof busable.api
             * @classdesc Legacy routes response with embedded stops
             * 
             * Uses busable.Route from routes.proto with all embedded entities populated
             * @implements ILegacyRoutesResponse
             * @constructor
             * @param {busable.api.ILegacyRoutesResponse=} [properties] Properties to set
             */
            function LegacyRoutesResponse(properties) {
                this.items = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * LegacyRoutesResponse items.
             * @member {Array.<busable.IRoute>} items
             * @memberof busable.api.LegacyRoutesResponse
             * @instance
             */
            LegacyRoutesResponse.prototype.items = $util.emptyArray;

            /**
             * LegacyRoutesResponse meta.
             * @member {busable.api.IResponseMeta|null|undefined} meta
             * @memberof busable.api.LegacyRoutesResponse
             * @instance
             */
            LegacyRoutesResponse.prototype.meta = null;

            /**
             * Creates a new LegacyRoutesResponse instance using the specified properties.
             * @function create
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {busable.api.ILegacyRoutesResponse=} [properties] Properties to set
             * @returns {busable.api.LegacyRoutesResponse} LegacyRoutesResponse instance
             */
            LegacyRoutesResponse.create = function create(properties) {
                return new LegacyRoutesResponse(properties);
            };

            /**
             * Encodes the specified LegacyRoutesResponse message. Does not implicitly {@link busable.api.LegacyRoutesResponse.verify|verify} messages.
             * @function encode
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {busable.api.ILegacyRoutesResponse} message LegacyRoutesResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LegacyRoutesResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.items != null && message.items.length)
                    for (var i = 0; i < message.items.length; ++i)
                        $root.busable.Route.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.meta != null && Object.hasOwnProperty.call(message, "meta"))
                    $root.busable.api.ResponseMeta.encode(message.meta, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified LegacyRoutesResponse message, length delimited. Does not implicitly {@link busable.api.LegacyRoutesResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {busable.api.ILegacyRoutesResponse} message LegacyRoutesResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            LegacyRoutesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a LegacyRoutesResponse message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.LegacyRoutesResponse} LegacyRoutesResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LegacyRoutesResponse.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.LegacyRoutesResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            if (!(message.items && message.items.length))
                                message.items = [];
                            message.items.push($root.busable.Route.decode(reader, reader.uint32()));
                            break;
                        }
                    case 2: {
                            message.meta = $root.busable.api.ResponseMeta.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a LegacyRoutesResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.LegacyRoutesResponse} LegacyRoutesResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            LegacyRoutesResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a LegacyRoutesResponse message.
             * @function verify
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            LegacyRoutesResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.items != null && message.hasOwnProperty("items")) {
                    if (!Array.isArray(message.items))
                        return "items: array expected";
                    for (var i = 0; i < message.items.length; ++i) {
                        var error = $root.busable.Route.verify(message.items[i]);
                        if (error)
                            return "items." + error;
                    }
                }
                if (message.meta != null && message.hasOwnProperty("meta")) {
                    var error = $root.busable.api.ResponseMeta.verify(message.meta);
                    if (error)
                        return "meta." + error;
                }
                return null;
            };

            /**
             * Creates a LegacyRoutesResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.LegacyRoutesResponse} LegacyRoutesResponse
             */
            LegacyRoutesResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.LegacyRoutesResponse)
                    return object;
                var message = new $root.busable.api.LegacyRoutesResponse();
                if (object.items) {
                    if (!Array.isArray(object.items))
                        throw TypeError(".busable.api.LegacyRoutesResponse.items: array expected");
                    message.items = [];
                    for (var i = 0; i < object.items.length; ++i) {
                        if (typeof object.items[i] !== "object")
                            throw TypeError(".busable.api.LegacyRoutesResponse.items: object expected");
                        message.items[i] = $root.busable.Route.fromObject(object.items[i]);
                    }
                }
                if (object.meta != null) {
                    if (typeof object.meta !== "object")
                        throw TypeError(".busable.api.LegacyRoutesResponse.meta: object expected");
                    message.meta = $root.busable.api.ResponseMeta.fromObject(object.meta);
                }
                return message;
            };

            /**
             * Creates a plain object from a LegacyRoutesResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {busable.api.LegacyRoutesResponse} message LegacyRoutesResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            LegacyRoutesResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.items = [];
                if (options.defaults)
                    object.meta = null;
                if (message.items && message.items.length) {
                    object.items = [];
                    for (var j = 0; j < message.items.length; ++j)
                        object.items[j] = $root.busable.Route.toObject(message.items[j], options);
                }
                if (message.meta != null && message.hasOwnProperty("meta"))
                    object.meta = $root.busable.api.ResponseMeta.toObject(message.meta, options);
                return object;
            };

            /**
             * Converts this LegacyRoutesResponse to JSON.
             * @function toJSON
             * @memberof busable.api.LegacyRoutesResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            LegacyRoutesResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for LegacyRoutesResponse
             * @function getTypeUrl
             * @memberof busable.api.LegacyRoutesResponse
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            LegacyRoutesResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.LegacyRoutesResponse";
            };

            return LegacyRoutesResponse;
        })();

        api.ModelResponse = (function() {

            /**
             * Properties of a ModelResponse.
             * @memberof busable.api
             * @interface IModelResponse
             * @property {string|null} [model] ModelResponse model
             * @property {Array.<busable.api.IModelItem>|null} [items] ModelResponse items
             * @property {busable.api.IResponseMeta|null} [meta] ModelResponse meta
             */

            /**
             * Constructs a new ModelResponse.
             * @memberof busable.api
             * @classdesc Generic model response with type discrimination
             * @implements IModelResponse
             * @constructor
             * @param {busable.api.IModelResponse=} [properties] Properties to set
             */
            function ModelResponse(properties) {
                this.items = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModelResponse model.
             * @member {string} model
             * @memberof busable.api.ModelResponse
             * @instance
             */
            ModelResponse.prototype.model = "";

            /**
             * ModelResponse items.
             * @member {Array.<busable.api.IModelItem>} items
             * @memberof busable.api.ModelResponse
             * @instance
             */
            ModelResponse.prototype.items = $util.emptyArray;

            /**
             * ModelResponse meta.
             * @member {busable.api.IResponseMeta|null|undefined} meta
             * @memberof busable.api.ModelResponse
             * @instance
             */
            ModelResponse.prototype.meta = null;

            /**
             * Creates a new ModelResponse instance using the specified properties.
             * @function create
             * @memberof busable.api.ModelResponse
             * @static
             * @param {busable.api.IModelResponse=} [properties] Properties to set
             * @returns {busable.api.ModelResponse} ModelResponse instance
             */
            ModelResponse.create = function create(properties) {
                return new ModelResponse(properties);
            };

            /**
             * Encodes the specified ModelResponse message. Does not implicitly {@link busable.api.ModelResponse.verify|verify} messages.
             * @function encode
             * @memberof busable.api.ModelResponse
             * @static
             * @param {busable.api.IModelResponse} message ModelResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModelResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.model);
                if (message.items != null && message.items.length)
                    for (var i = 0; i < message.items.length; ++i)
                        $root.busable.api.ModelItem.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.meta != null && Object.hasOwnProperty.call(message, "meta"))
                    $root.busable.api.ResponseMeta.encode(message.meta, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ModelResponse message, length delimited. Does not implicitly {@link busable.api.ModelResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.ModelResponse
             * @static
             * @param {busable.api.IModelResponse} message ModelResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModelResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModelResponse message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.ModelResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.ModelResponse} ModelResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModelResponse.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.ModelResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.model = reader.string();
                            break;
                        }
                    case 2: {
                            if (!(message.items && message.items.length))
                                message.items = [];
                            message.items.push($root.busable.api.ModelItem.decode(reader, reader.uint32()));
                            break;
                        }
                    case 3: {
                            message.meta = $root.busable.api.ResponseMeta.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModelResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.ModelResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.ModelResponse} ModelResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModelResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModelResponse message.
             * @function verify
             * @memberof busable.api.ModelResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModelResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.model != null && message.hasOwnProperty("model"))
                    if (!$util.isString(message.model))
                        return "model: string expected";
                if (message.items != null && message.hasOwnProperty("items")) {
                    if (!Array.isArray(message.items))
                        return "items: array expected";
                    for (var i = 0; i < message.items.length; ++i) {
                        var error = $root.busable.api.ModelItem.verify(message.items[i]);
                        if (error)
                            return "items." + error;
                    }
                }
                if (message.meta != null && message.hasOwnProperty("meta")) {
                    var error = $root.busable.api.ResponseMeta.verify(message.meta);
                    if (error)
                        return "meta." + error;
                }
                return null;
            };

            /**
             * Creates a ModelResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.ModelResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.ModelResponse} ModelResponse
             */
            ModelResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.ModelResponse)
                    return object;
                var message = new $root.busable.api.ModelResponse();
                if (object.model != null)
                    message.model = String(object.model);
                if (object.items) {
                    if (!Array.isArray(object.items))
                        throw TypeError(".busable.api.ModelResponse.items: array expected");
                    message.items = [];
                    for (var i = 0; i < object.items.length; ++i) {
                        if (typeof object.items[i] !== "object")
                            throw TypeError(".busable.api.ModelResponse.items: object expected");
                        message.items[i] = $root.busable.api.ModelItem.fromObject(object.items[i]);
                    }
                }
                if (object.meta != null) {
                    if (typeof object.meta !== "object")
                        throw TypeError(".busable.api.ModelResponse.meta: object expected");
                    message.meta = $root.busable.api.ResponseMeta.fromObject(object.meta);
                }
                return message;
            };

            /**
             * Creates a plain object from a ModelResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.ModelResponse
             * @static
             * @param {busable.api.ModelResponse} message ModelResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModelResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.items = [];
                if (options.defaults) {
                    object.model = "";
                    object.meta = null;
                }
                if (message.model != null && message.hasOwnProperty("model"))
                    object.model = message.model;
                if (message.items && message.items.length) {
                    object.items = [];
                    for (var j = 0; j < message.items.length; ++j)
                        object.items[j] = $root.busable.api.ModelItem.toObject(message.items[j], options);
                }
                if (message.meta != null && message.hasOwnProperty("meta"))
                    object.meta = $root.busable.api.ResponseMeta.toObject(message.meta, options);
                return object;
            };

            /**
             * Converts this ModelResponse to JSON.
             * @function toJSON
             * @memberof busable.api.ModelResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModelResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ModelResponse
             * @function getTypeUrl
             * @memberof busable.api.ModelResponse
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ModelResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.ModelResponse";
            };

            return ModelResponse;
        })();

        api.ModelItem = (function() {

            /**
             * Properties of a ModelItem.
             * @memberof busable.api
             * @interface IModelItem
             * @property {busable.IShiftBat|null} [shiftBat] ModelItem shiftBat
             * @property {busable.IRoute|null} [route] ModelItem route
             * @property {busable.IStop|null} [stop] ModelItem stop
             * @property {busable.ISchedule|null} [schedule] ModelItem schedule
             * @property {busable.IDriver|null} [driver] ModelItem driver
             * @property {busable.IVehicle|null} [vehicle] ModelItem vehicle
             * @property {busable.ITransfer|null} [transfer] ModelItem transfer
             */

            /**
             * Constructs a new ModelItem.
             * @memberof busable.api
             * @classdesc Represents a ModelItem.
             * @implements IModelItem
             * @constructor
             * @param {busable.api.IModelItem=} [properties] Properties to set
             */
            function ModelItem(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ModelItem shiftBat.
             * @member {busable.IShiftBat|null|undefined} shiftBat
             * @memberof busable.api.ModelItem
             * @instance
             */
            ModelItem.prototype.shiftBat = null;

            /**
             * ModelItem route.
             * @member {busable.IRoute|null|undefined} route
             * @memberof busable.api.ModelItem
             * @instance
             */
            ModelItem.prototype.route = null;

            /**
             * ModelItem stop.
             * @member {busable.IStop|null|undefined} stop
             * @memberof busable.api.ModelItem
             * @instance
             */
            ModelItem.prototype.stop = null;

            /**
             * ModelItem schedule.
             * @member {busable.ISchedule|null|undefined} schedule
             * @memberof busable.api.ModelItem
             * @instance
             */
            ModelItem.prototype.schedule = null;

            /**
             * ModelItem driver.
             * @member {busable.IDriver|null|undefined} driver
             * @memberof busable.api.ModelItem
             * @instance
             */
            ModelItem.prototype.driver = null;

            /**
             * ModelItem vehicle.
             * @member {busable.IVehicle|null|undefined} vehicle
             * @memberof busable.api.ModelItem
             * @instance
             */
            ModelItem.prototype.vehicle = null;

            /**
             * ModelItem transfer.
             * @member {busable.ITransfer|null|undefined} transfer
             * @memberof busable.api.ModelItem
             * @instance
             */
            ModelItem.prototype.transfer = null;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * ModelItem data.
             * @member {"shiftBat"|"route"|"stop"|"schedule"|"driver"|"vehicle"|"transfer"|undefined} data
             * @memberof busable.api.ModelItem
             * @instance
             */
            Object.defineProperty(ModelItem.prototype, "data", {
                get: $util.oneOfGetter($oneOfFields = ["shiftBat", "route", "stop", "schedule", "driver", "vehicle", "transfer"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new ModelItem instance using the specified properties.
             * @function create
             * @memberof busable.api.ModelItem
             * @static
             * @param {busable.api.IModelItem=} [properties] Properties to set
             * @returns {busable.api.ModelItem} ModelItem instance
             */
            ModelItem.create = function create(properties) {
                return new ModelItem(properties);
            };

            /**
             * Encodes the specified ModelItem message. Does not implicitly {@link busable.api.ModelItem.verify|verify} messages.
             * @function encode
             * @memberof busable.api.ModelItem
             * @static
             * @param {busable.api.IModelItem} message ModelItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModelItem.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.shiftBat != null && Object.hasOwnProperty.call(message, "shiftBat"))
                    $root.busable.ShiftBat.encode(message.shiftBat, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.route != null && Object.hasOwnProperty.call(message, "route"))
                    $root.busable.Route.encode(message.route, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.stop != null && Object.hasOwnProperty.call(message, "stop"))
                    $root.busable.Stop.encode(message.stop, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.schedule != null && Object.hasOwnProperty.call(message, "schedule"))
                    $root.busable.Schedule.encode(message.schedule, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.driver != null && Object.hasOwnProperty.call(message, "driver"))
                    $root.busable.Driver.encode(message.driver, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.vehicle != null && Object.hasOwnProperty.call(message, "vehicle"))
                    $root.busable.Vehicle.encode(message.vehicle, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.transfer != null && Object.hasOwnProperty.call(message, "transfer"))
                    $root.busable.Transfer.encode(message.transfer, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ModelItem message, length delimited. Does not implicitly {@link busable.api.ModelItem.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.ModelItem
             * @static
             * @param {busable.api.IModelItem} message ModelItem message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ModelItem.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ModelItem message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.ModelItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.ModelItem} ModelItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModelItem.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.ModelItem();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.shiftBat = $root.busable.ShiftBat.decode(reader, reader.uint32());
                            break;
                        }
                    case 2: {
                            message.route = $root.busable.Route.decode(reader, reader.uint32());
                            break;
                        }
                    case 3: {
                            message.stop = $root.busable.Stop.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.schedule = $root.busable.Schedule.decode(reader, reader.uint32());
                            break;
                        }
                    case 5: {
                            message.driver = $root.busable.Driver.decode(reader, reader.uint32());
                            break;
                        }
                    case 6: {
                            message.vehicle = $root.busable.Vehicle.decode(reader, reader.uint32());
                            break;
                        }
                    case 7: {
                            message.transfer = $root.busable.Transfer.decode(reader, reader.uint32());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ModelItem message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.ModelItem
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.ModelItem} ModelItem
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ModelItem.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ModelItem message.
             * @function verify
             * @memberof busable.api.ModelItem
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ModelItem.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.shiftBat != null && message.hasOwnProperty("shiftBat")) {
                    properties.data = 1;
                    {
                        var error = $root.busable.ShiftBat.verify(message.shiftBat);
                        if (error)
                            return "shiftBat." + error;
                    }
                }
                if (message.route != null && message.hasOwnProperty("route")) {
                    if (properties.data === 1)
                        return "data: multiple values";
                    properties.data = 1;
                    {
                        var error = $root.busable.Route.verify(message.route);
                        if (error)
                            return "route." + error;
                    }
                }
                if (message.stop != null && message.hasOwnProperty("stop")) {
                    if (properties.data === 1)
                        return "data: multiple values";
                    properties.data = 1;
                    {
                        var error = $root.busable.Stop.verify(message.stop);
                        if (error)
                            return "stop." + error;
                    }
                }
                if (message.schedule != null && message.hasOwnProperty("schedule")) {
                    if (properties.data === 1)
                        return "data: multiple values";
                    properties.data = 1;
                    {
                        var error = $root.busable.Schedule.verify(message.schedule);
                        if (error)
                            return "schedule." + error;
                    }
                }
                if (message.driver != null && message.hasOwnProperty("driver")) {
                    if (properties.data === 1)
                        return "data: multiple values";
                    properties.data = 1;
                    {
                        var error = $root.busable.Driver.verify(message.driver);
                        if (error)
                            return "driver." + error;
                    }
                }
                if (message.vehicle != null && message.hasOwnProperty("vehicle")) {
                    if (properties.data === 1)
                        return "data: multiple values";
                    properties.data = 1;
                    {
                        var error = $root.busable.Vehicle.verify(message.vehicle);
                        if (error)
                            return "vehicle." + error;
                    }
                }
                if (message.transfer != null && message.hasOwnProperty("transfer")) {
                    if (properties.data === 1)
                        return "data: multiple values";
                    properties.data = 1;
                    {
                        var error = $root.busable.Transfer.verify(message.transfer);
                        if (error)
                            return "transfer." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ModelItem message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.ModelItem
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.ModelItem} ModelItem
             */
            ModelItem.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.ModelItem)
                    return object;
                var message = new $root.busable.api.ModelItem();
                if (object.shiftBat != null) {
                    if (typeof object.shiftBat !== "object")
                        throw TypeError(".busable.api.ModelItem.shiftBat: object expected");
                    message.shiftBat = $root.busable.ShiftBat.fromObject(object.shiftBat);
                }
                if (object.route != null) {
                    if (typeof object.route !== "object")
                        throw TypeError(".busable.api.ModelItem.route: object expected");
                    message.route = $root.busable.Route.fromObject(object.route);
                }
                if (object.stop != null) {
                    if (typeof object.stop !== "object")
                        throw TypeError(".busable.api.ModelItem.stop: object expected");
                    message.stop = $root.busable.Stop.fromObject(object.stop);
                }
                if (object.schedule != null) {
                    if (typeof object.schedule !== "object")
                        throw TypeError(".busable.api.ModelItem.schedule: object expected");
                    message.schedule = $root.busable.Schedule.fromObject(object.schedule);
                }
                if (object.driver != null) {
                    if (typeof object.driver !== "object")
                        throw TypeError(".busable.api.ModelItem.driver: object expected");
                    message.driver = $root.busable.Driver.fromObject(object.driver);
                }
                if (object.vehicle != null) {
                    if (typeof object.vehicle !== "object")
                        throw TypeError(".busable.api.ModelItem.vehicle: object expected");
                    message.vehicle = $root.busable.Vehicle.fromObject(object.vehicle);
                }
                if (object.transfer != null) {
                    if (typeof object.transfer !== "object")
                        throw TypeError(".busable.api.ModelItem.transfer: object expected");
                    message.transfer = $root.busable.Transfer.fromObject(object.transfer);
                }
                return message;
            };

            /**
             * Creates a plain object from a ModelItem message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.ModelItem
             * @static
             * @param {busable.api.ModelItem} message ModelItem
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ModelItem.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (message.shiftBat != null && message.hasOwnProperty("shiftBat")) {
                    object.shiftBat = $root.busable.ShiftBat.toObject(message.shiftBat, options);
                    if (options.oneofs)
                        object.data = "shiftBat";
                }
                if (message.route != null && message.hasOwnProperty("route")) {
                    object.route = $root.busable.Route.toObject(message.route, options);
                    if (options.oneofs)
                        object.data = "route";
                }
                if (message.stop != null && message.hasOwnProperty("stop")) {
                    object.stop = $root.busable.Stop.toObject(message.stop, options);
                    if (options.oneofs)
                        object.data = "stop";
                }
                if (message.schedule != null && message.hasOwnProperty("schedule")) {
                    object.schedule = $root.busable.Schedule.toObject(message.schedule, options);
                    if (options.oneofs)
                        object.data = "schedule";
                }
                if (message.driver != null && message.hasOwnProperty("driver")) {
                    object.driver = $root.busable.Driver.toObject(message.driver, options);
                    if (options.oneofs)
                        object.data = "driver";
                }
                if (message.vehicle != null && message.hasOwnProperty("vehicle")) {
                    object.vehicle = $root.busable.Vehicle.toObject(message.vehicle, options);
                    if (options.oneofs)
                        object.data = "vehicle";
                }
                if (message.transfer != null && message.hasOwnProperty("transfer")) {
                    object.transfer = $root.busable.Transfer.toObject(message.transfer, options);
                    if (options.oneofs)
                        object.data = "transfer";
                }
                return object;
            };

            /**
             * Converts this ModelItem to JSON.
             * @function toJSON
             * @memberof busable.api.ModelItem
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ModelItem.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ModelItem
             * @function getTypeUrl
             * @memberof busable.api.ModelItem
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ModelItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.ModelItem";
            };

            return ModelItem;
        })();

        api.ErrorResponse = (function() {

            /**
             * Properties of an ErrorResponse.
             * @memberof busable.api
             * @interface IErrorResponse
             * @property {string|null} [error] ErrorResponse error
             * @property {string|null} [message] ErrorResponse message
             * @property {number|null} [statusCode] ErrorResponse statusCode
             * @property {string|null} [requestId] ErrorResponse requestId
             * @property {Array.<string>|null} [details] ErrorResponse details
             */

            /**
             * Constructs a new ErrorResponse.
             * @memberof busable.api
             * @classdesc Error response for failed requests
             * @implements IErrorResponse
             * @constructor
             * @param {busable.api.IErrorResponse=} [properties] Properties to set
             */
            function ErrorResponse(properties) {
                this.details = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ErrorResponse error.
             * @member {string} error
             * @memberof busable.api.ErrorResponse
             * @instance
             */
            ErrorResponse.prototype.error = "";

            /**
             * ErrorResponse message.
             * @member {string} message
             * @memberof busable.api.ErrorResponse
             * @instance
             */
            ErrorResponse.prototype.message = "";

            /**
             * ErrorResponse statusCode.
             * @member {number} statusCode
             * @memberof busable.api.ErrorResponse
             * @instance
             */
            ErrorResponse.prototype.statusCode = 0;

            /**
             * ErrorResponse requestId.
             * @member {string} requestId
             * @memberof busable.api.ErrorResponse
             * @instance
             */
            ErrorResponse.prototype.requestId = "";

            /**
             * ErrorResponse details.
             * @member {Array.<string>} details
             * @memberof busable.api.ErrorResponse
             * @instance
             */
            ErrorResponse.prototype.details = $util.emptyArray;

            /**
             * Creates a new ErrorResponse instance using the specified properties.
             * @function create
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {busable.api.IErrorResponse=} [properties] Properties to set
             * @returns {busable.api.ErrorResponse} ErrorResponse instance
             */
            ErrorResponse.create = function create(properties) {
                return new ErrorResponse(properties);
            };

            /**
             * Encodes the specified ErrorResponse message. Does not implicitly {@link busable.api.ErrorResponse.verify|verify} messages.
             * @function encode
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {busable.api.IErrorResponse} message ErrorResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ErrorResponse.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.error);
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                if (message.statusCode != null && Object.hasOwnProperty.call(message, "statusCode"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.statusCode);
                if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.requestId);
                if (message.details != null && message.details.length)
                    for (var i = 0; i < message.details.length; ++i)
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.details[i]);
                return writer;
            };

            /**
             * Encodes the specified ErrorResponse message, length delimited. Does not implicitly {@link busable.api.ErrorResponse.verify|verify} messages.
             * @function encodeDelimited
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {busable.api.IErrorResponse} message ErrorResponse message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ErrorResponse.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an ErrorResponse message from the specified reader or buffer.
             * @function decode
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {busable.api.ErrorResponse} ErrorResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ErrorResponse.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.api.ErrorResponse();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.error = reader.string();
                            break;
                        }
                    case 2: {
                            message.message = reader.string();
                            break;
                        }
                    case 3: {
                            message.statusCode = reader.int32();
                            break;
                        }
                    case 4: {
                            message.requestId = reader.string();
                            break;
                        }
                    case 5: {
                            if (!(message.details && message.details.length))
                                message.details = [];
                            message.details.push(reader.string());
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an ErrorResponse message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {busable.api.ErrorResponse} ErrorResponse
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ErrorResponse.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an ErrorResponse message.
             * @function verify
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ErrorResponse.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.error != null && message.hasOwnProperty("error"))
                    if (!$util.isString(message.error))
                        return "error: string expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                    if (!$util.isInteger(message.statusCode))
                        return "statusCode: integer expected";
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    if (!$util.isString(message.requestId))
                        return "requestId: string expected";
                if (message.details != null && message.hasOwnProperty("details")) {
                    if (!Array.isArray(message.details))
                        return "details: array expected";
                    for (var i = 0; i < message.details.length; ++i)
                        if (!$util.isString(message.details[i]))
                            return "details: string[] expected";
                }
                return null;
            };

            /**
             * Creates an ErrorResponse message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {busable.api.ErrorResponse} ErrorResponse
             */
            ErrorResponse.fromObject = function fromObject(object) {
                if (object instanceof $root.busable.api.ErrorResponse)
                    return object;
                var message = new $root.busable.api.ErrorResponse();
                if (object.error != null)
                    message.error = String(object.error);
                if (object.message != null)
                    message.message = String(object.message);
                if (object.statusCode != null)
                    message.statusCode = object.statusCode | 0;
                if (object.requestId != null)
                    message.requestId = String(object.requestId);
                if (object.details) {
                    if (!Array.isArray(object.details))
                        throw TypeError(".busable.api.ErrorResponse.details: array expected");
                    message.details = [];
                    for (var i = 0; i < object.details.length; ++i)
                        message.details[i] = String(object.details[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from an ErrorResponse message. Also converts values to other types if specified.
             * @function toObject
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {busable.api.ErrorResponse} message ErrorResponse
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ErrorResponse.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.details = [];
                if (options.defaults) {
                    object.error = "";
                    object.message = "";
                    object.statusCode = 0;
                    object.requestId = "";
                }
                if (message.error != null && message.hasOwnProperty("error"))
                    object.error = message.error;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                    object.statusCode = message.statusCode;
                if (message.requestId != null && message.hasOwnProperty("requestId"))
                    object.requestId = message.requestId;
                if (message.details && message.details.length) {
                    object.details = [];
                    for (var j = 0; j < message.details.length; ++j)
                        object.details[j] = message.details[j];
                }
                return object;
            };

            /**
             * Converts this ErrorResponse to JSON.
             * @function toJSON
             * @memberof busable.api.ErrorResponse
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ErrorResponse.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for ErrorResponse
             * @function getTypeUrl
             * @memberof busable.api.ErrorResponse
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            ErrorResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/busable.api.ErrorResponse";
            };

            return ErrorResponse;
        })();

        return api;
    })();

    busable.Point = (function() {

        /**
         * Properties of a Point.
         * @memberof busable
         * @interface IPoint
         * @property {number|null} [lat] Point lat
         * @property {number|null} [lon] Point lon
         */

        /**
         * Constructs a new Point.
         * @memberof busable
         * @classdesc Represents a Point.
         * @implements IPoint
         * @constructor
         * @param {busable.IPoint=} [properties] Properties to set
         */
        function Point(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Point lat.
         * @member {number} lat
         * @memberof busable.Point
         * @instance
         */
        Point.prototype.lat = 0;

        /**
         * Point lon.
         * @member {number} lon
         * @memberof busable.Point
         * @instance
         */
        Point.prototype.lon = 0;

        /**
         * Creates a new Point instance using the specified properties.
         * @function create
         * @memberof busable.Point
         * @static
         * @param {busable.IPoint=} [properties] Properties to set
         * @returns {busable.Point} Point instance
         */
        Point.create = function create(properties) {
            return new Point(properties);
        };

        /**
         * Encodes the specified Point message. Does not implicitly {@link busable.Point.verify|verify} messages.
         * @function encode
         * @memberof busable.Point
         * @static
         * @param {busable.IPoint} message Point message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Point.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.lat);
            if (message.lon != null && Object.hasOwnProperty.call(message, "lon"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.lon);
            return writer;
        };

        /**
         * Encodes the specified Point message, length delimited. Does not implicitly {@link busable.Point.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Point
         * @static
         * @param {busable.IPoint} message Point message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Point.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Point message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Point
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Point} Point
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Point.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Point();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lat = reader.double();
                        break;
                    }
                case 2: {
                        message.lon = reader.double();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Point message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Point
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Point} Point
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Point.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Point message.
         * @function verify
         * @memberof busable.Point
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Point.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lat != null && message.hasOwnProperty("lat"))
                if (typeof message.lat !== "number")
                    return "lat: number expected";
            if (message.lon != null && message.hasOwnProperty("lon"))
                if (typeof message.lon !== "number")
                    return "lon: number expected";
            return null;
        };

        /**
         * Creates a Point message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Point
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Point} Point
         */
        Point.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Point)
                return object;
            var message = new $root.busable.Point();
            if (object.lat != null)
                message.lat = Number(object.lat);
            if (object.lon != null)
                message.lon = Number(object.lon);
            return message;
        };

        /**
         * Creates a plain object from a Point message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Point
         * @static
         * @param {busable.Point} message Point
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Point.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.lat = 0;
                object.lon = 0;
            }
            if (message.lat != null && message.hasOwnProperty("lat"))
                object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
            if (message.lon != null && message.hasOwnProperty("lon"))
                object.lon = options.json && !isFinite(message.lon) ? String(message.lon) : message.lon;
            return object;
        };

        /**
         * Converts this Point to JSON.
         * @function toJSON
         * @memberof busable.Point
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Point.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Point
         * @function getTypeUrl
         * @memberof busable.Point
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Point.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Point";
        };

        return Point;
    })();

    busable.WayPoint = (function() {

        /**
         * Properties of a WayPoint.
         * @memberof busable
         * @interface IWayPoint
         * @property {number|null} [lat] WayPoint lat
         * @property {number|null} [lon] WayPoint lon
         * @property {boolean|null} [checkpoint] WayPoint checkpoint
         * @property {number|null} [distance] WayPoint distance
         * @property {string|null} [stopId] WayPoint stopId
         * @property {string|null} [stopTimeId] WayPoint stopTimeId
         * @property {number|null} [stopIndex] WayPoint stopIndex
         */

        /**
         * Constructs a new WayPoint.
         * @memberof busable
         * @classdesc Represents a WayPoint.
         * @implements IWayPoint
         * @constructor
         * @param {busable.IWayPoint=} [properties] Properties to set
         */
        function WayPoint(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WayPoint lat.
         * @member {number} lat
         * @memberof busable.WayPoint
         * @instance
         */
        WayPoint.prototype.lat = 0;

        /**
         * WayPoint lon.
         * @member {number} lon
         * @memberof busable.WayPoint
         * @instance
         */
        WayPoint.prototype.lon = 0;

        /**
         * WayPoint checkpoint.
         * @member {boolean} checkpoint
         * @memberof busable.WayPoint
         * @instance
         */
        WayPoint.prototype.checkpoint = false;

        /**
         * WayPoint distance.
         * @member {number} distance
         * @memberof busable.WayPoint
         * @instance
         */
        WayPoint.prototype.distance = 0;

        /**
         * WayPoint stopId.
         * @member {string} stopId
         * @memberof busable.WayPoint
         * @instance
         */
        WayPoint.prototype.stopId = "";

        /**
         * WayPoint stopTimeId.
         * @member {string} stopTimeId
         * @memberof busable.WayPoint
         * @instance
         */
        WayPoint.prototype.stopTimeId = "";

        /**
         * WayPoint stopIndex.
         * @member {number} stopIndex
         * @memberof busable.WayPoint
         * @instance
         */
        WayPoint.prototype.stopIndex = 0;

        /**
         * Creates a new WayPoint instance using the specified properties.
         * @function create
         * @memberof busable.WayPoint
         * @static
         * @param {busable.IWayPoint=} [properties] Properties to set
         * @returns {busable.WayPoint} WayPoint instance
         */
        WayPoint.create = function create(properties) {
            return new WayPoint(properties);
        };

        /**
         * Encodes the specified WayPoint message. Does not implicitly {@link busable.WayPoint.verify|verify} messages.
         * @function encode
         * @memberof busable.WayPoint
         * @static
         * @param {busable.IWayPoint} message WayPoint message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WayPoint.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.lat);
            if (message.lon != null && Object.hasOwnProperty.call(message, "lon"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.lon);
            if (message.checkpoint != null && Object.hasOwnProperty.call(message, "checkpoint"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.checkpoint);
            if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.distance);
            if (message.stopId != null && Object.hasOwnProperty.call(message, "stopId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.stopId);
            if (message.stopTimeId != null && Object.hasOwnProperty.call(message, "stopTimeId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.stopTimeId);
            if (message.stopIndex != null && Object.hasOwnProperty.call(message, "stopIndex"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.stopIndex);
            return writer;
        };

        /**
         * Encodes the specified WayPoint message, length delimited. Does not implicitly {@link busable.WayPoint.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.WayPoint
         * @static
         * @param {busable.IWayPoint} message WayPoint message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WayPoint.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a WayPoint message from the specified reader or buffer.
         * @function decode
         * @memberof busable.WayPoint
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.WayPoint} WayPoint
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WayPoint.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.WayPoint();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lat = reader.double();
                        break;
                    }
                case 2: {
                        message.lon = reader.double();
                        break;
                    }
                case 3: {
                        message.checkpoint = reader.bool();
                        break;
                    }
                case 4: {
                        message.distance = reader.int32();
                        break;
                    }
                case 5: {
                        message.stopId = reader.string();
                        break;
                    }
                case 6: {
                        message.stopTimeId = reader.string();
                        break;
                    }
                case 7: {
                        message.stopIndex = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a WayPoint message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.WayPoint
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.WayPoint} WayPoint
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WayPoint.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a WayPoint message.
         * @function verify
         * @memberof busable.WayPoint
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        WayPoint.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lat != null && message.hasOwnProperty("lat"))
                if (typeof message.lat !== "number")
                    return "lat: number expected";
            if (message.lon != null && message.hasOwnProperty("lon"))
                if (typeof message.lon !== "number")
                    return "lon: number expected";
            if (message.checkpoint != null && message.hasOwnProperty("checkpoint"))
                if (typeof message.checkpoint !== "boolean")
                    return "checkpoint: boolean expected";
            if (message.distance != null && message.hasOwnProperty("distance"))
                if (!$util.isInteger(message.distance))
                    return "distance: integer expected";
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                if (!$util.isString(message.stopId))
                    return "stopId: string expected";
            if (message.stopTimeId != null && message.hasOwnProperty("stopTimeId"))
                if (!$util.isString(message.stopTimeId))
                    return "stopTimeId: string expected";
            if (message.stopIndex != null && message.hasOwnProperty("stopIndex"))
                if (!$util.isInteger(message.stopIndex))
                    return "stopIndex: integer expected";
            return null;
        };

        /**
         * Creates a WayPoint message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.WayPoint
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.WayPoint} WayPoint
         */
        WayPoint.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.WayPoint)
                return object;
            var message = new $root.busable.WayPoint();
            if (object.lat != null)
                message.lat = Number(object.lat);
            if (object.lon != null)
                message.lon = Number(object.lon);
            if (object.checkpoint != null)
                message.checkpoint = Boolean(object.checkpoint);
            if (object.distance != null)
                message.distance = object.distance | 0;
            if (object.stopId != null)
                message.stopId = String(object.stopId);
            if (object.stopTimeId != null)
                message.stopTimeId = String(object.stopTimeId);
            if (object.stopIndex != null)
                message.stopIndex = object.stopIndex | 0;
            return message;
        };

        /**
         * Creates a plain object from a WayPoint message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.WayPoint
         * @static
         * @param {busable.WayPoint} message WayPoint
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WayPoint.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.lat = 0;
                object.lon = 0;
                object.checkpoint = false;
                object.distance = 0;
                object.stopId = "";
                object.stopTimeId = "";
                object.stopIndex = 0;
            }
            if (message.lat != null && message.hasOwnProperty("lat"))
                object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
            if (message.lon != null && message.hasOwnProperty("lon"))
                object.lon = options.json && !isFinite(message.lon) ? String(message.lon) : message.lon;
            if (message.checkpoint != null && message.hasOwnProperty("checkpoint"))
                object.checkpoint = message.checkpoint;
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = message.distance;
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                object.stopId = message.stopId;
            if (message.stopTimeId != null && message.hasOwnProperty("stopTimeId"))
                object.stopTimeId = message.stopTimeId;
            if (message.stopIndex != null && message.hasOwnProperty("stopIndex"))
                object.stopIndex = message.stopIndex;
            return object;
        };

        /**
         * Converts this WayPoint to JSON.
         * @function toJSON
         * @memberof busable.WayPoint
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WayPoint.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for WayPoint
         * @function getTypeUrl
         * @memberof busable.WayPoint
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        WayPoint.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.WayPoint";
        };

        return WayPoint;
    })();

    busable.LinkedStop = (function() {

        /**
         * Properties of a LinkedStop.
         * @memberof busable
         * @interface ILinkedStop
         * @property {string|null} [stopId] LinkedStop stopId
         * @property {number|null} [distance] LinkedStop distance
         * @property {number|null} [duration] LinkedStop duration
         * @property {Array.<busable.IWayPoint>|null} [waypoints] LinkedStop waypoints
         */

        /**
         * Constructs a new LinkedStop.
         * @memberof busable
         * @classdesc Represents a LinkedStop.
         * @implements ILinkedStop
         * @constructor
         * @param {busable.ILinkedStop=} [properties] Properties to set
         */
        function LinkedStop(properties) {
            this.waypoints = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LinkedStop stopId.
         * @member {string} stopId
         * @memberof busable.LinkedStop
         * @instance
         */
        LinkedStop.prototype.stopId = "";

        /**
         * LinkedStop distance.
         * @member {number} distance
         * @memberof busable.LinkedStop
         * @instance
         */
        LinkedStop.prototype.distance = 0;

        /**
         * LinkedStop duration.
         * @member {number} duration
         * @memberof busable.LinkedStop
         * @instance
         */
        LinkedStop.prototype.duration = 0;

        /**
         * LinkedStop waypoints.
         * @member {Array.<busable.IWayPoint>} waypoints
         * @memberof busable.LinkedStop
         * @instance
         */
        LinkedStop.prototype.waypoints = $util.emptyArray;

        /**
         * Creates a new LinkedStop instance using the specified properties.
         * @function create
         * @memberof busable.LinkedStop
         * @static
         * @param {busable.ILinkedStop=} [properties] Properties to set
         * @returns {busable.LinkedStop} LinkedStop instance
         */
        LinkedStop.create = function create(properties) {
            return new LinkedStop(properties);
        };

        /**
         * Encodes the specified LinkedStop message. Does not implicitly {@link busable.LinkedStop.verify|verify} messages.
         * @function encode
         * @memberof busable.LinkedStop
         * @static
         * @param {busable.ILinkedStop} message LinkedStop message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LinkedStop.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.stopId != null && Object.hasOwnProperty.call(message, "stopId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.stopId);
            if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.distance);
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.duration);
            if (message.waypoints != null && message.waypoints.length)
                for (var i = 0; i < message.waypoints.length; ++i)
                    $root.busable.WayPoint.encode(message.waypoints[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified LinkedStop message, length delimited. Does not implicitly {@link busable.LinkedStop.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.LinkedStop
         * @static
         * @param {busable.ILinkedStop} message LinkedStop message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LinkedStop.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LinkedStop message from the specified reader or buffer.
         * @function decode
         * @memberof busable.LinkedStop
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.LinkedStop} LinkedStop
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LinkedStop.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.LinkedStop();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.stopId = reader.string();
                        break;
                    }
                case 2: {
                        message.distance = reader.double();
                        break;
                    }
                case 3: {
                        message.duration = reader.double();
                        break;
                    }
                case 4: {
                        if (!(message.waypoints && message.waypoints.length))
                            message.waypoints = [];
                        message.waypoints.push($root.busable.WayPoint.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LinkedStop message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.LinkedStop
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.LinkedStop} LinkedStop
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LinkedStop.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LinkedStop message.
         * @function verify
         * @memberof busable.LinkedStop
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LinkedStop.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                if (!$util.isString(message.stopId))
                    return "stopId: string expected";
            if (message.distance != null && message.hasOwnProperty("distance"))
                if (typeof message.distance !== "number")
                    return "distance: number expected";
            if (message.duration != null && message.hasOwnProperty("duration"))
                if (typeof message.duration !== "number")
                    return "duration: number expected";
            if (message.waypoints != null && message.hasOwnProperty("waypoints")) {
                if (!Array.isArray(message.waypoints))
                    return "waypoints: array expected";
                for (var i = 0; i < message.waypoints.length; ++i) {
                    var error = $root.busable.WayPoint.verify(message.waypoints[i]);
                    if (error)
                        return "waypoints." + error;
                }
            }
            return null;
        };

        /**
         * Creates a LinkedStop message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.LinkedStop
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.LinkedStop} LinkedStop
         */
        LinkedStop.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.LinkedStop)
                return object;
            var message = new $root.busable.LinkedStop();
            if (object.stopId != null)
                message.stopId = String(object.stopId);
            if (object.distance != null)
                message.distance = Number(object.distance);
            if (object.duration != null)
                message.duration = Number(object.duration);
            if (object.waypoints) {
                if (!Array.isArray(object.waypoints))
                    throw TypeError(".busable.LinkedStop.waypoints: array expected");
                message.waypoints = [];
                for (var i = 0; i < object.waypoints.length; ++i) {
                    if (typeof object.waypoints[i] !== "object")
                        throw TypeError(".busable.LinkedStop.waypoints: object expected");
                    message.waypoints[i] = $root.busable.WayPoint.fromObject(object.waypoints[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a LinkedStop message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.LinkedStop
         * @static
         * @param {busable.LinkedStop} message LinkedStop
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LinkedStop.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.waypoints = [];
            if (options.defaults) {
                object.stopId = "";
                object.distance = 0;
                object.duration = 0;
            }
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                object.stopId = message.stopId;
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = options.json && !isFinite(message.distance) ? String(message.distance) : message.distance;
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = options.json && !isFinite(message.duration) ? String(message.duration) : message.duration;
            if (message.waypoints && message.waypoints.length) {
                object.waypoints = [];
                for (var j = 0; j < message.waypoints.length; ++j)
                    object.waypoints[j] = $root.busable.WayPoint.toObject(message.waypoints[j], options);
            }
            return object;
        };

        /**
         * Converts this LinkedStop to JSON.
         * @function toJSON
         * @memberof busable.LinkedStop
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LinkedStop.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LinkedStop
         * @function getTypeUrl
         * @memberof busable.LinkedStop
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LinkedStop.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.LinkedStop";
        };

        return LinkedStop;
    })();

    busable.RouteInfo = (function() {

        /**
         * Properties of a RouteInfo.
         * @memberof busable
         * @interface IRouteInfo
         * @property {string|null} [routeId] RouteInfo routeId
         * @property {string|null} [routeNumber] RouteInfo routeNumber
         * @property {string|null} [routeName] RouteInfo routeName
         * @property {Object.<string,busable.IServiceAtStop>|null} [services] RouteInfo services
         * @property {number|null} [minSequence] RouteInfo minSequence
         * @property {number|null} [maxSequence] RouteInfo maxSequence
         */

        /**
         * Constructs a new RouteInfo.
         * @memberof busable
         * @classdesc Represents a RouteInfo.
         * @implements IRouteInfo
         * @constructor
         * @param {busable.IRouteInfo=} [properties] Properties to set
         */
        function RouteInfo(properties) {
            this.services = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RouteInfo routeId.
         * @member {string} routeId
         * @memberof busable.RouteInfo
         * @instance
         */
        RouteInfo.prototype.routeId = "";

        /**
         * RouteInfo routeNumber.
         * @member {string} routeNumber
         * @memberof busable.RouteInfo
         * @instance
         */
        RouteInfo.prototype.routeNumber = "";

        /**
         * RouteInfo routeName.
         * @member {string} routeName
         * @memberof busable.RouteInfo
         * @instance
         */
        RouteInfo.prototype.routeName = "";

        /**
         * RouteInfo services.
         * @member {Object.<string,busable.IServiceAtStop>} services
         * @memberof busable.RouteInfo
         * @instance
         */
        RouteInfo.prototype.services = $util.emptyObject;

        /**
         * RouteInfo minSequence.
         * @member {number} minSequence
         * @memberof busable.RouteInfo
         * @instance
         */
        RouteInfo.prototype.minSequence = 0;

        /**
         * RouteInfo maxSequence.
         * @member {number} maxSequence
         * @memberof busable.RouteInfo
         * @instance
         */
        RouteInfo.prototype.maxSequence = 0;

        /**
         * Creates a new RouteInfo instance using the specified properties.
         * @function create
         * @memberof busable.RouteInfo
         * @static
         * @param {busable.IRouteInfo=} [properties] Properties to set
         * @returns {busable.RouteInfo} RouteInfo instance
         */
        RouteInfo.create = function create(properties) {
            return new RouteInfo(properties);
        };

        /**
         * Encodes the specified RouteInfo message. Does not implicitly {@link busable.RouteInfo.verify|verify} messages.
         * @function encode
         * @memberof busable.RouteInfo
         * @static
         * @param {busable.IRouteInfo} message RouteInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RouteInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.routeId != null && Object.hasOwnProperty.call(message, "routeId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.routeId);
            if (message.routeNumber != null && Object.hasOwnProperty.call(message, "routeNumber"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.routeNumber);
            if (message.routeName != null && Object.hasOwnProperty.call(message, "routeName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.routeName);
            if (message.services != null && Object.hasOwnProperty.call(message, "services"))
                for (var keys = Object.keys(message.services), i = 0; i < keys.length; ++i) {
                    writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                    $root.busable.ServiceAtStop.encode(message.services[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                }
            if (message.minSequence != null && Object.hasOwnProperty.call(message, "minSequence"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.minSequence);
            if (message.maxSequence != null && Object.hasOwnProperty.call(message, "maxSequence"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.maxSequence);
            return writer;
        };

        /**
         * Encodes the specified RouteInfo message, length delimited. Does not implicitly {@link busable.RouteInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.RouteInfo
         * @static
         * @param {busable.IRouteInfo} message RouteInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RouteInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RouteInfo message from the specified reader or buffer.
         * @function decode
         * @memberof busable.RouteInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.RouteInfo} RouteInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RouteInfo.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.RouteInfo(), key, value;
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.routeId = reader.string();
                        break;
                    }
                case 2: {
                        message.routeNumber = reader.string();
                        break;
                    }
                case 3: {
                        message.routeName = reader.string();
                        break;
                    }
                case 4: {
                        if (message.services === $util.emptyObject)
                            message.services = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = null;
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = $root.busable.ServiceAtStop.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.services[key] = value;
                        break;
                    }
                case 5: {
                        message.minSequence = reader.int32();
                        break;
                    }
                case 6: {
                        message.maxSequence = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RouteInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.RouteInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.RouteInfo} RouteInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RouteInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RouteInfo message.
         * @function verify
         * @memberof busable.RouteInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RouteInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                if (!$util.isString(message.routeId))
                    return "routeId: string expected";
            if (message.routeNumber != null && message.hasOwnProperty("routeNumber"))
                if (!$util.isString(message.routeNumber))
                    return "routeNumber: string expected";
            if (message.routeName != null && message.hasOwnProperty("routeName"))
                if (!$util.isString(message.routeName))
                    return "routeName: string expected";
            if (message.services != null && message.hasOwnProperty("services")) {
                if (!$util.isObject(message.services))
                    return "services: object expected";
                var key = Object.keys(message.services);
                for (var i = 0; i < key.length; ++i) {
                    var error = $root.busable.ServiceAtStop.verify(message.services[key[i]]);
                    if (error)
                        return "services." + error;
                }
            }
            if (message.minSequence != null && message.hasOwnProperty("minSequence"))
                if (!$util.isInteger(message.minSequence))
                    return "minSequence: integer expected";
            if (message.maxSequence != null && message.hasOwnProperty("maxSequence"))
                if (!$util.isInteger(message.maxSequence))
                    return "maxSequence: integer expected";
            return null;
        };

        /**
         * Creates a RouteInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.RouteInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.RouteInfo} RouteInfo
         */
        RouteInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.RouteInfo)
                return object;
            var message = new $root.busable.RouteInfo();
            if (object.routeId != null)
                message.routeId = String(object.routeId);
            if (object.routeNumber != null)
                message.routeNumber = String(object.routeNumber);
            if (object.routeName != null)
                message.routeName = String(object.routeName);
            if (object.services) {
                if (typeof object.services !== "object")
                    throw TypeError(".busable.RouteInfo.services: object expected");
                message.services = {};
                for (var keys = Object.keys(object.services), i = 0; i < keys.length; ++i) {
                    if (typeof object.services[keys[i]] !== "object")
                        throw TypeError(".busable.RouteInfo.services: object expected");
                    message.services[keys[i]] = $root.busable.ServiceAtStop.fromObject(object.services[keys[i]]);
                }
            }
            if (object.minSequence != null)
                message.minSequence = object.minSequence | 0;
            if (object.maxSequence != null)
                message.maxSequence = object.maxSequence | 0;
            return message;
        };

        /**
         * Creates a plain object from a RouteInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.RouteInfo
         * @static
         * @param {busable.RouteInfo} message RouteInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RouteInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.services = {};
            if (options.defaults) {
                object.routeId = "";
                object.routeNumber = "";
                object.routeName = "";
                object.minSequence = 0;
                object.maxSequence = 0;
            }
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                object.routeId = message.routeId;
            if (message.routeNumber != null && message.hasOwnProperty("routeNumber"))
                object.routeNumber = message.routeNumber;
            if (message.routeName != null && message.hasOwnProperty("routeName"))
                object.routeName = message.routeName;
            var keys2;
            if (message.services && (keys2 = Object.keys(message.services)).length) {
                object.services = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.services[keys2[j]] = $root.busable.ServiceAtStop.toObject(message.services[keys2[j]], options);
            }
            if (message.minSequence != null && message.hasOwnProperty("minSequence"))
                object.minSequence = message.minSequence;
            if (message.maxSequence != null && message.hasOwnProperty("maxSequence"))
                object.maxSequence = message.maxSequence;
            return object;
        };

        /**
         * Converts this RouteInfo to JSON.
         * @function toJSON
         * @memberof busable.RouteInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RouteInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RouteInfo
         * @function getTypeUrl
         * @memberof busable.RouteInfo
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RouteInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.RouteInfo";
        };

        return RouteInfo;
    })();

    busable.ServiceAtStop = (function() {

        /**
         * Properties of a ServiceAtStop.
         * @memberof busable
         * @interface IServiceAtStop
         * @property {string|null} [tripId] ServiceAtStop tripId
         * @property {string|null} [routeId] ServiceAtStop routeId
         * @property {Array.<string>|null} [scheduleIds] ServiceAtStop scheduleIds
         * @property {Array.<busable.IPassingTime>|null} [passingTimes] ServiceAtStop passingTimes
         */

        /**
         * Constructs a new ServiceAtStop.
         * @memberof busable
         * @classdesc Represents a ServiceAtStop.
         * @implements IServiceAtStop
         * @constructor
         * @param {busable.IServiceAtStop=} [properties] Properties to set
         */
        function ServiceAtStop(properties) {
            this.scheduleIds = [];
            this.passingTimes = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ServiceAtStop tripId.
         * @member {string} tripId
         * @memberof busable.ServiceAtStop
         * @instance
         */
        ServiceAtStop.prototype.tripId = "";

        /**
         * ServiceAtStop routeId.
         * @member {string} routeId
         * @memberof busable.ServiceAtStop
         * @instance
         */
        ServiceAtStop.prototype.routeId = "";

        /**
         * ServiceAtStop scheduleIds.
         * @member {Array.<string>} scheduleIds
         * @memberof busable.ServiceAtStop
         * @instance
         */
        ServiceAtStop.prototype.scheduleIds = $util.emptyArray;

        /**
         * ServiceAtStop passingTimes.
         * @member {Array.<busable.IPassingTime>} passingTimes
         * @memberof busable.ServiceAtStop
         * @instance
         */
        ServiceAtStop.prototype.passingTimes = $util.emptyArray;

        /**
         * Creates a new ServiceAtStop instance using the specified properties.
         * @function create
         * @memberof busable.ServiceAtStop
         * @static
         * @param {busable.IServiceAtStop=} [properties] Properties to set
         * @returns {busable.ServiceAtStop} ServiceAtStop instance
         */
        ServiceAtStop.create = function create(properties) {
            return new ServiceAtStop(properties);
        };

        /**
         * Encodes the specified ServiceAtStop message. Does not implicitly {@link busable.ServiceAtStop.verify|verify} messages.
         * @function encode
         * @memberof busable.ServiceAtStop
         * @static
         * @param {busable.IServiceAtStop} message ServiceAtStop message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServiceAtStop.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.tripId != null && Object.hasOwnProperty.call(message, "tripId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.tripId);
            if (message.routeId != null && Object.hasOwnProperty.call(message, "routeId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.routeId);
            if (message.scheduleIds != null && message.scheduleIds.length)
                for (var i = 0; i < message.scheduleIds.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.scheduleIds[i]);
            if (message.passingTimes != null && message.passingTimes.length)
                for (var i = 0; i < message.passingTimes.length; ++i)
                    $root.busable.PassingTime.encode(message.passingTimes[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ServiceAtStop message, length delimited. Does not implicitly {@link busable.ServiceAtStop.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.ServiceAtStop
         * @static
         * @param {busable.IServiceAtStop} message ServiceAtStop message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServiceAtStop.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ServiceAtStop message from the specified reader or buffer.
         * @function decode
         * @memberof busable.ServiceAtStop
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.ServiceAtStop} ServiceAtStop
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServiceAtStop.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.ServiceAtStop();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.tripId = reader.string();
                        break;
                    }
                case 2: {
                        message.routeId = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.scheduleIds && message.scheduleIds.length))
                            message.scheduleIds = [];
                        message.scheduleIds.push(reader.string());
                        break;
                    }
                case 4: {
                        if (!(message.passingTimes && message.passingTimes.length))
                            message.passingTimes = [];
                        message.passingTimes.push($root.busable.PassingTime.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ServiceAtStop message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.ServiceAtStop
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.ServiceAtStop} ServiceAtStop
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServiceAtStop.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ServiceAtStop message.
         * @function verify
         * @memberof busable.ServiceAtStop
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ServiceAtStop.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.tripId != null && message.hasOwnProperty("tripId"))
                if (!$util.isString(message.tripId))
                    return "tripId: string expected";
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                if (!$util.isString(message.routeId))
                    return "routeId: string expected";
            if (message.scheduleIds != null && message.hasOwnProperty("scheduleIds")) {
                if (!Array.isArray(message.scheduleIds))
                    return "scheduleIds: array expected";
                for (var i = 0; i < message.scheduleIds.length; ++i)
                    if (!$util.isString(message.scheduleIds[i]))
                        return "scheduleIds: string[] expected";
            }
            if (message.passingTimes != null && message.hasOwnProperty("passingTimes")) {
                if (!Array.isArray(message.passingTimes))
                    return "passingTimes: array expected";
                for (var i = 0; i < message.passingTimes.length; ++i) {
                    var error = $root.busable.PassingTime.verify(message.passingTimes[i]);
                    if (error)
                        return "passingTimes." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ServiceAtStop message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.ServiceAtStop
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.ServiceAtStop} ServiceAtStop
         */
        ServiceAtStop.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.ServiceAtStop)
                return object;
            var message = new $root.busable.ServiceAtStop();
            if (object.tripId != null)
                message.tripId = String(object.tripId);
            if (object.routeId != null)
                message.routeId = String(object.routeId);
            if (object.scheduleIds) {
                if (!Array.isArray(object.scheduleIds))
                    throw TypeError(".busable.ServiceAtStop.scheduleIds: array expected");
                message.scheduleIds = [];
                for (var i = 0; i < object.scheduleIds.length; ++i)
                    message.scheduleIds[i] = String(object.scheduleIds[i]);
            }
            if (object.passingTimes) {
                if (!Array.isArray(object.passingTimes))
                    throw TypeError(".busable.ServiceAtStop.passingTimes: array expected");
                message.passingTimes = [];
                for (var i = 0; i < object.passingTimes.length; ++i) {
                    if (typeof object.passingTimes[i] !== "object")
                        throw TypeError(".busable.ServiceAtStop.passingTimes: object expected");
                    message.passingTimes[i] = $root.busable.PassingTime.fromObject(object.passingTimes[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ServiceAtStop message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.ServiceAtStop
         * @static
         * @param {busable.ServiceAtStop} message ServiceAtStop
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServiceAtStop.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.scheduleIds = [];
                object.passingTimes = [];
            }
            if (options.defaults) {
                object.tripId = "";
                object.routeId = "";
            }
            if (message.tripId != null && message.hasOwnProperty("tripId"))
                object.tripId = message.tripId;
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                object.routeId = message.routeId;
            if (message.scheduleIds && message.scheduleIds.length) {
                object.scheduleIds = [];
                for (var j = 0; j < message.scheduleIds.length; ++j)
                    object.scheduleIds[j] = message.scheduleIds[j];
            }
            if (message.passingTimes && message.passingTimes.length) {
                object.passingTimes = [];
                for (var j = 0; j < message.passingTimes.length; ++j)
                    object.passingTimes[j] = $root.busable.PassingTime.toObject(message.passingTimes[j], options);
            }
            return object;
        };

        /**
         * Converts this ServiceAtStop to JSON.
         * @function toJSON
         * @memberof busable.ServiceAtStop
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ServiceAtStop.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ServiceAtStop
         * @function getTypeUrl
         * @memberof busable.ServiceAtStop
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ServiceAtStop.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.ServiceAtStop";
        };

        return ServiceAtStop;
    })();

    busable.PassingTime = (function() {

        /**
         * Properties of a PassingTime.
         * @memberof busable
         * @interface IPassingTime
         * @property {number|null} [arriveSecs] PassingTime arriveSecs
         * @property {number|null} [departSecs] PassingTime departSecs
         * @property {string|null} [stopTimeId] PassingTime stopTimeId
         * @property {string|null} [stopId] PassingTime stopId
         */

        /**
         * Constructs a new PassingTime.
         * @memberof busable
         * @classdesc Represents a PassingTime.
         * @implements IPassingTime
         * @constructor
         * @param {busable.IPassingTime=} [properties] Properties to set
         */
        function PassingTime(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PassingTime arriveSecs.
         * @member {number} arriveSecs
         * @memberof busable.PassingTime
         * @instance
         */
        PassingTime.prototype.arriveSecs = 0;

        /**
         * PassingTime departSecs.
         * @member {number} departSecs
         * @memberof busable.PassingTime
         * @instance
         */
        PassingTime.prototype.departSecs = 0;

        /**
         * PassingTime stopTimeId.
         * @member {string} stopTimeId
         * @memberof busable.PassingTime
         * @instance
         */
        PassingTime.prototype.stopTimeId = "";

        /**
         * PassingTime stopId.
         * @member {string} stopId
         * @memberof busable.PassingTime
         * @instance
         */
        PassingTime.prototype.stopId = "";

        /**
         * Creates a new PassingTime instance using the specified properties.
         * @function create
         * @memberof busable.PassingTime
         * @static
         * @param {busable.IPassingTime=} [properties] Properties to set
         * @returns {busable.PassingTime} PassingTime instance
         */
        PassingTime.create = function create(properties) {
            return new PassingTime(properties);
        };

        /**
         * Encodes the specified PassingTime message. Does not implicitly {@link busable.PassingTime.verify|verify} messages.
         * @function encode
         * @memberof busable.PassingTime
         * @static
         * @param {busable.IPassingTime} message PassingTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PassingTime.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.arriveSecs != null && Object.hasOwnProperty.call(message, "arriveSecs"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.arriveSecs);
            if (message.departSecs != null && Object.hasOwnProperty.call(message, "departSecs"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.departSecs);
            if (message.stopTimeId != null && Object.hasOwnProperty.call(message, "stopTimeId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.stopTimeId);
            if (message.stopId != null && Object.hasOwnProperty.call(message, "stopId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.stopId);
            return writer;
        };

        /**
         * Encodes the specified PassingTime message, length delimited. Does not implicitly {@link busable.PassingTime.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.PassingTime
         * @static
         * @param {busable.IPassingTime} message PassingTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PassingTime.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PassingTime message from the specified reader or buffer.
         * @function decode
         * @memberof busable.PassingTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.PassingTime} PassingTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PassingTime.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.PassingTime();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.arriveSecs = reader.int32();
                        break;
                    }
                case 2: {
                        message.departSecs = reader.int32();
                        break;
                    }
                case 3: {
                        message.stopTimeId = reader.string();
                        break;
                    }
                case 4: {
                        message.stopId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PassingTime message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.PassingTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.PassingTime} PassingTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PassingTime.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PassingTime message.
         * @function verify
         * @memberof busable.PassingTime
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PassingTime.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.arriveSecs != null && message.hasOwnProperty("arriveSecs"))
                if (!$util.isInteger(message.arriveSecs))
                    return "arriveSecs: integer expected";
            if (message.departSecs != null && message.hasOwnProperty("departSecs"))
                if (!$util.isInteger(message.departSecs))
                    return "departSecs: integer expected";
            if (message.stopTimeId != null && message.hasOwnProperty("stopTimeId"))
                if (!$util.isString(message.stopTimeId))
                    return "stopTimeId: string expected";
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                if (!$util.isString(message.stopId))
                    return "stopId: string expected";
            return null;
        };

        /**
         * Creates a PassingTime message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.PassingTime
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.PassingTime} PassingTime
         */
        PassingTime.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.PassingTime)
                return object;
            var message = new $root.busable.PassingTime();
            if (object.arriveSecs != null)
                message.arriveSecs = object.arriveSecs | 0;
            if (object.departSecs != null)
                message.departSecs = object.departSecs | 0;
            if (object.stopTimeId != null)
                message.stopTimeId = String(object.stopTimeId);
            if (object.stopId != null)
                message.stopId = String(object.stopId);
            return message;
        };

        /**
         * Creates a plain object from a PassingTime message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.PassingTime
         * @static
         * @param {busable.PassingTime} message PassingTime
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PassingTime.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.arriveSecs = 0;
                object.departSecs = 0;
                object.stopTimeId = "";
                object.stopId = "";
            }
            if (message.arriveSecs != null && message.hasOwnProperty("arriveSecs"))
                object.arriveSecs = message.arriveSecs;
            if (message.departSecs != null && message.hasOwnProperty("departSecs"))
                object.departSecs = message.departSecs;
            if (message.stopTimeId != null && message.hasOwnProperty("stopTimeId"))
                object.stopTimeId = message.stopTimeId;
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                object.stopId = message.stopId;
            return object;
        };

        /**
         * Converts this PassingTime to JSON.
         * @function toJSON
         * @memberof busable.PassingTime
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PassingTime.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for PassingTime
         * @function getTypeUrl
         * @memberof busable.PassingTime
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        PassingTime.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.PassingTime";
        };

        return PassingTime;
    })();

    busable.Stop = (function() {

        /**
         * Properties of a Stop.
         * @memberof busable
         * @interface IStop
         * @property {number|null} [lat] Stop lat
         * @property {number|null} [lon] Stop lon
         * @property {string|null} [stopId] Stop stopId
         * @property {string|null} [stopName] Stop stopName
         * @property {string|null} [stopDesc] Stop stopDesc
         * @property {string|null} [stopType] Stop stopType
         * @property {string|null} [stopCode] Stop stopCode
         * @property {Array.<busable.ILinkedStop>|null} [linkedStops] Stop linkedStops
         * @property {boolean|null} [imported] Stop imported
         * @property {string|null} [authorityId] Stop authorityId
         * @property {boolean|null} [master] Stop master
         * @property {Array.<string>|null} [outOfSync] Stop outOfSync
         * @property {Array.<busable.IRouteInfo>|null} [routes] Stop routes
         * @property {number|null} [startBell] Stop startBell
         * @property {number|null} [startBellWindow] Stop startBellWindow
         * @property {number|null} [endBell] Stop endBell
         * @property {number|null} [endBellWindow] Stop endBellWindow
         * @property {number|null} [transferWindow] Stop transferWindow
         * @property {number|null} [verified] Stop verified
         * @property {number|null} [radius] Stop radius
         */

        /**
         * Constructs a new Stop.
         * @memberof busable
         * @classdesc Represents a Stop.
         * @implements IStop
         * @constructor
         * @param {busable.IStop=} [properties] Properties to set
         */
        function Stop(properties) {
            this.linkedStops = [];
            this.outOfSync = [];
            this.routes = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Stop lat.
         * @member {number} lat
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.lat = 0;

        /**
         * Stop lon.
         * @member {number} lon
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.lon = 0;

        /**
         * Stop stopId.
         * @member {string} stopId
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.stopId = "";

        /**
         * Stop stopName.
         * @member {string} stopName
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.stopName = "";

        /**
         * Stop stopDesc.
         * @member {string} stopDesc
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.stopDesc = "";

        /**
         * Stop stopType.
         * @member {string} stopType
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.stopType = "";

        /**
         * Stop stopCode.
         * @member {string} stopCode
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.stopCode = "";

        /**
         * Stop linkedStops.
         * @member {Array.<busable.ILinkedStop>} linkedStops
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.linkedStops = $util.emptyArray;

        /**
         * Stop imported.
         * @member {boolean} imported
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.imported = false;

        /**
         * Stop authorityId.
         * @member {string} authorityId
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.authorityId = "";

        /**
         * Stop master.
         * @member {boolean} master
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.master = false;

        /**
         * Stop outOfSync.
         * @member {Array.<string>} outOfSync
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.outOfSync = $util.emptyArray;

        /**
         * Stop routes.
         * @member {Array.<busable.IRouteInfo>} routes
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.routes = $util.emptyArray;

        /**
         * Stop startBell.
         * @member {number} startBell
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.startBell = 0;

        /**
         * Stop startBellWindow.
         * @member {number} startBellWindow
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.startBellWindow = 0;

        /**
         * Stop endBell.
         * @member {number} endBell
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.endBell = 0;

        /**
         * Stop endBellWindow.
         * @member {number} endBellWindow
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.endBellWindow = 0;

        /**
         * Stop transferWindow.
         * @member {number} transferWindow
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.transferWindow = 0;

        /**
         * Stop verified.
         * @member {number} verified
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.verified = 0;

        /**
         * Stop radius.
         * @member {number} radius
         * @memberof busable.Stop
         * @instance
         */
        Stop.prototype.radius = 0;

        /**
         * Creates a new Stop instance using the specified properties.
         * @function create
         * @memberof busable.Stop
         * @static
         * @param {busable.IStop=} [properties] Properties to set
         * @returns {busable.Stop} Stop instance
         */
        Stop.create = function create(properties) {
            return new Stop(properties);
        };

        /**
         * Encodes the specified Stop message. Does not implicitly {@link busable.Stop.verify|verify} messages.
         * @function encode
         * @memberof busable.Stop
         * @static
         * @param {busable.IStop} message Stop message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Stop.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.lat);
            if (message.lon != null && Object.hasOwnProperty.call(message, "lon"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.lon);
            if (message.stopId != null && Object.hasOwnProperty.call(message, "stopId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.stopId);
            if (message.stopName != null && Object.hasOwnProperty.call(message, "stopName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.stopName);
            if (message.stopDesc != null && Object.hasOwnProperty.call(message, "stopDesc"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.stopDesc);
            if (message.stopType != null && Object.hasOwnProperty.call(message, "stopType"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.stopType);
            if (message.stopCode != null && Object.hasOwnProperty.call(message, "stopCode"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.stopCode);
            if (message.linkedStops != null && message.linkedStops.length)
                for (var i = 0; i < message.linkedStops.length; ++i)
                    $root.busable.LinkedStop.encode(message.linkedStops[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.imported != null && Object.hasOwnProperty.call(message, "imported"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.imported);
            if (message.authorityId != null && Object.hasOwnProperty.call(message, "authorityId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.authorityId);
            if (message.master != null && Object.hasOwnProperty.call(message, "master"))
                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.master);
            if (message.outOfSync != null && message.outOfSync.length)
                for (var i = 0; i < message.outOfSync.length; ++i)
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.outOfSync[i]);
            if (message.routes != null && message.routes.length)
                for (var i = 0; i < message.routes.length; ++i)
                    $root.busable.RouteInfo.encode(message.routes[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.startBell != null && Object.hasOwnProperty.call(message, "startBell"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.startBell);
            if (message.startBellWindow != null && Object.hasOwnProperty.call(message, "startBellWindow"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.startBellWindow);
            if (message.endBell != null && Object.hasOwnProperty.call(message, "endBell"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.endBell);
            if (message.endBellWindow != null && Object.hasOwnProperty.call(message, "endBellWindow"))
                writer.uint32(/* id 17, wireType 0 =*/136).int32(message.endBellWindow);
            if (message.transferWindow != null && Object.hasOwnProperty.call(message, "transferWindow"))
                writer.uint32(/* id 18, wireType 0 =*/144).int32(message.transferWindow);
            if (message.verified != null && Object.hasOwnProperty.call(message, "verified"))
                writer.uint32(/* id 19, wireType 0 =*/152).int32(message.verified);
            if (message.radius != null && Object.hasOwnProperty.call(message, "radius"))
                writer.uint32(/* id 20, wireType 0 =*/160).int32(message.radius);
            return writer;
        };

        /**
         * Encodes the specified Stop message, length delimited. Does not implicitly {@link busable.Stop.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Stop
         * @static
         * @param {busable.IStop} message Stop message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Stop.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Stop message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Stop
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Stop} Stop
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Stop.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Stop();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lat = reader.double();
                        break;
                    }
                case 2: {
                        message.lon = reader.double();
                        break;
                    }
                case 3: {
                        message.stopId = reader.string();
                        break;
                    }
                case 4: {
                        message.stopName = reader.string();
                        break;
                    }
                case 5: {
                        message.stopDesc = reader.string();
                        break;
                    }
                case 6: {
                        message.stopType = reader.string();
                        break;
                    }
                case 7: {
                        message.stopCode = reader.string();
                        break;
                    }
                case 8: {
                        if (!(message.linkedStops && message.linkedStops.length))
                            message.linkedStops = [];
                        message.linkedStops.push($root.busable.LinkedStop.decode(reader, reader.uint32()));
                        break;
                    }
                case 9: {
                        message.imported = reader.bool();
                        break;
                    }
                case 10: {
                        message.authorityId = reader.string();
                        break;
                    }
                case 11: {
                        message.master = reader.bool();
                        break;
                    }
                case 12: {
                        if (!(message.outOfSync && message.outOfSync.length))
                            message.outOfSync = [];
                        message.outOfSync.push(reader.string());
                        break;
                    }
                case 13: {
                        if (!(message.routes && message.routes.length))
                            message.routes = [];
                        message.routes.push($root.busable.RouteInfo.decode(reader, reader.uint32()));
                        break;
                    }
                case 14: {
                        message.startBell = reader.int32();
                        break;
                    }
                case 15: {
                        message.startBellWindow = reader.int32();
                        break;
                    }
                case 16: {
                        message.endBell = reader.int32();
                        break;
                    }
                case 17: {
                        message.endBellWindow = reader.int32();
                        break;
                    }
                case 18: {
                        message.transferWindow = reader.int32();
                        break;
                    }
                case 19: {
                        message.verified = reader.int32();
                        break;
                    }
                case 20: {
                        message.radius = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Stop message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Stop
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Stop} Stop
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Stop.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Stop message.
         * @function verify
         * @memberof busable.Stop
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Stop.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lat != null && message.hasOwnProperty("lat"))
                if (typeof message.lat !== "number")
                    return "lat: number expected";
            if (message.lon != null && message.hasOwnProperty("lon"))
                if (typeof message.lon !== "number")
                    return "lon: number expected";
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                if (!$util.isString(message.stopId))
                    return "stopId: string expected";
            if (message.stopName != null && message.hasOwnProperty("stopName"))
                if (!$util.isString(message.stopName))
                    return "stopName: string expected";
            if (message.stopDesc != null && message.hasOwnProperty("stopDesc"))
                if (!$util.isString(message.stopDesc))
                    return "stopDesc: string expected";
            if (message.stopType != null && message.hasOwnProperty("stopType"))
                if (!$util.isString(message.stopType))
                    return "stopType: string expected";
            if (message.stopCode != null && message.hasOwnProperty("stopCode"))
                if (!$util.isString(message.stopCode))
                    return "stopCode: string expected";
            if (message.linkedStops != null && message.hasOwnProperty("linkedStops")) {
                if (!Array.isArray(message.linkedStops))
                    return "linkedStops: array expected";
                for (var i = 0; i < message.linkedStops.length; ++i) {
                    var error = $root.busable.LinkedStop.verify(message.linkedStops[i]);
                    if (error)
                        return "linkedStops." + error;
                }
            }
            if (message.imported != null && message.hasOwnProperty("imported"))
                if (typeof message.imported !== "boolean")
                    return "imported: boolean expected";
            if (message.authorityId != null && message.hasOwnProperty("authorityId"))
                if (!$util.isString(message.authorityId))
                    return "authorityId: string expected";
            if (message.master != null && message.hasOwnProperty("master"))
                if (typeof message.master !== "boolean")
                    return "master: boolean expected";
            if (message.outOfSync != null && message.hasOwnProperty("outOfSync")) {
                if (!Array.isArray(message.outOfSync))
                    return "outOfSync: array expected";
                for (var i = 0; i < message.outOfSync.length; ++i)
                    if (!$util.isString(message.outOfSync[i]))
                        return "outOfSync: string[] expected";
            }
            if (message.routes != null && message.hasOwnProperty("routes")) {
                if (!Array.isArray(message.routes))
                    return "routes: array expected";
                for (var i = 0; i < message.routes.length; ++i) {
                    var error = $root.busable.RouteInfo.verify(message.routes[i]);
                    if (error)
                        return "routes." + error;
                }
            }
            if (message.startBell != null && message.hasOwnProperty("startBell"))
                if (!$util.isInteger(message.startBell))
                    return "startBell: integer expected";
            if (message.startBellWindow != null && message.hasOwnProperty("startBellWindow"))
                if (!$util.isInteger(message.startBellWindow))
                    return "startBellWindow: integer expected";
            if (message.endBell != null && message.hasOwnProperty("endBell"))
                if (!$util.isInteger(message.endBell))
                    return "endBell: integer expected";
            if (message.endBellWindow != null && message.hasOwnProperty("endBellWindow"))
                if (!$util.isInteger(message.endBellWindow))
                    return "endBellWindow: integer expected";
            if (message.transferWindow != null && message.hasOwnProperty("transferWindow"))
                if (!$util.isInteger(message.transferWindow))
                    return "transferWindow: integer expected";
            if (message.verified != null && message.hasOwnProperty("verified"))
                if (!$util.isInteger(message.verified))
                    return "verified: integer expected";
            if (message.radius != null && message.hasOwnProperty("radius"))
                if (!$util.isInteger(message.radius))
                    return "radius: integer expected";
            return null;
        };

        /**
         * Creates a Stop message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Stop
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Stop} Stop
         */
        Stop.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Stop)
                return object;
            var message = new $root.busable.Stop();
            if (object.lat != null)
                message.lat = Number(object.lat);
            if (object.lon != null)
                message.lon = Number(object.lon);
            if (object.stopId != null)
                message.stopId = String(object.stopId);
            if (object.stopName != null)
                message.stopName = String(object.stopName);
            if (object.stopDesc != null)
                message.stopDesc = String(object.stopDesc);
            if (object.stopType != null)
                message.stopType = String(object.stopType);
            if (object.stopCode != null)
                message.stopCode = String(object.stopCode);
            if (object.linkedStops) {
                if (!Array.isArray(object.linkedStops))
                    throw TypeError(".busable.Stop.linkedStops: array expected");
                message.linkedStops = [];
                for (var i = 0; i < object.linkedStops.length; ++i) {
                    if (typeof object.linkedStops[i] !== "object")
                        throw TypeError(".busable.Stop.linkedStops: object expected");
                    message.linkedStops[i] = $root.busable.LinkedStop.fromObject(object.linkedStops[i]);
                }
            }
            if (object.imported != null)
                message.imported = Boolean(object.imported);
            if (object.authorityId != null)
                message.authorityId = String(object.authorityId);
            if (object.master != null)
                message.master = Boolean(object.master);
            if (object.outOfSync) {
                if (!Array.isArray(object.outOfSync))
                    throw TypeError(".busable.Stop.outOfSync: array expected");
                message.outOfSync = [];
                for (var i = 0; i < object.outOfSync.length; ++i)
                    message.outOfSync[i] = String(object.outOfSync[i]);
            }
            if (object.routes) {
                if (!Array.isArray(object.routes))
                    throw TypeError(".busable.Stop.routes: array expected");
                message.routes = [];
                for (var i = 0; i < object.routes.length; ++i) {
                    if (typeof object.routes[i] !== "object")
                        throw TypeError(".busable.Stop.routes: object expected");
                    message.routes[i] = $root.busable.RouteInfo.fromObject(object.routes[i]);
                }
            }
            if (object.startBell != null)
                message.startBell = object.startBell | 0;
            if (object.startBellWindow != null)
                message.startBellWindow = object.startBellWindow | 0;
            if (object.endBell != null)
                message.endBell = object.endBell | 0;
            if (object.endBellWindow != null)
                message.endBellWindow = object.endBellWindow | 0;
            if (object.transferWindow != null)
                message.transferWindow = object.transferWindow | 0;
            if (object.verified != null)
                message.verified = object.verified | 0;
            if (object.radius != null)
                message.radius = object.radius | 0;
            return message;
        };

        /**
         * Creates a plain object from a Stop message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Stop
         * @static
         * @param {busable.Stop} message Stop
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Stop.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.linkedStops = [];
                object.outOfSync = [];
                object.routes = [];
            }
            if (options.defaults) {
                object.lat = 0;
                object.lon = 0;
                object.stopId = "";
                object.stopName = "";
                object.stopDesc = "";
                object.stopType = "";
                object.stopCode = "";
                object.imported = false;
                object.authorityId = "";
                object.master = false;
                object.startBell = 0;
                object.startBellWindow = 0;
                object.endBell = 0;
                object.endBellWindow = 0;
                object.transferWindow = 0;
                object.verified = 0;
                object.radius = 0;
            }
            if (message.lat != null && message.hasOwnProperty("lat"))
                object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
            if (message.lon != null && message.hasOwnProperty("lon"))
                object.lon = options.json && !isFinite(message.lon) ? String(message.lon) : message.lon;
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                object.stopId = message.stopId;
            if (message.stopName != null && message.hasOwnProperty("stopName"))
                object.stopName = message.stopName;
            if (message.stopDesc != null && message.hasOwnProperty("stopDesc"))
                object.stopDesc = message.stopDesc;
            if (message.stopType != null && message.hasOwnProperty("stopType"))
                object.stopType = message.stopType;
            if (message.stopCode != null && message.hasOwnProperty("stopCode"))
                object.stopCode = message.stopCode;
            if (message.linkedStops && message.linkedStops.length) {
                object.linkedStops = [];
                for (var j = 0; j < message.linkedStops.length; ++j)
                    object.linkedStops[j] = $root.busable.LinkedStop.toObject(message.linkedStops[j], options);
            }
            if (message.imported != null && message.hasOwnProperty("imported"))
                object.imported = message.imported;
            if (message.authorityId != null && message.hasOwnProperty("authorityId"))
                object.authorityId = message.authorityId;
            if (message.master != null && message.hasOwnProperty("master"))
                object.master = message.master;
            if (message.outOfSync && message.outOfSync.length) {
                object.outOfSync = [];
                for (var j = 0; j < message.outOfSync.length; ++j)
                    object.outOfSync[j] = message.outOfSync[j];
            }
            if (message.routes && message.routes.length) {
                object.routes = [];
                for (var j = 0; j < message.routes.length; ++j)
                    object.routes[j] = $root.busable.RouteInfo.toObject(message.routes[j], options);
            }
            if (message.startBell != null && message.hasOwnProperty("startBell"))
                object.startBell = message.startBell;
            if (message.startBellWindow != null && message.hasOwnProperty("startBellWindow"))
                object.startBellWindow = message.startBellWindow;
            if (message.endBell != null && message.hasOwnProperty("endBell"))
                object.endBell = message.endBell;
            if (message.endBellWindow != null && message.hasOwnProperty("endBellWindow"))
                object.endBellWindow = message.endBellWindow;
            if (message.transferWindow != null && message.hasOwnProperty("transferWindow"))
                object.transferWindow = message.transferWindow;
            if (message.verified != null && message.hasOwnProperty("verified"))
                object.verified = message.verified;
            if (message.radius != null && message.hasOwnProperty("radius"))
                object.radius = message.radius;
            return object;
        };

        /**
         * Converts this Stop to JSON.
         * @function toJSON
         * @memberof busable.Stop
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Stop.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Stop
         * @function getTypeUrl
         * @memberof busable.Stop
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Stop.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Stop";
        };

        return Stop;
    })();

    busable.StopTime = (function() {

        /**
         * Properties of a StopTime.
         * @memberof busable
         * @interface IStopTime
         * @property {string|null} [stopId] StopTime stopId
         * @property {string|null} [stopTimeId] StopTime stopTimeId
         * @property {boolean|null} [timingPoint] StopTime timingPoint
         * @property {number|null} [arriveSecs] StopTime arriveSecs
         * @property {number|null} [departSecs] StopTime departSecs
         * @property {number|null} [stopSequence] StopTime stopSequence
         * @property {number|null} [wpIdx] StopTime wpIdx
         * @property {Array.<string>|null} [transferToIds] StopTime transferToIds
         * @property {Array.<string>|null} [transferFromIds] StopTime transferFromIds
         * @property {number|null} [distance] StopTime distance
         */

        /**
         * Constructs a new StopTime.
         * @memberof busable
         * @classdesc Represents a StopTime.
         * @implements IStopTime
         * @constructor
         * @param {busable.IStopTime=} [properties] Properties to set
         */
        function StopTime(properties) {
            this.transferToIds = [];
            this.transferFromIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StopTime stopId.
         * @member {string} stopId
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.stopId = "";

        /**
         * StopTime stopTimeId.
         * @member {string} stopTimeId
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.stopTimeId = "";

        /**
         * StopTime timingPoint.
         * @member {boolean} timingPoint
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.timingPoint = false;

        /**
         * StopTime arriveSecs.
         * @member {number} arriveSecs
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.arriveSecs = 0;

        /**
         * StopTime departSecs.
         * @member {number} departSecs
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.departSecs = 0;

        /**
         * StopTime stopSequence.
         * @member {number} stopSequence
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.stopSequence = 0;

        /**
         * StopTime wpIdx.
         * @member {number} wpIdx
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.wpIdx = 0;

        /**
         * StopTime transferToIds.
         * @member {Array.<string>} transferToIds
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.transferToIds = $util.emptyArray;

        /**
         * StopTime transferFromIds.
         * @member {Array.<string>} transferFromIds
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.transferFromIds = $util.emptyArray;

        /**
         * StopTime distance.
         * @member {number} distance
         * @memberof busable.StopTime
         * @instance
         */
        StopTime.prototype.distance = 0;

        /**
         * Creates a new StopTime instance using the specified properties.
         * @function create
         * @memberof busable.StopTime
         * @static
         * @param {busable.IStopTime=} [properties] Properties to set
         * @returns {busable.StopTime} StopTime instance
         */
        StopTime.create = function create(properties) {
            return new StopTime(properties);
        };

        /**
         * Encodes the specified StopTime message. Does not implicitly {@link busable.StopTime.verify|verify} messages.
         * @function encode
         * @memberof busable.StopTime
         * @static
         * @param {busable.IStopTime} message StopTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StopTime.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.stopId != null && Object.hasOwnProperty.call(message, "stopId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.stopId);
            if (message.stopTimeId != null && Object.hasOwnProperty.call(message, "stopTimeId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.stopTimeId);
            if (message.timingPoint != null && Object.hasOwnProperty.call(message, "timingPoint"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.timingPoint);
            if (message.arriveSecs != null && Object.hasOwnProperty.call(message, "arriveSecs"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.arriveSecs);
            if (message.departSecs != null && Object.hasOwnProperty.call(message, "departSecs"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.departSecs);
            if (message.stopSequence != null && Object.hasOwnProperty.call(message, "stopSequence"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.stopSequence);
            if (message.wpIdx != null && Object.hasOwnProperty.call(message, "wpIdx"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.wpIdx);
            if (message.transferToIds != null && message.transferToIds.length)
                for (var i = 0; i < message.transferToIds.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.transferToIds[i]);
            if (message.transferFromIds != null && message.transferFromIds.length)
                for (var i = 0; i < message.transferFromIds.length; ++i)
                    writer.uint32(/* id 9, wireType 2 =*/74).string(message.transferFromIds[i]);
            if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.distance);
            return writer;
        };

        /**
         * Encodes the specified StopTime message, length delimited. Does not implicitly {@link busable.StopTime.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.StopTime
         * @static
         * @param {busable.IStopTime} message StopTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StopTime.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StopTime message from the specified reader or buffer.
         * @function decode
         * @memberof busable.StopTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.StopTime} StopTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StopTime.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.StopTime();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.stopId = reader.string();
                        break;
                    }
                case 2: {
                        message.stopTimeId = reader.string();
                        break;
                    }
                case 3: {
                        message.timingPoint = reader.bool();
                        break;
                    }
                case 4: {
                        message.arriveSecs = reader.int32();
                        break;
                    }
                case 5: {
                        message.departSecs = reader.int32();
                        break;
                    }
                case 6: {
                        message.stopSequence = reader.int32();
                        break;
                    }
                case 7: {
                        message.wpIdx = reader.int32();
                        break;
                    }
                case 8: {
                        if (!(message.transferToIds && message.transferToIds.length))
                            message.transferToIds = [];
                        message.transferToIds.push(reader.string());
                        break;
                    }
                case 9: {
                        if (!(message.transferFromIds && message.transferFromIds.length))
                            message.transferFromIds = [];
                        message.transferFromIds.push(reader.string());
                        break;
                    }
                case 10: {
                        message.distance = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StopTime message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.StopTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.StopTime} StopTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StopTime.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StopTime message.
         * @function verify
         * @memberof busable.StopTime
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StopTime.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                if (!$util.isString(message.stopId))
                    return "stopId: string expected";
            if (message.stopTimeId != null && message.hasOwnProperty("stopTimeId"))
                if (!$util.isString(message.stopTimeId))
                    return "stopTimeId: string expected";
            if (message.timingPoint != null && message.hasOwnProperty("timingPoint"))
                if (typeof message.timingPoint !== "boolean")
                    return "timingPoint: boolean expected";
            if (message.arriveSecs != null && message.hasOwnProperty("arriveSecs"))
                if (!$util.isInteger(message.arriveSecs))
                    return "arriveSecs: integer expected";
            if (message.departSecs != null && message.hasOwnProperty("departSecs"))
                if (!$util.isInteger(message.departSecs))
                    return "departSecs: integer expected";
            if (message.stopSequence != null && message.hasOwnProperty("stopSequence"))
                if (!$util.isInteger(message.stopSequence))
                    return "stopSequence: integer expected";
            if (message.wpIdx != null && message.hasOwnProperty("wpIdx"))
                if (!$util.isInteger(message.wpIdx))
                    return "wpIdx: integer expected";
            if (message.transferToIds != null && message.hasOwnProperty("transferToIds")) {
                if (!Array.isArray(message.transferToIds))
                    return "transferToIds: array expected";
                for (var i = 0; i < message.transferToIds.length; ++i)
                    if (!$util.isString(message.transferToIds[i]))
                        return "transferToIds: string[] expected";
            }
            if (message.transferFromIds != null && message.hasOwnProperty("transferFromIds")) {
                if (!Array.isArray(message.transferFromIds))
                    return "transferFromIds: array expected";
                for (var i = 0; i < message.transferFromIds.length; ++i)
                    if (!$util.isString(message.transferFromIds[i]))
                        return "transferFromIds: string[] expected";
            }
            if (message.distance != null && message.hasOwnProperty("distance"))
                if (!$util.isInteger(message.distance))
                    return "distance: integer expected";
            return null;
        };

        /**
         * Creates a StopTime message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.StopTime
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.StopTime} StopTime
         */
        StopTime.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.StopTime)
                return object;
            var message = new $root.busable.StopTime();
            if (object.stopId != null)
                message.stopId = String(object.stopId);
            if (object.stopTimeId != null)
                message.stopTimeId = String(object.stopTimeId);
            if (object.timingPoint != null)
                message.timingPoint = Boolean(object.timingPoint);
            if (object.arriveSecs != null)
                message.arriveSecs = object.arriveSecs | 0;
            if (object.departSecs != null)
                message.departSecs = object.departSecs | 0;
            if (object.stopSequence != null)
                message.stopSequence = object.stopSequence | 0;
            if (object.wpIdx != null)
                message.wpIdx = object.wpIdx | 0;
            if (object.transferToIds) {
                if (!Array.isArray(object.transferToIds))
                    throw TypeError(".busable.StopTime.transferToIds: array expected");
                message.transferToIds = [];
                for (var i = 0; i < object.transferToIds.length; ++i)
                    message.transferToIds[i] = String(object.transferToIds[i]);
            }
            if (object.transferFromIds) {
                if (!Array.isArray(object.transferFromIds))
                    throw TypeError(".busable.StopTime.transferFromIds: array expected");
                message.transferFromIds = [];
                for (var i = 0; i < object.transferFromIds.length; ++i)
                    message.transferFromIds[i] = String(object.transferFromIds[i]);
            }
            if (object.distance != null)
                message.distance = object.distance | 0;
            return message;
        };

        /**
         * Creates a plain object from a StopTime message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.StopTime
         * @static
         * @param {busable.StopTime} message StopTime
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StopTime.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.transferToIds = [];
                object.transferFromIds = [];
            }
            if (options.defaults) {
                object.stopId = "";
                object.stopTimeId = "";
                object.timingPoint = false;
                object.arriveSecs = 0;
                object.departSecs = 0;
                object.stopSequence = 0;
                object.wpIdx = 0;
                object.distance = 0;
            }
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                object.stopId = message.stopId;
            if (message.stopTimeId != null && message.hasOwnProperty("stopTimeId"))
                object.stopTimeId = message.stopTimeId;
            if (message.timingPoint != null && message.hasOwnProperty("timingPoint"))
                object.timingPoint = message.timingPoint;
            if (message.arriveSecs != null && message.hasOwnProperty("arriveSecs"))
                object.arriveSecs = message.arriveSecs;
            if (message.departSecs != null && message.hasOwnProperty("departSecs"))
                object.departSecs = message.departSecs;
            if (message.stopSequence != null && message.hasOwnProperty("stopSequence"))
                object.stopSequence = message.stopSequence;
            if (message.wpIdx != null && message.hasOwnProperty("wpIdx"))
                object.wpIdx = message.wpIdx;
            if (message.transferToIds && message.transferToIds.length) {
                object.transferToIds = [];
                for (var j = 0; j < message.transferToIds.length; ++j)
                    object.transferToIds[j] = message.transferToIds[j];
            }
            if (message.transferFromIds && message.transferFromIds.length) {
                object.transferFromIds = [];
                for (var j = 0; j < message.transferFromIds.length; ++j)
                    object.transferFromIds[j] = message.transferFromIds[j];
            }
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = message.distance;
            return object;
        };

        /**
         * Converts this StopTime to JSON.
         * @function toJSON
         * @memberof busable.StopTime
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StopTime.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for StopTime
         * @function getTypeUrl
         * @memberof busable.StopTime
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        StopTime.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.StopTime";
        };

        return StopTime;
    })();

    busable.Trip = (function() {

        /**
         * Properties of a Trip.
         * @memberof busable
         * @interface ITrip
         * @property {string|null} [tripId] Trip tripId
         * @property {string|null} [routeId] Trip routeId
         * @property {string|null} [routeType] Trip routeType
         * @property {Array.<busable.IStopTime>|null} [stopTimes] Trip stopTimes
         * @property {Array.<string>|null} [scheduleIds] Trip scheduleIds
         * @property {string|null} [date] Trip date
         * @property {Array.<string>|null} [dates] Trip dates
         * @property {string|null} [headsign] Trip headsign
         * @property {string|null} [transferAlias] Trip transferAlias
         * @property {boolean|null} [charter] Trip charter
         * @property {number|null} [startTime] Trip startTime
         * @property {number|null} [duration] Trip duration
         */

        /**
         * Constructs a new Trip.
         * @memberof busable
         * @classdesc Represents a Trip.
         * @implements ITrip
         * @constructor
         * @param {busable.ITrip=} [properties] Properties to set
         */
        function Trip(properties) {
            this.stopTimes = [];
            this.scheduleIds = [];
            this.dates = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Trip tripId.
         * @member {string} tripId
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.tripId = "";

        /**
         * Trip routeId.
         * @member {string} routeId
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.routeId = "";

        /**
         * Trip routeType.
         * @member {string} routeType
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.routeType = "";

        /**
         * Trip stopTimes.
         * @member {Array.<busable.IStopTime>} stopTimes
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.stopTimes = $util.emptyArray;

        /**
         * Trip scheduleIds.
         * @member {Array.<string>} scheduleIds
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.scheduleIds = $util.emptyArray;

        /**
         * Trip date.
         * @member {string} date
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.date = "";

        /**
         * Trip dates.
         * @member {Array.<string>} dates
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.dates = $util.emptyArray;

        /**
         * Trip headsign.
         * @member {string} headsign
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.headsign = "";

        /**
         * Trip transferAlias.
         * @member {string} transferAlias
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.transferAlias = "";

        /**
         * Trip charter.
         * @member {boolean} charter
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.charter = false;

        /**
         * Trip startTime.
         * @member {number} startTime
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.startTime = 0;

        /**
         * Trip duration.
         * @member {number} duration
         * @memberof busable.Trip
         * @instance
         */
        Trip.prototype.duration = 0;

        /**
         * Creates a new Trip instance using the specified properties.
         * @function create
         * @memberof busable.Trip
         * @static
         * @param {busable.ITrip=} [properties] Properties to set
         * @returns {busable.Trip} Trip instance
         */
        Trip.create = function create(properties) {
            return new Trip(properties);
        };

        /**
         * Encodes the specified Trip message. Does not implicitly {@link busable.Trip.verify|verify} messages.
         * @function encode
         * @memberof busable.Trip
         * @static
         * @param {busable.ITrip} message Trip message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Trip.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.tripId != null && Object.hasOwnProperty.call(message, "tripId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.tripId);
            if (message.routeId != null && Object.hasOwnProperty.call(message, "routeId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.routeId);
            if (message.routeType != null && Object.hasOwnProperty.call(message, "routeType"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.routeType);
            if (message.stopTimes != null && message.stopTimes.length)
                for (var i = 0; i < message.stopTimes.length; ++i)
                    $root.busable.StopTime.encode(message.stopTimes[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.scheduleIds != null && message.scheduleIds.length)
                for (var i = 0; i < message.scheduleIds.length; ++i)
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.scheduleIds[i]);
            if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.date);
            if (message.dates != null && message.dates.length)
                for (var i = 0; i < message.dates.length; ++i)
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.dates[i]);
            if (message.headsign != null && Object.hasOwnProperty.call(message, "headsign"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.headsign);
            if (message.transferAlias != null && Object.hasOwnProperty.call(message, "transferAlias"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.transferAlias);
            if (message.charter != null && Object.hasOwnProperty.call(message, "charter"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.charter);
            if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                writer.uint32(/* id 11, wireType 0 =*/88).int32(message.startTime);
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.duration);
            return writer;
        };

        /**
         * Encodes the specified Trip message, length delimited. Does not implicitly {@link busable.Trip.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Trip
         * @static
         * @param {busable.ITrip} message Trip message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Trip.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Trip message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Trip
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Trip} Trip
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Trip.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Trip();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.tripId = reader.string();
                        break;
                    }
                case 2: {
                        message.routeId = reader.string();
                        break;
                    }
                case 3: {
                        message.routeType = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.stopTimes && message.stopTimes.length))
                            message.stopTimes = [];
                        message.stopTimes.push($root.busable.StopTime.decode(reader, reader.uint32()));
                        break;
                    }
                case 5: {
                        if (!(message.scheduleIds && message.scheduleIds.length))
                            message.scheduleIds = [];
                        message.scheduleIds.push(reader.string());
                        break;
                    }
                case 6: {
                        message.date = reader.string();
                        break;
                    }
                case 7: {
                        if (!(message.dates && message.dates.length))
                            message.dates = [];
                        message.dates.push(reader.string());
                        break;
                    }
                case 8: {
                        message.headsign = reader.string();
                        break;
                    }
                case 9: {
                        message.transferAlias = reader.string();
                        break;
                    }
                case 10: {
                        message.charter = reader.bool();
                        break;
                    }
                case 11: {
                        message.startTime = reader.int32();
                        break;
                    }
                case 12: {
                        message.duration = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Trip message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Trip
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Trip} Trip
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Trip.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Trip message.
         * @function verify
         * @memberof busable.Trip
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Trip.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.tripId != null && message.hasOwnProperty("tripId"))
                if (!$util.isString(message.tripId))
                    return "tripId: string expected";
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                if (!$util.isString(message.routeId))
                    return "routeId: string expected";
            if (message.routeType != null && message.hasOwnProperty("routeType"))
                if (!$util.isString(message.routeType))
                    return "routeType: string expected";
            if (message.stopTimes != null && message.hasOwnProperty("stopTimes")) {
                if (!Array.isArray(message.stopTimes))
                    return "stopTimes: array expected";
                for (var i = 0; i < message.stopTimes.length; ++i) {
                    var error = $root.busable.StopTime.verify(message.stopTimes[i]);
                    if (error)
                        return "stopTimes." + error;
                }
            }
            if (message.scheduleIds != null && message.hasOwnProperty("scheduleIds")) {
                if (!Array.isArray(message.scheduleIds))
                    return "scheduleIds: array expected";
                for (var i = 0; i < message.scheduleIds.length; ++i)
                    if (!$util.isString(message.scheduleIds[i]))
                        return "scheduleIds: string[] expected";
            }
            if (message.date != null && message.hasOwnProperty("date"))
                if (!$util.isString(message.date))
                    return "date: string expected";
            if (message.dates != null && message.hasOwnProperty("dates")) {
                if (!Array.isArray(message.dates))
                    return "dates: array expected";
                for (var i = 0; i < message.dates.length; ++i)
                    if (!$util.isString(message.dates[i]))
                        return "dates: string[] expected";
            }
            if (message.headsign != null && message.hasOwnProperty("headsign"))
                if (!$util.isString(message.headsign))
                    return "headsign: string expected";
            if (message.transferAlias != null && message.hasOwnProperty("transferAlias"))
                if (!$util.isString(message.transferAlias))
                    return "transferAlias: string expected";
            if (message.charter != null && message.hasOwnProperty("charter"))
                if (typeof message.charter !== "boolean")
                    return "charter: boolean expected";
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                if (!$util.isInteger(message.startTime))
                    return "startTime: integer expected";
            if (message.duration != null && message.hasOwnProperty("duration"))
                if (!$util.isInteger(message.duration))
                    return "duration: integer expected";
            return null;
        };

        /**
         * Creates a Trip message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Trip
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Trip} Trip
         */
        Trip.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Trip)
                return object;
            var message = new $root.busable.Trip();
            if (object.tripId != null)
                message.tripId = String(object.tripId);
            if (object.routeId != null)
                message.routeId = String(object.routeId);
            if (object.routeType != null)
                message.routeType = String(object.routeType);
            if (object.stopTimes) {
                if (!Array.isArray(object.stopTimes))
                    throw TypeError(".busable.Trip.stopTimes: array expected");
                message.stopTimes = [];
                for (var i = 0; i < object.stopTimes.length; ++i) {
                    if (typeof object.stopTimes[i] !== "object")
                        throw TypeError(".busable.Trip.stopTimes: object expected");
                    message.stopTimes[i] = $root.busable.StopTime.fromObject(object.stopTimes[i]);
                }
            }
            if (object.scheduleIds) {
                if (!Array.isArray(object.scheduleIds))
                    throw TypeError(".busable.Trip.scheduleIds: array expected");
                message.scheduleIds = [];
                for (var i = 0; i < object.scheduleIds.length; ++i)
                    message.scheduleIds[i] = String(object.scheduleIds[i]);
            }
            if (object.date != null)
                message.date = String(object.date);
            if (object.dates) {
                if (!Array.isArray(object.dates))
                    throw TypeError(".busable.Trip.dates: array expected");
                message.dates = [];
                for (var i = 0; i < object.dates.length; ++i)
                    message.dates[i] = String(object.dates[i]);
            }
            if (object.headsign != null)
                message.headsign = String(object.headsign);
            if (object.transferAlias != null)
                message.transferAlias = String(object.transferAlias);
            if (object.charter != null)
                message.charter = Boolean(object.charter);
            if (object.startTime != null)
                message.startTime = object.startTime | 0;
            if (object.duration != null)
                message.duration = object.duration | 0;
            return message;
        };

        /**
         * Creates a plain object from a Trip message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Trip
         * @static
         * @param {busable.Trip} message Trip
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Trip.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.stopTimes = [];
                object.scheduleIds = [];
                object.dates = [];
            }
            if (options.defaults) {
                object.tripId = "";
                object.routeId = "";
                object.routeType = "";
                object.date = "";
                object.headsign = "";
                object.transferAlias = "";
                object.charter = false;
                object.startTime = 0;
                object.duration = 0;
            }
            if (message.tripId != null && message.hasOwnProperty("tripId"))
                object.tripId = message.tripId;
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                object.routeId = message.routeId;
            if (message.routeType != null && message.hasOwnProperty("routeType"))
                object.routeType = message.routeType;
            if (message.stopTimes && message.stopTimes.length) {
                object.stopTimes = [];
                for (var j = 0; j < message.stopTimes.length; ++j)
                    object.stopTimes[j] = $root.busable.StopTime.toObject(message.stopTimes[j], options);
            }
            if (message.scheduleIds && message.scheduleIds.length) {
                object.scheduleIds = [];
                for (var j = 0; j < message.scheduleIds.length; ++j)
                    object.scheduleIds[j] = message.scheduleIds[j];
            }
            if (message.date != null && message.hasOwnProperty("date"))
                object.date = message.date;
            if (message.dates && message.dates.length) {
                object.dates = [];
                for (var j = 0; j < message.dates.length; ++j)
                    object.dates[j] = message.dates[j];
            }
            if (message.headsign != null && message.hasOwnProperty("headsign"))
                object.headsign = message.headsign;
            if (message.transferAlias != null && message.hasOwnProperty("transferAlias"))
                object.transferAlias = message.transferAlias;
            if (message.charter != null && message.hasOwnProperty("charter"))
                object.charter = message.charter;
            if (message.startTime != null && message.hasOwnProperty("startTime"))
                object.startTime = message.startTime;
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = message.duration;
            return object;
        };

        /**
         * Converts this Trip to JSON.
         * @function toJSON
         * @memberof busable.Trip
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Trip.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Trip
         * @function getTypeUrl
         * @memberof busable.Trip
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Trip.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Trip";
        };

        return Trip;
    })();

    busable.Route = (function() {

        /**
         * Properties of a Route.
         * @memberof busable
         * @interface IRoute
         * @property {string|null} [routeId] Route routeId
         * @property {string|null} [routeNumber] Route routeNumber
         * @property {string|null} [routeType] Route routeType
         * @property {string|null} [routeDesc] Route routeDesc
         * @property {string|null} [colour] Route colour
         * @property {string|null} [routeName] Route routeName
         * @property {number|Long|null} [publishedAt] Route publishedAt
         * @property {string|null} [author] Route author
         * @property {Array.<busable.IWayPoint>|null} [waypoints] Route waypoints
         * @property {Array.<busable.IStopTime>|null} [stopTimes] Route stopTimes
         * @property {Array.<busable.ITrip>|null} [services] Route services
         * @property {number|null} [published] Route published
         * @property {boolean|null} [charter] Route charter
         * @property {string|null} [direction] Route direction
         * @property {string|null} [logo] Route logo
         * @property {string|null} [label] Route label
         * @property {string|null} [desc] Route desc
         * @property {string|null} [details] Route details
         * @property {string|null} [headsign] Route headsign
         * @property {number|Long|null} [createdAt] Route createdAt
         * @property {number|Long|null} [updatedAt] Route updatedAt
         * @property {string|null} [lastEditor] Route lastEditor
         * @property {string|null} [approvedBy] Route approvedBy
         * @property {number|Long|null} [approvedAt] Route approvedAt
         * @property {string|null} [publishedBy] Route publishedBy
         * @property {number|Long|null} [publishedAtTime] Route publishedAtTime
         * @property {string|null} [unpublishedBy] Route unpublishedBy
         * @property {number|Long|null} [unpublishedAt] Route unpublishedAt
         * @property {string|null} [contractId] Route contractId
         * @property {Array.<string>|null} [warnings] Route warnings
         * @property {number|null} [distance] Route distance
         */

        /**
         * Constructs a new Route.
         * @memberof busable
         * @classdesc Represents a Route.
         * @implements IRoute
         * @constructor
         * @param {busable.IRoute=} [properties] Properties to set
         */
        function Route(properties) {
            this.waypoints = [];
            this.stopTimes = [];
            this.services = [];
            this.warnings = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Route routeId.
         * @member {string} routeId
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.routeId = "";

        /**
         * Route routeNumber.
         * @member {string} routeNumber
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.routeNumber = "";

        /**
         * Route routeType.
         * @member {string} routeType
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.routeType = "";

        /**
         * Route routeDesc.
         * @member {string} routeDesc
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.routeDesc = "";

        /**
         * Route colour.
         * @member {string} colour
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.colour = "";

        /**
         * Route routeName.
         * @member {string} routeName
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.routeName = "";

        /**
         * Route publishedAt.
         * @member {number|Long} publishedAt
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.publishedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Route author.
         * @member {string} author
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.author = "";

        /**
         * Route waypoints.
         * @member {Array.<busable.IWayPoint>} waypoints
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.waypoints = $util.emptyArray;

        /**
         * Route stopTimes.
         * @member {Array.<busable.IStopTime>} stopTimes
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.stopTimes = $util.emptyArray;

        /**
         * Route services.
         * @member {Array.<busable.ITrip>} services
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.services = $util.emptyArray;

        /**
         * Route published.
         * @member {number} published
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.published = 0;

        /**
         * Route charter.
         * @member {boolean} charter
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.charter = false;

        /**
         * Route direction.
         * @member {string} direction
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.direction = "";

        /**
         * Route logo.
         * @member {string} logo
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.logo = "";

        /**
         * Route label.
         * @member {string} label
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.label = "";

        /**
         * Route desc.
         * @member {string} desc
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.desc = "";

        /**
         * Route details.
         * @member {string} details
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.details = "";

        /**
         * Route headsign.
         * @member {string} headsign
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.headsign = "";

        /**
         * Route createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Route updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Route lastEditor.
         * @member {string} lastEditor
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.lastEditor = "";

        /**
         * Route approvedBy.
         * @member {string} approvedBy
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.approvedBy = "";

        /**
         * Route approvedAt.
         * @member {number|Long} approvedAt
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.approvedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Route publishedBy.
         * @member {string} publishedBy
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.publishedBy = "";

        /**
         * Route publishedAtTime.
         * @member {number|Long} publishedAtTime
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.publishedAtTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Route unpublishedBy.
         * @member {string} unpublishedBy
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.unpublishedBy = "";

        /**
         * Route unpublishedAt.
         * @member {number|Long} unpublishedAt
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.unpublishedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Route contractId.
         * @member {string} contractId
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.contractId = "";

        /**
         * Route warnings.
         * @member {Array.<string>} warnings
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.warnings = $util.emptyArray;

        /**
         * Route distance.
         * @member {number} distance
         * @memberof busable.Route
         * @instance
         */
        Route.prototype.distance = 0;

        /**
         * Creates a new Route instance using the specified properties.
         * @function create
         * @memberof busable.Route
         * @static
         * @param {busable.IRoute=} [properties] Properties to set
         * @returns {busable.Route} Route instance
         */
        Route.create = function create(properties) {
            return new Route(properties);
        };

        /**
         * Encodes the specified Route message. Does not implicitly {@link busable.Route.verify|verify} messages.
         * @function encode
         * @memberof busable.Route
         * @static
         * @param {busable.IRoute} message Route message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Route.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.routeId != null && Object.hasOwnProperty.call(message, "routeId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.routeId);
            if (message.routeNumber != null && Object.hasOwnProperty.call(message, "routeNumber"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.routeNumber);
            if (message.routeType != null && Object.hasOwnProperty.call(message, "routeType"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.routeType);
            if (message.routeDesc != null && Object.hasOwnProperty.call(message, "routeDesc"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.routeDesc);
            if (message.colour != null && Object.hasOwnProperty.call(message, "colour"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.colour);
            if (message.routeName != null && Object.hasOwnProperty.call(message, "routeName"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.routeName);
            if (message.publishedAt != null && Object.hasOwnProperty.call(message, "publishedAt"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.publishedAt);
            if (message.author != null && Object.hasOwnProperty.call(message, "author"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.author);
            if (message.waypoints != null && message.waypoints.length)
                for (var i = 0; i < message.waypoints.length; ++i)
                    $root.busable.WayPoint.encode(message.waypoints[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.stopTimes != null && message.stopTimes.length)
                for (var i = 0; i < message.stopTimes.length; ++i)
                    $root.busable.StopTime.encode(message.stopTimes[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.services != null && message.services.length)
                for (var i = 0; i < message.services.length; ++i)
                    $root.busable.Trip.encode(message.services[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.published != null && Object.hasOwnProperty.call(message, "published"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.published);
            if (message.charter != null && Object.hasOwnProperty.call(message, "charter"))
                writer.uint32(/* id 13, wireType 0 =*/104).bool(message.charter);
            if (message.direction != null && Object.hasOwnProperty.call(message, "direction"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.direction);
            if (message.logo != null && Object.hasOwnProperty.call(message, "logo"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.logo);
            if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.label);
            if (message.desc != null && Object.hasOwnProperty.call(message, "desc"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.desc);
            if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.details);
            if (message.headsign != null && Object.hasOwnProperty.call(message, "headsign"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.headsign);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 20, wireType 0 =*/160).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 21, wireType 0 =*/168).int64(message.updatedAt);
            if (message.lastEditor != null && Object.hasOwnProperty.call(message, "lastEditor"))
                writer.uint32(/* id 22, wireType 2 =*/178).string(message.lastEditor);
            if (message.approvedBy != null && Object.hasOwnProperty.call(message, "approvedBy"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.approvedBy);
            if (message.approvedAt != null && Object.hasOwnProperty.call(message, "approvedAt"))
                writer.uint32(/* id 24, wireType 0 =*/192).int64(message.approvedAt);
            if (message.publishedBy != null && Object.hasOwnProperty.call(message, "publishedBy"))
                writer.uint32(/* id 25, wireType 2 =*/202).string(message.publishedBy);
            if (message.publishedAtTime != null && Object.hasOwnProperty.call(message, "publishedAtTime"))
                writer.uint32(/* id 26, wireType 0 =*/208).int64(message.publishedAtTime);
            if (message.unpublishedBy != null && Object.hasOwnProperty.call(message, "unpublishedBy"))
                writer.uint32(/* id 27, wireType 2 =*/218).string(message.unpublishedBy);
            if (message.unpublishedAt != null && Object.hasOwnProperty.call(message, "unpublishedAt"))
                writer.uint32(/* id 28, wireType 0 =*/224).int64(message.unpublishedAt);
            if (message.contractId != null && Object.hasOwnProperty.call(message, "contractId"))
                writer.uint32(/* id 29, wireType 2 =*/234).string(message.contractId);
            if (message.warnings != null && message.warnings.length)
                for (var i = 0; i < message.warnings.length; ++i)
                    writer.uint32(/* id 30, wireType 2 =*/242).string(message.warnings[i]);
            if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                writer.uint32(/* id 31, wireType 1 =*/249).double(message.distance);
            return writer;
        };

        /**
         * Encodes the specified Route message, length delimited. Does not implicitly {@link busable.Route.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Route
         * @static
         * @param {busable.IRoute} message Route message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Route.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Route message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Route
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Route} Route
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Route.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Route();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.routeId = reader.string();
                        break;
                    }
                case 2: {
                        message.routeNumber = reader.string();
                        break;
                    }
                case 3: {
                        message.routeType = reader.string();
                        break;
                    }
                case 4: {
                        message.routeDesc = reader.string();
                        break;
                    }
                case 5: {
                        message.colour = reader.string();
                        break;
                    }
                case 6: {
                        message.routeName = reader.string();
                        break;
                    }
                case 7: {
                        message.publishedAt = reader.int64();
                        break;
                    }
                case 8: {
                        message.author = reader.string();
                        break;
                    }
                case 9: {
                        if (!(message.waypoints && message.waypoints.length))
                            message.waypoints = [];
                        message.waypoints.push($root.busable.WayPoint.decode(reader, reader.uint32()));
                        break;
                    }
                case 10: {
                        if (!(message.stopTimes && message.stopTimes.length))
                            message.stopTimes = [];
                        message.stopTimes.push($root.busable.StopTime.decode(reader, reader.uint32()));
                        break;
                    }
                case 11: {
                        if (!(message.services && message.services.length))
                            message.services = [];
                        message.services.push($root.busable.Trip.decode(reader, reader.uint32()));
                        break;
                    }
                case 12: {
                        message.published = reader.int32();
                        break;
                    }
                case 13: {
                        message.charter = reader.bool();
                        break;
                    }
                case 14: {
                        message.direction = reader.string();
                        break;
                    }
                case 15: {
                        message.logo = reader.string();
                        break;
                    }
                case 16: {
                        message.label = reader.string();
                        break;
                    }
                case 17: {
                        message.desc = reader.string();
                        break;
                    }
                case 18: {
                        message.details = reader.string();
                        break;
                    }
                case 19: {
                        message.headsign = reader.string();
                        break;
                    }
                case 20: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 21: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                case 22: {
                        message.lastEditor = reader.string();
                        break;
                    }
                case 23: {
                        message.approvedBy = reader.string();
                        break;
                    }
                case 24: {
                        message.approvedAt = reader.int64();
                        break;
                    }
                case 25: {
                        message.publishedBy = reader.string();
                        break;
                    }
                case 26: {
                        message.publishedAtTime = reader.int64();
                        break;
                    }
                case 27: {
                        message.unpublishedBy = reader.string();
                        break;
                    }
                case 28: {
                        message.unpublishedAt = reader.int64();
                        break;
                    }
                case 29: {
                        message.contractId = reader.string();
                        break;
                    }
                case 30: {
                        if (!(message.warnings && message.warnings.length))
                            message.warnings = [];
                        message.warnings.push(reader.string());
                        break;
                    }
                case 31: {
                        message.distance = reader.double();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Route message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Route
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Route} Route
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Route.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Route message.
         * @function verify
         * @memberof busable.Route
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Route.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                if (!$util.isString(message.routeId))
                    return "routeId: string expected";
            if (message.routeNumber != null && message.hasOwnProperty("routeNumber"))
                if (!$util.isString(message.routeNumber))
                    return "routeNumber: string expected";
            if (message.routeType != null && message.hasOwnProperty("routeType"))
                if (!$util.isString(message.routeType))
                    return "routeType: string expected";
            if (message.routeDesc != null && message.hasOwnProperty("routeDesc"))
                if (!$util.isString(message.routeDesc))
                    return "routeDesc: string expected";
            if (message.colour != null && message.hasOwnProperty("colour"))
                if (!$util.isString(message.colour))
                    return "colour: string expected";
            if (message.routeName != null && message.hasOwnProperty("routeName"))
                if (!$util.isString(message.routeName))
                    return "routeName: string expected";
            if (message.publishedAt != null && message.hasOwnProperty("publishedAt"))
                if (!$util.isInteger(message.publishedAt) && !(message.publishedAt && $util.isInteger(message.publishedAt.low) && $util.isInteger(message.publishedAt.high)))
                    return "publishedAt: integer|Long expected";
            if (message.author != null && message.hasOwnProperty("author"))
                if (!$util.isString(message.author))
                    return "author: string expected";
            if (message.waypoints != null && message.hasOwnProperty("waypoints")) {
                if (!Array.isArray(message.waypoints))
                    return "waypoints: array expected";
                for (var i = 0; i < message.waypoints.length; ++i) {
                    var error = $root.busable.WayPoint.verify(message.waypoints[i]);
                    if (error)
                        return "waypoints." + error;
                }
            }
            if (message.stopTimes != null && message.hasOwnProperty("stopTimes")) {
                if (!Array.isArray(message.stopTimes))
                    return "stopTimes: array expected";
                for (var i = 0; i < message.stopTimes.length; ++i) {
                    var error = $root.busable.StopTime.verify(message.stopTimes[i]);
                    if (error)
                        return "stopTimes." + error;
                }
            }
            if (message.services != null && message.hasOwnProperty("services")) {
                if (!Array.isArray(message.services))
                    return "services: array expected";
                for (var i = 0; i < message.services.length; ++i) {
                    var error = $root.busable.Trip.verify(message.services[i]);
                    if (error)
                        return "services." + error;
                }
            }
            if (message.published != null && message.hasOwnProperty("published"))
                if (!$util.isInteger(message.published))
                    return "published: integer expected";
            if (message.charter != null && message.hasOwnProperty("charter"))
                if (typeof message.charter !== "boolean")
                    return "charter: boolean expected";
            if (message.direction != null && message.hasOwnProperty("direction"))
                if (!$util.isString(message.direction))
                    return "direction: string expected";
            if (message.logo != null && message.hasOwnProperty("logo"))
                if (!$util.isString(message.logo))
                    return "logo: string expected";
            if (message.label != null && message.hasOwnProperty("label"))
                if (!$util.isString(message.label))
                    return "label: string expected";
            if (message.desc != null && message.hasOwnProperty("desc"))
                if (!$util.isString(message.desc))
                    return "desc: string expected";
            if (message.details != null && message.hasOwnProperty("details"))
                if (!$util.isString(message.details))
                    return "details: string expected";
            if (message.headsign != null && message.hasOwnProperty("headsign"))
                if (!$util.isString(message.headsign))
                    return "headsign: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            if (message.lastEditor != null && message.hasOwnProperty("lastEditor"))
                if (!$util.isString(message.lastEditor))
                    return "lastEditor: string expected";
            if (message.approvedBy != null && message.hasOwnProperty("approvedBy"))
                if (!$util.isString(message.approvedBy))
                    return "approvedBy: string expected";
            if (message.approvedAt != null && message.hasOwnProperty("approvedAt"))
                if (!$util.isInteger(message.approvedAt) && !(message.approvedAt && $util.isInteger(message.approvedAt.low) && $util.isInteger(message.approvedAt.high)))
                    return "approvedAt: integer|Long expected";
            if (message.publishedBy != null && message.hasOwnProperty("publishedBy"))
                if (!$util.isString(message.publishedBy))
                    return "publishedBy: string expected";
            if (message.publishedAtTime != null && message.hasOwnProperty("publishedAtTime"))
                if (!$util.isInteger(message.publishedAtTime) && !(message.publishedAtTime && $util.isInteger(message.publishedAtTime.low) && $util.isInteger(message.publishedAtTime.high)))
                    return "publishedAtTime: integer|Long expected";
            if (message.unpublishedBy != null && message.hasOwnProperty("unpublishedBy"))
                if (!$util.isString(message.unpublishedBy))
                    return "unpublishedBy: string expected";
            if (message.unpublishedAt != null && message.hasOwnProperty("unpublishedAt"))
                if (!$util.isInteger(message.unpublishedAt) && !(message.unpublishedAt && $util.isInteger(message.unpublishedAt.low) && $util.isInteger(message.unpublishedAt.high)))
                    return "unpublishedAt: integer|Long expected";
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                if (!$util.isString(message.contractId))
                    return "contractId: string expected";
            if (message.warnings != null && message.hasOwnProperty("warnings")) {
                if (!Array.isArray(message.warnings))
                    return "warnings: array expected";
                for (var i = 0; i < message.warnings.length; ++i)
                    if (!$util.isString(message.warnings[i]))
                        return "warnings: string[] expected";
            }
            if (message.distance != null && message.hasOwnProperty("distance"))
                if (typeof message.distance !== "number")
                    return "distance: number expected";
            return null;
        };

        /**
         * Creates a Route message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Route
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Route} Route
         */
        Route.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Route)
                return object;
            var message = new $root.busable.Route();
            if (object.routeId != null)
                message.routeId = String(object.routeId);
            if (object.routeNumber != null)
                message.routeNumber = String(object.routeNumber);
            if (object.routeType != null)
                message.routeType = String(object.routeType);
            if (object.routeDesc != null)
                message.routeDesc = String(object.routeDesc);
            if (object.colour != null)
                message.colour = String(object.colour);
            if (object.routeName != null)
                message.routeName = String(object.routeName);
            if (object.publishedAt != null)
                if ($util.Long)
                    (message.publishedAt = $util.Long.fromValue(object.publishedAt)).unsigned = false;
                else if (typeof object.publishedAt === "string")
                    message.publishedAt = parseInt(object.publishedAt, 10);
                else if (typeof object.publishedAt === "number")
                    message.publishedAt = object.publishedAt;
                else if (typeof object.publishedAt === "object")
                    message.publishedAt = new $util.LongBits(object.publishedAt.low >>> 0, object.publishedAt.high >>> 0).toNumber();
            if (object.author != null)
                message.author = String(object.author);
            if (object.waypoints) {
                if (!Array.isArray(object.waypoints))
                    throw TypeError(".busable.Route.waypoints: array expected");
                message.waypoints = [];
                for (var i = 0; i < object.waypoints.length; ++i) {
                    if (typeof object.waypoints[i] !== "object")
                        throw TypeError(".busable.Route.waypoints: object expected");
                    message.waypoints[i] = $root.busable.WayPoint.fromObject(object.waypoints[i]);
                }
            }
            if (object.stopTimes) {
                if (!Array.isArray(object.stopTimes))
                    throw TypeError(".busable.Route.stopTimes: array expected");
                message.stopTimes = [];
                for (var i = 0; i < object.stopTimes.length; ++i) {
                    if (typeof object.stopTimes[i] !== "object")
                        throw TypeError(".busable.Route.stopTimes: object expected");
                    message.stopTimes[i] = $root.busable.StopTime.fromObject(object.stopTimes[i]);
                }
            }
            if (object.services) {
                if (!Array.isArray(object.services))
                    throw TypeError(".busable.Route.services: array expected");
                message.services = [];
                for (var i = 0; i < object.services.length; ++i) {
                    if (typeof object.services[i] !== "object")
                        throw TypeError(".busable.Route.services: object expected");
                    message.services[i] = $root.busable.Trip.fromObject(object.services[i]);
                }
            }
            if (object.published != null)
                message.published = object.published | 0;
            if (object.charter != null)
                message.charter = Boolean(object.charter);
            if (object.direction != null)
                message.direction = String(object.direction);
            if (object.logo != null)
                message.logo = String(object.logo);
            if (object.label != null)
                message.label = String(object.label);
            if (object.desc != null)
                message.desc = String(object.desc);
            if (object.details != null)
                message.details = String(object.details);
            if (object.headsign != null)
                message.headsign = String(object.headsign);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            if (object.lastEditor != null)
                message.lastEditor = String(object.lastEditor);
            if (object.approvedBy != null)
                message.approvedBy = String(object.approvedBy);
            if (object.approvedAt != null)
                if ($util.Long)
                    (message.approvedAt = $util.Long.fromValue(object.approvedAt)).unsigned = false;
                else if (typeof object.approvedAt === "string")
                    message.approvedAt = parseInt(object.approvedAt, 10);
                else if (typeof object.approvedAt === "number")
                    message.approvedAt = object.approvedAt;
                else if (typeof object.approvedAt === "object")
                    message.approvedAt = new $util.LongBits(object.approvedAt.low >>> 0, object.approvedAt.high >>> 0).toNumber();
            if (object.publishedBy != null)
                message.publishedBy = String(object.publishedBy);
            if (object.publishedAtTime != null)
                if ($util.Long)
                    (message.publishedAtTime = $util.Long.fromValue(object.publishedAtTime)).unsigned = false;
                else if (typeof object.publishedAtTime === "string")
                    message.publishedAtTime = parseInt(object.publishedAtTime, 10);
                else if (typeof object.publishedAtTime === "number")
                    message.publishedAtTime = object.publishedAtTime;
                else if (typeof object.publishedAtTime === "object")
                    message.publishedAtTime = new $util.LongBits(object.publishedAtTime.low >>> 0, object.publishedAtTime.high >>> 0).toNumber();
            if (object.unpublishedBy != null)
                message.unpublishedBy = String(object.unpublishedBy);
            if (object.unpublishedAt != null)
                if ($util.Long)
                    (message.unpublishedAt = $util.Long.fromValue(object.unpublishedAt)).unsigned = false;
                else if (typeof object.unpublishedAt === "string")
                    message.unpublishedAt = parseInt(object.unpublishedAt, 10);
                else if (typeof object.unpublishedAt === "number")
                    message.unpublishedAt = object.unpublishedAt;
                else if (typeof object.unpublishedAt === "object")
                    message.unpublishedAt = new $util.LongBits(object.unpublishedAt.low >>> 0, object.unpublishedAt.high >>> 0).toNumber();
            if (object.contractId != null)
                message.contractId = String(object.contractId);
            if (object.warnings) {
                if (!Array.isArray(object.warnings))
                    throw TypeError(".busable.Route.warnings: array expected");
                message.warnings = [];
                for (var i = 0; i < object.warnings.length; ++i)
                    message.warnings[i] = String(object.warnings[i]);
            }
            if (object.distance != null)
                message.distance = Number(object.distance);
            return message;
        };

        /**
         * Creates a plain object from a Route message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Route
         * @static
         * @param {busable.Route} message Route
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Route.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.waypoints = [];
                object.stopTimes = [];
                object.services = [];
                object.warnings = [];
            }
            if (options.defaults) {
                object.routeId = "";
                object.routeNumber = "";
                object.routeType = "";
                object.routeDesc = "";
                object.colour = "";
                object.routeName = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.publishedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.publishedAt = options.longs === String ? "0" : 0;
                object.author = "";
                object.published = 0;
                object.charter = false;
                object.direction = "";
                object.logo = "";
                object.label = "";
                object.desc = "";
                object.details = "";
                object.headsign = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
                object.lastEditor = "";
                object.approvedBy = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.approvedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.approvedAt = options.longs === String ? "0" : 0;
                object.publishedBy = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.publishedAtTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.publishedAtTime = options.longs === String ? "0" : 0;
                object.unpublishedBy = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.unpublishedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.unpublishedAt = options.longs === String ? "0" : 0;
                object.contractId = "";
                object.distance = 0;
            }
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                object.routeId = message.routeId;
            if (message.routeNumber != null && message.hasOwnProperty("routeNumber"))
                object.routeNumber = message.routeNumber;
            if (message.routeType != null && message.hasOwnProperty("routeType"))
                object.routeType = message.routeType;
            if (message.routeDesc != null && message.hasOwnProperty("routeDesc"))
                object.routeDesc = message.routeDesc;
            if (message.colour != null && message.hasOwnProperty("colour"))
                object.colour = message.colour;
            if (message.routeName != null && message.hasOwnProperty("routeName"))
                object.routeName = message.routeName;
            if (message.publishedAt != null && message.hasOwnProperty("publishedAt"))
                if (typeof message.publishedAt === "number")
                    object.publishedAt = options.longs === String ? String(message.publishedAt) : message.publishedAt;
                else
                    object.publishedAt = options.longs === String ? $util.Long.prototype.toString.call(message.publishedAt) : options.longs === Number ? new $util.LongBits(message.publishedAt.low >>> 0, message.publishedAt.high >>> 0).toNumber() : message.publishedAt;
            if (message.author != null && message.hasOwnProperty("author"))
                object.author = message.author;
            if (message.waypoints && message.waypoints.length) {
                object.waypoints = [];
                for (var j = 0; j < message.waypoints.length; ++j)
                    object.waypoints[j] = $root.busable.WayPoint.toObject(message.waypoints[j], options);
            }
            if (message.stopTimes && message.stopTimes.length) {
                object.stopTimes = [];
                for (var j = 0; j < message.stopTimes.length; ++j)
                    object.stopTimes[j] = $root.busable.StopTime.toObject(message.stopTimes[j], options);
            }
            if (message.services && message.services.length) {
                object.services = [];
                for (var j = 0; j < message.services.length; ++j)
                    object.services[j] = $root.busable.Trip.toObject(message.services[j], options);
            }
            if (message.published != null && message.hasOwnProperty("published"))
                object.published = message.published;
            if (message.charter != null && message.hasOwnProperty("charter"))
                object.charter = message.charter;
            if (message.direction != null && message.hasOwnProperty("direction"))
                object.direction = message.direction;
            if (message.logo != null && message.hasOwnProperty("logo"))
                object.logo = message.logo;
            if (message.label != null && message.hasOwnProperty("label"))
                object.label = message.label;
            if (message.desc != null && message.hasOwnProperty("desc"))
                object.desc = message.desc;
            if (message.details != null && message.hasOwnProperty("details"))
                object.details = message.details;
            if (message.headsign != null && message.hasOwnProperty("headsign"))
                object.headsign = message.headsign;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (message.lastEditor != null && message.hasOwnProperty("lastEditor"))
                object.lastEditor = message.lastEditor;
            if (message.approvedBy != null && message.hasOwnProperty("approvedBy"))
                object.approvedBy = message.approvedBy;
            if (message.approvedAt != null && message.hasOwnProperty("approvedAt"))
                if (typeof message.approvedAt === "number")
                    object.approvedAt = options.longs === String ? String(message.approvedAt) : message.approvedAt;
                else
                    object.approvedAt = options.longs === String ? $util.Long.prototype.toString.call(message.approvedAt) : options.longs === Number ? new $util.LongBits(message.approvedAt.low >>> 0, message.approvedAt.high >>> 0).toNumber() : message.approvedAt;
            if (message.publishedBy != null && message.hasOwnProperty("publishedBy"))
                object.publishedBy = message.publishedBy;
            if (message.publishedAtTime != null && message.hasOwnProperty("publishedAtTime"))
                if (typeof message.publishedAtTime === "number")
                    object.publishedAtTime = options.longs === String ? String(message.publishedAtTime) : message.publishedAtTime;
                else
                    object.publishedAtTime = options.longs === String ? $util.Long.prototype.toString.call(message.publishedAtTime) : options.longs === Number ? new $util.LongBits(message.publishedAtTime.low >>> 0, message.publishedAtTime.high >>> 0).toNumber() : message.publishedAtTime;
            if (message.unpublishedBy != null && message.hasOwnProperty("unpublishedBy"))
                object.unpublishedBy = message.unpublishedBy;
            if (message.unpublishedAt != null && message.hasOwnProperty("unpublishedAt"))
                if (typeof message.unpublishedAt === "number")
                    object.unpublishedAt = options.longs === String ? String(message.unpublishedAt) : message.unpublishedAt;
                else
                    object.unpublishedAt = options.longs === String ? $util.Long.prototype.toString.call(message.unpublishedAt) : options.longs === Number ? new $util.LongBits(message.unpublishedAt.low >>> 0, message.unpublishedAt.high >>> 0).toNumber() : message.unpublishedAt;
            if (message.contractId != null && message.hasOwnProperty("contractId"))
                object.contractId = message.contractId;
            if (message.warnings && message.warnings.length) {
                object.warnings = [];
                for (var j = 0; j < message.warnings.length; ++j)
                    object.warnings[j] = message.warnings[j];
            }
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = options.json && !isFinite(message.distance) ? String(message.distance) : message.distance;
            return object;
        };

        /**
         * Converts this Route to JSON.
         * @function toJSON
         * @memberof busable.Route
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Route.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Route
         * @function getTypeUrl
         * @memberof busable.Route
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Route.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Route";
        };

        return Route;
    })();

    busable.OperatingDays = (function() {

        /**
         * Properties of an OperatingDays.
         * @memberof busable
         * @interface IOperatingDays
         * @property {boolean|null} [monday] OperatingDays monday
         * @property {boolean|null} [tuesday] OperatingDays tuesday
         * @property {boolean|null} [wednesday] OperatingDays wednesday
         * @property {boolean|null} [thursday] OperatingDays thursday
         * @property {boolean|null} [friday] OperatingDays friday
         * @property {boolean|null} [saturday] OperatingDays saturday
         * @property {boolean|null} [sunday] OperatingDays sunday
         */

        /**
         * Constructs a new OperatingDays.
         * @memberof busable
         * @classdesc Represents an OperatingDays.
         * @implements IOperatingDays
         * @constructor
         * @param {busable.IOperatingDays=} [properties] Properties to set
         */
        function OperatingDays(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OperatingDays monday.
         * @member {boolean} monday
         * @memberof busable.OperatingDays
         * @instance
         */
        OperatingDays.prototype.monday = false;

        /**
         * OperatingDays tuesday.
         * @member {boolean} tuesday
         * @memberof busable.OperatingDays
         * @instance
         */
        OperatingDays.prototype.tuesday = false;

        /**
         * OperatingDays wednesday.
         * @member {boolean} wednesday
         * @memberof busable.OperatingDays
         * @instance
         */
        OperatingDays.prototype.wednesday = false;

        /**
         * OperatingDays thursday.
         * @member {boolean} thursday
         * @memberof busable.OperatingDays
         * @instance
         */
        OperatingDays.prototype.thursday = false;

        /**
         * OperatingDays friday.
         * @member {boolean} friday
         * @memberof busable.OperatingDays
         * @instance
         */
        OperatingDays.prototype.friday = false;

        /**
         * OperatingDays saturday.
         * @member {boolean} saturday
         * @memberof busable.OperatingDays
         * @instance
         */
        OperatingDays.prototype.saturday = false;

        /**
         * OperatingDays sunday.
         * @member {boolean} sunday
         * @memberof busable.OperatingDays
         * @instance
         */
        OperatingDays.prototype.sunday = false;

        /**
         * Creates a new OperatingDays instance using the specified properties.
         * @function create
         * @memberof busable.OperatingDays
         * @static
         * @param {busable.IOperatingDays=} [properties] Properties to set
         * @returns {busable.OperatingDays} OperatingDays instance
         */
        OperatingDays.create = function create(properties) {
            return new OperatingDays(properties);
        };

        /**
         * Encodes the specified OperatingDays message. Does not implicitly {@link busable.OperatingDays.verify|verify} messages.
         * @function encode
         * @memberof busable.OperatingDays
         * @static
         * @param {busable.IOperatingDays} message OperatingDays message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperatingDays.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.monday != null && Object.hasOwnProperty.call(message, "monday"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.monday);
            if (message.tuesday != null && Object.hasOwnProperty.call(message, "tuesday"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.tuesday);
            if (message.wednesday != null && Object.hasOwnProperty.call(message, "wednesday"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.wednesday);
            if (message.thursday != null && Object.hasOwnProperty.call(message, "thursday"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.thursday);
            if (message.friday != null && Object.hasOwnProperty.call(message, "friday"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.friday);
            if (message.saturday != null && Object.hasOwnProperty.call(message, "saturday"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.saturday);
            if (message.sunday != null && Object.hasOwnProperty.call(message, "sunday"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.sunday);
            return writer;
        };

        /**
         * Encodes the specified OperatingDays message, length delimited. Does not implicitly {@link busable.OperatingDays.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.OperatingDays
         * @static
         * @param {busable.IOperatingDays} message OperatingDays message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperatingDays.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OperatingDays message from the specified reader or buffer.
         * @function decode
         * @memberof busable.OperatingDays
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.OperatingDays} OperatingDays
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperatingDays.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.OperatingDays();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.monday = reader.bool();
                        break;
                    }
                case 2: {
                        message.tuesday = reader.bool();
                        break;
                    }
                case 3: {
                        message.wednesday = reader.bool();
                        break;
                    }
                case 4: {
                        message.thursday = reader.bool();
                        break;
                    }
                case 5: {
                        message.friday = reader.bool();
                        break;
                    }
                case 6: {
                        message.saturday = reader.bool();
                        break;
                    }
                case 7: {
                        message.sunday = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OperatingDays message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.OperatingDays
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.OperatingDays} OperatingDays
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperatingDays.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OperatingDays message.
         * @function verify
         * @memberof busable.OperatingDays
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OperatingDays.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.monday != null && message.hasOwnProperty("monday"))
                if (typeof message.monday !== "boolean")
                    return "monday: boolean expected";
            if (message.tuesday != null && message.hasOwnProperty("tuesday"))
                if (typeof message.tuesday !== "boolean")
                    return "tuesday: boolean expected";
            if (message.wednesday != null && message.hasOwnProperty("wednesday"))
                if (typeof message.wednesday !== "boolean")
                    return "wednesday: boolean expected";
            if (message.thursday != null && message.hasOwnProperty("thursday"))
                if (typeof message.thursday !== "boolean")
                    return "thursday: boolean expected";
            if (message.friday != null && message.hasOwnProperty("friday"))
                if (typeof message.friday !== "boolean")
                    return "friday: boolean expected";
            if (message.saturday != null && message.hasOwnProperty("saturday"))
                if (typeof message.saturday !== "boolean")
                    return "saturday: boolean expected";
            if (message.sunday != null && message.hasOwnProperty("sunday"))
                if (typeof message.sunday !== "boolean")
                    return "sunday: boolean expected";
            return null;
        };

        /**
         * Creates an OperatingDays message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.OperatingDays
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.OperatingDays} OperatingDays
         */
        OperatingDays.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.OperatingDays)
                return object;
            var message = new $root.busable.OperatingDays();
            if (object.monday != null)
                message.monday = Boolean(object.monday);
            if (object.tuesday != null)
                message.tuesday = Boolean(object.tuesday);
            if (object.wednesday != null)
                message.wednesday = Boolean(object.wednesday);
            if (object.thursday != null)
                message.thursday = Boolean(object.thursday);
            if (object.friday != null)
                message.friday = Boolean(object.friday);
            if (object.saturday != null)
                message.saturday = Boolean(object.saturday);
            if (object.sunday != null)
                message.sunday = Boolean(object.sunday);
            return message;
        };

        /**
         * Creates a plain object from an OperatingDays message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.OperatingDays
         * @static
         * @param {busable.OperatingDays} message OperatingDays
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OperatingDays.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.monday = false;
                object.tuesday = false;
                object.wednesday = false;
                object.thursday = false;
                object.friday = false;
                object.saturday = false;
                object.sunday = false;
            }
            if (message.monday != null && message.hasOwnProperty("monday"))
                object.monday = message.monday;
            if (message.tuesday != null && message.hasOwnProperty("tuesday"))
                object.tuesday = message.tuesday;
            if (message.wednesday != null && message.hasOwnProperty("wednesday"))
                object.wednesday = message.wednesday;
            if (message.thursday != null && message.hasOwnProperty("thursday"))
                object.thursday = message.thursday;
            if (message.friday != null && message.hasOwnProperty("friday"))
                object.friday = message.friday;
            if (message.saturday != null && message.hasOwnProperty("saturday"))
                object.saturday = message.saturday;
            if (message.sunday != null && message.hasOwnProperty("sunday"))
                object.sunday = message.sunday;
            return object;
        };

        /**
         * Converts this OperatingDays to JSON.
         * @function toJSON
         * @memberof busable.OperatingDays
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OperatingDays.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OperatingDays
         * @function getTypeUrl
         * @memberof busable.OperatingDays
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OperatingDays.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.OperatingDays";
        };

        return OperatingDays;
    })();

    busable.Period = (function() {

        /**
         * Properties of a Period.
         * @memberof busable
         * @interface IPeriod
         * @property {string|null} [id] Period id
         * @property {string|null} [start] Period start
         * @property {string|null} [end] Period end
         * @property {string|null} [type] Period type
         * @property {boolean|null} [forceInclude] Period forceInclude
         * @property {string|null} [name] Period name
         * @property {string|null} [shortName] Period shortName
         */

        /**
         * Constructs a new Period.
         * @memberof busable
         * @classdesc Represents a Period.
         * @implements IPeriod
         * @constructor
         * @param {busable.IPeriod=} [properties] Properties to set
         */
        function Period(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Period id.
         * @member {string} id
         * @memberof busable.Period
         * @instance
         */
        Period.prototype.id = "";

        /**
         * Period start.
         * @member {string} start
         * @memberof busable.Period
         * @instance
         */
        Period.prototype.start = "";

        /**
         * Period end.
         * @member {string} end
         * @memberof busable.Period
         * @instance
         */
        Period.prototype.end = "";

        /**
         * Period type.
         * @member {string} type
         * @memberof busable.Period
         * @instance
         */
        Period.prototype.type = "";

        /**
         * Period forceInclude.
         * @member {boolean} forceInclude
         * @memberof busable.Period
         * @instance
         */
        Period.prototype.forceInclude = false;

        /**
         * Period name.
         * @member {string} name
         * @memberof busable.Period
         * @instance
         */
        Period.prototype.name = "";

        /**
         * Period shortName.
         * @member {string} shortName
         * @memberof busable.Period
         * @instance
         */
        Period.prototype.shortName = "";

        /**
         * Creates a new Period instance using the specified properties.
         * @function create
         * @memberof busable.Period
         * @static
         * @param {busable.IPeriod=} [properties] Properties to set
         * @returns {busable.Period} Period instance
         */
        Period.create = function create(properties) {
            return new Period(properties);
        };

        /**
         * Encodes the specified Period message. Does not implicitly {@link busable.Period.verify|verify} messages.
         * @function encode
         * @memberof busable.Period
         * @static
         * @param {busable.IPeriod} message Period message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Period.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.start);
            if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.end);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.type);
            if (message.forceInclude != null && Object.hasOwnProperty.call(message, "forceInclude"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.forceInclude);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.name);
            if (message.shortName != null && Object.hasOwnProperty.call(message, "shortName"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.shortName);
            return writer;
        };

        /**
         * Encodes the specified Period message, length delimited. Does not implicitly {@link busable.Period.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Period
         * @static
         * @param {busable.IPeriod} message Period message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Period.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Period message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Period
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Period} Period
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Period.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Period();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.start = reader.string();
                        break;
                    }
                case 3: {
                        message.end = reader.string();
                        break;
                    }
                case 4: {
                        message.type = reader.string();
                        break;
                    }
                case 5: {
                        message.forceInclude = reader.bool();
                        break;
                    }
                case 6: {
                        message.name = reader.string();
                        break;
                    }
                case 7: {
                        message.shortName = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Period message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Period
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Period} Period
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Period.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Period message.
         * @function verify
         * @memberof busable.Period
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Period.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.start != null && message.hasOwnProperty("start"))
                if (!$util.isString(message.start))
                    return "start: string expected";
            if (message.end != null && message.hasOwnProperty("end"))
                if (!$util.isString(message.end))
                    return "end: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.forceInclude != null && message.hasOwnProperty("forceInclude"))
                if (typeof message.forceInclude !== "boolean")
                    return "forceInclude: boolean expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.shortName != null && message.hasOwnProperty("shortName"))
                if (!$util.isString(message.shortName))
                    return "shortName: string expected";
            return null;
        };

        /**
         * Creates a Period message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Period
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Period} Period
         */
        Period.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Period)
                return object;
            var message = new $root.busable.Period();
            if (object.id != null)
                message.id = String(object.id);
            if (object.start != null)
                message.start = String(object.start);
            if (object.end != null)
                message.end = String(object.end);
            if (object.type != null)
                message.type = String(object.type);
            if (object.forceInclude != null)
                message.forceInclude = Boolean(object.forceInclude);
            if (object.name != null)
                message.name = String(object.name);
            if (object.shortName != null)
                message.shortName = String(object.shortName);
            return message;
        };

        /**
         * Creates a plain object from a Period message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Period
         * @static
         * @param {busable.Period} message Period
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Period.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.start = "";
                object.end = "";
                object.type = "";
                object.forceInclude = false;
                object.name = "";
                object.shortName = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.start != null && message.hasOwnProperty("start"))
                object.start = message.start;
            if (message.end != null && message.hasOwnProperty("end"))
                object.end = message.end;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.forceInclude != null && message.hasOwnProperty("forceInclude"))
                object.forceInclude = message.forceInclude;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.shortName != null && message.hasOwnProperty("shortName"))
                object.shortName = message.shortName;
            return object;
        };

        /**
         * Converts this Period to JSON.
         * @function toJSON
         * @memberof busable.Period
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Period.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Period
         * @function getTypeUrl
         * @memberof busable.Period
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Period.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Period";
        };

        return Period;
    })();

    busable.Exception = (function() {

        /**
         * Properties of an Exception.
         * @memberof busable
         * @interface IException
         * @property {string|null} [id] Exception id
         * @property {string|null} [type] Exception type
         * @property {busable.IPeriod|null} [period] Exception period
         * @property {string|null} [scheduleId] Exception scheduleId
         * @property {string|null} [source] Exception source
         * @property {boolean|null} [legacy] Exception legacy
         */

        /**
         * Constructs a new Exception.
         * @memberof busable
         * @classdesc Represents an Exception.
         * @implements IException
         * @constructor
         * @param {busable.IException=} [properties] Properties to set
         */
        function Exception(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Exception id.
         * @member {string} id
         * @memberof busable.Exception
         * @instance
         */
        Exception.prototype.id = "";

        /**
         * Exception type.
         * @member {string} type
         * @memberof busable.Exception
         * @instance
         */
        Exception.prototype.type = "";

        /**
         * Exception period.
         * @member {busable.IPeriod|null|undefined} period
         * @memberof busable.Exception
         * @instance
         */
        Exception.prototype.period = null;

        /**
         * Exception scheduleId.
         * @member {string} scheduleId
         * @memberof busable.Exception
         * @instance
         */
        Exception.prototype.scheduleId = "";

        /**
         * Exception source.
         * @member {string} source
         * @memberof busable.Exception
         * @instance
         */
        Exception.prototype.source = "";

        /**
         * Exception legacy.
         * @member {boolean} legacy
         * @memberof busable.Exception
         * @instance
         */
        Exception.prototype.legacy = false;

        /**
         * Creates a new Exception instance using the specified properties.
         * @function create
         * @memberof busable.Exception
         * @static
         * @param {busable.IException=} [properties] Properties to set
         * @returns {busable.Exception} Exception instance
         */
        Exception.create = function create(properties) {
            return new Exception(properties);
        };

        /**
         * Encodes the specified Exception message. Does not implicitly {@link busable.Exception.verify|verify} messages.
         * @function encode
         * @memberof busable.Exception
         * @static
         * @param {busable.IException} message Exception message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Exception.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
            if (message.period != null && Object.hasOwnProperty.call(message, "period"))
                $root.busable.Period.encode(message.period, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.scheduleId != null && Object.hasOwnProperty.call(message, "scheduleId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.scheduleId);
            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.source);
            if (message.legacy != null && Object.hasOwnProperty.call(message, "legacy"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.legacy);
            return writer;
        };

        /**
         * Encodes the specified Exception message, length delimited. Does not implicitly {@link busable.Exception.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Exception
         * @static
         * @param {busable.IException} message Exception message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Exception.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Exception message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Exception
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Exception} Exception
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Exception.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Exception();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.type = reader.string();
                        break;
                    }
                case 3: {
                        message.period = $root.busable.Period.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.scheduleId = reader.string();
                        break;
                    }
                case 5: {
                        message.source = reader.string();
                        break;
                    }
                case 6: {
                        message.legacy = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Exception message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Exception
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Exception} Exception
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Exception.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Exception message.
         * @function verify
         * @memberof busable.Exception
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Exception.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.period != null && message.hasOwnProperty("period")) {
                var error = $root.busable.Period.verify(message.period);
                if (error)
                    return "period." + error;
            }
            if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                if (!$util.isString(message.scheduleId))
                    return "scheduleId: string expected";
            if (message.source != null && message.hasOwnProperty("source"))
                if (!$util.isString(message.source))
                    return "source: string expected";
            if (message.legacy != null && message.hasOwnProperty("legacy"))
                if (typeof message.legacy !== "boolean")
                    return "legacy: boolean expected";
            return null;
        };

        /**
         * Creates an Exception message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Exception
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Exception} Exception
         */
        Exception.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Exception)
                return object;
            var message = new $root.busable.Exception();
            if (object.id != null)
                message.id = String(object.id);
            if (object.type != null)
                message.type = String(object.type);
            if (object.period != null) {
                if (typeof object.period !== "object")
                    throw TypeError(".busable.Exception.period: object expected");
                message.period = $root.busable.Period.fromObject(object.period);
            }
            if (object.scheduleId != null)
                message.scheduleId = String(object.scheduleId);
            if (object.source != null)
                message.source = String(object.source);
            if (object.legacy != null)
                message.legacy = Boolean(object.legacy);
            return message;
        };

        /**
         * Creates a plain object from an Exception message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Exception
         * @static
         * @param {busable.Exception} message Exception
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Exception.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.type = "";
                object.period = null;
                object.scheduleId = "";
                object.source = "";
                object.legacy = false;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.period != null && message.hasOwnProperty("period"))
                object.period = $root.busable.Period.toObject(message.period, options);
            if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                object.scheduleId = message.scheduleId;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = message.source;
            if (message.legacy != null && message.hasOwnProperty("legacy"))
                object.legacy = message.legacy;
            return object;
        };

        /**
         * Converts this Exception to JSON.
         * @function toJSON
         * @memberof busable.Exception
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Exception.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Exception
         * @function getTypeUrl
         * @memberof busable.Exception
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Exception.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Exception";
        };

        return Exception;
    })();

    busable.Schedule = (function() {

        /**
         * Properties of a Schedule.
         * @memberof busable
         * @interface ISchedule
         * @property {string|null} [scheduleId] Schedule scheduleId
         * @property {string|null} [scheduleName] Schedule scheduleName
         * @property {Array.<busable.IPeriod>|null} [schedulePeriods] Schedule schedulePeriods
         * @property {busable.IOperatingDays|null} [operatingDays] Schedule operatingDays
         * @property {Array.<busable.IPeriod>|null} [excludedPeriods] Schedule excludedPeriods
         * @property {Array.<string>|null} [includedSchedules] Schedule includedSchedules
         * @property {Array.<string>|null} [excludedSchedules] Schedule excludedSchedules
         * @property {boolean|null} [charter] Schedule charter
         * @property {Array.<busable.IException>|null} [exceptions] Schedule exceptions
         * @property {Array.<string>|null} [tags] Schedule tags
         * @property {boolean|null} [shared] Schedule shared
         */

        /**
         * Constructs a new Schedule.
         * @memberof busable
         * @classdesc Represents a Schedule.
         * @implements ISchedule
         * @constructor
         * @param {busable.ISchedule=} [properties] Properties to set
         */
        function Schedule(properties) {
            this.schedulePeriods = [];
            this.excludedPeriods = [];
            this.includedSchedules = [];
            this.excludedSchedules = [];
            this.exceptions = [];
            this.tags = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Schedule scheduleId.
         * @member {string} scheduleId
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.scheduleId = "";

        /**
         * Schedule scheduleName.
         * @member {string} scheduleName
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.scheduleName = "";

        /**
         * Schedule schedulePeriods.
         * @member {Array.<busable.IPeriod>} schedulePeriods
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.schedulePeriods = $util.emptyArray;

        /**
         * Schedule operatingDays.
         * @member {busable.IOperatingDays|null|undefined} operatingDays
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.operatingDays = null;

        /**
         * Schedule excludedPeriods.
         * @member {Array.<busable.IPeriod>} excludedPeriods
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.excludedPeriods = $util.emptyArray;

        /**
         * Schedule includedSchedules.
         * @member {Array.<string>} includedSchedules
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.includedSchedules = $util.emptyArray;

        /**
         * Schedule excludedSchedules.
         * @member {Array.<string>} excludedSchedules
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.excludedSchedules = $util.emptyArray;

        /**
         * Schedule charter.
         * @member {boolean} charter
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.charter = false;

        /**
         * Schedule exceptions.
         * @member {Array.<busable.IException>} exceptions
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.exceptions = $util.emptyArray;

        /**
         * Schedule tags.
         * @member {Array.<string>} tags
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.tags = $util.emptyArray;

        /**
         * Schedule shared.
         * @member {boolean} shared
         * @memberof busable.Schedule
         * @instance
         */
        Schedule.prototype.shared = false;

        /**
         * Creates a new Schedule instance using the specified properties.
         * @function create
         * @memberof busable.Schedule
         * @static
         * @param {busable.ISchedule=} [properties] Properties to set
         * @returns {busable.Schedule} Schedule instance
         */
        Schedule.create = function create(properties) {
            return new Schedule(properties);
        };

        /**
         * Encodes the specified Schedule message. Does not implicitly {@link busable.Schedule.verify|verify} messages.
         * @function encode
         * @memberof busable.Schedule
         * @static
         * @param {busable.ISchedule} message Schedule message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Schedule.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.scheduleId != null && Object.hasOwnProperty.call(message, "scheduleId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.scheduleId);
            if (message.scheduleName != null && Object.hasOwnProperty.call(message, "scheduleName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.scheduleName);
            if (message.schedulePeriods != null && message.schedulePeriods.length)
                for (var i = 0; i < message.schedulePeriods.length; ++i)
                    $root.busable.Period.encode(message.schedulePeriods[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.operatingDays != null && Object.hasOwnProperty.call(message, "operatingDays"))
                $root.busable.OperatingDays.encode(message.operatingDays, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.excludedPeriods != null && message.excludedPeriods.length)
                for (var i = 0; i < message.excludedPeriods.length; ++i)
                    $root.busable.Period.encode(message.excludedPeriods[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.includedSchedules != null && message.includedSchedules.length)
                for (var i = 0; i < message.includedSchedules.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.includedSchedules[i]);
            if (message.excludedSchedules != null && message.excludedSchedules.length)
                for (var i = 0; i < message.excludedSchedules.length; ++i)
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.excludedSchedules[i]);
            if (message.charter != null && Object.hasOwnProperty.call(message, "charter"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.charter);
            if (message.exceptions != null && message.exceptions.length)
                for (var i = 0; i < message.exceptions.length; ++i)
                    $root.busable.Exception.encode(message.exceptions[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.tags != null && message.tags.length)
                for (var i = 0; i < message.tags.length; ++i)
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.tags[i]);
            if (message.shared != null && Object.hasOwnProperty.call(message, "shared"))
                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.shared);
            return writer;
        };

        /**
         * Encodes the specified Schedule message, length delimited. Does not implicitly {@link busable.Schedule.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Schedule
         * @static
         * @param {busable.ISchedule} message Schedule message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Schedule.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Schedule message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Schedule
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Schedule} Schedule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Schedule.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Schedule();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.scheduleId = reader.string();
                        break;
                    }
                case 2: {
                        message.scheduleName = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.schedulePeriods && message.schedulePeriods.length))
                            message.schedulePeriods = [];
                        message.schedulePeriods.push($root.busable.Period.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        message.operatingDays = $root.busable.OperatingDays.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        if (!(message.excludedPeriods && message.excludedPeriods.length))
                            message.excludedPeriods = [];
                        message.excludedPeriods.push($root.busable.Period.decode(reader, reader.uint32()));
                        break;
                    }
                case 6: {
                        if (!(message.includedSchedules && message.includedSchedules.length))
                            message.includedSchedules = [];
                        message.includedSchedules.push(reader.string());
                        break;
                    }
                case 7: {
                        if (!(message.excludedSchedules && message.excludedSchedules.length))
                            message.excludedSchedules = [];
                        message.excludedSchedules.push(reader.string());
                        break;
                    }
                case 8: {
                        message.charter = reader.bool();
                        break;
                    }
                case 9: {
                        if (!(message.exceptions && message.exceptions.length))
                            message.exceptions = [];
                        message.exceptions.push($root.busable.Exception.decode(reader, reader.uint32()));
                        break;
                    }
                case 10: {
                        if (!(message.tags && message.tags.length))
                            message.tags = [];
                        message.tags.push(reader.string());
                        break;
                    }
                case 11: {
                        message.shared = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Schedule message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Schedule
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Schedule} Schedule
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Schedule.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Schedule message.
         * @function verify
         * @memberof busable.Schedule
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Schedule.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                if (!$util.isString(message.scheduleId))
                    return "scheduleId: string expected";
            if (message.scheduleName != null && message.hasOwnProperty("scheduleName"))
                if (!$util.isString(message.scheduleName))
                    return "scheduleName: string expected";
            if (message.schedulePeriods != null && message.hasOwnProperty("schedulePeriods")) {
                if (!Array.isArray(message.schedulePeriods))
                    return "schedulePeriods: array expected";
                for (var i = 0; i < message.schedulePeriods.length; ++i) {
                    var error = $root.busable.Period.verify(message.schedulePeriods[i]);
                    if (error)
                        return "schedulePeriods." + error;
                }
            }
            if (message.operatingDays != null && message.hasOwnProperty("operatingDays")) {
                var error = $root.busable.OperatingDays.verify(message.operatingDays);
                if (error)
                    return "operatingDays." + error;
            }
            if (message.excludedPeriods != null && message.hasOwnProperty("excludedPeriods")) {
                if (!Array.isArray(message.excludedPeriods))
                    return "excludedPeriods: array expected";
                for (var i = 0; i < message.excludedPeriods.length; ++i) {
                    var error = $root.busable.Period.verify(message.excludedPeriods[i]);
                    if (error)
                        return "excludedPeriods." + error;
                }
            }
            if (message.includedSchedules != null && message.hasOwnProperty("includedSchedules")) {
                if (!Array.isArray(message.includedSchedules))
                    return "includedSchedules: array expected";
                for (var i = 0; i < message.includedSchedules.length; ++i)
                    if (!$util.isString(message.includedSchedules[i]))
                        return "includedSchedules: string[] expected";
            }
            if (message.excludedSchedules != null && message.hasOwnProperty("excludedSchedules")) {
                if (!Array.isArray(message.excludedSchedules))
                    return "excludedSchedules: array expected";
                for (var i = 0; i < message.excludedSchedules.length; ++i)
                    if (!$util.isString(message.excludedSchedules[i]))
                        return "excludedSchedules: string[] expected";
            }
            if (message.charter != null && message.hasOwnProperty("charter"))
                if (typeof message.charter !== "boolean")
                    return "charter: boolean expected";
            if (message.exceptions != null && message.hasOwnProperty("exceptions")) {
                if (!Array.isArray(message.exceptions))
                    return "exceptions: array expected";
                for (var i = 0; i < message.exceptions.length; ++i) {
                    var error = $root.busable.Exception.verify(message.exceptions[i]);
                    if (error)
                        return "exceptions." + error;
                }
            }
            if (message.tags != null && message.hasOwnProperty("tags")) {
                if (!Array.isArray(message.tags))
                    return "tags: array expected";
                for (var i = 0; i < message.tags.length; ++i)
                    if (!$util.isString(message.tags[i]))
                        return "tags: string[] expected";
            }
            if (message.shared != null && message.hasOwnProperty("shared"))
                if (typeof message.shared !== "boolean")
                    return "shared: boolean expected";
            return null;
        };

        /**
         * Creates a Schedule message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Schedule
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Schedule} Schedule
         */
        Schedule.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Schedule)
                return object;
            var message = new $root.busable.Schedule();
            if (object.scheduleId != null)
                message.scheduleId = String(object.scheduleId);
            if (object.scheduleName != null)
                message.scheduleName = String(object.scheduleName);
            if (object.schedulePeriods) {
                if (!Array.isArray(object.schedulePeriods))
                    throw TypeError(".busable.Schedule.schedulePeriods: array expected");
                message.schedulePeriods = [];
                for (var i = 0; i < object.schedulePeriods.length; ++i) {
                    if (typeof object.schedulePeriods[i] !== "object")
                        throw TypeError(".busable.Schedule.schedulePeriods: object expected");
                    message.schedulePeriods[i] = $root.busable.Period.fromObject(object.schedulePeriods[i]);
                }
            }
            if (object.operatingDays != null) {
                if (typeof object.operatingDays !== "object")
                    throw TypeError(".busable.Schedule.operatingDays: object expected");
                message.operatingDays = $root.busable.OperatingDays.fromObject(object.operatingDays);
            }
            if (object.excludedPeriods) {
                if (!Array.isArray(object.excludedPeriods))
                    throw TypeError(".busable.Schedule.excludedPeriods: array expected");
                message.excludedPeriods = [];
                for (var i = 0; i < object.excludedPeriods.length; ++i) {
                    if (typeof object.excludedPeriods[i] !== "object")
                        throw TypeError(".busable.Schedule.excludedPeriods: object expected");
                    message.excludedPeriods[i] = $root.busable.Period.fromObject(object.excludedPeriods[i]);
                }
            }
            if (object.includedSchedules) {
                if (!Array.isArray(object.includedSchedules))
                    throw TypeError(".busable.Schedule.includedSchedules: array expected");
                message.includedSchedules = [];
                for (var i = 0; i < object.includedSchedules.length; ++i)
                    message.includedSchedules[i] = String(object.includedSchedules[i]);
            }
            if (object.excludedSchedules) {
                if (!Array.isArray(object.excludedSchedules))
                    throw TypeError(".busable.Schedule.excludedSchedules: array expected");
                message.excludedSchedules = [];
                for (var i = 0; i < object.excludedSchedules.length; ++i)
                    message.excludedSchedules[i] = String(object.excludedSchedules[i]);
            }
            if (object.charter != null)
                message.charter = Boolean(object.charter);
            if (object.exceptions) {
                if (!Array.isArray(object.exceptions))
                    throw TypeError(".busable.Schedule.exceptions: array expected");
                message.exceptions = [];
                for (var i = 0; i < object.exceptions.length; ++i) {
                    if (typeof object.exceptions[i] !== "object")
                        throw TypeError(".busable.Schedule.exceptions: object expected");
                    message.exceptions[i] = $root.busable.Exception.fromObject(object.exceptions[i]);
                }
            }
            if (object.tags) {
                if (!Array.isArray(object.tags))
                    throw TypeError(".busable.Schedule.tags: array expected");
                message.tags = [];
                for (var i = 0; i < object.tags.length; ++i)
                    message.tags[i] = String(object.tags[i]);
            }
            if (object.shared != null)
                message.shared = Boolean(object.shared);
            return message;
        };

        /**
         * Creates a plain object from a Schedule message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Schedule
         * @static
         * @param {busable.Schedule} message Schedule
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Schedule.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.schedulePeriods = [];
                object.excludedPeriods = [];
                object.includedSchedules = [];
                object.excludedSchedules = [];
                object.exceptions = [];
                object.tags = [];
            }
            if (options.defaults) {
                object.scheduleId = "";
                object.scheduleName = "";
                object.operatingDays = null;
                object.charter = false;
                object.shared = false;
            }
            if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                object.scheduleId = message.scheduleId;
            if (message.scheduleName != null && message.hasOwnProperty("scheduleName"))
                object.scheduleName = message.scheduleName;
            if (message.schedulePeriods && message.schedulePeriods.length) {
                object.schedulePeriods = [];
                for (var j = 0; j < message.schedulePeriods.length; ++j)
                    object.schedulePeriods[j] = $root.busable.Period.toObject(message.schedulePeriods[j], options);
            }
            if (message.operatingDays != null && message.hasOwnProperty("operatingDays"))
                object.operatingDays = $root.busable.OperatingDays.toObject(message.operatingDays, options);
            if (message.excludedPeriods && message.excludedPeriods.length) {
                object.excludedPeriods = [];
                for (var j = 0; j < message.excludedPeriods.length; ++j)
                    object.excludedPeriods[j] = $root.busable.Period.toObject(message.excludedPeriods[j], options);
            }
            if (message.includedSchedules && message.includedSchedules.length) {
                object.includedSchedules = [];
                for (var j = 0; j < message.includedSchedules.length; ++j)
                    object.includedSchedules[j] = message.includedSchedules[j];
            }
            if (message.excludedSchedules && message.excludedSchedules.length) {
                object.excludedSchedules = [];
                for (var j = 0; j < message.excludedSchedules.length; ++j)
                    object.excludedSchedules[j] = message.excludedSchedules[j];
            }
            if (message.charter != null && message.hasOwnProperty("charter"))
                object.charter = message.charter;
            if (message.exceptions && message.exceptions.length) {
                object.exceptions = [];
                for (var j = 0; j < message.exceptions.length; ++j)
                    object.exceptions[j] = $root.busable.Exception.toObject(message.exceptions[j], options);
            }
            if (message.tags && message.tags.length) {
                object.tags = [];
                for (var j = 0; j < message.tags.length; ++j)
                    object.tags[j] = message.tags[j];
            }
            if (message.shared != null && message.hasOwnProperty("shared"))
                object.shared = message.shared;
            return object;
        };

        /**
         * Converts this Schedule to JSON.
         * @function toJSON
         * @memberof busable.Schedule
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Schedule.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Schedule
         * @function getTypeUrl
         * @memberof busable.Schedule
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Schedule.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Schedule";
        };

        return Schedule;
    })();

    busable.Transfer = (function() {

        /**
         * Properties of a Transfer.
         * @memberof busable
         * @interface ITransfer
         * @property {string|null} [transferId] Transfer transferId
         * @property {string|null} [fromRouteNumber] Transfer fromRouteNumber
         * @property {string|null} [fromRouteId] Transfer fromRouteId
         * @property {string|null} [fromTripId] Transfer fromTripId
         * @property {string|null} [fromStopId] Transfer fromStopId
         * @property {string|null} [fromStopTimeId] Transfer fromStopTimeId
         * @property {string|null} [toRouteNumber] Transfer toRouteNumber
         * @property {string|null} [toRouteId] Transfer toRouteId
         * @property {string|null} [toTripId] Transfer toTripId
         * @property {string|null} [toStopId] Transfer toStopId
         * @property {string|null} [toStopTimeId] Transfer toStopTimeId
         * @property {number|null} [time] Transfer time
         * @property {number|null} [window] Transfer window
         * @property {Array.<busable.IWayPoint>|null} [waypoints] Transfer waypoints
         * @property {number|null} [distance] Transfer distance
         * @property {number|null} [duration] Transfer duration
         * @property {Array.<string>|null} [warnings] Transfer warnings
         */

        /**
         * Constructs a new Transfer.
         * @memberof busable
         * @classdesc Represents a Transfer.
         * @implements ITransfer
         * @constructor
         * @param {busable.ITransfer=} [properties] Properties to set
         */
        function Transfer(properties) {
            this.waypoints = [];
            this.warnings = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Transfer transferId.
         * @member {string} transferId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.transferId = "";

        /**
         * Transfer fromRouteNumber.
         * @member {string} fromRouteNumber
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.fromRouteNumber = "";

        /**
         * Transfer fromRouteId.
         * @member {string} fromRouteId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.fromRouteId = "";

        /**
         * Transfer fromTripId.
         * @member {string} fromTripId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.fromTripId = "";

        /**
         * Transfer fromStopId.
         * @member {string} fromStopId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.fromStopId = "";

        /**
         * Transfer fromStopTimeId.
         * @member {string} fromStopTimeId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.fromStopTimeId = "";

        /**
         * Transfer toRouteNumber.
         * @member {string} toRouteNumber
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.toRouteNumber = "";

        /**
         * Transfer toRouteId.
         * @member {string} toRouteId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.toRouteId = "";

        /**
         * Transfer toTripId.
         * @member {string} toTripId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.toTripId = "";

        /**
         * Transfer toStopId.
         * @member {string} toStopId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.toStopId = "";

        /**
         * Transfer toStopTimeId.
         * @member {string} toStopTimeId
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.toStopTimeId = "";

        /**
         * Transfer time.
         * @member {number} time
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.time = 0;

        /**
         * Transfer window.
         * @member {number} window
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.window = 0;

        /**
         * Transfer waypoints.
         * @member {Array.<busable.IWayPoint>} waypoints
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.waypoints = $util.emptyArray;

        /**
         * Transfer distance.
         * @member {number} distance
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.distance = 0;

        /**
         * Transfer duration.
         * @member {number} duration
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.duration = 0;

        /**
         * Transfer warnings.
         * @member {Array.<string>} warnings
         * @memberof busable.Transfer
         * @instance
         */
        Transfer.prototype.warnings = $util.emptyArray;

        /**
         * Creates a new Transfer instance using the specified properties.
         * @function create
         * @memberof busable.Transfer
         * @static
         * @param {busable.ITransfer=} [properties] Properties to set
         * @returns {busable.Transfer} Transfer instance
         */
        Transfer.create = function create(properties) {
            return new Transfer(properties);
        };

        /**
         * Encodes the specified Transfer message. Does not implicitly {@link busable.Transfer.verify|verify} messages.
         * @function encode
         * @memberof busable.Transfer
         * @static
         * @param {busable.ITransfer} message Transfer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Transfer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.transferId != null && Object.hasOwnProperty.call(message, "transferId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.transferId);
            if (message.fromRouteNumber != null && Object.hasOwnProperty.call(message, "fromRouteNumber"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.fromRouteNumber);
            if (message.fromRouteId != null && Object.hasOwnProperty.call(message, "fromRouteId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromRouteId);
            if (message.fromTripId != null && Object.hasOwnProperty.call(message, "fromTripId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.fromTripId);
            if (message.fromStopId != null && Object.hasOwnProperty.call(message, "fromStopId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.fromStopId);
            if (message.fromStopTimeId != null && Object.hasOwnProperty.call(message, "fromStopTimeId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.fromStopTimeId);
            if (message.toRouteNumber != null && Object.hasOwnProperty.call(message, "toRouteNumber"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.toRouteNumber);
            if (message.toRouteId != null && Object.hasOwnProperty.call(message, "toRouteId"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.toRouteId);
            if (message.toTripId != null && Object.hasOwnProperty.call(message, "toTripId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.toTripId);
            if (message.toStopId != null && Object.hasOwnProperty.call(message, "toStopId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.toStopId);
            if (message.toStopTimeId != null && Object.hasOwnProperty.call(message, "toStopTimeId"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.toStopTimeId);
            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.time);
            if (message.window != null && Object.hasOwnProperty.call(message, "window"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.window);
            if (message.waypoints != null && message.waypoints.length)
                for (var i = 0; i < message.waypoints.length; ++i)
                    $root.busable.WayPoint.encode(message.waypoints[i], writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                writer.uint32(/* id 15, wireType 1 =*/121).double(message.distance);
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.duration);
            if (message.warnings != null && message.warnings.length)
                for (var i = 0; i < message.warnings.length; ++i)
                    writer.uint32(/* id 17, wireType 2 =*/138).string(message.warnings[i]);
            return writer;
        };

        /**
         * Encodes the specified Transfer message, length delimited. Does not implicitly {@link busable.Transfer.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Transfer
         * @static
         * @param {busable.ITransfer} message Transfer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Transfer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Transfer message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Transfer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Transfer} Transfer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Transfer.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Transfer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.transferId = reader.string();
                        break;
                    }
                case 2: {
                        message.fromRouteNumber = reader.string();
                        break;
                    }
                case 3: {
                        message.fromRouteId = reader.string();
                        break;
                    }
                case 4: {
                        message.fromTripId = reader.string();
                        break;
                    }
                case 5: {
                        message.fromStopId = reader.string();
                        break;
                    }
                case 6: {
                        message.fromStopTimeId = reader.string();
                        break;
                    }
                case 7: {
                        message.toRouteNumber = reader.string();
                        break;
                    }
                case 8: {
                        message.toRouteId = reader.string();
                        break;
                    }
                case 9: {
                        message.toTripId = reader.string();
                        break;
                    }
                case 10: {
                        message.toStopId = reader.string();
                        break;
                    }
                case 11: {
                        message.toStopTimeId = reader.string();
                        break;
                    }
                case 12: {
                        message.time = reader.int32();
                        break;
                    }
                case 13: {
                        message.window = reader.int32();
                        break;
                    }
                case 14: {
                        if (!(message.waypoints && message.waypoints.length))
                            message.waypoints = [];
                        message.waypoints.push($root.busable.WayPoint.decode(reader, reader.uint32()));
                        break;
                    }
                case 15: {
                        message.distance = reader.double();
                        break;
                    }
                case 16: {
                        message.duration = reader.int32();
                        break;
                    }
                case 17: {
                        if (!(message.warnings && message.warnings.length))
                            message.warnings = [];
                        message.warnings.push(reader.string());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Transfer message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Transfer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Transfer} Transfer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Transfer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Transfer message.
         * @function verify
         * @memberof busable.Transfer
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Transfer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.transferId != null && message.hasOwnProperty("transferId"))
                if (!$util.isString(message.transferId))
                    return "transferId: string expected";
            if (message.fromRouteNumber != null && message.hasOwnProperty("fromRouteNumber"))
                if (!$util.isString(message.fromRouteNumber))
                    return "fromRouteNumber: string expected";
            if (message.fromRouteId != null && message.hasOwnProperty("fromRouteId"))
                if (!$util.isString(message.fromRouteId))
                    return "fromRouteId: string expected";
            if (message.fromTripId != null && message.hasOwnProperty("fromTripId"))
                if (!$util.isString(message.fromTripId))
                    return "fromTripId: string expected";
            if (message.fromStopId != null && message.hasOwnProperty("fromStopId"))
                if (!$util.isString(message.fromStopId))
                    return "fromStopId: string expected";
            if (message.fromStopTimeId != null && message.hasOwnProperty("fromStopTimeId"))
                if (!$util.isString(message.fromStopTimeId))
                    return "fromStopTimeId: string expected";
            if (message.toRouteNumber != null && message.hasOwnProperty("toRouteNumber"))
                if (!$util.isString(message.toRouteNumber))
                    return "toRouteNumber: string expected";
            if (message.toRouteId != null && message.hasOwnProperty("toRouteId"))
                if (!$util.isString(message.toRouteId))
                    return "toRouteId: string expected";
            if (message.toTripId != null && message.hasOwnProperty("toTripId"))
                if (!$util.isString(message.toTripId))
                    return "toTripId: string expected";
            if (message.toStopId != null && message.hasOwnProperty("toStopId"))
                if (!$util.isString(message.toStopId))
                    return "toStopId: string expected";
            if (message.toStopTimeId != null && message.hasOwnProperty("toStopTimeId"))
                if (!$util.isString(message.toStopTimeId))
                    return "toStopTimeId: string expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time))
                    return "time: integer expected";
            if (message.window != null && message.hasOwnProperty("window"))
                if (!$util.isInteger(message.window))
                    return "window: integer expected";
            if (message.waypoints != null && message.hasOwnProperty("waypoints")) {
                if (!Array.isArray(message.waypoints))
                    return "waypoints: array expected";
                for (var i = 0; i < message.waypoints.length; ++i) {
                    var error = $root.busable.WayPoint.verify(message.waypoints[i]);
                    if (error)
                        return "waypoints." + error;
                }
            }
            if (message.distance != null && message.hasOwnProperty("distance"))
                if (typeof message.distance !== "number")
                    return "distance: number expected";
            if (message.duration != null && message.hasOwnProperty("duration"))
                if (!$util.isInteger(message.duration))
                    return "duration: integer expected";
            if (message.warnings != null && message.hasOwnProperty("warnings")) {
                if (!Array.isArray(message.warnings))
                    return "warnings: array expected";
                for (var i = 0; i < message.warnings.length; ++i)
                    if (!$util.isString(message.warnings[i]))
                        return "warnings: string[] expected";
            }
            return null;
        };

        /**
         * Creates a Transfer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Transfer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Transfer} Transfer
         */
        Transfer.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Transfer)
                return object;
            var message = new $root.busable.Transfer();
            if (object.transferId != null)
                message.transferId = String(object.transferId);
            if (object.fromRouteNumber != null)
                message.fromRouteNumber = String(object.fromRouteNumber);
            if (object.fromRouteId != null)
                message.fromRouteId = String(object.fromRouteId);
            if (object.fromTripId != null)
                message.fromTripId = String(object.fromTripId);
            if (object.fromStopId != null)
                message.fromStopId = String(object.fromStopId);
            if (object.fromStopTimeId != null)
                message.fromStopTimeId = String(object.fromStopTimeId);
            if (object.toRouteNumber != null)
                message.toRouteNumber = String(object.toRouteNumber);
            if (object.toRouteId != null)
                message.toRouteId = String(object.toRouteId);
            if (object.toTripId != null)
                message.toTripId = String(object.toTripId);
            if (object.toStopId != null)
                message.toStopId = String(object.toStopId);
            if (object.toStopTimeId != null)
                message.toStopTimeId = String(object.toStopTimeId);
            if (object.time != null)
                message.time = object.time | 0;
            if (object.window != null)
                message.window = object.window | 0;
            if (object.waypoints) {
                if (!Array.isArray(object.waypoints))
                    throw TypeError(".busable.Transfer.waypoints: array expected");
                message.waypoints = [];
                for (var i = 0; i < object.waypoints.length; ++i) {
                    if (typeof object.waypoints[i] !== "object")
                        throw TypeError(".busable.Transfer.waypoints: object expected");
                    message.waypoints[i] = $root.busable.WayPoint.fromObject(object.waypoints[i]);
                }
            }
            if (object.distance != null)
                message.distance = Number(object.distance);
            if (object.duration != null)
                message.duration = object.duration | 0;
            if (object.warnings) {
                if (!Array.isArray(object.warnings))
                    throw TypeError(".busable.Transfer.warnings: array expected");
                message.warnings = [];
                for (var i = 0; i < object.warnings.length; ++i)
                    message.warnings[i] = String(object.warnings[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a Transfer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Transfer
         * @static
         * @param {busable.Transfer} message Transfer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Transfer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.waypoints = [];
                object.warnings = [];
            }
            if (options.defaults) {
                object.transferId = "";
                object.fromRouteNumber = "";
                object.fromRouteId = "";
                object.fromTripId = "";
                object.fromStopId = "";
                object.fromStopTimeId = "";
                object.toRouteNumber = "";
                object.toRouteId = "";
                object.toTripId = "";
                object.toStopId = "";
                object.toStopTimeId = "";
                object.time = 0;
                object.window = 0;
                object.distance = 0;
                object.duration = 0;
            }
            if (message.transferId != null && message.hasOwnProperty("transferId"))
                object.transferId = message.transferId;
            if (message.fromRouteNumber != null && message.hasOwnProperty("fromRouteNumber"))
                object.fromRouteNumber = message.fromRouteNumber;
            if (message.fromRouteId != null && message.hasOwnProperty("fromRouteId"))
                object.fromRouteId = message.fromRouteId;
            if (message.fromTripId != null && message.hasOwnProperty("fromTripId"))
                object.fromTripId = message.fromTripId;
            if (message.fromStopId != null && message.hasOwnProperty("fromStopId"))
                object.fromStopId = message.fromStopId;
            if (message.fromStopTimeId != null && message.hasOwnProperty("fromStopTimeId"))
                object.fromStopTimeId = message.fromStopTimeId;
            if (message.toRouteNumber != null && message.hasOwnProperty("toRouteNumber"))
                object.toRouteNumber = message.toRouteNumber;
            if (message.toRouteId != null && message.hasOwnProperty("toRouteId"))
                object.toRouteId = message.toRouteId;
            if (message.toTripId != null && message.hasOwnProperty("toTripId"))
                object.toTripId = message.toTripId;
            if (message.toStopId != null && message.hasOwnProperty("toStopId"))
                object.toStopId = message.toStopId;
            if (message.toStopTimeId != null && message.hasOwnProperty("toStopTimeId"))
                object.toStopTimeId = message.toStopTimeId;
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.window != null && message.hasOwnProperty("window"))
                object.window = message.window;
            if (message.waypoints && message.waypoints.length) {
                object.waypoints = [];
                for (var j = 0; j < message.waypoints.length; ++j)
                    object.waypoints[j] = $root.busable.WayPoint.toObject(message.waypoints[j], options);
            }
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = options.json && !isFinite(message.distance) ? String(message.distance) : message.distance;
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = message.duration;
            if (message.warnings && message.warnings.length) {
                object.warnings = [];
                for (var j = 0; j < message.warnings.length; ++j)
                    object.warnings[j] = message.warnings[j];
            }
            return object;
        };

        /**
         * Converts this Transfer to JSON.
         * @function toJSON
         * @memberof busable.Transfer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Transfer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Transfer
         * @function getTypeUrl
         * @memberof busable.Transfer
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Transfer.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Transfer";
        };

        return Transfer;
    })();

    busable.ShiftBatRow = (function() {

        /**
         * Properties of a ShiftBatRow.
         * @memberof busable
         * @interface IShiftBatRow
         * @property {string|null} [id] ShiftBatRow id
         * @property {string|null} [type] ShiftBatRow type
         * @property {string|null} [title] ShiftBatRow title
         * @property {string|null} [description] ShiftBatRow description
         * @property {string|null} [priority] ShiftBatRow priority
         * @property {number|null} [time] ShiftBatRow time
         * @property {number|null} [endTime] ShiftBatRow endTime
         * @property {number|null} [duration] ShiftBatRow duration
         * @property {number|null} [distance] ShiftBatRow distance
         * @property {string|null} [routeId] ShiftBatRow routeId
         * @property {string|null} [tripId] ShiftBatRow tripId
         * @property {number|null} [startStopIdx] ShiftBatRow startStopIdx
         * @property {number|null} [endStopIdx] ShiftBatRow endStopIdx
         * @property {boolean|null} [charter] ShiftBatRow charter
         * @property {Array.<busable.IShiftBatRow>|null} [stopRows] ShiftBatRow stopRows
         * @property {string|null} [startStopId] ShiftBatRow startStopId
         * @property {string|null} [endStopId] ShiftBatRow endStopId
         * @property {string|null} [stopId] ShiftBatRow stopId
         * @property {Array.<busable.IShiftBatRow>|null} [noteRows] ShiftBatRow noteRows
         * @property {string|null} [charterId] ShiftBatRow charterId
         * @property {string|null} [templateId] ShiftBatRow templateId
         */

        /**
         * Constructs a new ShiftBatRow.
         * @memberof busable
         * @classdesc Represents a ShiftBatRow.
         * @implements IShiftBatRow
         * @constructor
         * @param {busable.IShiftBatRow=} [properties] Properties to set
         */
        function ShiftBatRow(properties) {
            this.stopRows = [];
            this.noteRows = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ShiftBatRow id.
         * @member {string} id
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.id = "";

        /**
         * ShiftBatRow type.
         * @member {string} type
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.type = "";

        /**
         * ShiftBatRow title.
         * @member {string} title
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.title = "";

        /**
         * ShiftBatRow description.
         * @member {string} description
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.description = "";

        /**
         * ShiftBatRow priority.
         * @member {string} priority
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.priority = "";

        /**
         * ShiftBatRow time.
         * @member {number} time
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.time = 0;

        /**
         * ShiftBatRow endTime.
         * @member {number} endTime
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.endTime = 0;

        /**
         * ShiftBatRow duration.
         * @member {number} duration
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.duration = 0;

        /**
         * ShiftBatRow distance.
         * @member {number} distance
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.distance = 0;

        /**
         * ShiftBatRow routeId.
         * @member {string} routeId
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.routeId = "";

        /**
         * ShiftBatRow tripId.
         * @member {string} tripId
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.tripId = "";

        /**
         * ShiftBatRow startStopIdx.
         * @member {number} startStopIdx
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.startStopIdx = 0;

        /**
         * ShiftBatRow endStopIdx.
         * @member {number} endStopIdx
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.endStopIdx = 0;

        /**
         * ShiftBatRow charter.
         * @member {boolean} charter
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.charter = false;

        /**
         * ShiftBatRow stopRows.
         * @member {Array.<busable.IShiftBatRow>} stopRows
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.stopRows = $util.emptyArray;

        /**
         * ShiftBatRow startStopId.
         * @member {string} startStopId
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.startStopId = "";

        /**
         * ShiftBatRow endStopId.
         * @member {string} endStopId
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.endStopId = "";

        /**
         * ShiftBatRow stopId.
         * @member {string} stopId
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.stopId = "";

        /**
         * ShiftBatRow noteRows.
         * @member {Array.<busable.IShiftBatRow>} noteRows
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.noteRows = $util.emptyArray;

        /**
         * ShiftBatRow charterId.
         * @member {string} charterId
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.charterId = "";

        /**
         * ShiftBatRow templateId.
         * @member {string} templateId
         * @memberof busable.ShiftBatRow
         * @instance
         */
        ShiftBatRow.prototype.templateId = "";

        /**
         * Creates a new ShiftBatRow instance using the specified properties.
         * @function create
         * @memberof busable.ShiftBatRow
         * @static
         * @param {busable.IShiftBatRow=} [properties] Properties to set
         * @returns {busable.ShiftBatRow} ShiftBatRow instance
         */
        ShiftBatRow.create = function create(properties) {
            return new ShiftBatRow(properties);
        };

        /**
         * Encodes the specified ShiftBatRow message. Does not implicitly {@link busable.ShiftBatRow.verify|verify} messages.
         * @function encode
         * @memberof busable.ShiftBatRow
         * @static
         * @param {busable.IShiftBatRow} message ShiftBatRow message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShiftBatRow.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
            if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.title);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
            if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.priority);
            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.time);
            if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.endTime);
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.duration);
            if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                writer.uint32(/* id 9, wireType 1 =*/73).double(message.distance);
            if (message.routeId != null && Object.hasOwnProperty.call(message, "routeId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.routeId);
            if (message.tripId != null && Object.hasOwnProperty.call(message, "tripId"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.tripId);
            if (message.startStopIdx != null && Object.hasOwnProperty.call(message, "startStopIdx"))
                writer.uint32(/* id 12, wireType 0 =*/96).int32(message.startStopIdx);
            if (message.endStopIdx != null && Object.hasOwnProperty.call(message, "endStopIdx"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.endStopIdx);
            if (message.charter != null && Object.hasOwnProperty.call(message, "charter"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.charter);
            if (message.stopRows != null && message.stopRows.length)
                for (var i = 0; i < message.stopRows.length; ++i)
                    $root.busable.ShiftBatRow.encode(message.stopRows[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.startStopId != null && Object.hasOwnProperty.call(message, "startStopId"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.startStopId);
            if (message.endStopId != null && Object.hasOwnProperty.call(message, "endStopId"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.endStopId);
            if (message.stopId != null && Object.hasOwnProperty.call(message, "stopId"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.stopId);
            if (message.noteRows != null && message.noteRows.length)
                for (var i = 0; i < message.noteRows.length; ++i)
                    $root.busable.ShiftBatRow.encode(message.noteRows[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
            if (message.charterId != null && Object.hasOwnProperty.call(message, "charterId"))
                writer.uint32(/* id 20, wireType 2 =*/162).string(message.charterId);
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 21, wireType 2 =*/170).string(message.templateId);
            return writer;
        };

        /**
         * Encodes the specified ShiftBatRow message, length delimited. Does not implicitly {@link busable.ShiftBatRow.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.ShiftBatRow
         * @static
         * @param {busable.IShiftBatRow} message ShiftBatRow message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShiftBatRow.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ShiftBatRow message from the specified reader or buffer.
         * @function decode
         * @memberof busable.ShiftBatRow
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.ShiftBatRow} ShiftBatRow
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShiftBatRow.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.ShiftBatRow();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.type = reader.string();
                        break;
                    }
                case 3: {
                        message.title = reader.string();
                        break;
                    }
                case 4: {
                        message.description = reader.string();
                        break;
                    }
                case 5: {
                        message.priority = reader.string();
                        break;
                    }
                case 6: {
                        message.time = reader.int32();
                        break;
                    }
                case 7: {
                        message.endTime = reader.int32();
                        break;
                    }
                case 8: {
                        message.duration = reader.int32();
                        break;
                    }
                case 9: {
                        message.distance = reader.double();
                        break;
                    }
                case 10: {
                        message.routeId = reader.string();
                        break;
                    }
                case 11: {
                        message.tripId = reader.string();
                        break;
                    }
                case 12: {
                        message.startStopIdx = reader.int32();
                        break;
                    }
                case 13: {
                        message.endStopIdx = reader.int32();
                        break;
                    }
                case 14: {
                        message.charter = reader.bool();
                        break;
                    }
                case 15: {
                        if (!(message.stopRows && message.stopRows.length))
                            message.stopRows = [];
                        message.stopRows.push($root.busable.ShiftBatRow.decode(reader, reader.uint32()));
                        break;
                    }
                case 16: {
                        message.startStopId = reader.string();
                        break;
                    }
                case 17: {
                        message.endStopId = reader.string();
                        break;
                    }
                case 18: {
                        message.stopId = reader.string();
                        break;
                    }
                case 19: {
                        if (!(message.noteRows && message.noteRows.length))
                            message.noteRows = [];
                        message.noteRows.push($root.busable.ShiftBatRow.decode(reader, reader.uint32()));
                        break;
                    }
                case 20: {
                        message.charterId = reader.string();
                        break;
                    }
                case 21: {
                        message.templateId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ShiftBatRow message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.ShiftBatRow
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.ShiftBatRow} ShiftBatRow
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShiftBatRow.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ShiftBatRow message.
         * @function verify
         * @memberof busable.ShiftBatRow
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ShiftBatRow.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.title != null && message.hasOwnProperty("title"))
                if (!$util.isString(message.title))
                    return "title: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.priority != null && message.hasOwnProperty("priority"))
                if (!$util.isString(message.priority))
                    return "priority: string expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time))
                    return "time: integer expected";
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                if (!$util.isInteger(message.endTime))
                    return "endTime: integer expected";
            if (message.duration != null && message.hasOwnProperty("duration"))
                if (!$util.isInteger(message.duration))
                    return "duration: integer expected";
            if (message.distance != null && message.hasOwnProperty("distance"))
                if (typeof message.distance !== "number")
                    return "distance: number expected";
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                if (!$util.isString(message.routeId))
                    return "routeId: string expected";
            if (message.tripId != null && message.hasOwnProperty("tripId"))
                if (!$util.isString(message.tripId))
                    return "tripId: string expected";
            if (message.startStopIdx != null && message.hasOwnProperty("startStopIdx"))
                if (!$util.isInteger(message.startStopIdx))
                    return "startStopIdx: integer expected";
            if (message.endStopIdx != null && message.hasOwnProperty("endStopIdx"))
                if (!$util.isInteger(message.endStopIdx))
                    return "endStopIdx: integer expected";
            if (message.charter != null && message.hasOwnProperty("charter"))
                if (typeof message.charter !== "boolean")
                    return "charter: boolean expected";
            if (message.stopRows != null && message.hasOwnProperty("stopRows")) {
                if (!Array.isArray(message.stopRows))
                    return "stopRows: array expected";
                for (var i = 0; i < message.stopRows.length; ++i) {
                    var error = $root.busable.ShiftBatRow.verify(message.stopRows[i]);
                    if (error)
                        return "stopRows." + error;
                }
            }
            if (message.startStopId != null && message.hasOwnProperty("startStopId"))
                if (!$util.isString(message.startStopId))
                    return "startStopId: string expected";
            if (message.endStopId != null && message.hasOwnProperty("endStopId"))
                if (!$util.isString(message.endStopId))
                    return "endStopId: string expected";
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                if (!$util.isString(message.stopId))
                    return "stopId: string expected";
            if (message.noteRows != null && message.hasOwnProperty("noteRows")) {
                if (!Array.isArray(message.noteRows))
                    return "noteRows: array expected";
                for (var i = 0; i < message.noteRows.length; ++i) {
                    var error = $root.busable.ShiftBatRow.verify(message.noteRows[i]);
                    if (error)
                        return "noteRows." + error;
                }
            }
            if (message.charterId != null && message.hasOwnProperty("charterId"))
                if (!$util.isString(message.charterId))
                    return "charterId: string expected";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isString(message.templateId))
                    return "templateId: string expected";
            return null;
        };

        /**
         * Creates a ShiftBatRow message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.ShiftBatRow
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.ShiftBatRow} ShiftBatRow
         */
        ShiftBatRow.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.ShiftBatRow)
                return object;
            var message = new $root.busable.ShiftBatRow();
            if (object.id != null)
                message.id = String(object.id);
            if (object.type != null)
                message.type = String(object.type);
            if (object.title != null)
                message.title = String(object.title);
            if (object.description != null)
                message.description = String(object.description);
            if (object.priority != null)
                message.priority = String(object.priority);
            if (object.time != null)
                message.time = object.time | 0;
            if (object.endTime != null)
                message.endTime = object.endTime | 0;
            if (object.duration != null)
                message.duration = object.duration | 0;
            if (object.distance != null)
                message.distance = Number(object.distance);
            if (object.routeId != null)
                message.routeId = String(object.routeId);
            if (object.tripId != null)
                message.tripId = String(object.tripId);
            if (object.startStopIdx != null)
                message.startStopIdx = object.startStopIdx | 0;
            if (object.endStopIdx != null)
                message.endStopIdx = object.endStopIdx | 0;
            if (object.charter != null)
                message.charter = Boolean(object.charter);
            if (object.stopRows) {
                if (!Array.isArray(object.stopRows))
                    throw TypeError(".busable.ShiftBatRow.stopRows: array expected");
                message.stopRows = [];
                for (var i = 0; i < object.stopRows.length; ++i) {
                    if (typeof object.stopRows[i] !== "object")
                        throw TypeError(".busable.ShiftBatRow.stopRows: object expected");
                    message.stopRows[i] = $root.busable.ShiftBatRow.fromObject(object.stopRows[i]);
                }
            }
            if (object.startStopId != null)
                message.startStopId = String(object.startStopId);
            if (object.endStopId != null)
                message.endStopId = String(object.endStopId);
            if (object.stopId != null)
                message.stopId = String(object.stopId);
            if (object.noteRows) {
                if (!Array.isArray(object.noteRows))
                    throw TypeError(".busable.ShiftBatRow.noteRows: array expected");
                message.noteRows = [];
                for (var i = 0; i < object.noteRows.length; ++i) {
                    if (typeof object.noteRows[i] !== "object")
                        throw TypeError(".busable.ShiftBatRow.noteRows: object expected");
                    message.noteRows[i] = $root.busable.ShiftBatRow.fromObject(object.noteRows[i]);
                }
            }
            if (object.charterId != null)
                message.charterId = String(object.charterId);
            if (object.templateId != null)
                message.templateId = String(object.templateId);
            return message;
        };

        /**
         * Creates a plain object from a ShiftBatRow message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.ShiftBatRow
         * @static
         * @param {busable.ShiftBatRow} message ShiftBatRow
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShiftBatRow.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.stopRows = [];
                object.noteRows = [];
            }
            if (options.defaults) {
                object.id = "";
                object.type = "";
                object.title = "";
                object.description = "";
                object.priority = "";
                object.time = 0;
                object.endTime = 0;
                object.duration = 0;
                object.distance = 0;
                object.routeId = "";
                object.tripId = "";
                object.startStopIdx = 0;
                object.endStopIdx = 0;
                object.charter = false;
                object.startStopId = "";
                object.endStopId = "";
                object.stopId = "";
                object.charterId = "";
                object.templateId = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.title != null && message.hasOwnProperty("title"))
                object.title = message.title;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.priority != null && message.hasOwnProperty("priority"))
                object.priority = message.priority;
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            if (message.endTime != null && message.hasOwnProperty("endTime"))
                object.endTime = message.endTime;
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = message.duration;
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = options.json && !isFinite(message.distance) ? String(message.distance) : message.distance;
            if (message.routeId != null && message.hasOwnProperty("routeId"))
                object.routeId = message.routeId;
            if (message.tripId != null && message.hasOwnProperty("tripId"))
                object.tripId = message.tripId;
            if (message.startStopIdx != null && message.hasOwnProperty("startStopIdx"))
                object.startStopIdx = message.startStopIdx;
            if (message.endStopIdx != null && message.hasOwnProperty("endStopIdx"))
                object.endStopIdx = message.endStopIdx;
            if (message.charter != null && message.hasOwnProperty("charter"))
                object.charter = message.charter;
            if (message.stopRows && message.stopRows.length) {
                object.stopRows = [];
                for (var j = 0; j < message.stopRows.length; ++j)
                    object.stopRows[j] = $root.busable.ShiftBatRow.toObject(message.stopRows[j], options);
            }
            if (message.startStopId != null && message.hasOwnProperty("startStopId"))
                object.startStopId = message.startStopId;
            if (message.endStopId != null && message.hasOwnProperty("endStopId"))
                object.endStopId = message.endStopId;
            if (message.stopId != null && message.hasOwnProperty("stopId"))
                object.stopId = message.stopId;
            if (message.noteRows && message.noteRows.length) {
                object.noteRows = [];
                for (var j = 0; j < message.noteRows.length; ++j)
                    object.noteRows[j] = $root.busable.ShiftBatRow.toObject(message.noteRows[j], options);
            }
            if (message.charterId != null && message.hasOwnProperty("charterId"))
                object.charterId = message.charterId;
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            return object;
        };

        /**
         * Converts this ShiftBatRow to JSON.
         * @function toJSON
         * @memberof busable.ShiftBatRow
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShiftBatRow.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ShiftBatRow
         * @function getTypeUrl
         * @memberof busable.ShiftBatRow
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ShiftBatRow.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.ShiftBatRow";
        };

        return ShiftBatRow;
    })();

    busable.ShiftBat = (function() {

        /**
         * Properties of a ShiftBat.
         * @memberof busable
         * @interface IShiftBat
         * @property {string|null} [shiftBatId] ShiftBat shiftBatId
         * @property {string|null} [shiftBatNumber] ShiftBat shiftBatNumber
         * @property {Array.<busable.IShiftBatRow>|null} [rows] ShiftBat rows
         * @property {Array.<string>|null} [scheduleIds] ShiftBat scheduleIds
         * @property {string|null} [date] ShiftBat date
         * @property {Array.<string>|null} [dates] ShiftBat dates
         * @property {boolean|null} [schoolServiceOnly] ShiftBat schoolServiceOnly
         * @property {number|Long|null} [createdAt] ShiftBat createdAt
         * @property {number|Long|null} [updatedAt] ShiftBat updatedAt
         * @property {string|null} [operatorId] ShiftBat operatorId
         * @property {Array.<string>|null} [routeIds] ShiftBat routeIds
         * @property {string|null} [shiftBatName] ShiftBat shiftBatName
         * @property {string|null} [shiftBatDetails] ShiftBat shiftBatDetails
         * @property {boolean|null} [charter] ShiftBat charter
         * @property {string|null} [shiftBatColour] ShiftBat shiftBatColour
         */

        /**
         * Constructs a new ShiftBat.
         * @memberof busable
         * @classdesc Represents a ShiftBat.
         * @implements IShiftBat
         * @constructor
         * @param {busable.IShiftBat=} [properties] Properties to set
         */
        function ShiftBat(properties) {
            this.rows = [];
            this.scheduleIds = [];
            this.dates = [];
            this.routeIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ShiftBat shiftBatId.
         * @member {string} shiftBatId
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.shiftBatId = "";

        /**
         * ShiftBat shiftBatNumber.
         * @member {string} shiftBatNumber
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.shiftBatNumber = "";

        /**
         * ShiftBat rows.
         * @member {Array.<busable.IShiftBatRow>} rows
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.rows = $util.emptyArray;

        /**
         * ShiftBat scheduleIds.
         * @member {Array.<string>} scheduleIds
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.scheduleIds = $util.emptyArray;

        /**
         * ShiftBat date.
         * @member {string} date
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.date = "";

        /**
         * ShiftBat dates.
         * @member {Array.<string>} dates
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.dates = $util.emptyArray;

        /**
         * ShiftBat schoolServiceOnly.
         * @member {boolean} schoolServiceOnly
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.schoolServiceOnly = false;

        /**
         * ShiftBat createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ShiftBat updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ShiftBat operatorId.
         * @member {string} operatorId
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.operatorId = "";

        /**
         * ShiftBat routeIds.
         * @member {Array.<string>} routeIds
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.routeIds = $util.emptyArray;

        /**
         * ShiftBat shiftBatName.
         * @member {string} shiftBatName
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.shiftBatName = "";

        /**
         * ShiftBat shiftBatDetails.
         * @member {string} shiftBatDetails
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.shiftBatDetails = "";

        /**
         * ShiftBat charter.
         * @member {boolean} charter
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.charter = false;

        /**
         * ShiftBat shiftBatColour.
         * @member {string} shiftBatColour
         * @memberof busable.ShiftBat
         * @instance
         */
        ShiftBat.prototype.shiftBatColour = "";

        /**
         * Creates a new ShiftBat instance using the specified properties.
         * @function create
         * @memberof busable.ShiftBat
         * @static
         * @param {busable.IShiftBat=} [properties] Properties to set
         * @returns {busable.ShiftBat} ShiftBat instance
         */
        ShiftBat.create = function create(properties) {
            return new ShiftBat(properties);
        };

        /**
         * Encodes the specified ShiftBat message. Does not implicitly {@link busable.ShiftBat.verify|verify} messages.
         * @function encode
         * @memberof busable.ShiftBat
         * @static
         * @param {busable.IShiftBat} message ShiftBat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShiftBat.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.shiftBatId != null && Object.hasOwnProperty.call(message, "shiftBatId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.shiftBatId);
            if (message.shiftBatNumber != null && Object.hasOwnProperty.call(message, "shiftBatNumber"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.shiftBatNumber);
            if (message.rows != null && message.rows.length)
                for (var i = 0; i < message.rows.length; ++i)
                    $root.busable.ShiftBatRow.encode(message.rows[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.scheduleIds != null && message.scheduleIds.length)
                for (var i = 0; i < message.scheduleIds.length; ++i)
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.scheduleIds[i]);
            if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.date);
            if (message.dates != null && message.dates.length)
                for (var i = 0; i < message.dates.length; ++i)
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.dates[i]);
            if (message.schoolServiceOnly != null && Object.hasOwnProperty.call(message, "schoolServiceOnly"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.schoolServiceOnly);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.updatedAt);
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.operatorId);
            if (message.routeIds != null && message.routeIds.length)
                for (var i = 0; i < message.routeIds.length; ++i)
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.routeIds[i]);
            if (message.shiftBatName != null && Object.hasOwnProperty.call(message, "shiftBatName"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.shiftBatName);
            if (message.shiftBatDetails != null && Object.hasOwnProperty.call(message, "shiftBatDetails"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.shiftBatDetails);
            if (message.charter != null && Object.hasOwnProperty.call(message, "charter"))
                writer.uint32(/* id 14, wireType 0 =*/112).bool(message.charter);
            if (message.shiftBatColour != null && Object.hasOwnProperty.call(message, "shiftBatColour"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.shiftBatColour);
            return writer;
        };

        /**
         * Encodes the specified ShiftBat message, length delimited. Does not implicitly {@link busable.ShiftBat.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.ShiftBat
         * @static
         * @param {busable.IShiftBat} message ShiftBat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ShiftBat.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ShiftBat message from the specified reader or buffer.
         * @function decode
         * @memberof busable.ShiftBat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.ShiftBat} ShiftBat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShiftBat.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.ShiftBat();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.shiftBatId = reader.string();
                        break;
                    }
                case 2: {
                        message.shiftBatNumber = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.rows && message.rows.length))
                            message.rows = [];
                        message.rows.push($root.busable.ShiftBatRow.decode(reader, reader.uint32()));
                        break;
                    }
                case 4: {
                        if (!(message.scheduleIds && message.scheduleIds.length))
                            message.scheduleIds = [];
                        message.scheduleIds.push(reader.string());
                        break;
                    }
                case 5: {
                        message.date = reader.string();
                        break;
                    }
                case 6: {
                        if (!(message.dates && message.dates.length))
                            message.dates = [];
                        message.dates.push(reader.string());
                        break;
                    }
                case 7: {
                        message.schoolServiceOnly = reader.bool();
                        break;
                    }
                case 8: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 9: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                case 10: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 11: {
                        if (!(message.routeIds && message.routeIds.length))
                            message.routeIds = [];
                        message.routeIds.push(reader.string());
                        break;
                    }
                case 12: {
                        message.shiftBatName = reader.string();
                        break;
                    }
                case 13: {
                        message.shiftBatDetails = reader.string();
                        break;
                    }
                case 14: {
                        message.charter = reader.bool();
                        break;
                    }
                case 15: {
                        message.shiftBatColour = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ShiftBat message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.ShiftBat
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.ShiftBat} ShiftBat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ShiftBat.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ShiftBat message.
         * @function verify
         * @memberof busable.ShiftBat
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ShiftBat.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.shiftBatId != null && message.hasOwnProperty("shiftBatId"))
                if (!$util.isString(message.shiftBatId))
                    return "shiftBatId: string expected";
            if (message.shiftBatNumber != null && message.hasOwnProperty("shiftBatNumber"))
                if (!$util.isString(message.shiftBatNumber))
                    return "shiftBatNumber: string expected";
            if (message.rows != null && message.hasOwnProperty("rows")) {
                if (!Array.isArray(message.rows))
                    return "rows: array expected";
                for (var i = 0; i < message.rows.length; ++i) {
                    var error = $root.busable.ShiftBatRow.verify(message.rows[i]);
                    if (error)
                        return "rows." + error;
                }
            }
            if (message.scheduleIds != null && message.hasOwnProperty("scheduleIds")) {
                if (!Array.isArray(message.scheduleIds))
                    return "scheduleIds: array expected";
                for (var i = 0; i < message.scheduleIds.length; ++i)
                    if (!$util.isString(message.scheduleIds[i]))
                        return "scheduleIds: string[] expected";
            }
            if (message.date != null && message.hasOwnProperty("date"))
                if (!$util.isString(message.date))
                    return "date: string expected";
            if (message.dates != null && message.hasOwnProperty("dates")) {
                if (!Array.isArray(message.dates))
                    return "dates: array expected";
                for (var i = 0; i < message.dates.length; ++i)
                    if (!$util.isString(message.dates[i]))
                        return "dates: string[] expected";
            }
            if (message.schoolServiceOnly != null && message.hasOwnProperty("schoolServiceOnly"))
                if (typeof message.schoolServiceOnly !== "boolean")
                    return "schoolServiceOnly: boolean expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.routeIds != null && message.hasOwnProperty("routeIds")) {
                if (!Array.isArray(message.routeIds))
                    return "routeIds: array expected";
                for (var i = 0; i < message.routeIds.length; ++i)
                    if (!$util.isString(message.routeIds[i]))
                        return "routeIds: string[] expected";
            }
            if (message.shiftBatName != null && message.hasOwnProperty("shiftBatName"))
                if (!$util.isString(message.shiftBatName))
                    return "shiftBatName: string expected";
            if (message.shiftBatDetails != null && message.hasOwnProperty("shiftBatDetails"))
                if (!$util.isString(message.shiftBatDetails))
                    return "shiftBatDetails: string expected";
            if (message.charter != null && message.hasOwnProperty("charter"))
                if (typeof message.charter !== "boolean")
                    return "charter: boolean expected";
            if (message.shiftBatColour != null && message.hasOwnProperty("shiftBatColour"))
                if (!$util.isString(message.shiftBatColour))
                    return "shiftBatColour: string expected";
            return null;
        };

        /**
         * Creates a ShiftBat message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.ShiftBat
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.ShiftBat} ShiftBat
         */
        ShiftBat.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.ShiftBat)
                return object;
            var message = new $root.busable.ShiftBat();
            if (object.shiftBatId != null)
                message.shiftBatId = String(object.shiftBatId);
            if (object.shiftBatNumber != null)
                message.shiftBatNumber = String(object.shiftBatNumber);
            if (object.rows) {
                if (!Array.isArray(object.rows))
                    throw TypeError(".busable.ShiftBat.rows: array expected");
                message.rows = [];
                for (var i = 0; i < object.rows.length; ++i) {
                    if (typeof object.rows[i] !== "object")
                        throw TypeError(".busable.ShiftBat.rows: object expected");
                    message.rows[i] = $root.busable.ShiftBatRow.fromObject(object.rows[i]);
                }
            }
            if (object.scheduleIds) {
                if (!Array.isArray(object.scheduleIds))
                    throw TypeError(".busable.ShiftBat.scheduleIds: array expected");
                message.scheduleIds = [];
                for (var i = 0; i < object.scheduleIds.length; ++i)
                    message.scheduleIds[i] = String(object.scheduleIds[i]);
            }
            if (object.date != null)
                message.date = String(object.date);
            if (object.dates) {
                if (!Array.isArray(object.dates))
                    throw TypeError(".busable.ShiftBat.dates: array expected");
                message.dates = [];
                for (var i = 0; i < object.dates.length; ++i)
                    message.dates[i] = String(object.dates[i]);
            }
            if (object.schoolServiceOnly != null)
                message.schoolServiceOnly = Boolean(object.schoolServiceOnly);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.routeIds) {
                if (!Array.isArray(object.routeIds))
                    throw TypeError(".busable.ShiftBat.routeIds: array expected");
                message.routeIds = [];
                for (var i = 0; i < object.routeIds.length; ++i)
                    message.routeIds[i] = String(object.routeIds[i]);
            }
            if (object.shiftBatName != null)
                message.shiftBatName = String(object.shiftBatName);
            if (object.shiftBatDetails != null)
                message.shiftBatDetails = String(object.shiftBatDetails);
            if (object.charter != null)
                message.charter = Boolean(object.charter);
            if (object.shiftBatColour != null)
                message.shiftBatColour = String(object.shiftBatColour);
            return message;
        };

        /**
         * Creates a plain object from a ShiftBat message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.ShiftBat
         * @static
         * @param {busable.ShiftBat} message ShiftBat
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ShiftBat.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.rows = [];
                object.scheduleIds = [];
                object.dates = [];
                object.routeIds = [];
            }
            if (options.defaults) {
                object.shiftBatId = "";
                object.shiftBatNumber = "";
                object.date = "";
                object.schoolServiceOnly = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
                object.operatorId = "";
                object.shiftBatName = "";
                object.shiftBatDetails = "";
                object.charter = false;
                object.shiftBatColour = "";
            }
            if (message.shiftBatId != null && message.hasOwnProperty("shiftBatId"))
                object.shiftBatId = message.shiftBatId;
            if (message.shiftBatNumber != null && message.hasOwnProperty("shiftBatNumber"))
                object.shiftBatNumber = message.shiftBatNumber;
            if (message.rows && message.rows.length) {
                object.rows = [];
                for (var j = 0; j < message.rows.length; ++j)
                    object.rows[j] = $root.busable.ShiftBatRow.toObject(message.rows[j], options);
            }
            if (message.scheduleIds && message.scheduleIds.length) {
                object.scheduleIds = [];
                for (var j = 0; j < message.scheduleIds.length; ++j)
                    object.scheduleIds[j] = message.scheduleIds[j];
            }
            if (message.date != null && message.hasOwnProperty("date"))
                object.date = message.date;
            if (message.dates && message.dates.length) {
                object.dates = [];
                for (var j = 0; j < message.dates.length; ++j)
                    object.dates[j] = message.dates[j];
            }
            if (message.schoolServiceOnly != null && message.hasOwnProperty("schoolServiceOnly"))
                object.schoolServiceOnly = message.schoolServiceOnly;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.routeIds && message.routeIds.length) {
                object.routeIds = [];
                for (var j = 0; j < message.routeIds.length; ++j)
                    object.routeIds[j] = message.routeIds[j];
            }
            if (message.shiftBatName != null && message.hasOwnProperty("shiftBatName"))
                object.shiftBatName = message.shiftBatName;
            if (message.shiftBatDetails != null && message.hasOwnProperty("shiftBatDetails"))
                object.shiftBatDetails = message.shiftBatDetails;
            if (message.charter != null && message.hasOwnProperty("charter"))
                object.charter = message.charter;
            if (message.shiftBatColour != null && message.hasOwnProperty("shiftBatColour"))
                object.shiftBatColour = message.shiftBatColour;
            return object;
        };

        /**
         * Converts this ShiftBat to JSON.
         * @function toJSON
         * @memberof busable.ShiftBat
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ShiftBat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ShiftBat
         * @function getTypeUrl
         * @memberof busable.ShiftBat
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ShiftBat.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.ShiftBat";
        };

        return ShiftBat;
    })();

    busable.Vehicle = (function() {

        /**
         * Properties of a Vehicle.
         * @memberof busable
         * @interface IVehicle
         * @property {string|null} [vehicleId] Vehicle vehicleId
         * @property {string|null} [vehicleNumber] Vehicle vehicleNumber
         * @property {string|null} [vehicleName] Vehicle vehicleName
         * @property {string|null} [vehicleTypeId] Vehicle vehicleTypeId
         * @property {string|null} [registration] Vehicle registration
         * @property {number|null} [capacity] Vehicle capacity
         * @property {boolean|null} [wheelchairAccessible] Vehicle wheelchairAccessible
         * @property {string|null} [operatorId] Vehicle operatorId
         * @property {number|Long|null} [createdAt] Vehicle createdAt
         * @property {number|Long|null} [updatedAt] Vehicle updatedAt
         * @property {number|null} [rate] Vehicle rate
         * @property {string|null} [description] Vehicle description
         */

        /**
         * Constructs a new Vehicle.
         * @memberof busable
         * @classdesc Represents a Vehicle.
         * @implements IVehicle
         * @constructor
         * @param {busable.IVehicle=} [properties] Properties to set
         */
        function Vehicle(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Vehicle vehicleId.
         * @member {string} vehicleId
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.vehicleId = "";

        /**
         * Vehicle vehicleNumber.
         * @member {string} vehicleNumber
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.vehicleNumber = "";

        /**
         * Vehicle vehicleName.
         * @member {string} vehicleName
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.vehicleName = "";

        /**
         * Vehicle vehicleTypeId.
         * @member {string} vehicleTypeId
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.vehicleTypeId = "";

        /**
         * Vehicle registration.
         * @member {string} registration
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.registration = "";

        /**
         * Vehicle capacity.
         * @member {number} capacity
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.capacity = 0;

        /**
         * Vehicle wheelchairAccessible.
         * @member {boolean} wheelchairAccessible
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.wheelchairAccessible = false;

        /**
         * Vehicle operatorId.
         * @member {string} operatorId
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.operatorId = "";

        /**
         * Vehicle createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Vehicle updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Vehicle rate.
         * @member {number} rate
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.rate = 0;

        /**
         * Vehicle description.
         * @member {string} description
         * @memberof busable.Vehicle
         * @instance
         */
        Vehicle.prototype.description = "";

        /**
         * Creates a new Vehicle instance using the specified properties.
         * @function create
         * @memberof busable.Vehicle
         * @static
         * @param {busable.IVehicle=} [properties] Properties to set
         * @returns {busable.Vehicle} Vehicle instance
         */
        Vehicle.create = function create(properties) {
            return new Vehicle(properties);
        };

        /**
         * Encodes the specified Vehicle message. Does not implicitly {@link busable.Vehicle.verify|verify} messages.
         * @function encode
         * @memberof busable.Vehicle
         * @static
         * @param {busable.IVehicle} message Vehicle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Vehicle.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.vehicleId != null && Object.hasOwnProperty.call(message, "vehicleId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.vehicleId);
            if (message.vehicleNumber != null && Object.hasOwnProperty.call(message, "vehicleNumber"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.vehicleNumber);
            if (message.vehicleName != null && Object.hasOwnProperty.call(message, "vehicleName"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.vehicleName);
            if (message.vehicleTypeId != null && Object.hasOwnProperty.call(message, "vehicleTypeId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.vehicleTypeId);
            if (message.registration != null && Object.hasOwnProperty.call(message, "registration"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.registration);
            if (message.capacity != null && Object.hasOwnProperty.call(message, "capacity"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.capacity);
            if (message.wheelchairAccessible != null && Object.hasOwnProperty.call(message, "wheelchairAccessible"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.wheelchairAccessible);
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.operatorId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.updatedAt);
            if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.rate);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.description);
            return writer;
        };

        /**
         * Encodes the specified Vehicle message, length delimited. Does not implicitly {@link busable.Vehicle.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Vehicle
         * @static
         * @param {busable.IVehicle} message Vehicle message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Vehicle.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Vehicle message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Vehicle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Vehicle} Vehicle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Vehicle.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Vehicle();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.vehicleId = reader.string();
                        break;
                    }
                case 2: {
                        message.vehicleNumber = reader.string();
                        break;
                    }
                case 3: {
                        message.vehicleName = reader.string();
                        break;
                    }
                case 4: {
                        message.vehicleTypeId = reader.string();
                        break;
                    }
                case 5: {
                        message.registration = reader.string();
                        break;
                    }
                case 6: {
                        message.capacity = reader.int32();
                        break;
                    }
                case 7: {
                        message.wheelchairAccessible = reader.bool();
                        break;
                    }
                case 8: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 9: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 10: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                case 11: {
                        message.rate = reader.double();
                        break;
                    }
                case 12: {
                        message.description = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Vehicle message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Vehicle
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Vehicle} Vehicle
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Vehicle.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Vehicle message.
         * @function verify
         * @memberof busable.Vehicle
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Vehicle.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                if (!$util.isString(message.vehicleId))
                    return "vehicleId: string expected";
            if (message.vehicleNumber != null && message.hasOwnProperty("vehicleNumber"))
                if (!$util.isString(message.vehicleNumber))
                    return "vehicleNumber: string expected";
            if (message.vehicleName != null && message.hasOwnProperty("vehicleName"))
                if (!$util.isString(message.vehicleName))
                    return "vehicleName: string expected";
            if (message.vehicleTypeId != null && message.hasOwnProperty("vehicleTypeId"))
                if (!$util.isString(message.vehicleTypeId))
                    return "vehicleTypeId: string expected";
            if (message.registration != null && message.hasOwnProperty("registration"))
                if (!$util.isString(message.registration))
                    return "registration: string expected";
            if (message.capacity != null && message.hasOwnProperty("capacity"))
                if (!$util.isInteger(message.capacity))
                    return "capacity: integer expected";
            if (message.wheelchairAccessible != null && message.hasOwnProperty("wheelchairAccessible"))
                if (typeof message.wheelchairAccessible !== "boolean")
                    return "wheelchairAccessible: boolean expected";
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            if (message.rate != null && message.hasOwnProperty("rate"))
                if (typeof message.rate !== "number")
                    return "rate: number expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            return null;
        };

        /**
         * Creates a Vehicle message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Vehicle
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Vehicle} Vehicle
         */
        Vehicle.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Vehicle)
                return object;
            var message = new $root.busable.Vehicle();
            if (object.vehicleId != null)
                message.vehicleId = String(object.vehicleId);
            if (object.vehicleNumber != null)
                message.vehicleNumber = String(object.vehicleNumber);
            if (object.vehicleName != null)
                message.vehicleName = String(object.vehicleName);
            if (object.vehicleTypeId != null)
                message.vehicleTypeId = String(object.vehicleTypeId);
            if (object.registration != null)
                message.registration = String(object.registration);
            if (object.capacity != null)
                message.capacity = object.capacity | 0;
            if (object.wheelchairAccessible != null)
                message.wheelchairAccessible = Boolean(object.wheelchairAccessible);
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            if (object.rate != null)
                message.rate = Number(object.rate);
            if (object.description != null)
                message.description = String(object.description);
            return message;
        };

        /**
         * Creates a plain object from a Vehicle message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Vehicle
         * @static
         * @param {busable.Vehicle} message Vehicle
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Vehicle.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.vehicleId = "";
                object.vehicleNumber = "";
                object.vehicleName = "";
                object.vehicleTypeId = "";
                object.registration = "";
                object.capacity = 0;
                object.wheelchairAccessible = false;
                object.operatorId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
                object.rate = 0;
                object.description = "";
            }
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                object.vehicleId = message.vehicleId;
            if (message.vehicleNumber != null && message.hasOwnProperty("vehicleNumber"))
                object.vehicleNumber = message.vehicleNumber;
            if (message.vehicleName != null && message.hasOwnProperty("vehicleName"))
                object.vehicleName = message.vehicleName;
            if (message.vehicleTypeId != null && message.hasOwnProperty("vehicleTypeId"))
                object.vehicleTypeId = message.vehicleTypeId;
            if (message.registration != null && message.hasOwnProperty("registration"))
                object.registration = message.registration;
            if (message.capacity != null && message.hasOwnProperty("capacity"))
                object.capacity = message.capacity;
            if (message.wheelchairAccessible != null && message.hasOwnProperty("wheelchairAccessible"))
                object.wheelchairAccessible = message.wheelchairAccessible;
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (message.rate != null && message.hasOwnProperty("rate"))
                object.rate = options.json && !isFinite(message.rate) ? String(message.rate) : message.rate;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            return object;
        };

        /**
         * Converts this Vehicle to JSON.
         * @function toJSON
         * @memberof busable.Vehicle
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Vehicle.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Vehicle
         * @function getTypeUrl
         * @memberof busable.Vehicle
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Vehicle.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Vehicle";
        };

        return Vehicle;
    })();

    busable.VehicleType = (function() {

        /**
         * Properties of a VehicleType.
         * @memberof busable
         * @interface IVehicleType
         * @property {string|null} [vehicleTypeId] VehicleType vehicleTypeId
         * @property {string|null} [vehicleTypeName] VehicleType vehicleTypeName
         * @property {number|null} [capacity] VehicleType capacity
         * @property {boolean|null} [wheelchairAccessible] VehicleType wheelchairAccessible
         * @property {string|null} [operatorId] VehicleType operatorId
         * @property {number|Long|null} [createdAt] VehicleType createdAt
         * @property {number|Long|null} [updatedAt] VehicleType updatedAt
         * @property {number|null} [rate] VehicleType rate
         */

        /**
         * Constructs a new VehicleType.
         * @memberof busable
         * @classdesc Represents a VehicleType.
         * @implements IVehicleType
         * @constructor
         * @param {busable.IVehicleType=} [properties] Properties to set
         */
        function VehicleType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * VehicleType vehicleTypeId.
         * @member {string} vehicleTypeId
         * @memberof busable.VehicleType
         * @instance
         */
        VehicleType.prototype.vehicleTypeId = "";

        /**
         * VehicleType vehicleTypeName.
         * @member {string} vehicleTypeName
         * @memberof busable.VehicleType
         * @instance
         */
        VehicleType.prototype.vehicleTypeName = "";

        /**
         * VehicleType capacity.
         * @member {number} capacity
         * @memberof busable.VehicleType
         * @instance
         */
        VehicleType.prototype.capacity = 0;

        /**
         * VehicleType wheelchairAccessible.
         * @member {boolean} wheelchairAccessible
         * @memberof busable.VehicleType
         * @instance
         */
        VehicleType.prototype.wheelchairAccessible = false;

        /**
         * VehicleType operatorId.
         * @member {string} operatorId
         * @memberof busable.VehicleType
         * @instance
         */
        VehicleType.prototype.operatorId = "";

        /**
         * VehicleType createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.VehicleType
         * @instance
         */
        VehicleType.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * VehicleType updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.VehicleType
         * @instance
         */
        VehicleType.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * VehicleType rate.
         * @member {number} rate
         * @memberof busable.VehicleType
         * @instance
         */
        VehicleType.prototype.rate = 0;

        /**
         * Creates a new VehicleType instance using the specified properties.
         * @function create
         * @memberof busable.VehicleType
         * @static
         * @param {busable.IVehicleType=} [properties] Properties to set
         * @returns {busable.VehicleType} VehicleType instance
         */
        VehicleType.create = function create(properties) {
            return new VehicleType(properties);
        };

        /**
         * Encodes the specified VehicleType message. Does not implicitly {@link busable.VehicleType.verify|verify} messages.
         * @function encode
         * @memberof busable.VehicleType
         * @static
         * @param {busable.IVehicleType} message VehicleType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VehicleType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.vehicleTypeId != null && Object.hasOwnProperty.call(message, "vehicleTypeId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.vehicleTypeId);
            if (message.vehicleTypeName != null && Object.hasOwnProperty.call(message, "vehicleTypeName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.vehicleTypeName);
            if (message.capacity != null && Object.hasOwnProperty.call(message, "capacity"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.capacity);
            if (message.wheelchairAccessible != null && Object.hasOwnProperty.call(message, "wheelchairAccessible"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.wheelchairAccessible);
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.operatorId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.updatedAt);
            if (message.rate != null && Object.hasOwnProperty.call(message, "rate"))
                writer.uint32(/* id 8, wireType 1 =*/65).double(message.rate);
            return writer;
        };

        /**
         * Encodes the specified VehicleType message, length delimited. Does not implicitly {@link busable.VehicleType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.VehicleType
         * @static
         * @param {busable.IVehicleType} message VehicleType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        VehicleType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a VehicleType message from the specified reader or buffer.
         * @function decode
         * @memberof busable.VehicleType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.VehicleType} VehicleType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VehicleType.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.VehicleType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.vehicleTypeId = reader.string();
                        break;
                    }
                case 2: {
                        message.vehicleTypeName = reader.string();
                        break;
                    }
                case 3: {
                        message.capacity = reader.int32();
                        break;
                    }
                case 4: {
                        message.wheelchairAccessible = reader.bool();
                        break;
                    }
                case 5: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 6: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 7: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                case 8: {
                        message.rate = reader.double();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a VehicleType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.VehicleType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.VehicleType} VehicleType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        VehicleType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a VehicleType message.
         * @function verify
         * @memberof busable.VehicleType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        VehicleType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.vehicleTypeId != null && message.hasOwnProperty("vehicleTypeId"))
                if (!$util.isString(message.vehicleTypeId))
                    return "vehicleTypeId: string expected";
            if (message.vehicleTypeName != null && message.hasOwnProperty("vehicleTypeName"))
                if (!$util.isString(message.vehicleTypeName))
                    return "vehicleTypeName: string expected";
            if (message.capacity != null && message.hasOwnProperty("capacity"))
                if (!$util.isInteger(message.capacity))
                    return "capacity: integer expected";
            if (message.wheelchairAccessible != null && message.hasOwnProperty("wheelchairAccessible"))
                if (typeof message.wheelchairAccessible !== "boolean")
                    return "wheelchairAccessible: boolean expected";
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            if (message.rate != null && message.hasOwnProperty("rate"))
                if (typeof message.rate !== "number")
                    return "rate: number expected";
            return null;
        };

        /**
         * Creates a VehicleType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.VehicleType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.VehicleType} VehicleType
         */
        VehicleType.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.VehicleType)
                return object;
            var message = new $root.busable.VehicleType();
            if (object.vehicleTypeId != null)
                message.vehicleTypeId = String(object.vehicleTypeId);
            if (object.vehicleTypeName != null)
                message.vehicleTypeName = String(object.vehicleTypeName);
            if (object.capacity != null)
                message.capacity = object.capacity | 0;
            if (object.wheelchairAccessible != null)
                message.wheelchairAccessible = Boolean(object.wheelchairAccessible);
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            if (object.rate != null)
                message.rate = Number(object.rate);
            return message;
        };

        /**
         * Creates a plain object from a VehicleType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.VehicleType
         * @static
         * @param {busable.VehicleType} message VehicleType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        VehicleType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.vehicleTypeId = "";
                object.vehicleTypeName = "";
                object.capacity = 0;
                object.wheelchairAccessible = false;
                object.operatorId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
                object.rate = 0;
            }
            if (message.vehicleTypeId != null && message.hasOwnProperty("vehicleTypeId"))
                object.vehicleTypeId = message.vehicleTypeId;
            if (message.vehicleTypeName != null && message.hasOwnProperty("vehicleTypeName"))
                object.vehicleTypeName = message.vehicleTypeName;
            if (message.capacity != null && message.hasOwnProperty("capacity"))
                object.capacity = message.capacity;
            if (message.wheelchairAccessible != null && message.hasOwnProperty("wheelchairAccessible"))
                object.wheelchairAccessible = message.wheelchairAccessible;
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (message.rate != null && message.hasOwnProperty("rate"))
                object.rate = options.json && !isFinite(message.rate) ? String(message.rate) : message.rate;
            return object;
        };

        /**
         * Converts this VehicleType to JSON.
         * @function toJSON
         * @memberof busable.VehicleType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        VehicleType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for VehicleType
         * @function getTypeUrl
         * @memberof busable.VehicleType
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        VehicleType.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.VehicleType";
        };

        return VehicleType;
    })();

    busable.Driver = (function() {

        /**
         * Properties of a Driver.
         * @memberof busable
         * @interface IDriver
         * @property {string|null} [driverId] Driver driverId
         * @property {string|null} [driverName] Driver driverName
         * @property {string|null} [licenseNumber] Driver licenseNumber
         * @property {string|null} [operatorId] Driver operatorId
         * @property {number|Long|null} [createdAt] Driver createdAt
         * @property {number|Long|null} [updatedAt] Driver updatedAt
         * @property {string|null} [email] Driver email
         * @property {string|null} [phone] Driver phone
         */

        /**
         * Constructs a new Driver.
         * @memberof busable
         * @classdesc Represents a Driver.
         * @implements IDriver
         * @constructor
         * @param {busable.IDriver=} [properties] Properties to set
         */
        function Driver(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Driver driverId.
         * @member {string} driverId
         * @memberof busable.Driver
         * @instance
         */
        Driver.prototype.driverId = "";

        /**
         * Driver driverName.
         * @member {string} driverName
         * @memberof busable.Driver
         * @instance
         */
        Driver.prototype.driverName = "";

        /**
         * Driver licenseNumber.
         * @member {string} licenseNumber
         * @memberof busable.Driver
         * @instance
         */
        Driver.prototype.licenseNumber = "";

        /**
         * Driver operatorId.
         * @member {string} operatorId
         * @memberof busable.Driver
         * @instance
         */
        Driver.prototype.operatorId = "";

        /**
         * Driver createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.Driver
         * @instance
         */
        Driver.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Driver updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.Driver
         * @instance
         */
        Driver.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Driver email.
         * @member {string} email
         * @memberof busable.Driver
         * @instance
         */
        Driver.prototype.email = "";

        /**
         * Driver phone.
         * @member {string} phone
         * @memberof busable.Driver
         * @instance
         */
        Driver.prototype.phone = "";

        /**
         * Creates a new Driver instance using the specified properties.
         * @function create
         * @memberof busable.Driver
         * @static
         * @param {busable.IDriver=} [properties] Properties to set
         * @returns {busable.Driver} Driver instance
         */
        Driver.create = function create(properties) {
            return new Driver(properties);
        };

        /**
         * Encodes the specified Driver message. Does not implicitly {@link busable.Driver.verify|verify} messages.
         * @function encode
         * @memberof busable.Driver
         * @static
         * @param {busable.IDriver} message Driver message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Driver.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.driverId != null && Object.hasOwnProperty.call(message, "driverId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.driverId);
            if (message.driverName != null && Object.hasOwnProperty.call(message, "driverName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.driverName);
            if (message.licenseNumber != null && Object.hasOwnProperty.call(message, "licenseNumber"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.licenseNumber);
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.operatorId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.updatedAt);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.email);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.phone);
            return writer;
        };

        /**
         * Encodes the specified Driver message, length delimited. Does not implicitly {@link busable.Driver.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Driver
         * @static
         * @param {busable.IDriver} message Driver message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Driver.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Driver message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Driver
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Driver} Driver
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Driver.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Driver();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.driverId = reader.string();
                        break;
                    }
                case 2: {
                        message.driverName = reader.string();
                        break;
                    }
                case 3: {
                        message.licenseNumber = reader.string();
                        break;
                    }
                case 4: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 5: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 6: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                case 7: {
                        message.email = reader.string();
                        break;
                    }
                case 8: {
                        message.phone = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Driver message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Driver
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Driver} Driver
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Driver.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Driver message.
         * @function verify
         * @memberof busable.Driver
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Driver.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.driverId != null && message.hasOwnProperty("driverId"))
                if (!$util.isString(message.driverId))
                    return "driverId: string expected";
            if (message.driverName != null && message.hasOwnProperty("driverName"))
                if (!$util.isString(message.driverName))
                    return "driverName: string expected";
            if (message.licenseNumber != null && message.hasOwnProperty("licenseNumber"))
                if (!$util.isString(message.licenseNumber))
                    return "licenseNumber: string expected";
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            return null;
        };

        /**
         * Creates a Driver message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Driver
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Driver} Driver
         */
        Driver.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Driver)
                return object;
            var message = new $root.busable.Driver();
            if (object.driverId != null)
                message.driverId = String(object.driverId);
            if (object.driverName != null)
                message.driverName = String(object.driverName);
            if (object.licenseNumber != null)
                message.licenseNumber = String(object.licenseNumber);
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            if (object.email != null)
                message.email = String(object.email);
            if (object.phone != null)
                message.phone = String(object.phone);
            return message;
        };

        /**
         * Creates a plain object from a Driver message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Driver
         * @static
         * @param {busable.Driver} message Driver
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Driver.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.driverId = "";
                object.driverName = "";
                object.licenseNumber = "";
                object.operatorId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
                object.email = "";
                object.phone = "";
            }
            if (message.driverId != null && message.hasOwnProperty("driverId"))
                object.driverId = message.driverId;
            if (message.driverName != null && message.hasOwnProperty("driverName"))
                object.driverName = message.driverName;
            if (message.licenseNumber != null && message.hasOwnProperty("licenseNumber"))
                object.licenseNumber = message.licenseNumber;
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            return object;
        };

        /**
         * Converts this Driver to JSON.
         * @function toJSON
         * @memberof busable.Driver
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Driver.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Driver
         * @function getTypeUrl
         * @memberof busable.Driver
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Driver.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Driver";
        };

        return Driver;
    })();

    busable.WorkItem = (function() {

        /**
         * Properties of a WorkItem.
         * @memberof busable
         * @interface IWorkItem
         * @property {string|null} [workItemId] WorkItem workItemId
         * @property {string|null} [dutyId] WorkItem dutyId
         * @property {busable.IShiftBat|null} [duty] WorkItem duty
         * @property {string|null} [date] WorkItem date
         * @property {string|null} [employeeId] WorkItem employeeId
         * @property {string|null} [employeeName] WorkItem employeeName
         * @property {string|null} [vehicleId] WorkItem vehicleId
         * @property {string|null} [vehicleNumber] WorkItem vehicleNumber
         * @property {number|null} [scheduledHours] WorkItem scheduledHours
         * @property {number|null} [actualHours] WorkItem actualHours
         * @property {number|null} [actualPayHours] WorkItem actualPayHours
         * @property {number|null} [wageRate] WorkItem wageRate
         * @property {string|null} [status] WorkItem status
         * @property {number|Long|null} [createdAt] WorkItem createdAt
         * @property {number|Long|null} [updatedAt] WorkItem updatedAt
         * @property {string|null} [operatorId] WorkItem operatorId
         * @property {string|null} [userId] WorkItem userId
         */

        /**
         * Constructs a new WorkItem.
         * @memberof busable
         * @classdesc Represents a WorkItem.
         * @implements IWorkItem
         * @constructor
         * @param {busable.IWorkItem=} [properties] Properties to set
         */
        function WorkItem(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WorkItem workItemId.
         * @member {string} workItemId
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.workItemId = "";

        /**
         * WorkItem dutyId.
         * @member {string} dutyId
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.dutyId = "";

        /**
         * WorkItem duty.
         * @member {busable.IShiftBat|null|undefined} duty
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.duty = null;

        /**
         * WorkItem date.
         * @member {string} date
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.date = "";

        /**
         * WorkItem employeeId.
         * @member {string} employeeId
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.employeeId = "";

        /**
         * WorkItem employeeName.
         * @member {string} employeeName
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.employeeName = "";

        /**
         * WorkItem vehicleId.
         * @member {string} vehicleId
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.vehicleId = "";

        /**
         * WorkItem vehicleNumber.
         * @member {string} vehicleNumber
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.vehicleNumber = "";

        /**
         * WorkItem scheduledHours.
         * @member {number} scheduledHours
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.scheduledHours = 0;

        /**
         * WorkItem actualHours.
         * @member {number} actualHours
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.actualHours = 0;

        /**
         * WorkItem actualPayHours.
         * @member {number} actualPayHours
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.actualPayHours = 0;

        /**
         * WorkItem wageRate.
         * @member {number} wageRate
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.wageRate = 0;

        /**
         * WorkItem status.
         * @member {string} status
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.status = "";

        /**
         * WorkItem createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * WorkItem updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * WorkItem operatorId.
         * @member {string} operatorId
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.operatorId = "";

        /**
         * WorkItem userId.
         * @member {string} userId
         * @memberof busable.WorkItem
         * @instance
         */
        WorkItem.prototype.userId = "";

        /**
         * Creates a new WorkItem instance using the specified properties.
         * @function create
         * @memberof busable.WorkItem
         * @static
         * @param {busable.IWorkItem=} [properties] Properties to set
         * @returns {busable.WorkItem} WorkItem instance
         */
        WorkItem.create = function create(properties) {
            return new WorkItem(properties);
        };

        /**
         * Encodes the specified WorkItem message. Does not implicitly {@link busable.WorkItem.verify|verify} messages.
         * @function encode
         * @memberof busable.WorkItem
         * @static
         * @param {busable.IWorkItem} message WorkItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WorkItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.workItemId != null && Object.hasOwnProperty.call(message, "workItemId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.workItemId);
            if (message.dutyId != null && Object.hasOwnProperty.call(message, "dutyId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dutyId);
            if (message.duty != null && Object.hasOwnProperty.call(message, "duty"))
                $root.busable.ShiftBat.encode(message.duty, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.date);
            if (message.employeeId != null && Object.hasOwnProperty.call(message, "employeeId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.employeeId);
            if (message.employeeName != null && Object.hasOwnProperty.call(message, "employeeName"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.employeeName);
            if (message.vehicleId != null && Object.hasOwnProperty.call(message, "vehicleId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.vehicleId);
            if (message.vehicleNumber != null && Object.hasOwnProperty.call(message, "vehicleNumber"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.vehicleNumber);
            if (message.scheduledHours != null && Object.hasOwnProperty.call(message, "scheduledHours"))
                writer.uint32(/* id 9, wireType 1 =*/73).double(message.scheduledHours);
            if (message.actualHours != null && Object.hasOwnProperty.call(message, "actualHours"))
                writer.uint32(/* id 10, wireType 1 =*/81).double(message.actualHours);
            if (message.actualPayHours != null && Object.hasOwnProperty.call(message, "actualPayHours"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.actualPayHours);
            if (message.wageRate != null && Object.hasOwnProperty.call(message, "wageRate"))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.wageRate);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.status);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.updatedAt);
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 16, wireType 2 =*/130).string(message.operatorId);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.userId);
            return writer;
        };

        /**
         * Encodes the specified WorkItem message, length delimited. Does not implicitly {@link busable.WorkItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.WorkItem
         * @static
         * @param {busable.IWorkItem} message WorkItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WorkItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a WorkItem message from the specified reader or buffer.
         * @function decode
         * @memberof busable.WorkItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.WorkItem} WorkItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WorkItem.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.WorkItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.workItemId = reader.string();
                        break;
                    }
                case 2: {
                        message.dutyId = reader.string();
                        break;
                    }
                case 3: {
                        message.duty = $root.busable.ShiftBat.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.date = reader.string();
                        break;
                    }
                case 5: {
                        message.employeeId = reader.string();
                        break;
                    }
                case 6: {
                        message.employeeName = reader.string();
                        break;
                    }
                case 7: {
                        message.vehicleId = reader.string();
                        break;
                    }
                case 8: {
                        message.vehicleNumber = reader.string();
                        break;
                    }
                case 9: {
                        message.scheduledHours = reader.double();
                        break;
                    }
                case 10: {
                        message.actualHours = reader.double();
                        break;
                    }
                case 11: {
                        message.actualPayHours = reader.double();
                        break;
                    }
                case 12: {
                        message.wageRate = reader.double();
                        break;
                    }
                case 13: {
                        message.status = reader.string();
                        break;
                    }
                case 14: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 15: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                case 16: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 17: {
                        message.userId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a WorkItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.WorkItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.WorkItem} WorkItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WorkItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a WorkItem message.
         * @function verify
         * @memberof busable.WorkItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        WorkItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.workItemId != null && message.hasOwnProperty("workItemId"))
                if (!$util.isString(message.workItemId))
                    return "workItemId: string expected";
            if (message.dutyId != null && message.hasOwnProperty("dutyId"))
                if (!$util.isString(message.dutyId))
                    return "dutyId: string expected";
            if (message.duty != null && message.hasOwnProperty("duty")) {
                var error = $root.busable.ShiftBat.verify(message.duty);
                if (error)
                    return "duty." + error;
            }
            if (message.date != null && message.hasOwnProperty("date"))
                if (!$util.isString(message.date))
                    return "date: string expected";
            if (message.employeeId != null && message.hasOwnProperty("employeeId"))
                if (!$util.isString(message.employeeId))
                    return "employeeId: string expected";
            if (message.employeeName != null && message.hasOwnProperty("employeeName"))
                if (!$util.isString(message.employeeName))
                    return "employeeName: string expected";
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                if (!$util.isString(message.vehicleId))
                    return "vehicleId: string expected";
            if (message.vehicleNumber != null && message.hasOwnProperty("vehicleNumber"))
                if (!$util.isString(message.vehicleNumber))
                    return "vehicleNumber: string expected";
            if (message.scheduledHours != null && message.hasOwnProperty("scheduledHours"))
                if (typeof message.scheduledHours !== "number")
                    return "scheduledHours: number expected";
            if (message.actualHours != null && message.hasOwnProperty("actualHours"))
                if (typeof message.actualHours !== "number")
                    return "actualHours: number expected";
            if (message.actualPayHours != null && message.hasOwnProperty("actualPayHours"))
                if (typeof message.actualPayHours !== "number")
                    return "actualPayHours: number expected";
            if (message.wageRate != null && message.hasOwnProperty("wageRate"))
                if (typeof message.wageRate !== "number")
                    return "wageRate: number expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isString(message.status))
                    return "status: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            return null;
        };

        /**
         * Creates a WorkItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.WorkItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.WorkItem} WorkItem
         */
        WorkItem.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.WorkItem)
                return object;
            var message = new $root.busable.WorkItem();
            if (object.workItemId != null)
                message.workItemId = String(object.workItemId);
            if (object.dutyId != null)
                message.dutyId = String(object.dutyId);
            if (object.duty != null) {
                if (typeof object.duty !== "object")
                    throw TypeError(".busable.WorkItem.duty: object expected");
                message.duty = $root.busable.ShiftBat.fromObject(object.duty);
            }
            if (object.date != null)
                message.date = String(object.date);
            if (object.employeeId != null)
                message.employeeId = String(object.employeeId);
            if (object.employeeName != null)
                message.employeeName = String(object.employeeName);
            if (object.vehicleId != null)
                message.vehicleId = String(object.vehicleId);
            if (object.vehicleNumber != null)
                message.vehicleNumber = String(object.vehicleNumber);
            if (object.scheduledHours != null)
                message.scheduledHours = Number(object.scheduledHours);
            if (object.actualHours != null)
                message.actualHours = Number(object.actualHours);
            if (object.actualPayHours != null)
                message.actualPayHours = Number(object.actualPayHours);
            if (object.wageRate != null)
                message.wageRate = Number(object.wageRate);
            if (object.status != null)
                message.status = String(object.status);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.userId != null)
                message.userId = String(object.userId);
            return message;
        };

        /**
         * Creates a plain object from a WorkItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.WorkItem
         * @static
         * @param {busable.WorkItem} message WorkItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WorkItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.workItemId = "";
                object.dutyId = "";
                object.duty = null;
                object.date = "";
                object.employeeId = "";
                object.employeeName = "";
                object.vehicleId = "";
                object.vehicleNumber = "";
                object.scheduledHours = 0;
                object.actualHours = 0;
                object.actualPayHours = 0;
                object.wageRate = 0;
                object.status = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
                object.operatorId = "";
                object.userId = "";
            }
            if (message.workItemId != null && message.hasOwnProperty("workItemId"))
                object.workItemId = message.workItemId;
            if (message.dutyId != null && message.hasOwnProperty("dutyId"))
                object.dutyId = message.dutyId;
            if (message.duty != null && message.hasOwnProperty("duty"))
                object.duty = $root.busable.ShiftBat.toObject(message.duty, options);
            if (message.date != null && message.hasOwnProperty("date"))
                object.date = message.date;
            if (message.employeeId != null && message.hasOwnProperty("employeeId"))
                object.employeeId = message.employeeId;
            if (message.employeeName != null && message.hasOwnProperty("employeeName"))
                object.employeeName = message.employeeName;
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                object.vehicleId = message.vehicleId;
            if (message.vehicleNumber != null && message.hasOwnProperty("vehicleNumber"))
                object.vehicleNumber = message.vehicleNumber;
            if (message.scheduledHours != null && message.hasOwnProperty("scheduledHours"))
                object.scheduledHours = options.json && !isFinite(message.scheduledHours) ? String(message.scheduledHours) : message.scheduledHours;
            if (message.actualHours != null && message.hasOwnProperty("actualHours"))
                object.actualHours = options.json && !isFinite(message.actualHours) ? String(message.actualHours) : message.actualHours;
            if (message.actualPayHours != null && message.hasOwnProperty("actualPayHours"))
                object.actualPayHours = options.json && !isFinite(message.actualPayHours) ? String(message.actualPayHours) : message.actualPayHours;
            if (message.wageRate != null && message.hasOwnProperty("wageRate"))
                object.wageRate = options.json && !isFinite(message.wageRate) ? String(message.wageRate) : message.wageRate;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            return object;
        };

        /**
         * Converts this WorkItem to JSON.
         * @function toJSON
         * @memberof busable.WorkItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WorkItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for WorkItem
         * @function getTypeUrl
         * @memberof busable.WorkItem
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        WorkItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.WorkItem";
        };

        return WorkItem;
    })();

    busable.Booking = (function() {

        /**
         * Properties of a Booking.
         * @memberof busable
         * @interface IBooking
         * @property {string|null} [bookingId] Booking bookingId
         * @property {string|null} [charterId] Booking charterId
         * @property {string|null} [bookingReference] Booking bookingReference
         * @property {number|Long|null} [createdAt] Booking createdAt
         * @property {number|Long|null} [updatedAt] Booking updatedAt
         */

        /**
         * Constructs a new Booking.
         * @memberof busable
         * @classdesc Represents a Booking.
         * @implements IBooking
         * @constructor
         * @param {busable.IBooking=} [properties] Properties to set
         */
        function Booking(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Booking bookingId.
         * @member {string} bookingId
         * @memberof busable.Booking
         * @instance
         */
        Booking.prototype.bookingId = "";

        /**
         * Booking charterId.
         * @member {string} charterId
         * @memberof busable.Booking
         * @instance
         */
        Booking.prototype.charterId = "";

        /**
         * Booking bookingReference.
         * @member {string} bookingReference
         * @memberof busable.Booking
         * @instance
         */
        Booking.prototype.bookingReference = "";

        /**
         * Booking createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.Booking
         * @instance
         */
        Booking.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Booking updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.Booking
         * @instance
         */
        Booking.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new Booking instance using the specified properties.
         * @function create
         * @memberof busable.Booking
         * @static
         * @param {busable.IBooking=} [properties] Properties to set
         * @returns {busable.Booking} Booking instance
         */
        Booking.create = function create(properties) {
            return new Booking(properties);
        };

        /**
         * Encodes the specified Booking message. Does not implicitly {@link busable.Booking.verify|verify} messages.
         * @function encode
         * @memberof busable.Booking
         * @static
         * @param {busable.IBooking} message Booking message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Booking.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.bookingId != null && Object.hasOwnProperty.call(message, "bookingId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.bookingId);
            if (message.charterId != null && Object.hasOwnProperty.call(message, "charterId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.charterId);
            if (message.bookingReference != null && Object.hasOwnProperty.call(message, "bookingReference"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.bookingReference);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified Booking message, length delimited. Does not implicitly {@link busable.Booking.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Booking
         * @static
         * @param {busable.IBooking} message Booking message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Booking.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Booking message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Booking
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Booking} Booking
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Booking.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Booking();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.bookingId = reader.string();
                        break;
                    }
                case 2: {
                        message.charterId = reader.string();
                        break;
                    }
                case 3: {
                        message.bookingReference = reader.string();
                        break;
                    }
                case 4: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 5: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Booking message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Booking
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Booking} Booking
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Booking.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Booking message.
         * @function verify
         * @memberof busable.Booking
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Booking.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.bookingId != null && message.hasOwnProperty("bookingId"))
                if (!$util.isString(message.bookingId))
                    return "bookingId: string expected";
            if (message.charterId != null && message.hasOwnProperty("charterId"))
                if (!$util.isString(message.charterId))
                    return "charterId: string expected";
            if (message.bookingReference != null && message.hasOwnProperty("bookingReference"))
                if (!$util.isString(message.bookingReference))
                    return "bookingReference: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            return null;
        };

        /**
         * Creates a Booking message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Booking
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Booking} Booking
         */
        Booking.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Booking)
                return object;
            var message = new $root.busable.Booking();
            if (object.bookingId != null)
                message.bookingId = String(object.bookingId);
            if (object.charterId != null)
                message.charterId = String(object.charterId);
            if (object.bookingReference != null)
                message.bookingReference = String(object.bookingReference);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a Booking message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Booking
         * @static
         * @param {busable.Booking} message Booking
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Booking.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.bookingId = "";
                object.charterId = "";
                object.bookingReference = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
            }
            if (message.bookingId != null && message.hasOwnProperty("bookingId"))
                object.bookingId = message.bookingId;
            if (message.charterId != null && message.hasOwnProperty("charterId"))
                object.charterId = message.charterId;
            if (message.bookingReference != null && message.hasOwnProperty("bookingReference"))
                object.bookingReference = message.bookingReference;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            return object;
        };

        /**
         * Converts this Booking to JSON.
         * @function toJSON
         * @memberof busable.Booking
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Booking.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Booking
         * @function getTypeUrl
         * @memberof busable.Booking
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Booking.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Booking";
        };

        return Booking;
    })();

    busable.LineItem = (function() {

        /**
         * Properties of a LineItem.
         * @memberof busable
         * @interface ILineItem
         * @property {string|null} [id] LineItem id
         * @property {string|null} [description] LineItem description
         * @property {number|null} [quantity] LineItem quantity
         * @property {number|null} [unitPrice] LineItem unitPrice
         * @property {number|null} [amount] LineItem amount
         * @property {number|null} [discount] LineItem discount
         * @property {string|null} [type] LineItem type
         */

        /**
         * Constructs a new LineItem.
         * @memberof busable
         * @classdesc Represents a LineItem.
         * @implements ILineItem
         * @constructor
         * @param {busable.ILineItem=} [properties] Properties to set
         */
        function LineItem(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LineItem id.
         * @member {string} id
         * @memberof busable.LineItem
         * @instance
         */
        LineItem.prototype.id = "";

        /**
         * LineItem description.
         * @member {string} description
         * @memberof busable.LineItem
         * @instance
         */
        LineItem.prototype.description = "";

        /**
         * LineItem quantity.
         * @member {number} quantity
         * @memberof busable.LineItem
         * @instance
         */
        LineItem.prototype.quantity = 0;

        /**
         * LineItem unitPrice.
         * @member {number} unitPrice
         * @memberof busable.LineItem
         * @instance
         */
        LineItem.prototype.unitPrice = 0;

        /**
         * LineItem amount.
         * @member {number} amount
         * @memberof busable.LineItem
         * @instance
         */
        LineItem.prototype.amount = 0;

        /**
         * LineItem discount.
         * @member {number} discount
         * @memberof busable.LineItem
         * @instance
         */
        LineItem.prototype.discount = 0;

        /**
         * LineItem type.
         * @member {string} type
         * @memberof busable.LineItem
         * @instance
         */
        LineItem.prototype.type = "";

        /**
         * Creates a new LineItem instance using the specified properties.
         * @function create
         * @memberof busable.LineItem
         * @static
         * @param {busable.ILineItem=} [properties] Properties to set
         * @returns {busable.LineItem} LineItem instance
         */
        LineItem.create = function create(properties) {
            return new LineItem(properties);
        };

        /**
         * Encodes the specified LineItem message. Does not implicitly {@link busable.LineItem.verify|verify} messages.
         * @function encode
         * @memberof busable.LineItem
         * @static
         * @param {busable.ILineItem} message LineItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LineItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.description);
            if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.quantity);
            if (message.unitPrice != null && Object.hasOwnProperty.call(message, "unitPrice"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.unitPrice);
            if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.amount);
            if (message.discount != null && Object.hasOwnProperty.call(message, "discount"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.discount);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.type);
            return writer;
        };

        /**
         * Encodes the specified LineItem message, length delimited. Does not implicitly {@link busable.LineItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.LineItem
         * @static
         * @param {busable.ILineItem} message LineItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LineItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LineItem message from the specified reader or buffer.
         * @function decode
         * @memberof busable.LineItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.LineItem} LineItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LineItem.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.LineItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.string();
                        break;
                    }
                case 2: {
                        message.description = reader.string();
                        break;
                    }
                case 3: {
                        message.quantity = reader.double();
                        break;
                    }
                case 4: {
                        message.unitPrice = reader.double();
                        break;
                    }
                case 5: {
                        message.amount = reader.double();
                        break;
                    }
                case 6: {
                        message.discount = reader.double();
                        break;
                    }
                case 7: {
                        message.type = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LineItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.LineItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.LineItem} LineItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LineItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LineItem message.
         * @function verify
         * @memberof busable.LineItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LineItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                if (typeof message.quantity !== "number")
                    return "quantity: number expected";
            if (message.unitPrice != null && message.hasOwnProperty("unitPrice"))
                if (typeof message.unitPrice !== "number")
                    return "unitPrice: number expected";
            if (message.amount != null && message.hasOwnProperty("amount"))
                if (typeof message.amount !== "number")
                    return "amount: number expected";
            if (message.discount != null && message.hasOwnProperty("discount"))
                if (typeof message.discount !== "number")
                    return "discount: number expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            return null;
        };

        /**
         * Creates a LineItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.LineItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.LineItem} LineItem
         */
        LineItem.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.LineItem)
                return object;
            var message = new $root.busable.LineItem();
            if (object.id != null)
                message.id = String(object.id);
            if (object.description != null)
                message.description = String(object.description);
            if (object.quantity != null)
                message.quantity = Number(object.quantity);
            if (object.unitPrice != null)
                message.unitPrice = Number(object.unitPrice);
            if (object.amount != null)
                message.amount = Number(object.amount);
            if (object.discount != null)
                message.discount = Number(object.discount);
            if (object.type != null)
                message.type = String(object.type);
            return message;
        };

        /**
         * Creates a plain object from a LineItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.LineItem
         * @static
         * @param {busable.LineItem} message LineItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LineItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.description = "";
                object.quantity = 0;
                object.unitPrice = 0;
                object.amount = 0;
                object.discount = 0;
                object.type = "";
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.quantity != null && message.hasOwnProperty("quantity"))
                object.quantity = options.json && !isFinite(message.quantity) ? String(message.quantity) : message.quantity;
            if (message.unitPrice != null && message.hasOwnProperty("unitPrice"))
                object.unitPrice = options.json && !isFinite(message.unitPrice) ? String(message.unitPrice) : message.unitPrice;
            if (message.amount != null && message.hasOwnProperty("amount"))
                object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
            if (message.discount != null && message.hasOwnProperty("discount"))
                object.discount = options.json && !isFinite(message.discount) ? String(message.discount) : message.discount;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this LineItem to JSON.
         * @function toJSON
         * @memberof busable.LineItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LineItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for LineItem
         * @function getTypeUrl
         * @memberof busable.LineItem
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        LineItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.LineItem";
        };

        return LineItem;
    })();

    busable.QuoteOverrides = (function() {

        /**
         * Properties of a QuoteOverrides.
         * @memberof busable
         * @interface IQuoteOverrides
         * @property {number|null} [distanceOverride] QuoteOverrides distanceOverride
         * @property {number|null} [durationOverride] QuoteOverrides durationOverride
         * @property {number|null} [vehicleCostOverride] QuoteOverrides vehicleCostOverride
         * @property {number|null} [driverCostOverride] QuoteOverrides driverCostOverride
         * @property {number|null} [baseRateOverride] QuoteOverrides baseRateOverride
         * @property {number|null} [totalOverride] QuoteOverrides totalOverride
         * @property {boolean|null} [useDistanceOverride] QuoteOverrides useDistanceOverride
         * @property {boolean|null} [useDurationOverride] QuoteOverrides useDurationOverride
         * @property {boolean|null} [useVehicleCostOverride] QuoteOverrides useVehicleCostOverride
         * @property {boolean|null} [useDriverCostOverride] QuoteOverrides useDriverCostOverride
         * @property {boolean|null} [useBaseRateOverride] QuoteOverrides useBaseRateOverride
         * @property {boolean|null} [useTotalOverride] QuoteOverrides useTotalOverride
         */

        /**
         * Constructs a new QuoteOverrides.
         * @memberof busable
         * @classdesc Represents a QuoteOverrides.
         * @implements IQuoteOverrides
         * @constructor
         * @param {busable.IQuoteOverrides=} [properties] Properties to set
         */
        function QuoteOverrides(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * QuoteOverrides distanceOverride.
         * @member {number} distanceOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.distanceOverride = 0;

        /**
         * QuoteOverrides durationOverride.
         * @member {number} durationOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.durationOverride = 0;

        /**
         * QuoteOverrides vehicleCostOverride.
         * @member {number} vehicleCostOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.vehicleCostOverride = 0;

        /**
         * QuoteOverrides driverCostOverride.
         * @member {number} driverCostOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.driverCostOverride = 0;

        /**
         * QuoteOverrides baseRateOverride.
         * @member {number} baseRateOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.baseRateOverride = 0;

        /**
         * QuoteOverrides totalOverride.
         * @member {number} totalOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.totalOverride = 0;

        /**
         * QuoteOverrides useDistanceOverride.
         * @member {boolean} useDistanceOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.useDistanceOverride = false;

        /**
         * QuoteOverrides useDurationOverride.
         * @member {boolean} useDurationOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.useDurationOverride = false;

        /**
         * QuoteOverrides useVehicleCostOverride.
         * @member {boolean} useVehicleCostOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.useVehicleCostOverride = false;

        /**
         * QuoteOverrides useDriverCostOverride.
         * @member {boolean} useDriverCostOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.useDriverCostOverride = false;

        /**
         * QuoteOverrides useBaseRateOverride.
         * @member {boolean} useBaseRateOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.useBaseRateOverride = false;

        /**
         * QuoteOverrides useTotalOverride.
         * @member {boolean} useTotalOverride
         * @memberof busable.QuoteOverrides
         * @instance
         */
        QuoteOverrides.prototype.useTotalOverride = false;

        /**
         * Creates a new QuoteOverrides instance using the specified properties.
         * @function create
         * @memberof busable.QuoteOverrides
         * @static
         * @param {busable.IQuoteOverrides=} [properties] Properties to set
         * @returns {busable.QuoteOverrides} QuoteOverrides instance
         */
        QuoteOverrides.create = function create(properties) {
            return new QuoteOverrides(properties);
        };

        /**
         * Encodes the specified QuoteOverrides message. Does not implicitly {@link busable.QuoteOverrides.verify|verify} messages.
         * @function encode
         * @memberof busable.QuoteOverrides
         * @static
         * @param {busable.IQuoteOverrides} message QuoteOverrides message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteOverrides.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.distanceOverride != null && Object.hasOwnProperty.call(message, "distanceOverride"))
                writer.uint32(/* id 1, wireType 1 =*/9).double(message.distanceOverride);
            if (message.durationOverride != null && Object.hasOwnProperty.call(message, "durationOverride"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.durationOverride);
            if (message.vehicleCostOverride != null && Object.hasOwnProperty.call(message, "vehicleCostOverride"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.vehicleCostOverride);
            if (message.driverCostOverride != null && Object.hasOwnProperty.call(message, "driverCostOverride"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.driverCostOverride);
            if (message.baseRateOverride != null && Object.hasOwnProperty.call(message, "baseRateOverride"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.baseRateOverride);
            if (message.totalOverride != null && Object.hasOwnProperty.call(message, "totalOverride"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.totalOverride);
            if (message.useDistanceOverride != null && Object.hasOwnProperty.call(message, "useDistanceOverride"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.useDistanceOverride);
            if (message.useDurationOverride != null && Object.hasOwnProperty.call(message, "useDurationOverride"))
                writer.uint32(/* id 8, wireType 0 =*/64).bool(message.useDurationOverride);
            if (message.useVehicleCostOverride != null && Object.hasOwnProperty.call(message, "useVehicleCostOverride"))
                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.useVehicleCostOverride);
            if (message.useDriverCostOverride != null && Object.hasOwnProperty.call(message, "useDriverCostOverride"))
                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.useDriverCostOverride);
            if (message.useBaseRateOverride != null && Object.hasOwnProperty.call(message, "useBaseRateOverride"))
                writer.uint32(/* id 11, wireType 0 =*/88).bool(message.useBaseRateOverride);
            if (message.useTotalOverride != null && Object.hasOwnProperty.call(message, "useTotalOverride"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.useTotalOverride);
            return writer;
        };

        /**
         * Encodes the specified QuoteOverrides message, length delimited. Does not implicitly {@link busable.QuoteOverrides.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.QuoteOverrides
         * @static
         * @param {busable.IQuoteOverrides} message QuoteOverrides message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteOverrides.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteOverrides message from the specified reader or buffer.
         * @function decode
         * @memberof busable.QuoteOverrides
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.QuoteOverrides} QuoteOverrides
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteOverrides.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.QuoteOverrides();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.distanceOverride = reader.double();
                        break;
                    }
                case 2: {
                        message.durationOverride = reader.double();
                        break;
                    }
                case 3: {
                        message.vehicleCostOverride = reader.double();
                        break;
                    }
                case 4: {
                        message.driverCostOverride = reader.double();
                        break;
                    }
                case 5: {
                        message.baseRateOverride = reader.double();
                        break;
                    }
                case 6: {
                        message.totalOverride = reader.double();
                        break;
                    }
                case 7: {
                        message.useDistanceOverride = reader.bool();
                        break;
                    }
                case 8: {
                        message.useDurationOverride = reader.bool();
                        break;
                    }
                case 9: {
                        message.useVehicleCostOverride = reader.bool();
                        break;
                    }
                case 10: {
                        message.useDriverCostOverride = reader.bool();
                        break;
                    }
                case 11: {
                        message.useBaseRateOverride = reader.bool();
                        break;
                    }
                case 12: {
                        message.useTotalOverride = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a QuoteOverrides message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.QuoteOverrides
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.QuoteOverrides} QuoteOverrides
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteOverrides.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a QuoteOverrides message.
         * @function verify
         * @memberof busable.QuoteOverrides
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        QuoteOverrides.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.distanceOverride != null && message.hasOwnProperty("distanceOverride"))
                if (typeof message.distanceOverride !== "number")
                    return "distanceOverride: number expected";
            if (message.durationOverride != null && message.hasOwnProperty("durationOverride"))
                if (typeof message.durationOverride !== "number")
                    return "durationOverride: number expected";
            if (message.vehicleCostOverride != null && message.hasOwnProperty("vehicleCostOverride"))
                if (typeof message.vehicleCostOverride !== "number")
                    return "vehicleCostOverride: number expected";
            if (message.driverCostOverride != null && message.hasOwnProperty("driverCostOverride"))
                if (typeof message.driverCostOverride !== "number")
                    return "driverCostOverride: number expected";
            if (message.baseRateOverride != null && message.hasOwnProperty("baseRateOverride"))
                if (typeof message.baseRateOverride !== "number")
                    return "baseRateOverride: number expected";
            if (message.totalOverride != null && message.hasOwnProperty("totalOverride"))
                if (typeof message.totalOverride !== "number")
                    return "totalOverride: number expected";
            if (message.useDistanceOverride != null && message.hasOwnProperty("useDistanceOverride"))
                if (typeof message.useDistanceOverride !== "boolean")
                    return "useDistanceOverride: boolean expected";
            if (message.useDurationOverride != null && message.hasOwnProperty("useDurationOverride"))
                if (typeof message.useDurationOverride !== "boolean")
                    return "useDurationOverride: boolean expected";
            if (message.useVehicleCostOverride != null && message.hasOwnProperty("useVehicleCostOverride"))
                if (typeof message.useVehicleCostOverride !== "boolean")
                    return "useVehicleCostOverride: boolean expected";
            if (message.useDriverCostOverride != null && message.hasOwnProperty("useDriverCostOverride"))
                if (typeof message.useDriverCostOverride !== "boolean")
                    return "useDriverCostOverride: boolean expected";
            if (message.useBaseRateOverride != null && message.hasOwnProperty("useBaseRateOverride"))
                if (typeof message.useBaseRateOverride !== "boolean")
                    return "useBaseRateOverride: boolean expected";
            if (message.useTotalOverride != null && message.hasOwnProperty("useTotalOverride"))
                if (typeof message.useTotalOverride !== "boolean")
                    return "useTotalOverride: boolean expected";
            return null;
        };

        /**
         * Creates a QuoteOverrides message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.QuoteOverrides
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.QuoteOverrides} QuoteOverrides
         */
        QuoteOverrides.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.QuoteOverrides)
                return object;
            var message = new $root.busable.QuoteOverrides();
            if (object.distanceOverride != null)
                message.distanceOverride = Number(object.distanceOverride);
            if (object.durationOverride != null)
                message.durationOverride = Number(object.durationOverride);
            if (object.vehicleCostOverride != null)
                message.vehicleCostOverride = Number(object.vehicleCostOverride);
            if (object.driverCostOverride != null)
                message.driverCostOverride = Number(object.driverCostOverride);
            if (object.baseRateOverride != null)
                message.baseRateOverride = Number(object.baseRateOverride);
            if (object.totalOverride != null)
                message.totalOverride = Number(object.totalOverride);
            if (object.useDistanceOverride != null)
                message.useDistanceOverride = Boolean(object.useDistanceOverride);
            if (object.useDurationOverride != null)
                message.useDurationOverride = Boolean(object.useDurationOverride);
            if (object.useVehicleCostOverride != null)
                message.useVehicleCostOverride = Boolean(object.useVehicleCostOverride);
            if (object.useDriverCostOverride != null)
                message.useDriverCostOverride = Boolean(object.useDriverCostOverride);
            if (object.useBaseRateOverride != null)
                message.useBaseRateOverride = Boolean(object.useBaseRateOverride);
            if (object.useTotalOverride != null)
                message.useTotalOverride = Boolean(object.useTotalOverride);
            return message;
        };

        /**
         * Creates a plain object from a QuoteOverrides message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.QuoteOverrides
         * @static
         * @param {busable.QuoteOverrides} message QuoteOverrides
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        QuoteOverrides.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.distanceOverride = 0;
                object.durationOverride = 0;
                object.vehicleCostOverride = 0;
                object.driverCostOverride = 0;
                object.baseRateOverride = 0;
                object.totalOverride = 0;
                object.useDistanceOverride = false;
                object.useDurationOverride = false;
                object.useVehicleCostOverride = false;
                object.useDriverCostOverride = false;
                object.useBaseRateOverride = false;
                object.useTotalOverride = false;
            }
            if (message.distanceOverride != null && message.hasOwnProperty("distanceOverride"))
                object.distanceOverride = options.json && !isFinite(message.distanceOverride) ? String(message.distanceOverride) : message.distanceOverride;
            if (message.durationOverride != null && message.hasOwnProperty("durationOverride"))
                object.durationOverride = options.json && !isFinite(message.durationOverride) ? String(message.durationOverride) : message.durationOverride;
            if (message.vehicleCostOverride != null && message.hasOwnProperty("vehicleCostOverride"))
                object.vehicleCostOverride = options.json && !isFinite(message.vehicleCostOverride) ? String(message.vehicleCostOverride) : message.vehicleCostOverride;
            if (message.driverCostOverride != null && message.hasOwnProperty("driverCostOverride"))
                object.driverCostOverride = options.json && !isFinite(message.driverCostOverride) ? String(message.driverCostOverride) : message.driverCostOverride;
            if (message.baseRateOverride != null && message.hasOwnProperty("baseRateOverride"))
                object.baseRateOverride = options.json && !isFinite(message.baseRateOverride) ? String(message.baseRateOverride) : message.baseRateOverride;
            if (message.totalOverride != null && message.hasOwnProperty("totalOverride"))
                object.totalOverride = options.json && !isFinite(message.totalOverride) ? String(message.totalOverride) : message.totalOverride;
            if (message.useDistanceOverride != null && message.hasOwnProperty("useDistanceOverride"))
                object.useDistanceOverride = message.useDistanceOverride;
            if (message.useDurationOverride != null && message.hasOwnProperty("useDurationOverride"))
                object.useDurationOverride = message.useDurationOverride;
            if (message.useVehicleCostOverride != null && message.hasOwnProperty("useVehicleCostOverride"))
                object.useVehicleCostOverride = message.useVehicleCostOverride;
            if (message.useDriverCostOverride != null && message.hasOwnProperty("useDriverCostOverride"))
                object.useDriverCostOverride = message.useDriverCostOverride;
            if (message.useBaseRateOverride != null && message.hasOwnProperty("useBaseRateOverride"))
                object.useBaseRateOverride = message.useBaseRateOverride;
            if (message.useTotalOverride != null && message.hasOwnProperty("useTotalOverride"))
                object.useTotalOverride = message.useTotalOverride;
            return object;
        };

        /**
         * Converts this QuoteOverrides to JSON.
         * @function toJSON
         * @memberof busable.QuoteOverrides
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        QuoteOverrides.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for QuoteOverrides
         * @function getTypeUrl
         * @memberof busable.QuoteOverrides
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        QuoteOverrides.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.QuoteOverrides";
        };

        return QuoteOverrides;
    })();

    busable.Charter = (function() {

        /**
         * Properties of a Charter.
         * @memberof busable
         * @interface ICharter
         * @property {string|null} [charterId] Charter charterId
         * @property {string|null} [name] Charter name
         * @property {string|null} [description] Charter description
         * @property {string|null} [operatorId] Charter operatorId
         * @property {string|null} [userId] Charter userId
         * @property {string|null} [bookingReference] Charter bookingReference
         * @property {string|null} [status] Charter status
         * @property {string|null} [customerName] Charter customerName
         * @property {string|null} [customerEmail] Charter customerEmail
         * @property {string|null} [customerPhone] Charter customerPhone
         * @property {string|null} [customerAddress] Charter customerAddress
         * @property {Array.<string>|null} [dates] Charter dates
         * @property {string|null} [date] Charter date
         * @property {Array.<string>|null} [calendarIds] Charter calendarIds
         * @property {number|null} [passengerCount] Charter passengerCount
         * @property {boolean|null} [wheelchairRequired] Charter wheelchairRequired
         * @property {string|null} [pickupLocation] Charter pickupLocation
         * @property {string|null} [dropoffLocation] Charter dropoffLocation
         * @property {Array.<busable.IRoute>|null} [itinerary] Charter itinerary
         * @property {busable.IShiftBat|null} [duty] Charter duty
         * @property {string|null} [vehicleTypeId] Charter vehicleTypeId
         * @property {string|null} [vehicleId] Charter vehicleId
         * @property {string|null} [driverId] Charter driverId
         * @property {number|null} [quotedPrice] Charter quotedPrice
         * @property {number|null} [finalPrice] Charter finalPrice
         * @property {string|null} [notes] Charter notes
         * @property {number|Long|null} [createdAt] Charter createdAt
         * @property {number|Long|null} [updatedAt] Charter updatedAt
         * @property {Array.<busable.ILineItem>|null} [lineItems] Charter lineItems
         * @property {number|null} [subTotal] Charter subTotal
         * @property {number|null} [discount] Charter discount
         * @property {number|null} [gst] Charter gst
         * @property {number|null} [total] Charter total
         * @property {string|null} [discountReason] Charter discountReason
         * @property {number|null} [discountPercentage] Charter discountPercentage
         * @property {boolean|null} [quoteSent] Charter quoteSent
         * @property {number|Long|null} [quoteSentAt] Charter quoteSentAt
         * @property {busable.IQuoteOverrides|null} [quoteOverrides] Charter quoteOverrides
         * @property {number|null} [duration] Charter duration
         * @property {number|null} [distance] Charter distance
         * @property {number|null} [vehicleCost] Charter vehicleCost
         * @property {number|null} [driverCost] Charter driverCost
         * @property {number|null} [margin] Charter margin
         * @property {boolean|null} [roundtrip] Charter roundtrip
         */

        /**
         * Constructs a new Charter.
         * @memberof busable
         * @classdesc Represents a Charter.
         * @implements ICharter
         * @constructor
         * @param {busable.ICharter=} [properties] Properties to set
         */
        function Charter(properties) {
            this.dates = [];
            this.calendarIds = [];
            this.itinerary = [];
            this.lineItems = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Charter charterId.
         * @member {string} charterId
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.charterId = "";

        /**
         * Charter name.
         * @member {string} name
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.name = "";

        /**
         * Charter description.
         * @member {string} description
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.description = "";

        /**
         * Charter operatorId.
         * @member {string} operatorId
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.operatorId = "";

        /**
         * Charter userId.
         * @member {string} userId
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.userId = "";

        /**
         * Charter bookingReference.
         * @member {string} bookingReference
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.bookingReference = "";

        /**
         * Charter status.
         * @member {string} status
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.status = "";

        /**
         * Charter customerName.
         * @member {string} customerName
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.customerName = "";

        /**
         * Charter customerEmail.
         * @member {string} customerEmail
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.customerEmail = "";

        /**
         * Charter customerPhone.
         * @member {string} customerPhone
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.customerPhone = "";

        /**
         * Charter customerAddress.
         * @member {string} customerAddress
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.customerAddress = "";

        /**
         * Charter dates.
         * @member {Array.<string>} dates
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.dates = $util.emptyArray;

        /**
         * Charter date.
         * @member {string} date
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.date = "";

        /**
         * Charter calendarIds.
         * @member {Array.<string>} calendarIds
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.calendarIds = $util.emptyArray;

        /**
         * Charter passengerCount.
         * @member {number} passengerCount
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.passengerCount = 0;

        /**
         * Charter wheelchairRequired.
         * @member {boolean} wheelchairRequired
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.wheelchairRequired = false;

        /**
         * Charter pickupLocation.
         * @member {string} pickupLocation
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.pickupLocation = "";

        /**
         * Charter dropoffLocation.
         * @member {string} dropoffLocation
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.dropoffLocation = "";

        /**
         * Charter itinerary.
         * @member {Array.<busable.IRoute>} itinerary
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.itinerary = $util.emptyArray;

        /**
         * Charter duty.
         * @member {busable.IShiftBat|null|undefined} duty
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.duty = null;

        /**
         * Charter vehicleTypeId.
         * @member {string} vehicleTypeId
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.vehicleTypeId = "";

        /**
         * Charter vehicleId.
         * @member {string} vehicleId
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.vehicleId = "";

        /**
         * Charter driverId.
         * @member {string} driverId
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.driverId = "";

        /**
         * Charter quotedPrice.
         * @member {number} quotedPrice
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.quotedPrice = 0;

        /**
         * Charter finalPrice.
         * @member {number} finalPrice
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.finalPrice = 0;

        /**
         * Charter notes.
         * @member {string} notes
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.notes = "";

        /**
         * Charter createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Charter updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Charter lineItems.
         * @member {Array.<busable.ILineItem>} lineItems
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.lineItems = $util.emptyArray;

        /**
         * Charter subTotal.
         * @member {number} subTotal
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.subTotal = 0;

        /**
         * Charter discount.
         * @member {number} discount
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.discount = 0;

        /**
         * Charter gst.
         * @member {number} gst
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.gst = 0;

        /**
         * Charter total.
         * @member {number} total
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.total = 0;

        /**
         * Charter discountReason.
         * @member {string} discountReason
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.discountReason = "";

        /**
         * Charter discountPercentage.
         * @member {number} discountPercentage
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.discountPercentage = 0;

        /**
         * Charter quoteSent.
         * @member {boolean} quoteSent
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.quoteSent = false;

        /**
         * Charter quoteSentAt.
         * @member {number|Long} quoteSentAt
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.quoteSentAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Charter quoteOverrides.
         * @member {busable.IQuoteOverrides|null|undefined} quoteOverrides
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.quoteOverrides = null;

        /**
         * Charter duration.
         * @member {number} duration
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.duration = 0;

        /**
         * Charter distance.
         * @member {number} distance
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.distance = 0;

        /**
         * Charter vehicleCost.
         * @member {number} vehicleCost
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.vehicleCost = 0;

        /**
         * Charter driverCost.
         * @member {number} driverCost
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.driverCost = 0;

        /**
         * Charter margin.
         * @member {number} margin
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.margin = 0;

        /**
         * Charter roundtrip.
         * @member {boolean} roundtrip
         * @memberof busable.Charter
         * @instance
         */
        Charter.prototype.roundtrip = false;

        /**
         * Creates a new Charter instance using the specified properties.
         * @function create
         * @memberof busable.Charter
         * @static
         * @param {busable.ICharter=} [properties] Properties to set
         * @returns {busable.Charter} Charter instance
         */
        Charter.create = function create(properties) {
            return new Charter(properties);
        };

        /**
         * Encodes the specified Charter message. Does not implicitly {@link busable.Charter.verify|verify} messages.
         * @function encode
         * @memberof busable.Charter
         * @static
         * @param {busable.ICharter} message Charter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Charter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.charterId != null && Object.hasOwnProperty.call(message, "charterId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.charterId);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.operatorId);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.userId);
            if (message.bookingReference != null && Object.hasOwnProperty.call(message, "bookingReference"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.bookingReference);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.status);
            if (message.customerName != null && Object.hasOwnProperty.call(message, "customerName"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.customerName);
            if (message.customerEmail != null && Object.hasOwnProperty.call(message, "customerEmail"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.customerEmail);
            if (message.customerPhone != null && Object.hasOwnProperty.call(message, "customerPhone"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.customerPhone);
            if (message.customerAddress != null && Object.hasOwnProperty.call(message, "customerAddress"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.customerAddress);
            if (message.dates != null && message.dates.length)
                for (var i = 0; i < message.dates.length; ++i)
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.dates[i]);
            if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.date);
            if (message.calendarIds != null && message.calendarIds.length)
                for (var i = 0; i < message.calendarIds.length; ++i)
                    writer.uint32(/* id 14, wireType 2 =*/114).string(message.calendarIds[i]);
            if (message.passengerCount != null && Object.hasOwnProperty.call(message, "passengerCount"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.passengerCount);
            if (message.wheelchairRequired != null && Object.hasOwnProperty.call(message, "wheelchairRequired"))
                writer.uint32(/* id 16, wireType 0 =*/128).bool(message.wheelchairRequired);
            if (message.pickupLocation != null && Object.hasOwnProperty.call(message, "pickupLocation"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.pickupLocation);
            if (message.dropoffLocation != null && Object.hasOwnProperty.call(message, "dropoffLocation"))
                writer.uint32(/* id 18, wireType 2 =*/146).string(message.dropoffLocation);
            if (message.itinerary != null && message.itinerary.length)
                for (var i = 0; i < message.itinerary.length; ++i)
                    $root.busable.Route.encode(message.itinerary[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
            if (message.duty != null && Object.hasOwnProperty.call(message, "duty"))
                $root.busable.ShiftBat.encode(message.duty, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
            if (message.vehicleTypeId != null && Object.hasOwnProperty.call(message, "vehicleTypeId"))
                writer.uint32(/* id 21, wireType 2 =*/170).string(message.vehicleTypeId);
            if (message.vehicleId != null && Object.hasOwnProperty.call(message, "vehicleId"))
                writer.uint32(/* id 22, wireType 2 =*/178).string(message.vehicleId);
            if (message.driverId != null && Object.hasOwnProperty.call(message, "driverId"))
                writer.uint32(/* id 23, wireType 2 =*/186).string(message.driverId);
            if (message.quotedPrice != null && Object.hasOwnProperty.call(message, "quotedPrice"))
                writer.uint32(/* id 24, wireType 1 =*/193).double(message.quotedPrice);
            if (message.finalPrice != null && Object.hasOwnProperty.call(message, "finalPrice"))
                writer.uint32(/* id 25, wireType 1 =*/201).double(message.finalPrice);
            if (message.notes != null && Object.hasOwnProperty.call(message, "notes"))
                writer.uint32(/* id 26, wireType 2 =*/210).string(message.notes);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 27, wireType 0 =*/216).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 28, wireType 0 =*/224).int64(message.updatedAt);
            if (message.lineItems != null && message.lineItems.length)
                for (var i = 0; i < message.lineItems.length; ++i)
                    $root.busable.LineItem.encode(message.lineItems[i], writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
            if (message.subTotal != null && Object.hasOwnProperty.call(message, "subTotal"))
                writer.uint32(/* id 30, wireType 1 =*/241).double(message.subTotal);
            if (message.discount != null && Object.hasOwnProperty.call(message, "discount"))
                writer.uint32(/* id 31, wireType 1 =*/249).double(message.discount);
            if (message.gst != null && Object.hasOwnProperty.call(message, "gst"))
                writer.uint32(/* id 32, wireType 1 =*/257).double(message.gst);
            if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                writer.uint32(/* id 33, wireType 1 =*/265).double(message.total);
            if (message.discountReason != null && Object.hasOwnProperty.call(message, "discountReason"))
                writer.uint32(/* id 34, wireType 2 =*/274).string(message.discountReason);
            if (message.discountPercentage != null && Object.hasOwnProperty.call(message, "discountPercentage"))
                writer.uint32(/* id 35, wireType 1 =*/281).double(message.discountPercentage);
            if (message.quoteSent != null && Object.hasOwnProperty.call(message, "quoteSent"))
                writer.uint32(/* id 36, wireType 0 =*/288).bool(message.quoteSent);
            if (message.quoteSentAt != null && Object.hasOwnProperty.call(message, "quoteSentAt"))
                writer.uint32(/* id 37, wireType 0 =*/296).int64(message.quoteSentAt);
            if (message.quoteOverrides != null && Object.hasOwnProperty.call(message, "quoteOverrides"))
                $root.busable.QuoteOverrides.encode(message.quoteOverrides, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
            if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                writer.uint32(/* id 39, wireType 0 =*/312).int32(message.duration);
            if (message.distance != null && Object.hasOwnProperty.call(message, "distance"))
                writer.uint32(/* id 40, wireType 1 =*/321).double(message.distance);
            if (message.vehicleCost != null && Object.hasOwnProperty.call(message, "vehicleCost"))
                writer.uint32(/* id 41, wireType 1 =*/329).double(message.vehicleCost);
            if (message.driverCost != null && Object.hasOwnProperty.call(message, "driverCost"))
                writer.uint32(/* id 42, wireType 1 =*/337).double(message.driverCost);
            if (message.margin != null && Object.hasOwnProperty.call(message, "margin"))
                writer.uint32(/* id 43, wireType 1 =*/345).double(message.margin);
            if (message.roundtrip != null && Object.hasOwnProperty.call(message, "roundtrip"))
                writer.uint32(/* id 44, wireType 0 =*/352).bool(message.roundtrip);
            return writer;
        };

        /**
         * Encodes the specified Charter message, length delimited. Does not implicitly {@link busable.Charter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Charter
         * @static
         * @param {busable.ICharter} message Charter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Charter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Charter message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Charter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Charter} Charter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Charter.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Charter();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.charterId = reader.string();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 5: {
                        message.userId = reader.string();
                        break;
                    }
                case 6: {
                        message.bookingReference = reader.string();
                        break;
                    }
                case 7: {
                        message.status = reader.string();
                        break;
                    }
                case 8: {
                        message.customerName = reader.string();
                        break;
                    }
                case 9: {
                        message.customerEmail = reader.string();
                        break;
                    }
                case 10: {
                        message.customerPhone = reader.string();
                        break;
                    }
                case 11: {
                        message.customerAddress = reader.string();
                        break;
                    }
                case 12: {
                        if (!(message.dates && message.dates.length))
                            message.dates = [];
                        message.dates.push(reader.string());
                        break;
                    }
                case 13: {
                        message.date = reader.string();
                        break;
                    }
                case 14: {
                        if (!(message.calendarIds && message.calendarIds.length))
                            message.calendarIds = [];
                        message.calendarIds.push(reader.string());
                        break;
                    }
                case 15: {
                        message.passengerCount = reader.int32();
                        break;
                    }
                case 16: {
                        message.wheelchairRequired = reader.bool();
                        break;
                    }
                case 17: {
                        message.pickupLocation = reader.string();
                        break;
                    }
                case 18: {
                        message.dropoffLocation = reader.string();
                        break;
                    }
                case 19: {
                        if (!(message.itinerary && message.itinerary.length))
                            message.itinerary = [];
                        message.itinerary.push($root.busable.Route.decode(reader, reader.uint32()));
                        break;
                    }
                case 20: {
                        message.duty = $root.busable.ShiftBat.decode(reader, reader.uint32());
                        break;
                    }
                case 21: {
                        message.vehicleTypeId = reader.string();
                        break;
                    }
                case 22: {
                        message.vehicleId = reader.string();
                        break;
                    }
                case 23: {
                        message.driverId = reader.string();
                        break;
                    }
                case 24: {
                        message.quotedPrice = reader.double();
                        break;
                    }
                case 25: {
                        message.finalPrice = reader.double();
                        break;
                    }
                case 26: {
                        message.notes = reader.string();
                        break;
                    }
                case 27: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 28: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                case 29: {
                        if (!(message.lineItems && message.lineItems.length))
                            message.lineItems = [];
                        message.lineItems.push($root.busable.LineItem.decode(reader, reader.uint32()));
                        break;
                    }
                case 30: {
                        message.subTotal = reader.double();
                        break;
                    }
                case 31: {
                        message.discount = reader.double();
                        break;
                    }
                case 32: {
                        message.gst = reader.double();
                        break;
                    }
                case 33: {
                        message.total = reader.double();
                        break;
                    }
                case 34: {
                        message.discountReason = reader.string();
                        break;
                    }
                case 35: {
                        message.discountPercentage = reader.double();
                        break;
                    }
                case 36: {
                        message.quoteSent = reader.bool();
                        break;
                    }
                case 37: {
                        message.quoteSentAt = reader.int64();
                        break;
                    }
                case 38: {
                        message.quoteOverrides = $root.busable.QuoteOverrides.decode(reader, reader.uint32());
                        break;
                    }
                case 39: {
                        message.duration = reader.int32();
                        break;
                    }
                case 40: {
                        message.distance = reader.double();
                        break;
                    }
                case 41: {
                        message.vehicleCost = reader.double();
                        break;
                    }
                case 42: {
                        message.driverCost = reader.double();
                        break;
                    }
                case 43: {
                        message.margin = reader.double();
                        break;
                    }
                case 44: {
                        message.roundtrip = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Charter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Charter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Charter} Charter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Charter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Charter message.
         * @function verify
         * @memberof busable.Charter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Charter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.charterId != null && message.hasOwnProperty("charterId"))
                if (!$util.isString(message.charterId))
                    return "charterId: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.bookingReference != null && message.hasOwnProperty("bookingReference"))
                if (!$util.isString(message.bookingReference))
                    return "bookingReference: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isString(message.status))
                    return "status: string expected";
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                if (!$util.isString(message.customerName))
                    return "customerName: string expected";
            if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
                if (!$util.isString(message.customerEmail))
                    return "customerEmail: string expected";
            if (message.customerPhone != null && message.hasOwnProperty("customerPhone"))
                if (!$util.isString(message.customerPhone))
                    return "customerPhone: string expected";
            if (message.customerAddress != null && message.hasOwnProperty("customerAddress"))
                if (!$util.isString(message.customerAddress))
                    return "customerAddress: string expected";
            if (message.dates != null && message.hasOwnProperty("dates")) {
                if (!Array.isArray(message.dates))
                    return "dates: array expected";
                for (var i = 0; i < message.dates.length; ++i)
                    if (!$util.isString(message.dates[i]))
                        return "dates: string[] expected";
            }
            if (message.date != null && message.hasOwnProperty("date"))
                if (!$util.isString(message.date))
                    return "date: string expected";
            if (message.calendarIds != null && message.hasOwnProperty("calendarIds")) {
                if (!Array.isArray(message.calendarIds))
                    return "calendarIds: array expected";
                for (var i = 0; i < message.calendarIds.length; ++i)
                    if (!$util.isString(message.calendarIds[i]))
                        return "calendarIds: string[] expected";
            }
            if (message.passengerCount != null && message.hasOwnProperty("passengerCount"))
                if (!$util.isInteger(message.passengerCount))
                    return "passengerCount: integer expected";
            if (message.wheelchairRequired != null && message.hasOwnProperty("wheelchairRequired"))
                if (typeof message.wheelchairRequired !== "boolean")
                    return "wheelchairRequired: boolean expected";
            if (message.pickupLocation != null && message.hasOwnProperty("pickupLocation"))
                if (!$util.isString(message.pickupLocation))
                    return "pickupLocation: string expected";
            if (message.dropoffLocation != null && message.hasOwnProperty("dropoffLocation"))
                if (!$util.isString(message.dropoffLocation))
                    return "dropoffLocation: string expected";
            if (message.itinerary != null && message.hasOwnProperty("itinerary")) {
                if (!Array.isArray(message.itinerary))
                    return "itinerary: array expected";
                for (var i = 0; i < message.itinerary.length; ++i) {
                    var error = $root.busable.Route.verify(message.itinerary[i]);
                    if (error)
                        return "itinerary." + error;
                }
            }
            if (message.duty != null && message.hasOwnProperty("duty")) {
                var error = $root.busable.ShiftBat.verify(message.duty);
                if (error)
                    return "duty." + error;
            }
            if (message.vehicleTypeId != null && message.hasOwnProperty("vehicleTypeId"))
                if (!$util.isString(message.vehicleTypeId))
                    return "vehicleTypeId: string expected";
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                if (!$util.isString(message.vehicleId))
                    return "vehicleId: string expected";
            if (message.driverId != null && message.hasOwnProperty("driverId"))
                if (!$util.isString(message.driverId))
                    return "driverId: string expected";
            if (message.quotedPrice != null && message.hasOwnProperty("quotedPrice"))
                if (typeof message.quotedPrice !== "number")
                    return "quotedPrice: number expected";
            if (message.finalPrice != null && message.hasOwnProperty("finalPrice"))
                if (typeof message.finalPrice !== "number")
                    return "finalPrice: number expected";
            if (message.notes != null && message.hasOwnProperty("notes"))
                if (!$util.isString(message.notes))
                    return "notes: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            if (message.lineItems != null && message.hasOwnProperty("lineItems")) {
                if (!Array.isArray(message.lineItems))
                    return "lineItems: array expected";
                for (var i = 0; i < message.lineItems.length; ++i) {
                    var error = $root.busable.LineItem.verify(message.lineItems[i]);
                    if (error)
                        return "lineItems." + error;
                }
            }
            if (message.subTotal != null && message.hasOwnProperty("subTotal"))
                if (typeof message.subTotal !== "number")
                    return "subTotal: number expected";
            if (message.discount != null && message.hasOwnProperty("discount"))
                if (typeof message.discount !== "number")
                    return "discount: number expected";
            if (message.gst != null && message.hasOwnProperty("gst"))
                if (typeof message.gst !== "number")
                    return "gst: number expected";
            if (message.total != null && message.hasOwnProperty("total"))
                if (typeof message.total !== "number")
                    return "total: number expected";
            if (message.discountReason != null && message.hasOwnProperty("discountReason"))
                if (!$util.isString(message.discountReason))
                    return "discountReason: string expected";
            if (message.discountPercentage != null && message.hasOwnProperty("discountPercentage"))
                if (typeof message.discountPercentage !== "number")
                    return "discountPercentage: number expected";
            if (message.quoteSent != null && message.hasOwnProperty("quoteSent"))
                if (typeof message.quoteSent !== "boolean")
                    return "quoteSent: boolean expected";
            if (message.quoteSentAt != null && message.hasOwnProperty("quoteSentAt"))
                if (!$util.isInteger(message.quoteSentAt) && !(message.quoteSentAt && $util.isInteger(message.quoteSentAt.low) && $util.isInteger(message.quoteSentAt.high)))
                    return "quoteSentAt: integer|Long expected";
            if (message.quoteOverrides != null && message.hasOwnProperty("quoteOverrides")) {
                var error = $root.busable.QuoteOverrides.verify(message.quoteOverrides);
                if (error)
                    return "quoteOverrides." + error;
            }
            if (message.duration != null && message.hasOwnProperty("duration"))
                if (!$util.isInteger(message.duration))
                    return "duration: integer expected";
            if (message.distance != null && message.hasOwnProperty("distance"))
                if (typeof message.distance !== "number")
                    return "distance: number expected";
            if (message.vehicleCost != null && message.hasOwnProperty("vehicleCost"))
                if (typeof message.vehicleCost !== "number")
                    return "vehicleCost: number expected";
            if (message.driverCost != null && message.hasOwnProperty("driverCost"))
                if (typeof message.driverCost !== "number")
                    return "driverCost: number expected";
            if (message.margin != null && message.hasOwnProperty("margin"))
                if (typeof message.margin !== "number")
                    return "margin: number expected";
            if (message.roundtrip != null && message.hasOwnProperty("roundtrip"))
                if (typeof message.roundtrip !== "boolean")
                    return "roundtrip: boolean expected";
            return null;
        };

        /**
         * Creates a Charter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Charter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Charter} Charter
         */
        Charter.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Charter)
                return object;
            var message = new $root.busable.Charter();
            if (object.charterId != null)
                message.charterId = String(object.charterId);
            if (object.name != null)
                message.name = String(object.name);
            if (object.description != null)
                message.description = String(object.description);
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.bookingReference != null)
                message.bookingReference = String(object.bookingReference);
            if (object.status != null)
                message.status = String(object.status);
            if (object.customerName != null)
                message.customerName = String(object.customerName);
            if (object.customerEmail != null)
                message.customerEmail = String(object.customerEmail);
            if (object.customerPhone != null)
                message.customerPhone = String(object.customerPhone);
            if (object.customerAddress != null)
                message.customerAddress = String(object.customerAddress);
            if (object.dates) {
                if (!Array.isArray(object.dates))
                    throw TypeError(".busable.Charter.dates: array expected");
                message.dates = [];
                for (var i = 0; i < object.dates.length; ++i)
                    message.dates[i] = String(object.dates[i]);
            }
            if (object.date != null)
                message.date = String(object.date);
            if (object.calendarIds) {
                if (!Array.isArray(object.calendarIds))
                    throw TypeError(".busable.Charter.calendarIds: array expected");
                message.calendarIds = [];
                for (var i = 0; i < object.calendarIds.length; ++i)
                    message.calendarIds[i] = String(object.calendarIds[i]);
            }
            if (object.passengerCount != null)
                message.passengerCount = object.passengerCount | 0;
            if (object.wheelchairRequired != null)
                message.wheelchairRequired = Boolean(object.wheelchairRequired);
            if (object.pickupLocation != null)
                message.pickupLocation = String(object.pickupLocation);
            if (object.dropoffLocation != null)
                message.dropoffLocation = String(object.dropoffLocation);
            if (object.itinerary) {
                if (!Array.isArray(object.itinerary))
                    throw TypeError(".busable.Charter.itinerary: array expected");
                message.itinerary = [];
                for (var i = 0; i < object.itinerary.length; ++i) {
                    if (typeof object.itinerary[i] !== "object")
                        throw TypeError(".busable.Charter.itinerary: object expected");
                    message.itinerary[i] = $root.busable.Route.fromObject(object.itinerary[i]);
                }
            }
            if (object.duty != null) {
                if (typeof object.duty !== "object")
                    throw TypeError(".busable.Charter.duty: object expected");
                message.duty = $root.busable.ShiftBat.fromObject(object.duty);
            }
            if (object.vehicleTypeId != null)
                message.vehicleTypeId = String(object.vehicleTypeId);
            if (object.vehicleId != null)
                message.vehicleId = String(object.vehicleId);
            if (object.driverId != null)
                message.driverId = String(object.driverId);
            if (object.quotedPrice != null)
                message.quotedPrice = Number(object.quotedPrice);
            if (object.finalPrice != null)
                message.finalPrice = Number(object.finalPrice);
            if (object.notes != null)
                message.notes = String(object.notes);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            if (object.lineItems) {
                if (!Array.isArray(object.lineItems))
                    throw TypeError(".busable.Charter.lineItems: array expected");
                message.lineItems = [];
                for (var i = 0; i < object.lineItems.length; ++i) {
                    if (typeof object.lineItems[i] !== "object")
                        throw TypeError(".busable.Charter.lineItems: object expected");
                    message.lineItems[i] = $root.busable.LineItem.fromObject(object.lineItems[i]);
                }
            }
            if (object.subTotal != null)
                message.subTotal = Number(object.subTotal);
            if (object.discount != null)
                message.discount = Number(object.discount);
            if (object.gst != null)
                message.gst = Number(object.gst);
            if (object.total != null)
                message.total = Number(object.total);
            if (object.discountReason != null)
                message.discountReason = String(object.discountReason);
            if (object.discountPercentage != null)
                message.discountPercentage = Number(object.discountPercentage);
            if (object.quoteSent != null)
                message.quoteSent = Boolean(object.quoteSent);
            if (object.quoteSentAt != null)
                if ($util.Long)
                    (message.quoteSentAt = $util.Long.fromValue(object.quoteSentAt)).unsigned = false;
                else if (typeof object.quoteSentAt === "string")
                    message.quoteSentAt = parseInt(object.quoteSentAt, 10);
                else if (typeof object.quoteSentAt === "number")
                    message.quoteSentAt = object.quoteSentAt;
                else if (typeof object.quoteSentAt === "object")
                    message.quoteSentAt = new $util.LongBits(object.quoteSentAt.low >>> 0, object.quoteSentAt.high >>> 0).toNumber();
            if (object.quoteOverrides != null) {
                if (typeof object.quoteOverrides !== "object")
                    throw TypeError(".busable.Charter.quoteOverrides: object expected");
                message.quoteOverrides = $root.busable.QuoteOverrides.fromObject(object.quoteOverrides);
            }
            if (object.duration != null)
                message.duration = object.duration | 0;
            if (object.distance != null)
                message.distance = Number(object.distance);
            if (object.vehicleCost != null)
                message.vehicleCost = Number(object.vehicleCost);
            if (object.driverCost != null)
                message.driverCost = Number(object.driverCost);
            if (object.margin != null)
                message.margin = Number(object.margin);
            if (object.roundtrip != null)
                message.roundtrip = Boolean(object.roundtrip);
            return message;
        };

        /**
         * Creates a plain object from a Charter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Charter
         * @static
         * @param {busable.Charter} message Charter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Charter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.dates = [];
                object.calendarIds = [];
                object.itinerary = [];
                object.lineItems = [];
            }
            if (options.defaults) {
                object.charterId = "";
                object.name = "";
                object.description = "";
                object.operatorId = "";
                object.userId = "";
                object.bookingReference = "";
                object.status = "";
                object.customerName = "";
                object.customerEmail = "";
                object.customerPhone = "";
                object.customerAddress = "";
                object.date = "";
                object.passengerCount = 0;
                object.wheelchairRequired = false;
                object.pickupLocation = "";
                object.dropoffLocation = "";
                object.duty = null;
                object.vehicleTypeId = "";
                object.vehicleId = "";
                object.driverId = "";
                object.quotedPrice = 0;
                object.finalPrice = 0;
                object.notes = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
                object.subTotal = 0;
                object.discount = 0;
                object.gst = 0;
                object.total = 0;
                object.discountReason = "";
                object.discountPercentage = 0;
                object.quoteSent = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.quoteSentAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.quoteSentAt = options.longs === String ? "0" : 0;
                object.quoteOverrides = null;
                object.duration = 0;
                object.distance = 0;
                object.vehicleCost = 0;
                object.driverCost = 0;
                object.margin = 0;
                object.roundtrip = false;
            }
            if (message.charterId != null && message.hasOwnProperty("charterId"))
                object.charterId = message.charterId;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.bookingReference != null && message.hasOwnProperty("bookingReference"))
                object.bookingReference = message.bookingReference;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            if (message.customerName != null && message.hasOwnProperty("customerName"))
                object.customerName = message.customerName;
            if (message.customerEmail != null && message.hasOwnProperty("customerEmail"))
                object.customerEmail = message.customerEmail;
            if (message.customerPhone != null && message.hasOwnProperty("customerPhone"))
                object.customerPhone = message.customerPhone;
            if (message.customerAddress != null && message.hasOwnProperty("customerAddress"))
                object.customerAddress = message.customerAddress;
            if (message.dates && message.dates.length) {
                object.dates = [];
                for (var j = 0; j < message.dates.length; ++j)
                    object.dates[j] = message.dates[j];
            }
            if (message.date != null && message.hasOwnProperty("date"))
                object.date = message.date;
            if (message.calendarIds && message.calendarIds.length) {
                object.calendarIds = [];
                for (var j = 0; j < message.calendarIds.length; ++j)
                    object.calendarIds[j] = message.calendarIds[j];
            }
            if (message.passengerCount != null && message.hasOwnProperty("passengerCount"))
                object.passengerCount = message.passengerCount;
            if (message.wheelchairRequired != null && message.hasOwnProperty("wheelchairRequired"))
                object.wheelchairRequired = message.wheelchairRequired;
            if (message.pickupLocation != null && message.hasOwnProperty("pickupLocation"))
                object.pickupLocation = message.pickupLocation;
            if (message.dropoffLocation != null && message.hasOwnProperty("dropoffLocation"))
                object.dropoffLocation = message.dropoffLocation;
            if (message.itinerary && message.itinerary.length) {
                object.itinerary = [];
                for (var j = 0; j < message.itinerary.length; ++j)
                    object.itinerary[j] = $root.busable.Route.toObject(message.itinerary[j], options);
            }
            if (message.duty != null && message.hasOwnProperty("duty"))
                object.duty = $root.busable.ShiftBat.toObject(message.duty, options);
            if (message.vehicleTypeId != null && message.hasOwnProperty("vehicleTypeId"))
                object.vehicleTypeId = message.vehicleTypeId;
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                object.vehicleId = message.vehicleId;
            if (message.driverId != null && message.hasOwnProperty("driverId"))
                object.driverId = message.driverId;
            if (message.quotedPrice != null && message.hasOwnProperty("quotedPrice"))
                object.quotedPrice = options.json && !isFinite(message.quotedPrice) ? String(message.quotedPrice) : message.quotedPrice;
            if (message.finalPrice != null && message.hasOwnProperty("finalPrice"))
                object.finalPrice = options.json && !isFinite(message.finalPrice) ? String(message.finalPrice) : message.finalPrice;
            if (message.notes != null && message.hasOwnProperty("notes"))
                object.notes = message.notes;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (message.lineItems && message.lineItems.length) {
                object.lineItems = [];
                for (var j = 0; j < message.lineItems.length; ++j)
                    object.lineItems[j] = $root.busable.LineItem.toObject(message.lineItems[j], options);
            }
            if (message.subTotal != null && message.hasOwnProperty("subTotal"))
                object.subTotal = options.json && !isFinite(message.subTotal) ? String(message.subTotal) : message.subTotal;
            if (message.discount != null && message.hasOwnProperty("discount"))
                object.discount = options.json && !isFinite(message.discount) ? String(message.discount) : message.discount;
            if (message.gst != null && message.hasOwnProperty("gst"))
                object.gst = options.json && !isFinite(message.gst) ? String(message.gst) : message.gst;
            if (message.total != null && message.hasOwnProperty("total"))
                object.total = options.json && !isFinite(message.total) ? String(message.total) : message.total;
            if (message.discountReason != null && message.hasOwnProperty("discountReason"))
                object.discountReason = message.discountReason;
            if (message.discountPercentage != null && message.hasOwnProperty("discountPercentage"))
                object.discountPercentage = options.json && !isFinite(message.discountPercentage) ? String(message.discountPercentage) : message.discountPercentage;
            if (message.quoteSent != null && message.hasOwnProperty("quoteSent"))
                object.quoteSent = message.quoteSent;
            if (message.quoteSentAt != null && message.hasOwnProperty("quoteSentAt"))
                if (typeof message.quoteSentAt === "number")
                    object.quoteSentAt = options.longs === String ? String(message.quoteSentAt) : message.quoteSentAt;
                else
                    object.quoteSentAt = options.longs === String ? $util.Long.prototype.toString.call(message.quoteSentAt) : options.longs === Number ? new $util.LongBits(message.quoteSentAt.low >>> 0, message.quoteSentAt.high >>> 0).toNumber() : message.quoteSentAt;
            if (message.quoteOverrides != null && message.hasOwnProperty("quoteOverrides"))
                object.quoteOverrides = $root.busable.QuoteOverrides.toObject(message.quoteOverrides, options);
            if (message.duration != null && message.hasOwnProperty("duration"))
                object.duration = message.duration;
            if (message.distance != null && message.hasOwnProperty("distance"))
                object.distance = options.json && !isFinite(message.distance) ? String(message.distance) : message.distance;
            if (message.vehicleCost != null && message.hasOwnProperty("vehicleCost"))
                object.vehicleCost = options.json && !isFinite(message.vehicleCost) ? String(message.vehicleCost) : message.vehicleCost;
            if (message.driverCost != null && message.hasOwnProperty("driverCost"))
                object.driverCost = options.json && !isFinite(message.driverCost) ? String(message.driverCost) : message.driverCost;
            if (message.margin != null && message.hasOwnProperty("margin"))
                object.margin = options.json && !isFinite(message.margin) ? String(message.margin) : message.margin;
            if (message.roundtrip != null && message.hasOwnProperty("roundtrip"))
                object.roundtrip = message.roundtrip;
            return object;
        };

        /**
         * Converts this Charter to JSON.
         * @function toJSON
         * @memberof busable.Charter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Charter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Charter
         * @function getTypeUrl
         * @memberof busable.Charter
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Charter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Charter";
        };

        return Charter;
    })();

    busable.CharterTemplate = (function() {

        /**
         * Properties of a CharterTemplate.
         * @memberof busable
         * @interface ICharterTemplate
         * @property {string|null} [templateId] CharterTemplate templateId
         * @property {string|null} [templateName] CharterTemplate templateName
         * @property {string|null} [description] CharterTemplate description
         * @property {busable.IShiftBat|null} [duty] CharterTemplate duty
         * @property {string|null} [operatorId] CharterTemplate operatorId
         * @property {string|null} [userId] CharterTemplate userId
         * @property {number|Long|null} [createdAt] CharterTemplate createdAt
         * @property {number|Long|null} [updatedAt] CharterTemplate updatedAt
         */

        /**
         * Constructs a new CharterTemplate.
         * @memberof busable
         * @classdesc Represents a CharterTemplate.
         * @implements ICharterTemplate
         * @constructor
         * @param {busable.ICharterTemplate=} [properties] Properties to set
         */
        function CharterTemplate(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CharterTemplate templateId.
         * @member {string} templateId
         * @memberof busable.CharterTemplate
         * @instance
         */
        CharterTemplate.prototype.templateId = "";

        /**
         * CharterTemplate templateName.
         * @member {string} templateName
         * @memberof busable.CharterTemplate
         * @instance
         */
        CharterTemplate.prototype.templateName = "";

        /**
         * CharterTemplate description.
         * @member {string} description
         * @memberof busable.CharterTemplate
         * @instance
         */
        CharterTemplate.prototype.description = "";

        /**
         * CharterTemplate duty.
         * @member {busable.IShiftBat|null|undefined} duty
         * @memberof busable.CharterTemplate
         * @instance
         */
        CharterTemplate.prototype.duty = null;

        /**
         * CharterTemplate operatorId.
         * @member {string} operatorId
         * @memberof busable.CharterTemplate
         * @instance
         */
        CharterTemplate.prototype.operatorId = "";

        /**
         * CharterTemplate userId.
         * @member {string} userId
         * @memberof busable.CharterTemplate
         * @instance
         */
        CharterTemplate.prototype.userId = "";

        /**
         * CharterTemplate createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.CharterTemplate
         * @instance
         */
        CharterTemplate.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * CharterTemplate updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.CharterTemplate
         * @instance
         */
        CharterTemplate.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new CharterTemplate instance using the specified properties.
         * @function create
         * @memberof busable.CharterTemplate
         * @static
         * @param {busable.ICharterTemplate=} [properties] Properties to set
         * @returns {busable.CharterTemplate} CharterTemplate instance
         */
        CharterTemplate.create = function create(properties) {
            return new CharterTemplate(properties);
        };

        /**
         * Encodes the specified CharterTemplate message. Does not implicitly {@link busable.CharterTemplate.verify|verify} messages.
         * @function encode
         * @memberof busable.CharterTemplate
         * @static
         * @param {busable.ICharterTemplate} message CharterTemplate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CharterTemplate.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.templateId != null && Object.hasOwnProperty.call(message, "templateId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.templateId);
            if (message.templateName != null && Object.hasOwnProperty.call(message, "templateName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.templateName);
            if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
            if (message.duty != null && Object.hasOwnProperty.call(message, "duty"))
                $root.busable.ShiftBat.encode(message.duty, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.operatorId);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.userId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified CharterTemplate message, length delimited. Does not implicitly {@link busable.CharterTemplate.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.CharterTemplate
         * @static
         * @param {busable.ICharterTemplate} message CharterTemplate message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CharterTemplate.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CharterTemplate message from the specified reader or buffer.
         * @function decode
         * @memberof busable.CharterTemplate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.CharterTemplate} CharterTemplate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CharterTemplate.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.CharterTemplate();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.templateId = reader.string();
                        break;
                    }
                case 2: {
                        message.templateName = reader.string();
                        break;
                    }
                case 3: {
                        message.description = reader.string();
                        break;
                    }
                case 4: {
                        message.duty = $root.busable.ShiftBat.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 6: {
                        message.userId = reader.string();
                        break;
                    }
                case 7: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 8: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CharterTemplate message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.CharterTemplate
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.CharterTemplate} CharterTemplate
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CharterTemplate.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CharterTemplate message.
         * @function verify
         * @memberof busable.CharterTemplate
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CharterTemplate.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                if (!$util.isString(message.templateId))
                    return "templateId: string expected";
            if (message.templateName != null && message.hasOwnProperty("templateName"))
                if (!$util.isString(message.templateName))
                    return "templateName: string expected";
            if (message.description != null && message.hasOwnProperty("description"))
                if (!$util.isString(message.description))
                    return "description: string expected";
            if (message.duty != null && message.hasOwnProperty("duty")) {
                var error = $root.busable.ShiftBat.verify(message.duty);
                if (error)
                    return "duty." + error;
            }
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            return null;
        };

        /**
         * Creates a CharterTemplate message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.CharterTemplate
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.CharterTemplate} CharterTemplate
         */
        CharterTemplate.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.CharterTemplate)
                return object;
            var message = new $root.busable.CharterTemplate();
            if (object.templateId != null)
                message.templateId = String(object.templateId);
            if (object.templateName != null)
                message.templateName = String(object.templateName);
            if (object.description != null)
                message.description = String(object.description);
            if (object.duty != null) {
                if (typeof object.duty !== "object")
                    throw TypeError(".busable.CharterTemplate.duty: object expected");
                message.duty = $root.busable.ShiftBat.fromObject(object.duty);
            }
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a CharterTemplate message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.CharterTemplate
         * @static
         * @param {busable.CharterTemplate} message CharterTemplate
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CharterTemplate.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.templateId = "";
                object.templateName = "";
                object.description = "";
                object.duty = null;
                object.operatorId = "";
                object.userId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
            }
            if (message.templateId != null && message.hasOwnProperty("templateId"))
                object.templateId = message.templateId;
            if (message.templateName != null && message.hasOwnProperty("templateName"))
                object.templateName = message.templateName;
            if (message.description != null && message.hasOwnProperty("description"))
                object.description = message.description;
            if (message.duty != null && message.hasOwnProperty("duty"))
                object.duty = $root.busable.ShiftBat.toObject(message.duty, options);
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            return object;
        };

        /**
         * Converts this CharterTemplate to JSON.
         * @function toJSON
         * @memberof busable.CharterTemplate
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CharterTemplate.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CharterTemplate
         * @function getTypeUrl
         * @memberof busable.CharterTemplate
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CharterTemplate.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.CharterTemplate";
        };

        return CharterTemplate;
    })();

    busable.WeeklyRoster = (function() {

        /**
         * Properties of a WeeklyRoster.
         * @memberof busable
         * @interface IWeeklyRoster
         * @property {string|null} [rosterId] WeeklyRoster rosterId
         * @property {string|null} [rosterName] WeeklyRoster rosterName
         * @property {string|null} [date] WeeklyRoster date
         * @property {string|null} [defaultEmployeeId] WeeklyRoster defaultEmployeeId
         * @property {string|null} [defaultEmployeeName] WeeklyRoster defaultEmployeeName
         * @property {string|null} [defaultVehicleId] WeeklyRoster defaultVehicleId
         * @property {string|null} [defaultVehicleName] WeeklyRoster defaultVehicleName
         * @property {Array.<busable.IWorkItemList>|null} [workItemsByDay] WeeklyRoster workItemsByDay
         * @property {string|null} [operatorId] WeeklyRoster operatorId
         * @property {string|null} [userId] WeeklyRoster userId
         * @property {number|Long|null} [createdAt] WeeklyRoster createdAt
         * @property {number|Long|null} [updatedAt] WeeklyRoster updatedAt
         */

        /**
         * Constructs a new WeeklyRoster.
         * @memberof busable
         * @classdesc WeeklyRoster represents a single roster for a week
         * Contains work items organized by day of week (0=Monday, 6=Sunday)
         * @implements IWeeklyRoster
         * @constructor
         * @param {busable.IWeeklyRoster=} [properties] Properties to set
         */
        function WeeklyRoster(properties) {
            this.workItemsByDay = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WeeklyRoster rosterId.
         * @member {string} rosterId
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.rosterId = "";

        /**
         * WeeklyRoster rosterName.
         * @member {string} rosterName
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.rosterName = "";

        /**
         * WeeklyRoster date.
         * @member {string} date
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.date = "";

        /**
         * WeeklyRoster defaultEmployeeId.
         * @member {string} defaultEmployeeId
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.defaultEmployeeId = "";

        /**
         * WeeklyRoster defaultEmployeeName.
         * @member {string} defaultEmployeeName
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.defaultEmployeeName = "";

        /**
         * WeeklyRoster defaultVehicleId.
         * @member {string} defaultVehicleId
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.defaultVehicleId = "";

        /**
         * WeeklyRoster defaultVehicleName.
         * @member {string} defaultVehicleName
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.defaultVehicleName = "";

        /**
         * WeeklyRoster workItemsByDay.
         * @member {Array.<busable.IWorkItemList>} workItemsByDay
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.workItemsByDay = $util.emptyArray;

        /**
         * WeeklyRoster operatorId.
         * @member {string} operatorId
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.operatorId = "";

        /**
         * WeeklyRoster userId.
         * @member {string} userId
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.userId = "";

        /**
         * WeeklyRoster createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * WeeklyRoster updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.WeeklyRoster
         * @instance
         */
        WeeklyRoster.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new WeeklyRoster instance using the specified properties.
         * @function create
         * @memberof busable.WeeklyRoster
         * @static
         * @param {busable.IWeeklyRoster=} [properties] Properties to set
         * @returns {busable.WeeklyRoster} WeeklyRoster instance
         */
        WeeklyRoster.create = function create(properties) {
            return new WeeklyRoster(properties);
        };

        /**
         * Encodes the specified WeeklyRoster message. Does not implicitly {@link busable.WeeklyRoster.verify|verify} messages.
         * @function encode
         * @memberof busable.WeeklyRoster
         * @static
         * @param {busable.IWeeklyRoster} message WeeklyRoster message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WeeklyRoster.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.rosterId != null && Object.hasOwnProperty.call(message, "rosterId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.rosterId);
            if (message.rosterName != null && Object.hasOwnProperty.call(message, "rosterName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.rosterName);
            if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.date);
            if (message.defaultEmployeeId != null && Object.hasOwnProperty.call(message, "defaultEmployeeId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.defaultEmployeeId);
            if (message.defaultEmployeeName != null && Object.hasOwnProperty.call(message, "defaultEmployeeName"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.defaultEmployeeName);
            if (message.defaultVehicleId != null && Object.hasOwnProperty.call(message, "defaultVehicleId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.defaultVehicleId);
            if (message.defaultVehicleName != null && Object.hasOwnProperty.call(message, "defaultVehicleName"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.defaultVehicleName);
            if (message.workItemsByDay != null && message.workItemsByDay.length)
                for (var i = 0; i < message.workItemsByDay.length; ++i)
                    $root.busable.WorkItemList.encode(message.workItemsByDay[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.operatorId);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.userId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified WeeklyRoster message, length delimited. Does not implicitly {@link busable.WeeklyRoster.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.WeeklyRoster
         * @static
         * @param {busable.IWeeklyRoster} message WeeklyRoster message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WeeklyRoster.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a WeeklyRoster message from the specified reader or buffer.
         * @function decode
         * @memberof busable.WeeklyRoster
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.WeeklyRoster} WeeklyRoster
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WeeklyRoster.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.WeeklyRoster();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.rosterId = reader.string();
                        break;
                    }
                case 2: {
                        message.rosterName = reader.string();
                        break;
                    }
                case 3: {
                        message.date = reader.string();
                        break;
                    }
                case 4: {
                        message.defaultEmployeeId = reader.string();
                        break;
                    }
                case 5: {
                        message.defaultEmployeeName = reader.string();
                        break;
                    }
                case 6: {
                        message.defaultVehicleId = reader.string();
                        break;
                    }
                case 7: {
                        message.defaultVehicleName = reader.string();
                        break;
                    }
                case 8: {
                        if (!(message.workItemsByDay && message.workItemsByDay.length))
                            message.workItemsByDay = [];
                        message.workItemsByDay.push($root.busable.WorkItemList.decode(reader, reader.uint32()));
                        break;
                    }
                case 9: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 10: {
                        message.userId = reader.string();
                        break;
                    }
                case 11: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 12: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a WeeklyRoster message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.WeeklyRoster
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.WeeklyRoster} WeeklyRoster
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WeeklyRoster.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a WeeklyRoster message.
         * @function verify
         * @memberof busable.WeeklyRoster
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        WeeklyRoster.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.rosterId != null && message.hasOwnProperty("rosterId"))
                if (!$util.isString(message.rosterId))
                    return "rosterId: string expected";
            if (message.rosterName != null && message.hasOwnProperty("rosterName"))
                if (!$util.isString(message.rosterName))
                    return "rosterName: string expected";
            if (message.date != null && message.hasOwnProperty("date"))
                if (!$util.isString(message.date))
                    return "date: string expected";
            if (message.defaultEmployeeId != null && message.hasOwnProperty("defaultEmployeeId"))
                if (!$util.isString(message.defaultEmployeeId))
                    return "defaultEmployeeId: string expected";
            if (message.defaultEmployeeName != null && message.hasOwnProperty("defaultEmployeeName"))
                if (!$util.isString(message.defaultEmployeeName))
                    return "defaultEmployeeName: string expected";
            if (message.defaultVehicleId != null && message.hasOwnProperty("defaultVehicleId"))
                if (!$util.isString(message.defaultVehicleId))
                    return "defaultVehicleId: string expected";
            if (message.defaultVehicleName != null && message.hasOwnProperty("defaultVehicleName"))
                if (!$util.isString(message.defaultVehicleName))
                    return "defaultVehicleName: string expected";
            if (message.workItemsByDay != null && message.hasOwnProperty("workItemsByDay")) {
                if (!Array.isArray(message.workItemsByDay))
                    return "workItemsByDay: array expected";
                for (var i = 0; i < message.workItemsByDay.length; ++i) {
                    var error = $root.busable.WorkItemList.verify(message.workItemsByDay[i]);
                    if (error)
                        return "workItemsByDay." + error;
                }
            }
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            return null;
        };

        /**
         * Creates a WeeklyRoster message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.WeeklyRoster
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.WeeklyRoster} WeeklyRoster
         */
        WeeklyRoster.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.WeeklyRoster)
                return object;
            var message = new $root.busable.WeeklyRoster();
            if (object.rosterId != null)
                message.rosterId = String(object.rosterId);
            if (object.rosterName != null)
                message.rosterName = String(object.rosterName);
            if (object.date != null)
                message.date = String(object.date);
            if (object.defaultEmployeeId != null)
                message.defaultEmployeeId = String(object.defaultEmployeeId);
            if (object.defaultEmployeeName != null)
                message.defaultEmployeeName = String(object.defaultEmployeeName);
            if (object.defaultVehicleId != null)
                message.defaultVehicleId = String(object.defaultVehicleId);
            if (object.defaultVehicleName != null)
                message.defaultVehicleName = String(object.defaultVehicleName);
            if (object.workItemsByDay) {
                if (!Array.isArray(object.workItemsByDay))
                    throw TypeError(".busable.WeeklyRoster.workItemsByDay: array expected");
                message.workItemsByDay = [];
                for (var i = 0; i < object.workItemsByDay.length; ++i) {
                    if (typeof object.workItemsByDay[i] !== "object")
                        throw TypeError(".busable.WeeklyRoster.workItemsByDay: object expected");
                    message.workItemsByDay[i] = $root.busable.WorkItemList.fromObject(object.workItemsByDay[i]);
                }
            }
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a WeeklyRoster message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.WeeklyRoster
         * @static
         * @param {busable.WeeklyRoster} message WeeklyRoster
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WeeklyRoster.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.workItemsByDay = [];
            if (options.defaults) {
                object.rosterId = "";
                object.rosterName = "";
                object.date = "";
                object.defaultEmployeeId = "";
                object.defaultEmployeeName = "";
                object.defaultVehicleId = "";
                object.defaultVehicleName = "";
                object.operatorId = "";
                object.userId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
            }
            if (message.rosterId != null && message.hasOwnProperty("rosterId"))
                object.rosterId = message.rosterId;
            if (message.rosterName != null && message.hasOwnProperty("rosterName"))
                object.rosterName = message.rosterName;
            if (message.date != null && message.hasOwnProperty("date"))
                object.date = message.date;
            if (message.defaultEmployeeId != null && message.hasOwnProperty("defaultEmployeeId"))
                object.defaultEmployeeId = message.defaultEmployeeId;
            if (message.defaultEmployeeName != null && message.hasOwnProperty("defaultEmployeeName"))
                object.defaultEmployeeName = message.defaultEmployeeName;
            if (message.defaultVehicleId != null && message.hasOwnProperty("defaultVehicleId"))
                object.defaultVehicleId = message.defaultVehicleId;
            if (message.defaultVehicleName != null && message.hasOwnProperty("defaultVehicleName"))
                object.defaultVehicleName = message.defaultVehicleName;
            if (message.workItemsByDay && message.workItemsByDay.length) {
                object.workItemsByDay = [];
                for (var j = 0; j < message.workItemsByDay.length; ++j)
                    object.workItemsByDay[j] = $root.busable.WorkItemList.toObject(message.workItemsByDay[j], options);
            }
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            return object;
        };

        /**
         * Converts this WeeklyRoster to JSON.
         * @function toJSON
         * @memberof busable.WeeklyRoster
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WeeklyRoster.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for WeeklyRoster
         * @function getTypeUrl
         * @memberof busable.WeeklyRoster
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        WeeklyRoster.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.WeeklyRoster";
        };

        return WeeklyRoster;
    })();

    busable.WorkItemList = (function() {

        /**
         * Properties of a WorkItemList.
         * @memberof busable
         * @interface IWorkItemList
         * @property {Array.<busable.IWorkItem>|null} [items] WorkItemList items
         */

        /**
         * Constructs a new WorkItemList.
         * @memberof busable
         * @classdesc WorkItemList is a helper message to represent arrays of work items per day
         * @implements IWorkItemList
         * @constructor
         * @param {busable.IWorkItemList=} [properties] Properties to set
         */
        function WorkItemList(properties) {
            this.items = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WorkItemList items.
         * @member {Array.<busable.IWorkItem>} items
         * @memberof busable.WorkItemList
         * @instance
         */
        WorkItemList.prototype.items = $util.emptyArray;

        /**
         * Creates a new WorkItemList instance using the specified properties.
         * @function create
         * @memberof busable.WorkItemList
         * @static
         * @param {busable.IWorkItemList=} [properties] Properties to set
         * @returns {busable.WorkItemList} WorkItemList instance
         */
        WorkItemList.create = function create(properties) {
            return new WorkItemList(properties);
        };

        /**
         * Encodes the specified WorkItemList message. Does not implicitly {@link busable.WorkItemList.verify|verify} messages.
         * @function encode
         * @memberof busable.WorkItemList
         * @static
         * @param {busable.IWorkItemList} message WorkItemList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WorkItemList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.items != null && message.items.length)
                for (var i = 0; i < message.items.length; ++i)
                    $root.busable.WorkItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified WorkItemList message, length delimited. Does not implicitly {@link busable.WorkItemList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.WorkItemList
         * @static
         * @param {busable.IWorkItemList} message WorkItemList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WorkItemList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a WorkItemList message from the specified reader or buffer.
         * @function decode
         * @memberof busable.WorkItemList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.WorkItemList} WorkItemList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WorkItemList.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.WorkItemList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.items && message.items.length))
                            message.items = [];
                        message.items.push($root.busable.WorkItem.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a WorkItemList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.WorkItemList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.WorkItemList} WorkItemList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WorkItemList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a WorkItemList message.
         * @function verify
         * @memberof busable.WorkItemList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        WorkItemList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.items != null && message.hasOwnProperty("items")) {
                if (!Array.isArray(message.items))
                    return "items: array expected";
                for (var i = 0; i < message.items.length; ++i) {
                    var error = $root.busable.WorkItem.verify(message.items[i]);
                    if (error)
                        return "items." + error;
                }
            }
            return null;
        };

        /**
         * Creates a WorkItemList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.WorkItemList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.WorkItemList} WorkItemList
         */
        WorkItemList.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.WorkItemList)
                return object;
            var message = new $root.busable.WorkItemList();
            if (object.items) {
                if (!Array.isArray(object.items))
                    throw TypeError(".busable.WorkItemList.items: array expected");
                message.items = [];
                for (var i = 0; i < object.items.length; ++i) {
                    if (typeof object.items[i] !== "object")
                        throw TypeError(".busable.WorkItemList.items: object expected");
                    message.items[i] = $root.busable.WorkItem.fromObject(object.items[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a WorkItemList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.WorkItemList
         * @static
         * @param {busable.WorkItemList} message WorkItemList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WorkItemList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.items = [];
            if (message.items && message.items.length) {
                object.items = [];
                for (var j = 0; j < message.items.length; ++j)
                    object.items[j] = $root.busable.WorkItem.toObject(message.items[j], options);
            }
            return object;
        };

        /**
         * Converts this WorkItemList to JSON.
         * @function toJSON
         * @memberof busable.WorkItemList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WorkItemList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for WorkItemList
         * @function getTypeUrl
         * @memberof busable.WorkItemList
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        WorkItemList.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.WorkItemList";
        };

        return WorkItemList;
    })();

    busable.WeeklyScenario = (function() {

        /**
         * Properties of a WeeklyScenario.
         * @memberof busable
         * @interface IWeeklyScenario
         * @property {string|null} [scenarioId] WeeklyScenario scenarioId
         * @property {string|null} [name] WeeklyScenario name
         * @property {string|null} [date] WeeklyScenario date
         * @property {Array.<busable.IWeeklyRoster>|null} [weeklyRosters] WeeklyScenario weeklyRosters
         * @property {busable.IWeeklyRoster|null} [unallocatedRoster] WeeklyScenario unallocatedRoster
         * @property {Array.<busable.IWorkItem>|null} [adHocItems] WeeklyScenario adHocItems
         * @property {string|null} [operatorId] WeeklyScenario operatorId
         * @property {string|null} [userId] WeeklyScenario userId
         * @property {number|Long|null} [createdAt] WeeklyScenario createdAt
         * @property {number|Long|null} [updatedAt] WeeklyScenario updatedAt
         */

        /**
         * Constructs a new WeeklyScenario.
         * @memberof busable
         * @classdesc WeeklyScenario represents a complete scheduling scenario
         * Contains multiple weekly rosters and unallocated work items
         * @implements IWeeklyScenario
         * @constructor
         * @param {busable.IWeeklyScenario=} [properties] Properties to set
         */
        function WeeklyScenario(properties) {
            this.weeklyRosters = [];
            this.adHocItems = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WeeklyScenario scenarioId.
         * @member {string} scenarioId
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.scenarioId = "";

        /**
         * WeeklyScenario name.
         * @member {string} name
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.name = "";

        /**
         * WeeklyScenario date.
         * @member {string} date
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.date = "";

        /**
         * WeeklyScenario weeklyRosters.
         * @member {Array.<busable.IWeeklyRoster>} weeklyRosters
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.weeklyRosters = $util.emptyArray;

        /**
         * WeeklyScenario unallocatedRoster.
         * @member {busable.IWeeklyRoster|null|undefined} unallocatedRoster
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.unallocatedRoster = null;

        /**
         * WeeklyScenario adHocItems.
         * @member {Array.<busable.IWorkItem>} adHocItems
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.adHocItems = $util.emptyArray;

        /**
         * WeeklyScenario operatorId.
         * @member {string} operatorId
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.operatorId = "";

        /**
         * WeeklyScenario userId.
         * @member {string} userId
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.userId = "";

        /**
         * WeeklyScenario createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * WeeklyScenario updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.WeeklyScenario
         * @instance
         */
        WeeklyScenario.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new WeeklyScenario instance using the specified properties.
         * @function create
         * @memberof busable.WeeklyScenario
         * @static
         * @param {busable.IWeeklyScenario=} [properties] Properties to set
         * @returns {busable.WeeklyScenario} WeeklyScenario instance
         */
        WeeklyScenario.create = function create(properties) {
            return new WeeklyScenario(properties);
        };

        /**
         * Encodes the specified WeeklyScenario message. Does not implicitly {@link busable.WeeklyScenario.verify|verify} messages.
         * @function encode
         * @memberof busable.WeeklyScenario
         * @static
         * @param {busable.IWeeklyScenario} message WeeklyScenario message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WeeklyScenario.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.scenarioId != null && Object.hasOwnProperty.call(message, "scenarioId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.scenarioId);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
            if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.date);
            if (message.weeklyRosters != null && message.weeklyRosters.length)
                for (var i = 0; i < message.weeklyRosters.length; ++i)
                    $root.busable.WeeklyRoster.encode(message.weeklyRosters[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.unallocatedRoster != null && Object.hasOwnProperty.call(message, "unallocatedRoster"))
                $root.busable.WeeklyRoster.encode(message.unallocatedRoster, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.adHocItems != null && message.adHocItems.length)
                for (var i = 0; i < message.adHocItems.length; ++i)
                    $root.busable.WorkItem.encode(message.adHocItems[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.operatorId);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.userId);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.updatedAt);
            return writer;
        };

        /**
         * Encodes the specified WeeklyScenario message, length delimited. Does not implicitly {@link busable.WeeklyScenario.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.WeeklyScenario
         * @static
         * @param {busable.IWeeklyScenario} message WeeklyScenario message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WeeklyScenario.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a WeeklyScenario message from the specified reader or buffer.
         * @function decode
         * @memberof busable.WeeklyScenario
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.WeeklyScenario} WeeklyScenario
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WeeklyScenario.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.WeeklyScenario();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.scenarioId = reader.string();
                        break;
                    }
                case 2: {
                        message.name = reader.string();
                        break;
                    }
                case 3: {
                        message.date = reader.string();
                        break;
                    }
                case 4: {
                        if (!(message.weeklyRosters && message.weeklyRosters.length))
                            message.weeklyRosters = [];
                        message.weeklyRosters.push($root.busable.WeeklyRoster.decode(reader, reader.uint32()));
                        break;
                    }
                case 5: {
                        message.unallocatedRoster = $root.busable.WeeklyRoster.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        if (!(message.adHocItems && message.adHocItems.length))
                            message.adHocItems = [];
                        message.adHocItems.push($root.busable.WorkItem.decode(reader, reader.uint32()));
                        break;
                    }
                case 7: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 8: {
                        message.userId = reader.string();
                        break;
                    }
                case 9: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 10: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a WeeklyScenario message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.WeeklyScenario
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.WeeklyScenario} WeeklyScenario
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WeeklyScenario.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a WeeklyScenario message.
         * @function verify
         * @memberof busable.WeeklyScenario
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        WeeklyScenario.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.scenarioId != null && message.hasOwnProperty("scenarioId"))
                if (!$util.isString(message.scenarioId))
                    return "scenarioId: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.date != null && message.hasOwnProperty("date"))
                if (!$util.isString(message.date))
                    return "date: string expected";
            if (message.weeklyRosters != null && message.hasOwnProperty("weeklyRosters")) {
                if (!Array.isArray(message.weeklyRosters))
                    return "weeklyRosters: array expected";
                for (var i = 0; i < message.weeklyRosters.length; ++i) {
                    var error = $root.busable.WeeklyRoster.verify(message.weeklyRosters[i]);
                    if (error)
                        return "weeklyRosters." + error;
                }
            }
            if (message.unallocatedRoster != null && message.hasOwnProperty("unallocatedRoster")) {
                var error = $root.busable.WeeklyRoster.verify(message.unallocatedRoster);
                if (error)
                    return "unallocatedRoster." + error;
            }
            if (message.adHocItems != null && message.hasOwnProperty("adHocItems")) {
                if (!Array.isArray(message.adHocItems))
                    return "adHocItems: array expected";
                for (var i = 0; i < message.adHocItems.length; ++i) {
                    var error = $root.busable.WorkItem.verify(message.adHocItems[i]);
                    if (error)
                        return "adHocItems." + error;
                }
            }
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            return null;
        };

        /**
         * Creates a WeeklyScenario message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.WeeklyScenario
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.WeeklyScenario} WeeklyScenario
         */
        WeeklyScenario.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.WeeklyScenario)
                return object;
            var message = new $root.busable.WeeklyScenario();
            if (object.scenarioId != null)
                message.scenarioId = String(object.scenarioId);
            if (object.name != null)
                message.name = String(object.name);
            if (object.date != null)
                message.date = String(object.date);
            if (object.weeklyRosters) {
                if (!Array.isArray(object.weeklyRosters))
                    throw TypeError(".busable.WeeklyScenario.weeklyRosters: array expected");
                message.weeklyRosters = [];
                for (var i = 0; i < object.weeklyRosters.length; ++i) {
                    if (typeof object.weeklyRosters[i] !== "object")
                        throw TypeError(".busable.WeeklyScenario.weeklyRosters: object expected");
                    message.weeklyRosters[i] = $root.busable.WeeklyRoster.fromObject(object.weeklyRosters[i]);
                }
            }
            if (object.unallocatedRoster != null) {
                if (typeof object.unallocatedRoster !== "object")
                    throw TypeError(".busable.WeeklyScenario.unallocatedRoster: object expected");
                message.unallocatedRoster = $root.busable.WeeklyRoster.fromObject(object.unallocatedRoster);
            }
            if (object.adHocItems) {
                if (!Array.isArray(object.adHocItems))
                    throw TypeError(".busable.WeeklyScenario.adHocItems: array expected");
                message.adHocItems = [];
                for (var i = 0; i < object.adHocItems.length; ++i) {
                    if (typeof object.adHocItems[i] !== "object")
                        throw TypeError(".busable.WeeklyScenario.adHocItems: object expected");
                    message.adHocItems[i] = $root.busable.WorkItem.fromObject(object.adHocItems[i]);
                }
            }
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.userId != null)
                message.userId = String(object.userId);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a WeeklyScenario message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.WeeklyScenario
         * @static
         * @param {busable.WeeklyScenario} message WeeklyScenario
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WeeklyScenario.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.weeklyRosters = [];
                object.adHocItems = [];
            }
            if (options.defaults) {
                object.scenarioId = "";
                object.name = "";
                object.date = "";
                object.unallocatedRoster = null;
                object.operatorId = "";
                object.userId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
            }
            if (message.scenarioId != null && message.hasOwnProperty("scenarioId"))
                object.scenarioId = message.scenarioId;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.date != null && message.hasOwnProperty("date"))
                object.date = message.date;
            if (message.weeklyRosters && message.weeklyRosters.length) {
                object.weeklyRosters = [];
                for (var j = 0; j < message.weeklyRosters.length; ++j)
                    object.weeklyRosters[j] = $root.busable.WeeklyRoster.toObject(message.weeklyRosters[j], options);
            }
            if (message.unallocatedRoster != null && message.hasOwnProperty("unallocatedRoster"))
                object.unallocatedRoster = $root.busable.WeeklyRoster.toObject(message.unallocatedRoster, options);
            if (message.adHocItems && message.adHocItems.length) {
                object.adHocItems = [];
                for (var j = 0; j < message.adHocItems.length; ++j)
                    object.adHocItems[j] = $root.busable.WorkItem.toObject(message.adHocItems[j], options);
            }
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            return object;
        };

        /**
         * Converts this WeeklyScenario to JSON.
         * @function toJSON
         * @memberof busable.WeeklyScenario
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WeeklyScenario.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for WeeklyScenario
         * @function getTypeUrl
         * @memberof busable.WeeklyScenario
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        WeeklyScenario.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.WeeklyScenario";
        };

        return WeeklyScenario;
    })();

    busable.RosterAssignment = (function() {

        /**
         * Properties of a RosterAssignment.
         * @memberof busable
         * @interface IRosterAssignment
         * @property {string|null} [assignmentId] RosterAssignment assignmentId
         * @property {string|null} [rosterId] RosterAssignment rosterId
         * @property {string|null} [workItemId] RosterAssignment workItemId
         * @property {number|null} [dayOfWeek] RosterAssignment dayOfWeek
         * @property {string|null} [employeeId] RosterAssignment employeeId
         * @property {string|null} [vehicleId] RosterAssignment vehicleId
         * @property {number|Long|null} [assignedAt] RosterAssignment assignedAt
         * @property {string|null} [assignedBy] RosterAssignment assignedBy
         */

        /**
         * Constructs a new RosterAssignment.
         * @memberof busable
         * @classdesc RosterAssignment represents the assignment of a work item to a roster
         * Used for tracking changes and history
         * @implements IRosterAssignment
         * @constructor
         * @param {busable.IRosterAssignment=} [properties] Properties to set
         */
        function RosterAssignment(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RosterAssignment assignmentId.
         * @member {string} assignmentId
         * @memberof busable.RosterAssignment
         * @instance
         */
        RosterAssignment.prototype.assignmentId = "";

        /**
         * RosterAssignment rosterId.
         * @member {string} rosterId
         * @memberof busable.RosterAssignment
         * @instance
         */
        RosterAssignment.prototype.rosterId = "";

        /**
         * RosterAssignment workItemId.
         * @member {string} workItemId
         * @memberof busable.RosterAssignment
         * @instance
         */
        RosterAssignment.prototype.workItemId = "";

        /**
         * RosterAssignment dayOfWeek.
         * @member {number} dayOfWeek
         * @memberof busable.RosterAssignment
         * @instance
         */
        RosterAssignment.prototype.dayOfWeek = 0;

        /**
         * RosterAssignment employeeId.
         * @member {string} employeeId
         * @memberof busable.RosterAssignment
         * @instance
         */
        RosterAssignment.prototype.employeeId = "";

        /**
         * RosterAssignment vehicleId.
         * @member {string} vehicleId
         * @memberof busable.RosterAssignment
         * @instance
         */
        RosterAssignment.prototype.vehicleId = "";

        /**
         * RosterAssignment assignedAt.
         * @member {number|Long} assignedAt
         * @memberof busable.RosterAssignment
         * @instance
         */
        RosterAssignment.prototype.assignedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * RosterAssignment assignedBy.
         * @member {string} assignedBy
         * @memberof busable.RosterAssignment
         * @instance
         */
        RosterAssignment.prototype.assignedBy = "";

        /**
         * Creates a new RosterAssignment instance using the specified properties.
         * @function create
         * @memberof busable.RosterAssignment
         * @static
         * @param {busable.IRosterAssignment=} [properties] Properties to set
         * @returns {busable.RosterAssignment} RosterAssignment instance
         */
        RosterAssignment.create = function create(properties) {
            return new RosterAssignment(properties);
        };

        /**
         * Encodes the specified RosterAssignment message. Does not implicitly {@link busable.RosterAssignment.verify|verify} messages.
         * @function encode
         * @memberof busable.RosterAssignment
         * @static
         * @param {busable.IRosterAssignment} message RosterAssignment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterAssignment.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.assignmentId != null && Object.hasOwnProperty.call(message, "assignmentId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.assignmentId);
            if (message.rosterId != null && Object.hasOwnProperty.call(message, "rosterId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.rosterId);
            if (message.workItemId != null && Object.hasOwnProperty.call(message, "workItemId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.workItemId);
            if (message.dayOfWeek != null && Object.hasOwnProperty.call(message, "dayOfWeek"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.dayOfWeek);
            if (message.employeeId != null && Object.hasOwnProperty.call(message, "employeeId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.employeeId);
            if (message.vehicleId != null && Object.hasOwnProperty.call(message, "vehicleId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.vehicleId);
            if (message.assignedAt != null && Object.hasOwnProperty.call(message, "assignedAt"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.assignedAt);
            if (message.assignedBy != null && Object.hasOwnProperty.call(message, "assignedBy"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.assignedBy);
            return writer;
        };

        /**
         * Encodes the specified RosterAssignment message, length delimited. Does not implicitly {@link busable.RosterAssignment.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.RosterAssignment
         * @static
         * @param {busable.IRosterAssignment} message RosterAssignment message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterAssignment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RosterAssignment message from the specified reader or buffer.
         * @function decode
         * @memberof busable.RosterAssignment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.RosterAssignment} RosterAssignment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterAssignment.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.RosterAssignment();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.assignmentId = reader.string();
                        break;
                    }
                case 2: {
                        message.rosterId = reader.string();
                        break;
                    }
                case 3: {
                        message.workItemId = reader.string();
                        break;
                    }
                case 4: {
                        message.dayOfWeek = reader.int32();
                        break;
                    }
                case 5: {
                        message.employeeId = reader.string();
                        break;
                    }
                case 6: {
                        message.vehicleId = reader.string();
                        break;
                    }
                case 7: {
                        message.assignedAt = reader.int64();
                        break;
                    }
                case 8: {
                        message.assignedBy = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RosterAssignment message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.RosterAssignment
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.RosterAssignment} RosterAssignment
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterAssignment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RosterAssignment message.
         * @function verify
         * @memberof busable.RosterAssignment
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RosterAssignment.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.assignmentId != null && message.hasOwnProperty("assignmentId"))
                if (!$util.isString(message.assignmentId))
                    return "assignmentId: string expected";
            if (message.rosterId != null && message.hasOwnProperty("rosterId"))
                if (!$util.isString(message.rosterId))
                    return "rosterId: string expected";
            if (message.workItemId != null && message.hasOwnProperty("workItemId"))
                if (!$util.isString(message.workItemId))
                    return "workItemId: string expected";
            if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                if (!$util.isInteger(message.dayOfWeek))
                    return "dayOfWeek: integer expected";
            if (message.employeeId != null && message.hasOwnProperty("employeeId"))
                if (!$util.isString(message.employeeId))
                    return "employeeId: string expected";
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                if (!$util.isString(message.vehicleId))
                    return "vehicleId: string expected";
            if (message.assignedAt != null && message.hasOwnProperty("assignedAt"))
                if (!$util.isInteger(message.assignedAt) && !(message.assignedAt && $util.isInteger(message.assignedAt.low) && $util.isInteger(message.assignedAt.high)))
                    return "assignedAt: integer|Long expected";
            if (message.assignedBy != null && message.hasOwnProperty("assignedBy"))
                if (!$util.isString(message.assignedBy))
                    return "assignedBy: string expected";
            return null;
        };

        /**
         * Creates a RosterAssignment message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.RosterAssignment
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.RosterAssignment} RosterAssignment
         */
        RosterAssignment.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.RosterAssignment)
                return object;
            var message = new $root.busable.RosterAssignment();
            if (object.assignmentId != null)
                message.assignmentId = String(object.assignmentId);
            if (object.rosterId != null)
                message.rosterId = String(object.rosterId);
            if (object.workItemId != null)
                message.workItemId = String(object.workItemId);
            if (object.dayOfWeek != null)
                message.dayOfWeek = object.dayOfWeek | 0;
            if (object.employeeId != null)
                message.employeeId = String(object.employeeId);
            if (object.vehicleId != null)
                message.vehicleId = String(object.vehicleId);
            if (object.assignedAt != null)
                if ($util.Long)
                    (message.assignedAt = $util.Long.fromValue(object.assignedAt)).unsigned = false;
                else if (typeof object.assignedAt === "string")
                    message.assignedAt = parseInt(object.assignedAt, 10);
                else if (typeof object.assignedAt === "number")
                    message.assignedAt = object.assignedAt;
                else if (typeof object.assignedAt === "object")
                    message.assignedAt = new $util.LongBits(object.assignedAt.low >>> 0, object.assignedAt.high >>> 0).toNumber();
            if (object.assignedBy != null)
                message.assignedBy = String(object.assignedBy);
            return message;
        };

        /**
         * Creates a plain object from a RosterAssignment message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.RosterAssignment
         * @static
         * @param {busable.RosterAssignment} message RosterAssignment
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RosterAssignment.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.assignmentId = "";
                object.rosterId = "";
                object.workItemId = "";
                object.dayOfWeek = 0;
                object.employeeId = "";
                object.vehicleId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.assignedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.assignedAt = options.longs === String ? "0" : 0;
                object.assignedBy = "";
            }
            if (message.assignmentId != null && message.hasOwnProperty("assignmentId"))
                object.assignmentId = message.assignmentId;
            if (message.rosterId != null && message.hasOwnProperty("rosterId"))
                object.rosterId = message.rosterId;
            if (message.workItemId != null && message.hasOwnProperty("workItemId"))
                object.workItemId = message.workItemId;
            if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                object.dayOfWeek = message.dayOfWeek;
            if (message.employeeId != null && message.hasOwnProperty("employeeId"))
                object.employeeId = message.employeeId;
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                object.vehicleId = message.vehicleId;
            if (message.assignedAt != null && message.hasOwnProperty("assignedAt"))
                if (typeof message.assignedAt === "number")
                    object.assignedAt = options.longs === String ? String(message.assignedAt) : message.assignedAt;
                else
                    object.assignedAt = options.longs === String ? $util.Long.prototype.toString.call(message.assignedAt) : options.longs === Number ? new $util.LongBits(message.assignedAt.low >>> 0, message.assignedAt.high >>> 0).toNumber() : message.assignedAt;
            if (message.assignedBy != null && message.hasOwnProperty("assignedBy"))
                object.assignedBy = message.assignedBy;
            return object;
        };

        /**
         * Converts this RosterAssignment to JSON.
         * @function toJSON
         * @memberof busable.RosterAssignment
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RosterAssignment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RosterAssignment
         * @function getTypeUrl
         * @memberof busable.RosterAssignment
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RosterAssignment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.RosterAssignment";
        };

        return RosterAssignment;
    })();

    busable.RosterValidation = (function() {

        /**
         * Properties of a RosterValidation.
         * @memberof busable
         * @interface IRosterValidation
         * @property {busable.RosterValidation.ValidationType|null} [type] RosterValidation type
         * @property {string|null} [message] RosterValidation message
         * @property {Array.<string>|null} [workItemIds] RosterValidation workItemIds
         * @property {string|null} [employeeId] RosterValidation employeeId
         * @property {string|null} [vehicleId] RosterValidation vehicleId
         * @property {boolean|null} [blocking] RosterValidation blocking
         * @property {string|null} [details] RosterValidation details
         */

        /**
         * Constructs a new RosterValidation.
         * @memberof busable
         * @classdesc RosterValidation represents validation results for roster assignments
         * Used to check for conflicts, overtime, and other constraints
         * @implements IRosterValidation
         * @constructor
         * @param {busable.IRosterValidation=} [properties] Properties to set
         */
        function RosterValidation(properties) {
            this.workItemIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RosterValidation type.
         * @member {busable.RosterValidation.ValidationType} type
         * @memberof busable.RosterValidation
         * @instance
         */
        RosterValidation.prototype.type = 0;

        /**
         * RosterValidation message.
         * @member {string} message
         * @memberof busable.RosterValidation
         * @instance
         */
        RosterValidation.prototype.message = "";

        /**
         * RosterValidation workItemIds.
         * @member {Array.<string>} workItemIds
         * @memberof busable.RosterValidation
         * @instance
         */
        RosterValidation.prototype.workItemIds = $util.emptyArray;

        /**
         * RosterValidation employeeId.
         * @member {string} employeeId
         * @memberof busable.RosterValidation
         * @instance
         */
        RosterValidation.prototype.employeeId = "";

        /**
         * RosterValidation vehicleId.
         * @member {string} vehicleId
         * @memberof busable.RosterValidation
         * @instance
         */
        RosterValidation.prototype.vehicleId = "";

        /**
         * RosterValidation blocking.
         * @member {boolean} blocking
         * @memberof busable.RosterValidation
         * @instance
         */
        RosterValidation.prototype.blocking = false;

        /**
         * RosterValidation details.
         * @member {string} details
         * @memberof busable.RosterValidation
         * @instance
         */
        RosterValidation.prototype.details = "";

        /**
         * Creates a new RosterValidation instance using the specified properties.
         * @function create
         * @memberof busable.RosterValidation
         * @static
         * @param {busable.IRosterValidation=} [properties] Properties to set
         * @returns {busable.RosterValidation} RosterValidation instance
         */
        RosterValidation.create = function create(properties) {
            return new RosterValidation(properties);
        };

        /**
         * Encodes the specified RosterValidation message. Does not implicitly {@link busable.RosterValidation.verify|verify} messages.
         * @function encode
         * @memberof busable.RosterValidation
         * @static
         * @param {busable.IRosterValidation} message RosterValidation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterValidation.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
            if (message.workItemIds != null && message.workItemIds.length)
                for (var i = 0; i < message.workItemIds.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.workItemIds[i]);
            if (message.employeeId != null && Object.hasOwnProperty.call(message, "employeeId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.employeeId);
            if (message.vehicleId != null && Object.hasOwnProperty.call(message, "vehicleId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.vehicleId);
            if (message.blocking != null && Object.hasOwnProperty.call(message, "blocking"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.blocking);
            if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.details);
            return writer;
        };

        /**
         * Encodes the specified RosterValidation message, length delimited. Does not implicitly {@link busable.RosterValidation.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.RosterValidation
         * @static
         * @param {busable.IRosterValidation} message RosterValidation message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterValidation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RosterValidation message from the specified reader or buffer.
         * @function decode
         * @memberof busable.RosterValidation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.RosterValidation} RosterValidation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterValidation.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.RosterValidation();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.type = reader.int32();
                        break;
                    }
                case 2: {
                        message.message = reader.string();
                        break;
                    }
                case 3: {
                        if (!(message.workItemIds && message.workItemIds.length))
                            message.workItemIds = [];
                        message.workItemIds.push(reader.string());
                        break;
                    }
                case 4: {
                        message.employeeId = reader.string();
                        break;
                    }
                case 5: {
                        message.vehicleId = reader.string();
                        break;
                    }
                case 6: {
                        message.blocking = reader.bool();
                        break;
                    }
                case 7: {
                        message.details = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RosterValidation message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.RosterValidation
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.RosterValidation} RosterValidation
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterValidation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RosterValidation message.
         * @function verify
         * @memberof busable.RosterValidation
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RosterValidation.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.type != null && message.hasOwnProperty("type"))
                switch (message.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
                }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.workItemIds != null && message.hasOwnProperty("workItemIds")) {
                if (!Array.isArray(message.workItemIds))
                    return "workItemIds: array expected";
                for (var i = 0; i < message.workItemIds.length; ++i)
                    if (!$util.isString(message.workItemIds[i]))
                        return "workItemIds: string[] expected";
            }
            if (message.employeeId != null && message.hasOwnProperty("employeeId"))
                if (!$util.isString(message.employeeId))
                    return "employeeId: string expected";
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                if (!$util.isString(message.vehicleId))
                    return "vehicleId: string expected";
            if (message.blocking != null && message.hasOwnProperty("blocking"))
                if (typeof message.blocking !== "boolean")
                    return "blocking: boolean expected";
            if (message.details != null && message.hasOwnProperty("details"))
                if (!$util.isString(message.details))
                    return "details: string expected";
            return null;
        };

        /**
         * Creates a RosterValidation message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.RosterValidation
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.RosterValidation} RosterValidation
         */
        RosterValidation.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.RosterValidation)
                return object;
            var message = new $root.busable.RosterValidation();
            switch (object.type) {
            default:
                if (typeof object.type === "number") {
                    message.type = object.type;
                    break;
                }
                break;
            case "VALIDATION_TYPE_UNSPECIFIED":
            case 0:
                message.type = 0;
                break;
            case "VALIDATION_TYPE_OVERTIME":
            case 1:
                message.type = 1;
                break;
            case "VALIDATION_TYPE_UNAVAILABLE":
            case 2:
                message.type = 2;
                break;
            case "VALIDATION_TYPE_ON_LEAVE":
            case 3:
                message.type = 3;
                break;
            case "VALIDATION_TYPE_VEHICLE_REPAIR":
            case 4:
                message.type = 4;
                break;
            case "VALIDATION_TYPE_VEHICLE_SERVICE":
            case 5:
                message.type = 5;
                break;
            case "VALIDATION_TYPE_TIME_CONFLICT":
            case 6:
                message.type = 6;
                break;
            case "VALIDATION_TYPE_LICENSE_MISSING":
            case 7:
                message.type = 7;
                break;
            case "VALIDATION_TYPE_SKILL_MISSING":
            case 8:
                message.type = 8;
                break;
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.workItemIds) {
                if (!Array.isArray(object.workItemIds))
                    throw TypeError(".busable.RosterValidation.workItemIds: array expected");
                message.workItemIds = [];
                for (var i = 0; i < object.workItemIds.length; ++i)
                    message.workItemIds[i] = String(object.workItemIds[i]);
            }
            if (object.employeeId != null)
                message.employeeId = String(object.employeeId);
            if (object.vehicleId != null)
                message.vehicleId = String(object.vehicleId);
            if (object.blocking != null)
                message.blocking = Boolean(object.blocking);
            if (object.details != null)
                message.details = String(object.details);
            return message;
        };

        /**
         * Creates a plain object from a RosterValidation message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.RosterValidation
         * @static
         * @param {busable.RosterValidation} message RosterValidation
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RosterValidation.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.workItemIds = [];
            if (options.defaults) {
                object.type = options.enums === String ? "VALIDATION_TYPE_UNSPECIFIED" : 0;
                object.message = "";
                object.employeeId = "";
                object.vehicleId = "";
                object.blocking = false;
                object.details = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = options.enums === String ? $root.busable.RosterValidation.ValidationType[message.type] === undefined ? message.type : $root.busable.RosterValidation.ValidationType[message.type] : message.type;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.workItemIds && message.workItemIds.length) {
                object.workItemIds = [];
                for (var j = 0; j < message.workItemIds.length; ++j)
                    object.workItemIds[j] = message.workItemIds[j];
            }
            if (message.employeeId != null && message.hasOwnProperty("employeeId"))
                object.employeeId = message.employeeId;
            if (message.vehicleId != null && message.hasOwnProperty("vehicleId"))
                object.vehicleId = message.vehicleId;
            if (message.blocking != null && message.hasOwnProperty("blocking"))
                object.blocking = message.blocking;
            if (message.details != null && message.hasOwnProperty("details"))
                object.details = message.details;
            return object;
        };

        /**
         * Converts this RosterValidation to JSON.
         * @function toJSON
         * @memberof busable.RosterValidation
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RosterValidation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RosterValidation
         * @function getTypeUrl
         * @memberof busable.RosterValidation
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RosterValidation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.RosterValidation";
        };

        /**
         * ValidationType enum.
         * @name busable.RosterValidation.ValidationType
         * @enum {number}
         * @property {number} VALIDATION_TYPE_UNSPECIFIED=0 VALIDATION_TYPE_UNSPECIFIED value
         * @property {number} VALIDATION_TYPE_OVERTIME=1 VALIDATION_TYPE_OVERTIME value
         * @property {number} VALIDATION_TYPE_UNAVAILABLE=2 VALIDATION_TYPE_UNAVAILABLE value
         * @property {number} VALIDATION_TYPE_ON_LEAVE=3 VALIDATION_TYPE_ON_LEAVE value
         * @property {number} VALIDATION_TYPE_VEHICLE_REPAIR=4 VALIDATION_TYPE_VEHICLE_REPAIR value
         * @property {number} VALIDATION_TYPE_VEHICLE_SERVICE=5 VALIDATION_TYPE_VEHICLE_SERVICE value
         * @property {number} VALIDATION_TYPE_TIME_CONFLICT=6 VALIDATION_TYPE_TIME_CONFLICT value
         * @property {number} VALIDATION_TYPE_LICENSE_MISSING=7 VALIDATION_TYPE_LICENSE_MISSING value
         * @property {number} VALIDATION_TYPE_SKILL_MISSING=8 VALIDATION_TYPE_SKILL_MISSING value
         */
        RosterValidation.ValidationType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "VALIDATION_TYPE_UNSPECIFIED"] = 0;
            values[valuesById[1] = "VALIDATION_TYPE_OVERTIME"] = 1;
            values[valuesById[2] = "VALIDATION_TYPE_UNAVAILABLE"] = 2;
            values[valuesById[3] = "VALIDATION_TYPE_ON_LEAVE"] = 3;
            values[valuesById[4] = "VALIDATION_TYPE_VEHICLE_REPAIR"] = 4;
            values[valuesById[5] = "VALIDATION_TYPE_VEHICLE_SERVICE"] = 5;
            values[valuesById[6] = "VALIDATION_TYPE_TIME_CONFLICT"] = 6;
            values[valuesById[7] = "VALIDATION_TYPE_LICENSE_MISSING"] = 7;
            values[valuesById[8] = "VALIDATION_TYPE_SKILL_MISSING"] = 8;
            return values;
        })();

        return RosterValidation;
    })();

    busable.RosterSummary = (function() {

        /**
         * Properties of a RosterSummary.
         * @memberof busable
         * @interface IRosterSummary
         * @property {string|null} [rosterId] RosterSummary rosterId
         * @property {string|null} [rosterName] RosterSummary rosterName
         * @property {number|null} [totalWorkItems] RosterSummary totalWorkItems
         * @property {number|null} [allocatedWorkItems] RosterSummary allocatedWorkItems
         * @property {number|null} [unallocatedWorkItems] RosterSummary unallocatedWorkItems
         * @property {number|null} [optionalWorkItems] RosterSummary optionalWorkItems
         * @property {number|null} [completedWorkItems] RosterSummary completedWorkItems
         * @property {number|null} [totalScheduledTime] RosterSummary totalScheduledTime
         * @property {number|null} [totalActualTime] RosterSummary totalActualTime
         * @property {number|null} [totalDriverTime] RosterSummary totalDriverTime
         * @property {number|null} [totalWages] RosterSummary totalWages
         * @property {number|null} [totalVehicleCosts] RosterSummary totalVehicleCosts
         * @property {number|null} [uniqueEmployees] RosterSummary uniqueEmployees
         * @property {number|null} [uniqueVehicles] RosterSummary uniqueVehicles
         * @property {Array.<busable.IDaySummary>|null} [daySummaries] RosterSummary daySummaries
         */

        /**
         * Constructs a new RosterSummary.
         * @memberof busable
         * @classdesc RosterSummary provides aggregated statistics for a roster
         * @implements IRosterSummary
         * @constructor
         * @param {busable.IRosterSummary=} [properties] Properties to set
         */
        function RosterSummary(properties) {
            this.daySummaries = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RosterSummary rosterId.
         * @member {string} rosterId
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.rosterId = "";

        /**
         * RosterSummary rosterName.
         * @member {string} rosterName
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.rosterName = "";

        /**
         * RosterSummary totalWorkItems.
         * @member {number} totalWorkItems
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.totalWorkItems = 0;

        /**
         * RosterSummary allocatedWorkItems.
         * @member {number} allocatedWorkItems
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.allocatedWorkItems = 0;

        /**
         * RosterSummary unallocatedWorkItems.
         * @member {number} unallocatedWorkItems
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.unallocatedWorkItems = 0;

        /**
         * RosterSummary optionalWorkItems.
         * @member {number} optionalWorkItems
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.optionalWorkItems = 0;

        /**
         * RosterSummary completedWorkItems.
         * @member {number} completedWorkItems
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.completedWorkItems = 0;

        /**
         * RosterSummary totalScheduledTime.
         * @member {number} totalScheduledTime
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.totalScheduledTime = 0;

        /**
         * RosterSummary totalActualTime.
         * @member {number} totalActualTime
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.totalActualTime = 0;

        /**
         * RosterSummary totalDriverTime.
         * @member {number} totalDriverTime
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.totalDriverTime = 0;

        /**
         * RosterSummary totalWages.
         * @member {number} totalWages
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.totalWages = 0;

        /**
         * RosterSummary totalVehicleCosts.
         * @member {number} totalVehicleCosts
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.totalVehicleCosts = 0;

        /**
         * RosterSummary uniqueEmployees.
         * @member {number} uniqueEmployees
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.uniqueEmployees = 0;

        /**
         * RosterSummary uniqueVehicles.
         * @member {number} uniqueVehicles
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.uniqueVehicles = 0;

        /**
         * RosterSummary daySummaries.
         * @member {Array.<busable.IDaySummary>} daySummaries
         * @memberof busable.RosterSummary
         * @instance
         */
        RosterSummary.prototype.daySummaries = $util.emptyArray;

        /**
         * Creates a new RosterSummary instance using the specified properties.
         * @function create
         * @memberof busable.RosterSummary
         * @static
         * @param {busable.IRosterSummary=} [properties] Properties to set
         * @returns {busable.RosterSummary} RosterSummary instance
         */
        RosterSummary.create = function create(properties) {
            return new RosterSummary(properties);
        };

        /**
         * Encodes the specified RosterSummary message. Does not implicitly {@link busable.RosterSummary.verify|verify} messages.
         * @function encode
         * @memberof busable.RosterSummary
         * @static
         * @param {busable.IRosterSummary} message RosterSummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterSummary.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.rosterId != null && Object.hasOwnProperty.call(message, "rosterId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.rosterId);
            if (message.rosterName != null && Object.hasOwnProperty.call(message, "rosterName"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.rosterName);
            if (message.totalWorkItems != null && Object.hasOwnProperty.call(message, "totalWorkItems"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalWorkItems);
            if (message.allocatedWorkItems != null && Object.hasOwnProperty.call(message, "allocatedWorkItems"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.allocatedWorkItems);
            if (message.unallocatedWorkItems != null && Object.hasOwnProperty.call(message, "unallocatedWorkItems"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.unallocatedWorkItems);
            if (message.optionalWorkItems != null && Object.hasOwnProperty.call(message, "optionalWorkItems"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.optionalWorkItems);
            if (message.completedWorkItems != null && Object.hasOwnProperty.call(message, "completedWorkItems"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.completedWorkItems);
            if (message.totalScheduledTime != null && Object.hasOwnProperty.call(message, "totalScheduledTime"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.totalScheduledTime);
            if (message.totalActualTime != null && Object.hasOwnProperty.call(message, "totalActualTime"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.totalActualTime);
            if (message.totalDriverTime != null && Object.hasOwnProperty.call(message, "totalDriverTime"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.totalDriverTime);
            if (message.totalWages != null && Object.hasOwnProperty.call(message, "totalWages"))
                writer.uint32(/* id 11, wireType 1 =*/89).double(message.totalWages);
            if (message.totalVehicleCosts != null && Object.hasOwnProperty.call(message, "totalVehicleCosts"))
                writer.uint32(/* id 12, wireType 1 =*/97).double(message.totalVehicleCosts);
            if (message.uniqueEmployees != null && Object.hasOwnProperty.call(message, "uniqueEmployees"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.uniqueEmployees);
            if (message.uniqueVehicles != null && Object.hasOwnProperty.call(message, "uniqueVehicles"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.uniqueVehicles);
            if (message.daySummaries != null && message.daySummaries.length)
                for (var i = 0; i < message.daySummaries.length; ++i)
                    $root.busable.DaySummary.encode(message.daySummaries[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RosterSummary message, length delimited. Does not implicitly {@link busable.RosterSummary.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.RosterSummary
         * @static
         * @param {busable.IRosterSummary} message RosterSummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterSummary.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RosterSummary message from the specified reader or buffer.
         * @function decode
         * @memberof busable.RosterSummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.RosterSummary} RosterSummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterSummary.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.RosterSummary();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.rosterId = reader.string();
                        break;
                    }
                case 2: {
                        message.rosterName = reader.string();
                        break;
                    }
                case 3: {
                        message.totalWorkItems = reader.int32();
                        break;
                    }
                case 4: {
                        message.allocatedWorkItems = reader.int32();
                        break;
                    }
                case 5: {
                        message.unallocatedWorkItems = reader.int32();
                        break;
                    }
                case 6: {
                        message.optionalWorkItems = reader.int32();
                        break;
                    }
                case 7: {
                        message.completedWorkItems = reader.int32();
                        break;
                    }
                case 8: {
                        message.totalScheduledTime = reader.int32();
                        break;
                    }
                case 9: {
                        message.totalActualTime = reader.int32();
                        break;
                    }
                case 10: {
                        message.totalDriverTime = reader.int32();
                        break;
                    }
                case 11: {
                        message.totalWages = reader.double();
                        break;
                    }
                case 12: {
                        message.totalVehicleCosts = reader.double();
                        break;
                    }
                case 13: {
                        message.uniqueEmployees = reader.int32();
                        break;
                    }
                case 14: {
                        message.uniqueVehicles = reader.int32();
                        break;
                    }
                case 15: {
                        if (!(message.daySummaries && message.daySummaries.length))
                            message.daySummaries = [];
                        message.daySummaries.push($root.busable.DaySummary.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RosterSummary message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.RosterSummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.RosterSummary} RosterSummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterSummary.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RosterSummary message.
         * @function verify
         * @memberof busable.RosterSummary
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RosterSummary.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.rosterId != null && message.hasOwnProperty("rosterId"))
                if (!$util.isString(message.rosterId))
                    return "rosterId: string expected";
            if (message.rosterName != null && message.hasOwnProperty("rosterName"))
                if (!$util.isString(message.rosterName))
                    return "rosterName: string expected";
            if (message.totalWorkItems != null && message.hasOwnProperty("totalWorkItems"))
                if (!$util.isInteger(message.totalWorkItems))
                    return "totalWorkItems: integer expected";
            if (message.allocatedWorkItems != null && message.hasOwnProperty("allocatedWorkItems"))
                if (!$util.isInteger(message.allocatedWorkItems))
                    return "allocatedWorkItems: integer expected";
            if (message.unallocatedWorkItems != null && message.hasOwnProperty("unallocatedWorkItems"))
                if (!$util.isInteger(message.unallocatedWorkItems))
                    return "unallocatedWorkItems: integer expected";
            if (message.optionalWorkItems != null && message.hasOwnProperty("optionalWorkItems"))
                if (!$util.isInteger(message.optionalWorkItems))
                    return "optionalWorkItems: integer expected";
            if (message.completedWorkItems != null && message.hasOwnProperty("completedWorkItems"))
                if (!$util.isInteger(message.completedWorkItems))
                    return "completedWorkItems: integer expected";
            if (message.totalScheduledTime != null && message.hasOwnProperty("totalScheduledTime"))
                if (!$util.isInteger(message.totalScheduledTime))
                    return "totalScheduledTime: integer expected";
            if (message.totalActualTime != null && message.hasOwnProperty("totalActualTime"))
                if (!$util.isInteger(message.totalActualTime))
                    return "totalActualTime: integer expected";
            if (message.totalDriverTime != null && message.hasOwnProperty("totalDriverTime"))
                if (!$util.isInteger(message.totalDriverTime))
                    return "totalDriverTime: integer expected";
            if (message.totalWages != null && message.hasOwnProperty("totalWages"))
                if (typeof message.totalWages !== "number")
                    return "totalWages: number expected";
            if (message.totalVehicleCosts != null && message.hasOwnProperty("totalVehicleCosts"))
                if (typeof message.totalVehicleCosts !== "number")
                    return "totalVehicleCosts: number expected";
            if (message.uniqueEmployees != null && message.hasOwnProperty("uniqueEmployees"))
                if (!$util.isInteger(message.uniqueEmployees))
                    return "uniqueEmployees: integer expected";
            if (message.uniqueVehicles != null && message.hasOwnProperty("uniqueVehicles"))
                if (!$util.isInteger(message.uniqueVehicles))
                    return "uniqueVehicles: integer expected";
            if (message.daySummaries != null && message.hasOwnProperty("daySummaries")) {
                if (!Array.isArray(message.daySummaries))
                    return "daySummaries: array expected";
                for (var i = 0; i < message.daySummaries.length; ++i) {
                    var error = $root.busable.DaySummary.verify(message.daySummaries[i]);
                    if (error)
                        return "daySummaries." + error;
                }
            }
            return null;
        };

        /**
         * Creates a RosterSummary message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.RosterSummary
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.RosterSummary} RosterSummary
         */
        RosterSummary.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.RosterSummary)
                return object;
            var message = new $root.busable.RosterSummary();
            if (object.rosterId != null)
                message.rosterId = String(object.rosterId);
            if (object.rosterName != null)
                message.rosterName = String(object.rosterName);
            if (object.totalWorkItems != null)
                message.totalWorkItems = object.totalWorkItems | 0;
            if (object.allocatedWorkItems != null)
                message.allocatedWorkItems = object.allocatedWorkItems | 0;
            if (object.unallocatedWorkItems != null)
                message.unallocatedWorkItems = object.unallocatedWorkItems | 0;
            if (object.optionalWorkItems != null)
                message.optionalWorkItems = object.optionalWorkItems | 0;
            if (object.completedWorkItems != null)
                message.completedWorkItems = object.completedWorkItems | 0;
            if (object.totalScheduledTime != null)
                message.totalScheduledTime = object.totalScheduledTime | 0;
            if (object.totalActualTime != null)
                message.totalActualTime = object.totalActualTime | 0;
            if (object.totalDriverTime != null)
                message.totalDriverTime = object.totalDriverTime | 0;
            if (object.totalWages != null)
                message.totalWages = Number(object.totalWages);
            if (object.totalVehicleCosts != null)
                message.totalVehicleCosts = Number(object.totalVehicleCosts);
            if (object.uniqueEmployees != null)
                message.uniqueEmployees = object.uniqueEmployees | 0;
            if (object.uniqueVehicles != null)
                message.uniqueVehicles = object.uniqueVehicles | 0;
            if (object.daySummaries) {
                if (!Array.isArray(object.daySummaries))
                    throw TypeError(".busable.RosterSummary.daySummaries: array expected");
                message.daySummaries = [];
                for (var i = 0; i < object.daySummaries.length; ++i) {
                    if (typeof object.daySummaries[i] !== "object")
                        throw TypeError(".busable.RosterSummary.daySummaries: object expected");
                    message.daySummaries[i] = $root.busable.DaySummary.fromObject(object.daySummaries[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a RosterSummary message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.RosterSummary
         * @static
         * @param {busable.RosterSummary} message RosterSummary
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RosterSummary.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.daySummaries = [];
            if (options.defaults) {
                object.rosterId = "";
                object.rosterName = "";
                object.totalWorkItems = 0;
                object.allocatedWorkItems = 0;
                object.unallocatedWorkItems = 0;
                object.optionalWorkItems = 0;
                object.completedWorkItems = 0;
                object.totalScheduledTime = 0;
                object.totalActualTime = 0;
                object.totalDriverTime = 0;
                object.totalWages = 0;
                object.totalVehicleCosts = 0;
                object.uniqueEmployees = 0;
                object.uniqueVehicles = 0;
            }
            if (message.rosterId != null && message.hasOwnProperty("rosterId"))
                object.rosterId = message.rosterId;
            if (message.rosterName != null && message.hasOwnProperty("rosterName"))
                object.rosterName = message.rosterName;
            if (message.totalWorkItems != null && message.hasOwnProperty("totalWorkItems"))
                object.totalWorkItems = message.totalWorkItems;
            if (message.allocatedWorkItems != null && message.hasOwnProperty("allocatedWorkItems"))
                object.allocatedWorkItems = message.allocatedWorkItems;
            if (message.unallocatedWorkItems != null && message.hasOwnProperty("unallocatedWorkItems"))
                object.unallocatedWorkItems = message.unallocatedWorkItems;
            if (message.optionalWorkItems != null && message.hasOwnProperty("optionalWorkItems"))
                object.optionalWorkItems = message.optionalWorkItems;
            if (message.completedWorkItems != null && message.hasOwnProperty("completedWorkItems"))
                object.completedWorkItems = message.completedWorkItems;
            if (message.totalScheduledTime != null && message.hasOwnProperty("totalScheduledTime"))
                object.totalScheduledTime = message.totalScheduledTime;
            if (message.totalActualTime != null && message.hasOwnProperty("totalActualTime"))
                object.totalActualTime = message.totalActualTime;
            if (message.totalDriverTime != null && message.hasOwnProperty("totalDriverTime"))
                object.totalDriverTime = message.totalDriverTime;
            if (message.totalWages != null && message.hasOwnProperty("totalWages"))
                object.totalWages = options.json && !isFinite(message.totalWages) ? String(message.totalWages) : message.totalWages;
            if (message.totalVehicleCosts != null && message.hasOwnProperty("totalVehicleCosts"))
                object.totalVehicleCosts = options.json && !isFinite(message.totalVehicleCosts) ? String(message.totalVehicleCosts) : message.totalVehicleCosts;
            if (message.uniqueEmployees != null && message.hasOwnProperty("uniqueEmployees"))
                object.uniqueEmployees = message.uniqueEmployees;
            if (message.uniqueVehicles != null && message.hasOwnProperty("uniqueVehicles"))
                object.uniqueVehicles = message.uniqueVehicles;
            if (message.daySummaries && message.daySummaries.length) {
                object.daySummaries = [];
                for (var j = 0; j < message.daySummaries.length; ++j)
                    object.daySummaries[j] = $root.busable.DaySummary.toObject(message.daySummaries[j], options);
            }
            return object;
        };

        /**
         * Converts this RosterSummary to JSON.
         * @function toJSON
         * @memberof busable.RosterSummary
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RosterSummary.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RosterSummary
         * @function getTypeUrl
         * @memberof busable.RosterSummary
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RosterSummary.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.RosterSummary";
        };

        return RosterSummary;
    })();

    busable.DaySummary = (function() {

        /**
         * Properties of a DaySummary.
         * @memberof busable
         * @interface IDaySummary
         * @property {number|null} [dayOfWeek] DaySummary dayOfWeek
         * @property {string|null} [date] DaySummary date
         * @property {number|null} [workItemCount] DaySummary workItemCount
         * @property {number|null} [scheduledTime] DaySummary scheduledTime
         * @property {number|null} [actualTime] DaySummary actualTime
         * @property {number|null} [wages] DaySummary wages
         * @property {number|null} [employeeCount] DaySummary employeeCount
         * @property {number|null} [vehicleCount] DaySummary vehicleCount
         */

        /**
         * Constructs a new DaySummary.
         * @memberof busable
         * @classdesc DaySummary provides aggregated statistics for a single day
         * @implements IDaySummary
         * @constructor
         * @param {busable.IDaySummary=} [properties] Properties to set
         */
        function DaySummary(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DaySummary dayOfWeek.
         * @member {number} dayOfWeek
         * @memberof busable.DaySummary
         * @instance
         */
        DaySummary.prototype.dayOfWeek = 0;

        /**
         * DaySummary date.
         * @member {string} date
         * @memberof busable.DaySummary
         * @instance
         */
        DaySummary.prototype.date = "";

        /**
         * DaySummary workItemCount.
         * @member {number} workItemCount
         * @memberof busable.DaySummary
         * @instance
         */
        DaySummary.prototype.workItemCount = 0;

        /**
         * DaySummary scheduledTime.
         * @member {number} scheduledTime
         * @memberof busable.DaySummary
         * @instance
         */
        DaySummary.prototype.scheduledTime = 0;

        /**
         * DaySummary actualTime.
         * @member {number} actualTime
         * @memberof busable.DaySummary
         * @instance
         */
        DaySummary.prototype.actualTime = 0;

        /**
         * DaySummary wages.
         * @member {number} wages
         * @memberof busable.DaySummary
         * @instance
         */
        DaySummary.prototype.wages = 0;

        /**
         * DaySummary employeeCount.
         * @member {number} employeeCount
         * @memberof busable.DaySummary
         * @instance
         */
        DaySummary.prototype.employeeCount = 0;

        /**
         * DaySummary vehicleCount.
         * @member {number} vehicleCount
         * @memberof busable.DaySummary
         * @instance
         */
        DaySummary.prototype.vehicleCount = 0;

        /**
         * Creates a new DaySummary instance using the specified properties.
         * @function create
         * @memberof busable.DaySummary
         * @static
         * @param {busable.IDaySummary=} [properties] Properties to set
         * @returns {busable.DaySummary} DaySummary instance
         */
        DaySummary.create = function create(properties) {
            return new DaySummary(properties);
        };

        /**
         * Encodes the specified DaySummary message. Does not implicitly {@link busable.DaySummary.verify|verify} messages.
         * @function encode
         * @memberof busable.DaySummary
         * @static
         * @param {busable.IDaySummary} message DaySummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DaySummary.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.dayOfWeek != null && Object.hasOwnProperty.call(message, "dayOfWeek"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dayOfWeek);
            if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.date);
            if (message.workItemCount != null && Object.hasOwnProperty.call(message, "workItemCount"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.workItemCount);
            if (message.scheduledTime != null && Object.hasOwnProperty.call(message, "scheduledTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.scheduledTime);
            if (message.actualTime != null && Object.hasOwnProperty.call(message, "actualTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.actualTime);
            if (message.wages != null && Object.hasOwnProperty.call(message, "wages"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.wages);
            if (message.employeeCount != null && Object.hasOwnProperty.call(message, "employeeCount"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.employeeCount);
            if (message.vehicleCount != null && Object.hasOwnProperty.call(message, "vehicleCount"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.vehicleCount);
            return writer;
        };

        /**
         * Encodes the specified DaySummary message, length delimited. Does not implicitly {@link busable.DaySummary.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.DaySummary
         * @static
         * @param {busable.IDaySummary} message DaySummary message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DaySummary.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DaySummary message from the specified reader or buffer.
         * @function decode
         * @memberof busable.DaySummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.DaySummary} DaySummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DaySummary.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.DaySummary();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.dayOfWeek = reader.int32();
                        break;
                    }
                case 2: {
                        message.date = reader.string();
                        break;
                    }
                case 3: {
                        message.workItemCount = reader.int32();
                        break;
                    }
                case 4: {
                        message.scheduledTime = reader.int32();
                        break;
                    }
                case 5: {
                        message.actualTime = reader.int32();
                        break;
                    }
                case 6: {
                        message.wages = reader.double();
                        break;
                    }
                case 7: {
                        message.employeeCount = reader.int32();
                        break;
                    }
                case 8: {
                        message.vehicleCount = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DaySummary message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.DaySummary
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.DaySummary} DaySummary
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DaySummary.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DaySummary message.
         * @function verify
         * @memberof busable.DaySummary
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DaySummary.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                if (!$util.isInteger(message.dayOfWeek))
                    return "dayOfWeek: integer expected";
            if (message.date != null && message.hasOwnProperty("date"))
                if (!$util.isString(message.date))
                    return "date: string expected";
            if (message.workItemCount != null && message.hasOwnProperty("workItemCount"))
                if (!$util.isInteger(message.workItemCount))
                    return "workItemCount: integer expected";
            if (message.scheduledTime != null && message.hasOwnProperty("scheduledTime"))
                if (!$util.isInteger(message.scheduledTime))
                    return "scheduledTime: integer expected";
            if (message.actualTime != null && message.hasOwnProperty("actualTime"))
                if (!$util.isInteger(message.actualTime))
                    return "actualTime: integer expected";
            if (message.wages != null && message.hasOwnProperty("wages"))
                if (typeof message.wages !== "number")
                    return "wages: number expected";
            if (message.employeeCount != null && message.hasOwnProperty("employeeCount"))
                if (!$util.isInteger(message.employeeCount))
                    return "employeeCount: integer expected";
            if (message.vehicleCount != null && message.hasOwnProperty("vehicleCount"))
                if (!$util.isInteger(message.vehicleCount))
                    return "vehicleCount: integer expected";
            return null;
        };

        /**
         * Creates a DaySummary message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.DaySummary
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.DaySummary} DaySummary
         */
        DaySummary.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.DaySummary)
                return object;
            var message = new $root.busable.DaySummary();
            if (object.dayOfWeek != null)
                message.dayOfWeek = object.dayOfWeek | 0;
            if (object.date != null)
                message.date = String(object.date);
            if (object.workItemCount != null)
                message.workItemCount = object.workItemCount | 0;
            if (object.scheduledTime != null)
                message.scheduledTime = object.scheduledTime | 0;
            if (object.actualTime != null)
                message.actualTime = object.actualTime | 0;
            if (object.wages != null)
                message.wages = Number(object.wages);
            if (object.employeeCount != null)
                message.employeeCount = object.employeeCount | 0;
            if (object.vehicleCount != null)
                message.vehicleCount = object.vehicleCount | 0;
            return message;
        };

        /**
         * Creates a plain object from a DaySummary message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.DaySummary
         * @static
         * @param {busable.DaySummary} message DaySummary
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DaySummary.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.dayOfWeek = 0;
                object.date = "";
                object.workItemCount = 0;
                object.scheduledTime = 0;
                object.actualTime = 0;
                object.wages = 0;
                object.employeeCount = 0;
                object.vehicleCount = 0;
            }
            if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                object.dayOfWeek = message.dayOfWeek;
            if (message.date != null && message.hasOwnProperty("date"))
                object.date = message.date;
            if (message.workItemCount != null && message.hasOwnProperty("workItemCount"))
                object.workItemCount = message.workItemCount;
            if (message.scheduledTime != null && message.hasOwnProperty("scheduledTime"))
                object.scheduledTime = message.scheduledTime;
            if (message.actualTime != null && message.hasOwnProperty("actualTime"))
                object.actualTime = message.actualTime;
            if (message.wages != null && message.hasOwnProperty("wages"))
                object.wages = options.json && !isFinite(message.wages) ? String(message.wages) : message.wages;
            if (message.employeeCount != null && message.hasOwnProperty("employeeCount"))
                object.employeeCount = message.employeeCount;
            if (message.vehicleCount != null && message.hasOwnProperty("vehicleCount"))
                object.vehicleCount = message.vehicleCount;
            return object;
        };

        /**
         * Converts this DaySummary to JSON.
         * @function toJSON
         * @memberof busable.DaySummary
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DaySummary.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DaySummary
         * @function getTypeUrl
         * @memberof busable.DaySummary
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DaySummary.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.DaySummary";
        };

        return DaySummary;
    })();

    busable.RosterFilter = (function() {

        /**
         * Properties of a RosterFilter.
         * @memberof busable
         * @interface IRosterFilter
         * @property {Array.<string>|null} [rosterIds] RosterFilter rosterIds
         * @property {Array.<string>|null} [employeeIds] RosterFilter employeeIds
         * @property {Array.<string>|null} [vehicleIds] RosterFilter vehicleIds
         * @property {string|null} [startDate] RosterFilter startDate
         * @property {string|null} [endDate] RosterFilter endDate
         * @property {boolean|null} [includeCompleted] RosterFilter includeCompleted
         * @property {boolean|null} [includeOptional] RosterFilter includeOptional
         * @property {string|null} [operatorId] RosterFilter operatorId
         */

        /**
         * Constructs a new RosterFilter.
         * @memberof busable
         * @classdesc RosterFilter for querying rosters
         * @implements IRosterFilter
         * @constructor
         * @param {busable.IRosterFilter=} [properties] Properties to set
         */
        function RosterFilter(properties) {
            this.rosterIds = [];
            this.employeeIds = [];
            this.vehicleIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RosterFilter rosterIds.
         * @member {Array.<string>} rosterIds
         * @memberof busable.RosterFilter
         * @instance
         */
        RosterFilter.prototype.rosterIds = $util.emptyArray;

        /**
         * RosterFilter employeeIds.
         * @member {Array.<string>} employeeIds
         * @memberof busable.RosterFilter
         * @instance
         */
        RosterFilter.prototype.employeeIds = $util.emptyArray;

        /**
         * RosterFilter vehicleIds.
         * @member {Array.<string>} vehicleIds
         * @memberof busable.RosterFilter
         * @instance
         */
        RosterFilter.prototype.vehicleIds = $util.emptyArray;

        /**
         * RosterFilter startDate.
         * @member {string} startDate
         * @memberof busable.RosterFilter
         * @instance
         */
        RosterFilter.prototype.startDate = "";

        /**
         * RosterFilter endDate.
         * @member {string} endDate
         * @memberof busable.RosterFilter
         * @instance
         */
        RosterFilter.prototype.endDate = "";

        /**
         * RosterFilter includeCompleted.
         * @member {boolean} includeCompleted
         * @memberof busable.RosterFilter
         * @instance
         */
        RosterFilter.prototype.includeCompleted = false;

        /**
         * RosterFilter includeOptional.
         * @member {boolean} includeOptional
         * @memberof busable.RosterFilter
         * @instance
         */
        RosterFilter.prototype.includeOptional = false;

        /**
         * RosterFilter operatorId.
         * @member {string} operatorId
         * @memberof busable.RosterFilter
         * @instance
         */
        RosterFilter.prototype.operatorId = "";

        /**
         * Creates a new RosterFilter instance using the specified properties.
         * @function create
         * @memberof busable.RosterFilter
         * @static
         * @param {busable.IRosterFilter=} [properties] Properties to set
         * @returns {busable.RosterFilter} RosterFilter instance
         */
        RosterFilter.create = function create(properties) {
            return new RosterFilter(properties);
        };

        /**
         * Encodes the specified RosterFilter message. Does not implicitly {@link busable.RosterFilter.verify|verify} messages.
         * @function encode
         * @memberof busable.RosterFilter
         * @static
         * @param {busable.IRosterFilter} message RosterFilter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterFilter.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.rosterIds != null && message.rosterIds.length)
                for (var i = 0; i < message.rosterIds.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.rosterIds[i]);
            if (message.employeeIds != null && message.employeeIds.length)
                for (var i = 0; i < message.employeeIds.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.employeeIds[i]);
            if (message.vehicleIds != null && message.vehicleIds.length)
                for (var i = 0; i < message.vehicleIds.length; ++i)
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.vehicleIds[i]);
            if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.startDate);
            if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.endDate);
            if (message.includeCompleted != null && Object.hasOwnProperty.call(message, "includeCompleted"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeCompleted);
            if (message.includeOptional != null && Object.hasOwnProperty.call(message, "includeOptional"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeOptional);
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.operatorId);
            return writer;
        };

        /**
         * Encodes the specified RosterFilter message, length delimited. Does not implicitly {@link busable.RosterFilter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.RosterFilter
         * @static
         * @param {busable.IRosterFilter} message RosterFilter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterFilter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RosterFilter message from the specified reader or buffer.
         * @function decode
         * @memberof busable.RosterFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.RosterFilter} RosterFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterFilter.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.RosterFilter();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (!(message.rosterIds && message.rosterIds.length))
                            message.rosterIds = [];
                        message.rosterIds.push(reader.string());
                        break;
                    }
                case 2: {
                        if (!(message.employeeIds && message.employeeIds.length))
                            message.employeeIds = [];
                        message.employeeIds.push(reader.string());
                        break;
                    }
                case 3: {
                        if (!(message.vehicleIds && message.vehicleIds.length))
                            message.vehicleIds = [];
                        message.vehicleIds.push(reader.string());
                        break;
                    }
                case 4: {
                        message.startDate = reader.string();
                        break;
                    }
                case 5: {
                        message.endDate = reader.string();
                        break;
                    }
                case 6: {
                        message.includeCompleted = reader.bool();
                        break;
                    }
                case 7: {
                        message.includeOptional = reader.bool();
                        break;
                    }
                case 8: {
                        message.operatorId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RosterFilter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.RosterFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.RosterFilter} RosterFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterFilter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RosterFilter message.
         * @function verify
         * @memberof busable.RosterFilter
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RosterFilter.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.rosterIds != null && message.hasOwnProperty("rosterIds")) {
                if (!Array.isArray(message.rosterIds))
                    return "rosterIds: array expected";
                for (var i = 0; i < message.rosterIds.length; ++i)
                    if (!$util.isString(message.rosterIds[i]))
                        return "rosterIds: string[] expected";
            }
            if (message.employeeIds != null && message.hasOwnProperty("employeeIds")) {
                if (!Array.isArray(message.employeeIds))
                    return "employeeIds: array expected";
                for (var i = 0; i < message.employeeIds.length; ++i)
                    if (!$util.isString(message.employeeIds[i]))
                        return "employeeIds: string[] expected";
            }
            if (message.vehicleIds != null && message.hasOwnProperty("vehicleIds")) {
                if (!Array.isArray(message.vehicleIds))
                    return "vehicleIds: array expected";
                for (var i = 0; i < message.vehicleIds.length; ++i)
                    if (!$util.isString(message.vehicleIds[i]))
                        return "vehicleIds: string[] expected";
            }
            if (message.startDate != null && message.hasOwnProperty("startDate"))
                if (!$util.isString(message.startDate))
                    return "startDate: string expected";
            if (message.endDate != null && message.hasOwnProperty("endDate"))
                if (!$util.isString(message.endDate))
                    return "endDate: string expected";
            if (message.includeCompleted != null && message.hasOwnProperty("includeCompleted"))
                if (typeof message.includeCompleted !== "boolean")
                    return "includeCompleted: boolean expected";
            if (message.includeOptional != null && message.hasOwnProperty("includeOptional"))
                if (typeof message.includeOptional !== "boolean")
                    return "includeOptional: boolean expected";
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            return null;
        };

        /**
         * Creates a RosterFilter message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.RosterFilter
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.RosterFilter} RosterFilter
         */
        RosterFilter.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.RosterFilter)
                return object;
            var message = new $root.busable.RosterFilter();
            if (object.rosterIds) {
                if (!Array.isArray(object.rosterIds))
                    throw TypeError(".busable.RosterFilter.rosterIds: array expected");
                message.rosterIds = [];
                for (var i = 0; i < object.rosterIds.length; ++i)
                    message.rosterIds[i] = String(object.rosterIds[i]);
            }
            if (object.employeeIds) {
                if (!Array.isArray(object.employeeIds))
                    throw TypeError(".busable.RosterFilter.employeeIds: array expected");
                message.employeeIds = [];
                for (var i = 0; i < object.employeeIds.length; ++i)
                    message.employeeIds[i] = String(object.employeeIds[i]);
            }
            if (object.vehicleIds) {
                if (!Array.isArray(object.vehicleIds))
                    throw TypeError(".busable.RosterFilter.vehicleIds: array expected");
                message.vehicleIds = [];
                for (var i = 0; i < object.vehicleIds.length; ++i)
                    message.vehicleIds[i] = String(object.vehicleIds[i]);
            }
            if (object.startDate != null)
                message.startDate = String(object.startDate);
            if (object.endDate != null)
                message.endDate = String(object.endDate);
            if (object.includeCompleted != null)
                message.includeCompleted = Boolean(object.includeCompleted);
            if (object.includeOptional != null)
                message.includeOptional = Boolean(object.includeOptional);
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            return message;
        };

        /**
         * Creates a plain object from a RosterFilter message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.RosterFilter
         * @static
         * @param {busable.RosterFilter} message RosterFilter
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RosterFilter.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.rosterIds = [];
                object.employeeIds = [];
                object.vehicleIds = [];
            }
            if (options.defaults) {
                object.startDate = "";
                object.endDate = "";
                object.includeCompleted = false;
                object.includeOptional = false;
                object.operatorId = "";
            }
            if (message.rosterIds && message.rosterIds.length) {
                object.rosterIds = [];
                for (var j = 0; j < message.rosterIds.length; ++j)
                    object.rosterIds[j] = message.rosterIds[j];
            }
            if (message.employeeIds && message.employeeIds.length) {
                object.employeeIds = [];
                for (var j = 0; j < message.employeeIds.length; ++j)
                    object.employeeIds[j] = message.employeeIds[j];
            }
            if (message.vehicleIds && message.vehicleIds.length) {
                object.vehicleIds = [];
                for (var j = 0; j < message.vehicleIds.length; ++j)
                    object.vehicleIds[j] = message.vehicleIds[j];
            }
            if (message.startDate != null && message.hasOwnProperty("startDate"))
                object.startDate = message.startDate;
            if (message.endDate != null && message.hasOwnProperty("endDate"))
                object.endDate = message.endDate;
            if (message.includeCompleted != null && message.hasOwnProperty("includeCompleted"))
                object.includeCompleted = message.includeCompleted;
            if (message.includeOptional != null && message.hasOwnProperty("includeOptional"))
                object.includeOptional = message.includeOptional;
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            return object;
        };

        /**
         * Converts this RosterFilter to JSON.
         * @function toJSON
         * @memberof busable.RosterFilter
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RosterFilter.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RosterFilter
         * @function getTypeUrl
         * @memberof busable.RosterFilter
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RosterFilter.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.RosterFilter";
        };

        return RosterFilter;
    })();

    busable.RosterRequest = (function() {

        /**
         * Properties of a RosterRequest.
         * @memberof busable
         * @interface IRosterRequest
         * @property {busable.IWeeklyRoster|null} [roster] RosterRequest roster
         * @property {string|null} [operatorId] RosterRequest operatorId
         * @property {string|null} [userId] RosterRequest userId
         */

        /**
         * Constructs a new RosterRequest.
         * @memberof busable
         * @classdesc Request to create or update a roster
         * @implements IRosterRequest
         * @constructor
         * @param {busable.IRosterRequest=} [properties] Properties to set
         */
        function RosterRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RosterRequest roster.
         * @member {busable.IWeeklyRoster|null|undefined} roster
         * @memberof busable.RosterRequest
         * @instance
         */
        RosterRequest.prototype.roster = null;

        /**
         * RosterRequest operatorId.
         * @member {string} operatorId
         * @memberof busable.RosterRequest
         * @instance
         */
        RosterRequest.prototype.operatorId = "";

        /**
         * RosterRequest userId.
         * @member {string} userId
         * @memberof busable.RosterRequest
         * @instance
         */
        RosterRequest.prototype.userId = "";

        /**
         * Creates a new RosterRequest instance using the specified properties.
         * @function create
         * @memberof busable.RosterRequest
         * @static
         * @param {busable.IRosterRequest=} [properties] Properties to set
         * @returns {busable.RosterRequest} RosterRequest instance
         */
        RosterRequest.create = function create(properties) {
            return new RosterRequest(properties);
        };

        /**
         * Encodes the specified RosterRequest message. Does not implicitly {@link busable.RosterRequest.verify|verify} messages.
         * @function encode
         * @memberof busable.RosterRequest
         * @static
         * @param {busable.IRosterRequest} message RosterRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roster != null && Object.hasOwnProperty.call(message, "roster"))
                $root.busable.WeeklyRoster.encode(message.roster, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.operatorId);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.userId);
            return writer;
        };

        /**
         * Encodes the specified RosterRequest message, length delimited. Does not implicitly {@link busable.RosterRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.RosterRequest
         * @static
         * @param {busable.IRosterRequest} message RosterRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RosterRequest message from the specified reader or buffer.
         * @function decode
         * @memberof busable.RosterRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.RosterRequest} RosterRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterRequest.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.RosterRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.roster = $root.busable.WeeklyRoster.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 3: {
                        message.userId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RosterRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.RosterRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.RosterRequest} RosterRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RosterRequest message.
         * @function verify
         * @memberof busable.RosterRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RosterRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roster != null && message.hasOwnProperty("roster")) {
                var error = $root.busable.WeeklyRoster.verify(message.roster);
                if (error)
                    return "roster." + error;
            }
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            return null;
        };

        /**
         * Creates a RosterRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.RosterRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.RosterRequest} RosterRequest
         */
        RosterRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.RosterRequest)
                return object;
            var message = new $root.busable.RosterRequest();
            if (object.roster != null) {
                if (typeof object.roster !== "object")
                    throw TypeError(".busable.RosterRequest.roster: object expected");
                message.roster = $root.busable.WeeklyRoster.fromObject(object.roster);
            }
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.userId != null)
                message.userId = String(object.userId);
            return message;
        };

        /**
         * Creates a plain object from a RosterRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.RosterRequest
         * @static
         * @param {busable.RosterRequest} message RosterRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RosterRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roster = null;
                object.operatorId = "";
                object.userId = "";
            }
            if (message.roster != null && message.hasOwnProperty("roster"))
                object.roster = $root.busable.WeeklyRoster.toObject(message.roster, options);
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            return object;
        };

        /**
         * Converts this RosterRequest to JSON.
         * @function toJSON
         * @memberof busable.RosterRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RosterRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RosterRequest
         * @function getTypeUrl
         * @memberof busable.RosterRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RosterRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.RosterRequest";
        };

        return RosterRequest;
    })();

    busable.RosterResponse = (function() {

        /**
         * Properties of a RosterResponse.
         * @memberof busable
         * @interface IRosterResponse
         * @property {busable.IWeeklyRoster|null} [roster] RosterResponse roster
         * @property {Array.<busable.IRosterValidation>|null} [validations] RosterResponse validations
         * @property {busable.IRosterSummary|null} [summary] RosterResponse summary
         */

        /**
         * Constructs a new RosterResponse.
         * @memberof busable
         * @classdesc Response containing roster data
         * @implements IRosterResponse
         * @constructor
         * @param {busable.IRosterResponse=} [properties] Properties to set
         */
        function RosterResponse(properties) {
            this.validations = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RosterResponse roster.
         * @member {busable.IWeeklyRoster|null|undefined} roster
         * @memberof busable.RosterResponse
         * @instance
         */
        RosterResponse.prototype.roster = null;

        /**
         * RosterResponse validations.
         * @member {Array.<busable.IRosterValidation>} validations
         * @memberof busable.RosterResponse
         * @instance
         */
        RosterResponse.prototype.validations = $util.emptyArray;

        /**
         * RosterResponse summary.
         * @member {busable.IRosterSummary|null|undefined} summary
         * @memberof busable.RosterResponse
         * @instance
         */
        RosterResponse.prototype.summary = null;

        /**
         * Creates a new RosterResponse instance using the specified properties.
         * @function create
         * @memberof busable.RosterResponse
         * @static
         * @param {busable.IRosterResponse=} [properties] Properties to set
         * @returns {busable.RosterResponse} RosterResponse instance
         */
        RosterResponse.create = function create(properties) {
            return new RosterResponse(properties);
        };

        /**
         * Encodes the specified RosterResponse message. Does not implicitly {@link busable.RosterResponse.verify|verify} messages.
         * @function encode
         * @memberof busable.RosterResponse
         * @static
         * @param {busable.IRosterResponse} message RosterResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roster != null && Object.hasOwnProperty.call(message, "roster"))
                $root.busable.WeeklyRoster.encode(message.roster, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.validations != null && message.validations.length)
                for (var i = 0; i < message.validations.length; ++i)
                    $root.busable.RosterValidation.encode(message.validations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
                $root.busable.RosterSummary.encode(message.summary, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RosterResponse message, length delimited. Does not implicitly {@link busable.RosterResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.RosterResponse
         * @static
         * @param {busable.IRosterResponse} message RosterResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RosterResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RosterResponse message from the specified reader or buffer.
         * @function decode
         * @memberof busable.RosterResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.RosterResponse} RosterResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.RosterResponse();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.roster = $root.busable.WeeklyRoster.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        if (!(message.validations && message.validations.length))
                            message.validations = [];
                        message.validations.push($root.busable.RosterValidation.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        message.summary = $root.busable.RosterSummary.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RosterResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.RosterResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.RosterResponse} RosterResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RosterResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RosterResponse message.
         * @function verify
         * @memberof busable.RosterResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RosterResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roster != null && message.hasOwnProperty("roster")) {
                var error = $root.busable.WeeklyRoster.verify(message.roster);
                if (error)
                    return "roster." + error;
            }
            if (message.validations != null && message.hasOwnProperty("validations")) {
                if (!Array.isArray(message.validations))
                    return "validations: array expected";
                for (var i = 0; i < message.validations.length; ++i) {
                    var error = $root.busable.RosterValidation.verify(message.validations[i]);
                    if (error)
                        return "validations." + error;
                }
            }
            if (message.summary != null && message.hasOwnProperty("summary")) {
                var error = $root.busable.RosterSummary.verify(message.summary);
                if (error)
                    return "summary." + error;
            }
            return null;
        };

        /**
         * Creates a RosterResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.RosterResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.RosterResponse} RosterResponse
         */
        RosterResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.RosterResponse)
                return object;
            var message = new $root.busable.RosterResponse();
            if (object.roster != null) {
                if (typeof object.roster !== "object")
                    throw TypeError(".busable.RosterResponse.roster: object expected");
                message.roster = $root.busable.WeeklyRoster.fromObject(object.roster);
            }
            if (object.validations) {
                if (!Array.isArray(object.validations))
                    throw TypeError(".busable.RosterResponse.validations: array expected");
                message.validations = [];
                for (var i = 0; i < object.validations.length; ++i) {
                    if (typeof object.validations[i] !== "object")
                        throw TypeError(".busable.RosterResponse.validations: object expected");
                    message.validations[i] = $root.busable.RosterValidation.fromObject(object.validations[i]);
                }
            }
            if (object.summary != null) {
                if (typeof object.summary !== "object")
                    throw TypeError(".busable.RosterResponse.summary: object expected");
                message.summary = $root.busable.RosterSummary.fromObject(object.summary);
            }
            return message;
        };

        /**
         * Creates a plain object from a RosterResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.RosterResponse
         * @static
         * @param {busable.RosterResponse} message RosterResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RosterResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.validations = [];
            if (options.defaults) {
                object.roster = null;
                object.summary = null;
            }
            if (message.roster != null && message.hasOwnProperty("roster"))
                object.roster = $root.busable.WeeklyRoster.toObject(message.roster, options);
            if (message.validations && message.validations.length) {
                object.validations = [];
                for (var j = 0; j < message.validations.length; ++j)
                    object.validations[j] = $root.busable.RosterValidation.toObject(message.validations[j], options);
            }
            if (message.summary != null && message.hasOwnProperty("summary"))
                object.summary = $root.busable.RosterSummary.toObject(message.summary, options);
            return object;
        };

        /**
         * Converts this RosterResponse to JSON.
         * @function toJSON
         * @memberof busable.RosterResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RosterResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RosterResponse
         * @function getTypeUrl
         * @memberof busable.RosterResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RosterResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.RosterResponse";
        };

        return RosterResponse;
    })();

    busable.ScenarioRequest = (function() {

        /**
         * Properties of a ScenarioRequest.
         * @memberof busable
         * @interface IScenarioRequest
         * @property {busable.IWeeklyScenario|null} [scenario] ScenarioRequest scenario
         * @property {string|null} [operatorId] ScenarioRequest operatorId
         * @property {string|null} [userId] ScenarioRequest userId
         */

        /**
         * Constructs a new ScenarioRequest.
         * @memberof busable
         * @classdesc Request to create or update a scenario
         * @implements IScenarioRequest
         * @constructor
         * @param {busable.IScenarioRequest=} [properties] Properties to set
         */
        function ScenarioRequest(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScenarioRequest scenario.
         * @member {busable.IWeeklyScenario|null|undefined} scenario
         * @memberof busable.ScenarioRequest
         * @instance
         */
        ScenarioRequest.prototype.scenario = null;

        /**
         * ScenarioRequest operatorId.
         * @member {string} operatorId
         * @memberof busable.ScenarioRequest
         * @instance
         */
        ScenarioRequest.prototype.operatorId = "";

        /**
         * ScenarioRequest userId.
         * @member {string} userId
         * @memberof busable.ScenarioRequest
         * @instance
         */
        ScenarioRequest.prototype.userId = "";

        /**
         * Creates a new ScenarioRequest instance using the specified properties.
         * @function create
         * @memberof busable.ScenarioRequest
         * @static
         * @param {busable.IScenarioRequest=} [properties] Properties to set
         * @returns {busable.ScenarioRequest} ScenarioRequest instance
         */
        ScenarioRequest.create = function create(properties) {
            return new ScenarioRequest(properties);
        };

        /**
         * Encodes the specified ScenarioRequest message. Does not implicitly {@link busable.ScenarioRequest.verify|verify} messages.
         * @function encode
         * @memberof busable.ScenarioRequest
         * @static
         * @param {busable.IScenarioRequest} message ScenarioRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScenarioRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.scenario != null && Object.hasOwnProperty.call(message, "scenario"))
                $root.busable.WeeklyScenario.encode(message.scenario, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.operatorId);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.userId);
            return writer;
        };

        /**
         * Encodes the specified ScenarioRequest message, length delimited. Does not implicitly {@link busable.ScenarioRequest.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.ScenarioRequest
         * @static
         * @param {busable.IScenarioRequest} message ScenarioRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScenarioRequest.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScenarioRequest message from the specified reader or buffer.
         * @function decode
         * @memberof busable.ScenarioRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.ScenarioRequest} ScenarioRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScenarioRequest.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.ScenarioRequest();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.scenario = $root.busable.WeeklyScenario.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 3: {
                        message.userId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ScenarioRequest message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.ScenarioRequest
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.ScenarioRequest} ScenarioRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScenarioRequest.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScenarioRequest message.
         * @function verify
         * @memberof busable.ScenarioRequest
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScenarioRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.scenario != null && message.hasOwnProperty("scenario")) {
                var error = $root.busable.WeeklyScenario.verify(message.scenario);
                if (error)
                    return "scenario." + error;
            }
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            return null;
        };

        /**
         * Creates a ScenarioRequest message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.ScenarioRequest
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.ScenarioRequest} ScenarioRequest
         */
        ScenarioRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.ScenarioRequest)
                return object;
            var message = new $root.busable.ScenarioRequest();
            if (object.scenario != null) {
                if (typeof object.scenario !== "object")
                    throw TypeError(".busable.ScenarioRequest.scenario: object expected");
                message.scenario = $root.busable.WeeklyScenario.fromObject(object.scenario);
            }
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.userId != null)
                message.userId = String(object.userId);
            return message;
        };

        /**
         * Creates a plain object from a ScenarioRequest message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.ScenarioRequest
         * @static
         * @param {busable.ScenarioRequest} message ScenarioRequest
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScenarioRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.scenario = null;
                object.operatorId = "";
                object.userId = "";
            }
            if (message.scenario != null && message.hasOwnProperty("scenario"))
                object.scenario = $root.busable.WeeklyScenario.toObject(message.scenario, options);
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            return object;
        };

        /**
         * Converts this ScenarioRequest to JSON.
         * @function toJSON
         * @memberof busable.ScenarioRequest
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScenarioRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ScenarioRequest
         * @function getTypeUrl
         * @memberof busable.ScenarioRequest
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ScenarioRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.ScenarioRequest";
        };

        return ScenarioRequest;
    })();

    busable.ScenarioResponse = (function() {

        /**
         * Properties of a ScenarioResponse.
         * @memberof busable
         * @interface IScenarioResponse
         * @property {busable.IWeeklyScenario|null} [scenario] ScenarioResponse scenario
         * @property {Array.<busable.IRosterValidation>|null} [validations] ScenarioResponse validations
         * @property {Array.<busable.IRosterSummary>|null} [rosterSummaries] ScenarioResponse rosterSummaries
         */

        /**
         * Constructs a new ScenarioResponse.
         * @memberof busable
         * @classdesc Response containing scenario data
         * @implements IScenarioResponse
         * @constructor
         * @param {busable.IScenarioResponse=} [properties] Properties to set
         */
        function ScenarioResponse(properties) {
            this.validations = [];
            this.rosterSummaries = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScenarioResponse scenario.
         * @member {busable.IWeeklyScenario|null|undefined} scenario
         * @memberof busable.ScenarioResponse
         * @instance
         */
        ScenarioResponse.prototype.scenario = null;

        /**
         * ScenarioResponse validations.
         * @member {Array.<busable.IRosterValidation>} validations
         * @memberof busable.ScenarioResponse
         * @instance
         */
        ScenarioResponse.prototype.validations = $util.emptyArray;

        /**
         * ScenarioResponse rosterSummaries.
         * @member {Array.<busable.IRosterSummary>} rosterSummaries
         * @memberof busable.ScenarioResponse
         * @instance
         */
        ScenarioResponse.prototype.rosterSummaries = $util.emptyArray;

        /**
         * Creates a new ScenarioResponse instance using the specified properties.
         * @function create
         * @memberof busable.ScenarioResponse
         * @static
         * @param {busable.IScenarioResponse=} [properties] Properties to set
         * @returns {busable.ScenarioResponse} ScenarioResponse instance
         */
        ScenarioResponse.create = function create(properties) {
            return new ScenarioResponse(properties);
        };

        /**
         * Encodes the specified ScenarioResponse message. Does not implicitly {@link busable.ScenarioResponse.verify|verify} messages.
         * @function encode
         * @memberof busable.ScenarioResponse
         * @static
         * @param {busable.IScenarioResponse} message ScenarioResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScenarioResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.scenario != null && Object.hasOwnProperty.call(message, "scenario"))
                $root.busable.WeeklyScenario.encode(message.scenario, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.validations != null && message.validations.length)
                for (var i = 0; i < message.validations.length; ++i)
                    $root.busable.RosterValidation.encode(message.validations[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.rosterSummaries != null && message.rosterSummaries.length)
                for (var i = 0; i < message.rosterSummaries.length; ++i)
                    $root.busable.RosterSummary.encode(message.rosterSummaries[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ScenarioResponse message, length delimited. Does not implicitly {@link busable.ScenarioResponse.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.ScenarioResponse
         * @static
         * @param {busable.IScenarioResponse} message ScenarioResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScenarioResponse.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScenarioResponse message from the specified reader or buffer.
         * @function decode
         * @memberof busable.ScenarioResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.ScenarioResponse} ScenarioResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScenarioResponse.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.ScenarioResponse();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.scenario = $root.busable.WeeklyScenario.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        if (!(message.validations && message.validations.length))
                            message.validations = [];
                        message.validations.push($root.busable.RosterValidation.decode(reader, reader.uint32()));
                        break;
                    }
                case 3: {
                        if (!(message.rosterSummaries && message.rosterSummaries.length))
                            message.rosterSummaries = [];
                        message.rosterSummaries.push($root.busable.RosterSummary.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ScenarioResponse message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.ScenarioResponse
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.ScenarioResponse} ScenarioResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScenarioResponse.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScenarioResponse message.
         * @function verify
         * @memberof busable.ScenarioResponse
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScenarioResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.scenario != null && message.hasOwnProperty("scenario")) {
                var error = $root.busable.WeeklyScenario.verify(message.scenario);
                if (error)
                    return "scenario." + error;
            }
            if (message.validations != null && message.hasOwnProperty("validations")) {
                if (!Array.isArray(message.validations))
                    return "validations: array expected";
                for (var i = 0; i < message.validations.length; ++i) {
                    var error = $root.busable.RosterValidation.verify(message.validations[i]);
                    if (error)
                        return "validations." + error;
                }
            }
            if (message.rosterSummaries != null && message.hasOwnProperty("rosterSummaries")) {
                if (!Array.isArray(message.rosterSummaries))
                    return "rosterSummaries: array expected";
                for (var i = 0; i < message.rosterSummaries.length; ++i) {
                    var error = $root.busable.RosterSummary.verify(message.rosterSummaries[i]);
                    if (error)
                        return "rosterSummaries." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ScenarioResponse message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.ScenarioResponse
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.ScenarioResponse} ScenarioResponse
         */
        ScenarioResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.ScenarioResponse)
                return object;
            var message = new $root.busable.ScenarioResponse();
            if (object.scenario != null) {
                if (typeof object.scenario !== "object")
                    throw TypeError(".busable.ScenarioResponse.scenario: object expected");
                message.scenario = $root.busable.WeeklyScenario.fromObject(object.scenario);
            }
            if (object.validations) {
                if (!Array.isArray(object.validations))
                    throw TypeError(".busable.ScenarioResponse.validations: array expected");
                message.validations = [];
                for (var i = 0; i < object.validations.length; ++i) {
                    if (typeof object.validations[i] !== "object")
                        throw TypeError(".busable.ScenarioResponse.validations: object expected");
                    message.validations[i] = $root.busable.RosterValidation.fromObject(object.validations[i]);
                }
            }
            if (object.rosterSummaries) {
                if (!Array.isArray(object.rosterSummaries))
                    throw TypeError(".busable.ScenarioResponse.rosterSummaries: array expected");
                message.rosterSummaries = [];
                for (var i = 0; i < object.rosterSummaries.length; ++i) {
                    if (typeof object.rosterSummaries[i] !== "object")
                        throw TypeError(".busable.ScenarioResponse.rosterSummaries: object expected");
                    message.rosterSummaries[i] = $root.busable.RosterSummary.fromObject(object.rosterSummaries[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ScenarioResponse message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.ScenarioResponse
         * @static
         * @param {busable.ScenarioResponse} message ScenarioResponse
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScenarioResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.validations = [];
                object.rosterSummaries = [];
            }
            if (options.defaults)
                object.scenario = null;
            if (message.scenario != null && message.hasOwnProperty("scenario"))
                object.scenario = $root.busable.WeeklyScenario.toObject(message.scenario, options);
            if (message.validations && message.validations.length) {
                object.validations = [];
                for (var j = 0; j < message.validations.length; ++j)
                    object.validations[j] = $root.busable.RosterValidation.toObject(message.validations[j], options);
            }
            if (message.rosterSummaries && message.rosterSummaries.length) {
                object.rosterSummaries = [];
                for (var j = 0; j < message.rosterSummaries.length; ++j)
                    object.rosterSummaries[j] = $root.busable.RosterSummary.toObject(message.rosterSummaries[j], options);
            }
            return object;
        };

        /**
         * Converts this ScenarioResponse to JSON.
         * @function toJSON
         * @memberof busable.ScenarioResponse
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScenarioResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ScenarioResponse
         * @function getTypeUrl
         * @memberof busable.ScenarioResponse
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ScenarioResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.ScenarioResponse";
        };

        return ScenarioResponse;
    })();

    busable.OtrConfig = (function() {

        /**
         * Properties of an OtrConfig.
         * @memberof busable
         * @interface IOtrConfig
         * @property {number|null} [lateThreshold] OtrConfig lateThreshold
         * @property {string|null} [onTimeColor] OtrConfig onTimeColor
         * @property {string|null} [lateColor] OtrConfig lateColor
         * @property {string|null} [earlyColor] OtrConfig earlyColor
         * @property {number|null} [earlyThreshold] OtrConfig earlyThreshold
         */

        /**
         * Constructs a new OtrConfig.
         * @memberof busable
         * @classdesc Represents an OtrConfig.
         * @implements IOtrConfig
         * @constructor
         * @param {busable.IOtrConfig=} [properties] Properties to set
         */
        function OtrConfig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OtrConfig lateThreshold.
         * @member {number} lateThreshold
         * @memberof busable.OtrConfig
         * @instance
         */
        OtrConfig.prototype.lateThreshold = 0;

        /**
         * OtrConfig onTimeColor.
         * @member {string} onTimeColor
         * @memberof busable.OtrConfig
         * @instance
         */
        OtrConfig.prototype.onTimeColor = "";

        /**
         * OtrConfig lateColor.
         * @member {string} lateColor
         * @memberof busable.OtrConfig
         * @instance
         */
        OtrConfig.prototype.lateColor = "";

        /**
         * OtrConfig earlyColor.
         * @member {string} earlyColor
         * @memberof busable.OtrConfig
         * @instance
         */
        OtrConfig.prototype.earlyColor = "";

        /**
         * OtrConfig earlyThreshold.
         * @member {number} earlyThreshold
         * @memberof busable.OtrConfig
         * @instance
         */
        OtrConfig.prototype.earlyThreshold = 0;

        /**
         * Creates a new OtrConfig instance using the specified properties.
         * @function create
         * @memberof busable.OtrConfig
         * @static
         * @param {busable.IOtrConfig=} [properties] Properties to set
         * @returns {busable.OtrConfig} OtrConfig instance
         */
        OtrConfig.create = function create(properties) {
            return new OtrConfig(properties);
        };

        /**
         * Encodes the specified OtrConfig message. Does not implicitly {@link busable.OtrConfig.verify|verify} messages.
         * @function encode
         * @memberof busable.OtrConfig
         * @static
         * @param {busable.IOtrConfig} message OtrConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtrConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.lateThreshold != null && Object.hasOwnProperty.call(message, "lateThreshold"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.lateThreshold);
            if (message.onTimeColor != null && Object.hasOwnProperty.call(message, "onTimeColor"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.onTimeColor);
            if (message.lateColor != null && Object.hasOwnProperty.call(message, "lateColor"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.lateColor);
            if (message.earlyColor != null && Object.hasOwnProperty.call(message, "earlyColor"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.earlyColor);
            if (message.earlyThreshold != null && Object.hasOwnProperty.call(message, "earlyThreshold"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.earlyThreshold);
            return writer;
        };

        /**
         * Encodes the specified OtrConfig message, length delimited. Does not implicitly {@link busable.OtrConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.OtrConfig
         * @static
         * @param {busable.IOtrConfig} message OtrConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtrConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OtrConfig message from the specified reader or buffer.
         * @function decode
         * @memberof busable.OtrConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.OtrConfig} OtrConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtrConfig.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.OtrConfig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.lateThreshold = reader.int32();
                        break;
                    }
                case 2: {
                        message.onTimeColor = reader.string();
                        break;
                    }
                case 3: {
                        message.lateColor = reader.string();
                        break;
                    }
                case 4: {
                        message.earlyColor = reader.string();
                        break;
                    }
                case 5: {
                        message.earlyThreshold = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OtrConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.OtrConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.OtrConfig} OtrConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtrConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OtrConfig message.
         * @function verify
         * @memberof busable.OtrConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OtrConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.lateThreshold != null && message.hasOwnProperty("lateThreshold"))
                if (!$util.isInteger(message.lateThreshold))
                    return "lateThreshold: integer expected";
            if (message.onTimeColor != null && message.hasOwnProperty("onTimeColor"))
                if (!$util.isString(message.onTimeColor))
                    return "onTimeColor: string expected";
            if (message.lateColor != null && message.hasOwnProperty("lateColor"))
                if (!$util.isString(message.lateColor))
                    return "lateColor: string expected";
            if (message.earlyColor != null && message.hasOwnProperty("earlyColor"))
                if (!$util.isString(message.earlyColor))
                    return "earlyColor: string expected";
            if (message.earlyThreshold != null && message.hasOwnProperty("earlyThreshold"))
                if (!$util.isInteger(message.earlyThreshold))
                    return "earlyThreshold: integer expected";
            return null;
        };

        /**
         * Creates an OtrConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.OtrConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.OtrConfig} OtrConfig
         */
        OtrConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.OtrConfig)
                return object;
            var message = new $root.busable.OtrConfig();
            if (object.lateThreshold != null)
                message.lateThreshold = object.lateThreshold | 0;
            if (object.onTimeColor != null)
                message.onTimeColor = String(object.onTimeColor);
            if (object.lateColor != null)
                message.lateColor = String(object.lateColor);
            if (object.earlyColor != null)
                message.earlyColor = String(object.earlyColor);
            if (object.earlyThreshold != null)
                message.earlyThreshold = object.earlyThreshold | 0;
            return message;
        };

        /**
         * Creates a plain object from an OtrConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.OtrConfig
         * @static
         * @param {busable.OtrConfig} message OtrConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OtrConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.lateThreshold = 0;
                object.onTimeColor = "";
                object.lateColor = "";
                object.earlyColor = "";
                object.earlyThreshold = 0;
            }
            if (message.lateThreshold != null && message.hasOwnProperty("lateThreshold"))
                object.lateThreshold = message.lateThreshold;
            if (message.onTimeColor != null && message.hasOwnProperty("onTimeColor"))
                object.onTimeColor = message.onTimeColor;
            if (message.lateColor != null && message.hasOwnProperty("lateColor"))
                object.lateColor = message.lateColor;
            if (message.earlyColor != null && message.hasOwnProperty("earlyColor"))
                object.earlyColor = message.earlyColor;
            if (message.earlyThreshold != null && message.hasOwnProperty("earlyThreshold"))
                object.earlyThreshold = message.earlyThreshold;
            return object;
        };

        /**
         * Converts this OtrConfig to JSON.
         * @function toJSON
         * @memberof busable.OtrConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OtrConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OtrConfig
         * @function getTypeUrl
         * @memberof busable.OtrConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OtrConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.OtrConfig";
        };

        return OtrConfig;
    })();

    busable.ExternalConfig = (function() {

        /**
         * Properties of an ExternalConfig.
         * @memberof busable
         * @interface IExternalConfig
         * @property {string|null} [clientId] ExternalConfig clientId
         * @property {string|null} [tenantId] ExternalConfig tenantId
         * @property {string|null} [tokenExpiry] ExternalConfig tokenExpiry
         * @property {string|null} [clientSecret] ExternalConfig clientSecret
         * @property {string|null} [accessToken] ExternalConfig accessToken
         * @property {string|null} [expiresAt] ExternalConfig expiresAt
         * @property {string|null} [refreshToken] ExternalConfig refreshToken
         */

        /**
         * Constructs a new ExternalConfig.
         * @memberof busable
         * @classdesc Represents an ExternalConfig.
         * @implements IExternalConfig
         * @constructor
         * @param {busable.IExternalConfig=} [properties] Properties to set
         */
        function ExternalConfig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExternalConfig clientId.
         * @member {string} clientId
         * @memberof busable.ExternalConfig
         * @instance
         */
        ExternalConfig.prototype.clientId = "";

        /**
         * ExternalConfig tenantId.
         * @member {string} tenantId
         * @memberof busable.ExternalConfig
         * @instance
         */
        ExternalConfig.prototype.tenantId = "";

        /**
         * ExternalConfig tokenExpiry.
         * @member {string} tokenExpiry
         * @memberof busable.ExternalConfig
         * @instance
         */
        ExternalConfig.prototype.tokenExpiry = "";

        /**
         * ExternalConfig clientSecret.
         * @member {string} clientSecret
         * @memberof busable.ExternalConfig
         * @instance
         */
        ExternalConfig.prototype.clientSecret = "";

        /**
         * ExternalConfig accessToken.
         * @member {string} accessToken
         * @memberof busable.ExternalConfig
         * @instance
         */
        ExternalConfig.prototype.accessToken = "";

        /**
         * ExternalConfig expiresAt.
         * @member {string} expiresAt
         * @memberof busable.ExternalConfig
         * @instance
         */
        ExternalConfig.prototype.expiresAt = "";

        /**
         * ExternalConfig refreshToken.
         * @member {string} refreshToken
         * @memberof busable.ExternalConfig
         * @instance
         */
        ExternalConfig.prototype.refreshToken = "";

        /**
         * Creates a new ExternalConfig instance using the specified properties.
         * @function create
         * @memberof busable.ExternalConfig
         * @static
         * @param {busable.IExternalConfig=} [properties] Properties to set
         * @returns {busable.ExternalConfig} ExternalConfig instance
         */
        ExternalConfig.create = function create(properties) {
            return new ExternalConfig(properties);
        };

        /**
         * Encodes the specified ExternalConfig message. Does not implicitly {@link busable.ExternalConfig.verify|verify} messages.
         * @function encode
         * @memberof busable.ExternalConfig
         * @static
         * @param {busable.IExternalConfig} message ExternalConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.clientId != null && Object.hasOwnProperty.call(message, "clientId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientId);
            if (message.tenantId != null && Object.hasOwnProperty.call(message, "tenantId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.tenantId);
            if (message.tokenExpiry != null && Object.hasOwnProperty.call(message, "tokenExpiry"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.tokenExpiry);
            if (message.clientSecret != null && Object.hasOwnProperty.call(message, "clientSecret"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.clientSecret);
            if (message.accessToken != null && Object.hasOwnProperty.call(message, "accessToken"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.accessToken);
            if (message.expiresAt != null && Object.hasOwnProperty.call(message, "expiresAt"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.expiresAt);
            if (message.refreshToken != null && Object.hasOwnProperty.call(message, "refreshToken"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.refreshToken);
            return writer;
        };

        /**
         * Encodes the specified ExternalConfig message, length delimited. Does not implicitly {@link busable.ExternalConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.ExternalConfig
         * @static
         * @param {busable.IExternalConfig} message ExternalConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExternalConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExternalConfig message from the specified reader or buffer.
         * @function decode
         * @memberof busable.ExternalConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.ExternalConfig} ExternalConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalConfig.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.ExternalConfig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.clientId = reader.string();
                        break;
                    }
                case 2: {
                        message.tenantId = reader.string();
                        break;
                    }
                case 3: {
                        message.tokenExpiry = reader.string();
                        break;
                    }
                case 4: {
                        message.clientSecret = reader.string();
                        break;
                    }
                case 5: {
                        message.accessToken = reader.string();
                        break;
                    }
                case 6: {
                        message.expiresAt = reader.string();
                        break;
                    }
                case 7: {
                        message.refreshToken = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExternalConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.ExternalConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.ExternalConfig} ExternalConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExternalConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExternalConfig message.
         * @function verify
         * @memberof busable.ExternalConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExternalConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.clientId != null && message.hasOwnProperty("clientId"))
                if (!$util.isString(message.clientId))
                    return "clientId: string expected";
            if (message.tenantId != null && message.hasOwnProperty("tenantId"))
                if (!$util.isString(message.tenantId))
                    return "tenantId: string expected";
            if (message.tokenExpiry != null && message.hasOwnProperty("tokenExpiry"))
                if (!$util.isString(message.tokenExpiry))
                    return "tokenExpiry: string expected";
            if (message.clientSecret != null && message.hasOwnProperty("clientSecret"))
                if (!$util.isString(message.clientSecret))
                    return "clientSecret: string expected";
            if (message.accessToken != null && message.hasOwnProperty("accessToken"))
                if (!$util.isString(message.accessToken))
                    return "accessToken: string expected";
            if (message.expiresAt != null && message.hasOwnProperty("expiresAt"))
                if (!$util.isString(message.expiresAt))
                    return "expiresAt: string expected";
            if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                if (!$util.isString(message.refreshToken))
                    return "refreshToken: string expected";
            return null;
        };

        /**
         * Creates an ExternalConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.ExternalConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.ExternalConfig} ExternalConfig
         */
        ExternalConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.ExternalConfig)
                return object;
            var message = new $root.busable.ExternalConfig();
            if (object.clientId != null)
                message.clientId = String(object.clientId);
            if (object.tenantId != null)
                message.tenantId = String(object.tenantId);
            if (object.tokenExpiry != null)
                message.tokenExpiry = String(object.tokenExpiry);
            if (object.clientSecret != null)
                message.clientSecret = String(object.clientSecret);
            if (object.accessToken != null)
                message.accessToken = String(object.accessToken);
            if (object.expiresAt != null)
                message.expiresAt = String(object.expiresAt);
            if (object.refreshToken != null)
                message.refreshToken = String(object.refreshToken);
            return message;
        };

        /**
         * Creates a plain object from an ExternalConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.ExternalConfig
         * @static
         * @param {busable.ExternalConfig} message ExternalConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExternalConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.clientId = "";
                object.tenantId = "";
                object.tokenExpiry = "";
                object.clientSecret = "";
                object.accessToken = "";
                object.expiresAt = "";
                object.refreshToken = "";
            }
            if (message.clientId != null && message.hasOwnProperty("clientId"))
                object.clientId = message.clientId;
            if (message.tenantId != null && message.hasOwnProperty("tenantId"))
                object.tenantId = message.tenantId;
            if (message.tokenExpiry != null && message.hasOwnProperty("tokenExpiry"))
                object.tokenExpiry = message.tokenExpiry;
            if (message.clientSecret != null && message.hasOwnProperty("clientSecret"))
                object.clientSecret = message.clientSecret;
            if (message.accessToken != null && message.hasOwnProperty("accessToken"))
                object.accessToken = message.accessToken;
            if (message.expiresAt != null && message.hasOwnProperty("expiresAt"))
                object.expiresAt = message.expiresAt;
            if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                object.refreshToken = message.refreshToken;
            return object;
        };

        /**
         * Converts this ExternalConfig to JSON.
         * @function toJSON
         * @memberof busable.ExternalConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExternalConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ExternalConfig
         * @function getTypeUrl
         * @memberof busable.ExternalConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ExternalConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.ExternalConfig";
        };

        return ExternalConfig;
    })();

    /**
     * PayItemRateType enum.
     * @name busable.PayItemRateType
     * @enum {number}
     * @property {number} PAY_ITEM_RATE_TYPE_UNSPECIFIED=0 PAY_ITEM_RATE_TYPE_UNSPECIFIED value
     * @property {number} PAY_ITEM_RATE_TYPE_RATEPERUNIT=1 PAY_ITEM_RATE_TYPE_RATEPERUNIT value
     * @property {number} PAY_ITEM_RATE_TYPE_FIXEDAMOUNT=2 PAY_ITEM_RATE_TYPE_FIXEDAMOUNT value
     * @property {number} PAY_ITEM_RATE_TYPE_MULTIPLE=3 PAY_ITEM_RATE_TYPE_MULTIPLE value
     */
    busable.PayItemRateType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PAY_ITEM_RATE_TYPE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "PAY_ITEM_RATE_TYPE_RATEPERUNIT"] = 1;
        values[valuesById[2] = "PAY_ITEM_RATE_TYPE_FIXEDAMOUNT"] = 2;
        values[valuesById[3] = "PAY_ITEM_RATE_TYPE_MULTIPLE"] = 3;
        return values;
    })();

    /**
     * PayItemType enum.
     * @name busable.PayItemType
     * @enum {number}
     * @property {number} PAY_ITEM_TYPE_UNSPECIFIED=0 PAY_ITEM_TYPE_UNSPECIFIED value
     * @property {number} PAY_ITEM_TYPE_EARNINGS_RATE=1 PAY_ITEM_TYPE_EARNINGS_RATE value
     * @property {number} PAY_ITEM_TYPE_LEAVE=2 PAY_ITEM_TYPE_LEAVE value
     * @property {number} PAY_ITEM_TYPE_DEDUCTION=3 PAY_ITEM_TYPE_DEDUCTION value
     * @property {number} PAY_ITEM_TYPE_REIMBURSEMENT=4 PAY_ITEM_TYPE_REIMBURSEMENT value
     */
    busable.PayItemType = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "PAY_ITEM_TYPE_UNSPECIFIED"] = 0;
        values[valuesById[1] = "PAY_ITEM_TYPE_EARNINGS_RATE"] = 1;
        values[valuesById[2] = "PAY_ITEM_TYPE_LEAVE"] = 2;
        values[valuesById[3] = "PAY_ITEM_TYPE_DEDUCTION"] = 3;
        values[valuesById[4] = "PAY_ITEM_TYPE_REIMBURSEMENT"] = 4;
        return values;
    })();

    busable.XeroPayItem = (function() {

        /**
         * Properties of a XeroPayItem.
         * @memberof busable
         * @interface IXeroPayItem
         * @property {string|null} [name] XeroPayItem name
         * @property {string|null} [rateType] XeroPayItem rateType
         * @property {string|null} [type] XeroPayItem type
         * @property {boolean|null} [isActive] XeroPayItem isActive
         * @property {string|null} [payItemId] XeroPayItem payItemId
         */

        /**
         * Constructs a new XeroPayItem.
         * @memberof busable
         * @classdesc Represents a XeroPayItem.
         * @implements IXeroPayItem
         * @constructor
         * @param {busable.IXeroPayItem=} [properties] Properties to set
         */
        function XeroPayItem(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * XeroPayItem name.
         * @member {string} name
         * @memberof busable.XeroPayItem
         * @instance
         */
        XeroPayItem.prototype.name = "";

        /**
         * XeroPayItem rateType.
         * @member {string} rateType
         * @memberof busable.XeroPayItem
         * @instance
         */
        XeroPayItem.prototype.rateType = "";

        /**
         * XeroPayItem type.
         * @member {string} type
         * @memberof busable.XeroPayItem
         * @instance
         */
        XeroPayItem.prototype.type = "";

        /**
         * XeroPayItem isActive.
         * @member {boolean} isActive
         * @memberof busable.XeroPayItem
         * @instance
         */
        XeroPayItem.prototype.isActive = false;

        /**
         * XeroPayItem payItemId.
         * @member {string} payItemId
         * @memberof busable.XeroPayItem
         * @instance
         */
        XeroPayItem.prototype.payItemId = "";

        /**
         * Creates a new XeroPayItem instance using the specified properties.
         * @function create
         * @memberof busable.XeroPayItem
         * @static
         * @param {busable.IXeroPayItem=} [properties] Properties to set
         * @returns {busable.XeroPayItem} XeroPayItem instance
         */
        XeroPayItem.create = function create(properties) {
            return new XeroPayItem(properties);
        };

        /**
         * Encodes the specified XeroPayItem message. Does not implicitly {@link busable.XeroPayItem.verify|verify} messages.
         * @function encode
         * @memberof busable.XeroPayItem
         * @static
         * @param {busable.IXeroPayItem} message XeroPayItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        XeroPayItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.rateType != null && Object.hasOwnProperty.call(message, "rateType"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.rateType);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
            if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isActive);
            if (message.payItemId != null && Object.hasOwnProperty.call(message, "payItemId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.payItemId);
            return writer;
        };

        /**
         * Encodes the specified XeroPayItem message, length delimited. Does not implicitly {@link busable.XeroPayItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.XeroPayItem
         * @static
         * @param {busable.IXeroPayItem} message XeroPayItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        XeroPayItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a XeroPayItem message from the specified reader or buffer.
         * @function decode
         * @memberof busable.XeroPayItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.XeroPayItem} XeroPayItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        XeroPayItem.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.XeroPayItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.name = reader.string();
                        break;
                    }
                case 2: {
                        message.rateType = reader.string();
                        break;
                    }
                case 3: {
                        message.type = reader.string();
                        break;
                    }
                case 4: {
                        message.isActive = reader.bool();
                        break;
                    }
                case 5: {
                        message.payItemId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a XeroPayItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.XeroPayItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.XeroPayItem} XeroPayItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        XeroPayItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a XeroPayItem message.
         * @function verify
         * @memberof busable.XeroPayItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        XeroPayItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.rateType != null && message.hasOwnProperty("rateType"))
                if (!$util.isString(message.rateType))
                    return "rateType: string expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.isActive != null && message.hasOwnProperty("isActive"))
                if (typeof message.isActive !== "boolean")
                    return "isActive: boolean expected";
            if (message.payItemId != null && message.hasOwnProperty("payItemId"))
                if (!$util.isString(message.payItemId))
                    return "payItemId: string expected";
            return null;
        };

        /**
         * Creates a XeroPayItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.XeroPayItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.XeroPayItem} XeroPayItem
         */
        XeroPayItem.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.XeroPayItem)
                return object;
            var message = new $root.busable.XeroPayItem();
            if (object.name != null)
                message.name = String(object.name);
            if (object.rateType != null)
                message.rateType = String(object.rateType);
            if (object.type != null)
                message.type = String(object.type);
            if (object.isActive != null)
                message.isActive = Boolean(object.isActive);
            if (object.payItemId != null)
                message.payItemId = String(object.payItemId);
            return message;
        };

        /**
         * Creates a plain object from a XeroPayItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.XeroPayItem
         * @static
         * @param {busable.XeroPayItem} message XeroPayItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        XeroPayItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                object.rateType = "";
                object.type = "";
                object.isActive = false;
                object.payItemId = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.rateType != null && message.hasOwnProperty("rateType"))
                object.rateType = message.rateType;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.isActive != null && message.hasOwnProperty("isActive"))
                object.isActive = message.isActive;
            if (message.payItemId != null && message.hasOwnProperty("payItemId"))
                object.payItemId = message.payItemId;
            return object;
        };

        /**
         * Converts this XeroPayItem to JSON.
         * @function toJSON
         * @memberof busable.XeroPayItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        XeroPayItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for XeroPayItem
         * @function getTypeUrl
         * @memberof busable.XeroPayItem
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        XeroPayItem.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.XeroPayItem";
        };

        return XeroPayItem;
    })();

    busable.XeroConfig = (function() {

        /**
         * Properties of a XeroConfig.
         * @memberof busable
         * @interface IXeroConfig
         * @property {Object.<string,string>|null} [payItemMappings] XeroConfig payItemMappings
         * @property {Array.<busable.IXeroPayItem>|null} [availablePayItems] XeroConfig availablePayItems
         */

        /**
         * Constructs a new XeroConfig.
         * @memberof busable
         * @classdesc Represents a XeroConfig.
         * @implements IXeroConfig
         * @constructor
         * @param {busable.IXeroConfig=} [properties] Properties to set
         */
        function XeroConfig(properties) {
            this.payItemMappings = {};
            this.availablePayItems = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * XeroConfig payItemMappings.
         * @member {Object.<string,string>} payItemMappings
         * @memberof busable.XeroConfig
         * @instance
         */
        XeroConfig.prototype.payItemMappings = $util.emptyObject;

        /**
         * XeroConfig availablePayItems.
         * @member {Array.<busable.IXeroPayItem>} availablePayItems
         * @memberof busable.XeroConfig
         * @instance
         */
        XeroConfig.prototype.availablePayItems = $util.emptyArray;

        /**
         * Creates a new XeroConfig instance using the specified properties.
         * @function create
         * @memberof busable.XeroConfig
         * @static
         * @param {busable.IXeroConfig=} [properties] Properties to set
         * @returns {busable.XeroConfig} XeroConfig instance
         */
        XeroConfig.create = function create(properties) {
            return new XeroConfig(properties);
        };

        /**
         * Encodes the specified XeroConfig message. Does not implicitly {@link busable.XeroConfig.verify|verify} messages.
         * @function encode
         * @memberof busable.XeroConfig
         * @static
         * @param {busable.IXeroConfig} message XeroConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        XeroConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.payItemMappings != null && Object.hasOwnProperty.call(message, "payItemMappings"))
                for (var keys = Object.keys(message.payItemMappings), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.payItemMappings[keys[i]]).ldelim();
            if (message.availablePayItems != null && message.availablePayItems.length)
                for (var i = 0; i < message.availablePayItems.length; ++i)
                    $root.busable.XeroPayItem.encode(message.availablePayItems[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified XeroConfig message, length delimited. Does not implicitly {@link busable.XeroConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.XeroConfig
         * @static
         * @param {busable.IXeroConfig} message XeroConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        XeroConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a XeroConfig message from the specified reader or buffer.
         * @function decode
         * @memberof busable.XeroConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.XeroConfig} XeroConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        XeroConfig.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.XeroConfig(), key, value;
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (message.payItemMappings === $util.emptyObject)
                            message.payItemMappings = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = "";
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = reader.string();
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.payItemMappings[key] = value;
                        break;
                    }
                case 2: {
                        if (!(message.availablePayItems && message.availablePayItems.length))
                            message.availablePayItems = [];
                        message.availablePayItems.push($root.busable.XeroPayItem.decode(reader, reader.uint32()));
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a XeroConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.XeroConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.XeroConfig} XeroConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        XeroConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a XeroConfig message.
         * @function verify
         * @memberof busable.XeroConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        XeroConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.payItemMappings != null && message.hasOwnProperty("payItemMappings")) {
                if (!$util.isObject(message.payItemMappings))
                    return "payItemMappings: object expected";
                var key = Object.keys(message.payItemMappings);
                for (var i = 0; i < key.length; ++i)
                    if (!$util.isString(message.payItemMappings[key[i]]))
                        return "payItemMappings: string{k:string} expected";
            }
            if (message.availablePayItems != null && message.hasOwnProperty("availablePayItems")) {
                if (!Array.isArray(message.availablePayItems))
                    return "availablePayItems: array expected";
                for (var i = 0; i < message.availablePayItems.length; ++i) {
                    var error = $root.busable.XeroPayItem.verify(message.availablePayItems[i]);
                    if (error)
                        return "availablePayItems." + error;
                }
            }
            return null;
        };

        /**
         * Creates a XeroConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.XeroConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.XeroConfig} XeroConfig
         */
        XeroConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.XeroConfig)
                return object;
            var message = new $root.busable.XeroConfig();
            if (object.payItemMappings) {
                if (typeof object.payItemMappings !== "object")
                    throw TypeError(".busable.XeroConfig.payItemMappings: object expected");
                message.payItemMappings = {};
                for (var keys = Object.keys(object.payItemMappings), i = 0; i < keys.length; ++i)
                    message.payItemMappings[keys[i]] = String(object.payItemMappings[keys[i]]);
            }
            if (object.availablePayItems) {
                if (!Array.isArray(object.availablePayItems))
                    throw TypeError(".busable.XeroConfig.availablePayItems: array expected");
                message.availablePayItems = [];
                for (var i = 0; i < object.availablePayItems.length; ++i) {
                    if (typeof object.availablePayItems[i] !== "object")
                        throw TypeError(".busable.XeroConfig.availablePayItems: object expected");
                    message.availablePayItems[i] = $root.busable.XeroPayItem.fromObject(object.availablePayItems[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a XeroConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.XeroConfig
         * @static
         * @param {busable.XeroConfig} message XeroConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        XeroConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.availablePayItems = [];
            if (options.objects || options.defaults)
                object.payItemMappings = {};
            var keys2;
            if (message.payItemMappings && (keys2 = Object.keys(message.payItemMappings)).length) {
                object.payItemMappings = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.payItemMappings[keys2[j]] = message.payItemMappings[keys2[j]];
            }
            if (message.availablePayItems && message.availablePayItems.length) {
                object.availablePayItems = [];
                for (var j = 0; j < message.availablePayItems.length; ++j)
                    object.availablePayItems[j] = $root.busable.XeroPayItem.toObject(message.availablePayItems[j], options);
            }
            return object;
        };

        /**
         * Converts this XeroConfig to JSON.
         * @function toJSON
         * @memberof busable.XeroConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        XeroConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for XeroConfig
         * @function getTypeUrl
         * @memberof busable.XeroConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        XeroConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.XeroConfig";
        };

        return XeroConfig;
    })();

    busable.CharterConfig = (function() {

        /**
         * Properties of a CharterConfig.
         * @memberof busable
         * @interface ICharterConfig
         * @property {number|null} [preDepartureCheck] CharterConfig preDepartureCheck
         * @property {number|null} [postDepartureCheck] CharterConfig postDepartureCheck
         */

        /**
         * Constructs a new CharterConfig.
         * @memberof busable
         * @classdesc Represents a CharterConfig.
         * @implements ICharterConfig
         * @constructor
         * @param {busable.ICharterConfig=} [properties] Properties to set
         */
        function CharterConfig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CharterConfig preDepartureCheck.
         * @member {number} preDepartureCheck
         * @memberof busable.CharterConfig
         * @instance
         */
        CharterConfig.prototype.preDepartureCheck = 0;

        /**
         * CharterConfig postDepartureCheck.
         * @member {number} postDepartureCheck
         * @memberof busable.CharterConfig
         * @instance
         */
        CharterConfig.prototype.postDepartureCheck = 0;

        /**
         * Creates a new CharterConfig instance using the specified properties.
         * @function create
         * @memberof busable.CharterConfig
         * @static
         * @param {busable.ICharterConfig=} [properties] Properties to set
         * @returns {busable.CharterConfig} CharterConfig instance
         */
        CharterConfig.create = function create(properties) {
            return new CharterConfig(properties);
        };

        /**
         * Encodes the specified CharterConfig message. Does not implicitly {@link busable.CharterConfig.verify|verify} messages.
         * @function encode
         * @memberof busable.CharterConfig
         * @static
         * @param {busable.ICharterConfig} message CharterConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CharterConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.preDepartureCheck != null && Object.hasOwnProperty.call(message, "preDepartureCheck"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.preDepartureCheck);
            if (message.postDepartureCheck != null && Object.hasOwnProperty.call(message, "postDepartureCheck"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.postDepartureCheck);
            return writer;
        };

        /**
         * Encodes the specified CharterConfig message, length delimited. Does not implicitly {@link busable.CharterConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.CharterConfig
         * @static
         * @param {busable.ICharterConfig} message CharterConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CharterConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CharterConfig message from the specified reader or buffer.
         * @function decode
         * @memberof busable.CharterConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.CharterConfig} CharterConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CharterConfig.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.CharterConfig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.preDepartureCheck = reader.int32();
                        break;
                    }
                case 2: {
                        message.postDepartureCheck = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CharterConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.CharterConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.CharterConfig} CharterConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CharterConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CharterConfig message.
         * @function verify
         * @memberof busable.CharterConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CharterConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.preDepartureCheck != null && message.hasOwnProperty("preDepartureCheck"))
                if (!$util.isInteger(message.preDepartureCheck))
                    return "preDepartureCheck: integer expected";
            if (message.postDepartureCheck != null && message.hasOwnProperty("postDepartureCheck"))
                if (!$util.isInteger(message.postDepartureCheck))
                    return "postDepartureCheck: integer expected";
            return null;
        };

        /**
         * Creates a CharterConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.CharterConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.CharterConfig} CharterConfig
         */
        CharterConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.CharterConfig)
                return object;
            var message = new $root.busable.CharterConfig();
            if (object.preDepartureCheck != null)
                message.preDepartureCheck = object.preDepartureCheck | 0;
            if (object.postDepartureCheck != null)
                message.postDepartureCheck = object.postDepartureCheck | 0;
            return message;
        };

        /**
         * Creates a plain object from a CharterConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.CharterConfig
         * @static
         * @param {busable.CharterConfig} message CharterConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CharterConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.preDepartureCheck = 0;
                object.postDepartureCheck = 0;
            }
            if (message.preDepartureCheck != null && message.hasOwnProperty("preDepartureCheck"))
                object.preDepartureCheck = message.preDepartureCheck;
            if (message.postDepartureCheck != null && message.hasOwnProperty("postDepartureCheck"))
                object.postDepartureCheck = message.postDepartureCheck;
            return object;
        };

        /**
         * Converts this CharterConfig to JSON.
         * @function toJSON
         * @memberof busable.CharterConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CharterConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for CharterConfig
         * @function getTypeUrl
         * @memberof busable.CharterConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        CharterConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.CharterConfig";
        };

        return CharterConfig;
    })();

    busable.ComplianceConfig = (function() {

        /**
         * Properties of a ComplianceConfig.
         * @memberof busable
         * @interface IComplianceConfig
         * @property {boolean|null} [accept] ComplianceConfig accept
         */

        /**
         * Constructs a new ComplianceConfig.
         * @memberof busable
         * @classdesc Represents a ComplianceConfig.
         * @implements IComplianceConfig
         * @constructor
         * @param {busable.IComplianceConfig=} [properties] Properties to set
         */
        function ComplianceConfig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComplianceConfig accept.
         * @member {boolean} accept
         * @memberof busable.ComplianceConfig
         * @instance
         */
        ComplianceConfig.prototype.accept = false;

        /**
         * Creates a new ComplianceConfig instance using the specified properties.
         * @function create
         * @memberof busable.ComplianceConfig
         * @static
         * @param {busable.IComplianceConfig=} [properties] Properties to set
         * @returns {busable.ComplianceConfig} ComplianceConfig instance
         */
        ComplianceConfig.create = function create(properties) {
            return new ComplianceConfig(properties);
        };

        /**
         * Encodes the specified ComplianceConfig message. Does not implicitly {@link busable.ComplianceConfig.verify|verify} messages.
         * @function encode
         * @memberof busable.ComplianceConfig
         * @static
         * @param {busable.IComplianceConfig} message ComplianceConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComplianceConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.accept != null && Object.hasOwnProperty.call(message, "accept"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.accept);
            return writer;
        };

        /**
         * Encodes the specified ComplianceConfig message, length delimited. Does not implicitly {@link busable.ComplianceConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.ComplianceConfig
         * @static
         * @param {busable.IComplianceConfig} message ComplianceConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComplianceConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComplianceConfig message from the specified reader or buffer.
         * @function decode
         * @memberof busable.ComplianceConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.ComplianceConfig} ComplianceConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComplianceConfig.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.ComplianceConfig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.accept = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ComplianceConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.ComplianceConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.ComplianceConfig} ComplianceConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComplianceConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComplianceConfig message.
         * @function verify
         * @memberof busable.ComplianceConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComplianceConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.accept != null && message.hasOwnProperty("accept"))
                if (typeof message.accept !== "boolean")
                    return "accept: boolean expected";
            return null;
        };

        /**
         * Creates a ComplianceConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.ComplianceConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.ComplianceConfig} ComplianceConfig
         */
        ComplianceConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.ComplianceConfig)
                return object;
            var message = new $root.busable.ComplianceConfig();
            if (object.accept != null)
                message.accept = Boolean(object.accept);
            return message;
        };

        /**
         * Creates a plain object from a ComplianceConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.ComplianceConfig
         * @static
         * @param {busable.ComplianceConfig} message ComplianceConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComplianceConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.accept = false;
            if (message.accept != null && message.hasOwnProperty("accept"))
                object.accept = message.accept;
            return object;
        };

        /**
         * Converts this ComplianceConfig to JSON.
         * @function toJSON
         * @memberof busable.ComplianceConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComplianceConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ComplianceConfig
         * @function getTypeUrl
         * @memberof busable.ComplianceConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ComplianceConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.ComplianceConfig";
        };

        return ComplianceConfig;
    })();

    busable.BrandingConfig = (function() {

        /**
         * Properties of a BrandingConfig.
         * @memberof busable
         * @interface IBrandingConfig
         * @property {string|null} [companyPrimaryColour] BrandingConfig companyPrimaryColour
         * @property {string|null} [companySecondaryColour] BrandingConfig companySecondaryColour
         */

        /**
         * Constructs a new BrandingConfig.
         * @memberof busable
         * @classdesc Represents a BrandingConfig.
         * @implements IBrandingConfig
         * @constructor
         * @param {busable.IBrandingConfig=} [properties] Properties to set
         */
        function BrandingConfig(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BrandingConfig companyPrimaryColour.
         * @member {string} companyPrimaryColour
         * @memberof busable.BrandingConfig
         * @instance
         */
        BrandingConfig.prototype.companyPrimaryColour = "";

        /**
         * BrandingConfig companySecondaryColour.
         * @member {string} companySecondaryColour
         * @memberof busable.BrandingConfig
         * @instance
         */
        BrandingConfig.prototype.companySecondaryColour = "";

        /**
         * Creates a new BrandingConfig instance using the specified properties.
         * @function create
         * @memberof busable.BrandingConfig
         * @static
         * @param {busable.IBrandingConfig=} [properties] Properties to set
         * @returns {busable.BrandingConfig} BrandingConfig instance
         */
        BrandingConfig.create = function create(properties) {
            return new BrandingConfig(properties);
        };

        /**
         * Encodes the specified BrandingConfig message. Does not implicitly {@link busable.BrandingConfig.verify|verify} messages.
         * @function encode
         * @memberof busable.BrandingConfig
         * @static
         * @param {busable.IBrandingConfig} message BrandingConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BrandingConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.companyPrimaryColour != null && Object.hasOwnProperty.call(message, "companyPrimaryColour"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.companyPrimaryColour);
            if (message.companySecondaryColour != null && Object.hasOwnProperty.call(message, "companySecondaryColour"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.companySecondaryColour);
            return writer;
        };

        /**
         * Encodes the specified BrandingConfig message, length delimited. Does not implicitly {@link busable.BrandingConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.BrandingConfig
         * @static
         * @param {busable.IBrandingConfig} message BrandingConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BrandingConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BrandingConfig message from the specified reader or buffer.
         * @function decode
         * @memberof busable.BrandingConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.BrandingConfig} BrandingConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BrandingConfig.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.BrandingConfig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.companyPrimaryColour = reader.string();
                        break;
                    }
                case 2: {
                        message.companySecondaryColour = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BrandingConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.BrandingConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.BrandingConfig} BrandingConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BrandingConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BrandingConfig message.
         * @function verify
         * @memberof busable.BrandingConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BrandingConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.companyPrimaryColour != null && message.hasOwnProperty("companyPrimaryColour"))
                if (!$util.isString(message.companyPrimaryColour))
                    return "companyPrimaryColour: string expected";
            if (message.companySecondaryColour != null && message.hasOwnProperty("companySecondaryColour"))
                if (!$util.isString(message.companySecondaryColour))
                    return "companySecondaryColour: string expected";
            return null;
        };

        /**
         * Creates a BrandingConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.BrandingConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.BrandingConfig} BrandingConfig
         */
        BrandingConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.BrandingConfig)
                return object;
            var message = new $root.busable.BrandingConfig();
            if (object.companyPrimaryColour != null)
                message.companyPrimaryColour = String(object.companyPrimaryColour);
            if (object.companySecondaryColour != null)
                message.companySecondaryColour = String(object.companySecondaryColour);
            return message;
        };

        /**
         * Creates a plain object from a BrandingConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.BrandingConfig
         * @static
         * @param {busable.BrandingConfig} message BrandingConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BrandingConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.companyPrimaryColour = "";
                object.companySecondaryColour = "";
            }
            if (message.companyPrimaryColour != null && message.hasOwnProperty("companyPrimaryColour"))
                object.companyPrimaryColour = message.companyPrimaryColour;
            if (message.companySecondaryColour != null && message.hasOwnProperty("companySecondaryColour"))
                object.companySecondaryColour = message.companySecondaryColour;
            return object;
        };

        /**
         * Converts this BrandingConfig to JSON.
         * @function toJSON
         * @memberof busable.BrandingConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BrandingConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for BrandingConfig
         * @function getTypeUrl
         * @memberof busable.BrandingConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        BrandingConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.BrandingConfig";
        };

        return BrandingConfig;
    })();

    busable.DepotDisplayConfig = (function() {

        /**
         * Properties of a DepotDisplayConfig.
         * @memberof busable
         * @interface IDepotDisplayConfig
         * @property {number|null} [fontSize] DepotDisplayConfig fontSize
         * @property {Array.<string>|null} [footerMessages] DepotDisplayConfig footerMessages
         * @property {number|null} [scrollSpeed] DepotDisplayConfig scrollSpeed
         */

        /**
         * Constructs a new DepotDisplayConfig.
         * @memberof busable
         * @classdesc Represents a DepotDisplayConfig.
         * @implements IDepotDisplayConfig
         * @constructor
         * @param {busable.IDepotDisplayConfig=} [properties] Properties to set
         */
        function DepotDisplayConfig(properties) {
            this.footerMessages = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DepotDisplayConfig fontSize.
         * @member {number} fontSize
         * @memberof busable.DepotDisplayConfig
         * @instance
         */
        DepotDisplayConfig.prototype.fontSize = 0;

        /**
         * DepotDisplayConfig footerMessages.
         * @member {Array.<string>} footerMessages
         * @memberof busable.DepotDisplayConfig
         * @instance
         */
        DepotDisplayConfig.prototype.footerMessages = $util.emptyArray;

        /**
         * DepotDisplayConfig scrollSpeed.
         * @member {number} scrollSpeed
         * @memberof busable.DepotDisplayConfig
         * @instance
         */
        DepotDisplayConfig.prototype.scrollSpeed = 0;

        /**
         * Creates a new DepotDisplayConfig instance using the specified properties.
         * @function create
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {busable.IDepotDisplayConfig=} [properties] Properties to set
         * @returns {busable.DepotDisplayConfig} DepotDisplayConfig instance
         */
        DepotDisplayConfig.create = function create(properties) {
            return new DepotDisplayConfig(properties);
        };

        /**
         * Encodes the specified DepotDisplayConfig message. Does not implicitly {@link busable.DepotDisplayConfig.verify|verify} messages.
         * @function encode
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {busable.IDepotDisplayConfig} message DepotDisplayConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DepotDisplayConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.fontSize != null && Object.hasOwnProperty.call(message, "fontSize"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fontSize);
            if (message.footerMessages != null && message.footerMessages.length)
                for (var i = 0; i < message.footerMessages.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.footerMessages[i]);
            if (message.scrollSpeed != null && Object.hasOwnProperty.call(message, "scrollSpeed"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.scrollSpeed);
            return writer;
        };

        /**
         * Encodes the specified DepotDisplayConfig message, length delimited. Does not implicitly {@link busable.DepotDisplayConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {busable.IDepotDisplayConfig} message DepotDisplayConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DepotDisplayConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DepotDisplayConfig message from the specified reader or buffer.
         * @function decode
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.DepotDisplayConfig} DepotDisplayConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DepotDisplayConfig.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.DepotDisplayConfig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.fontSize = reader.int32();
                        break;
                    }
                case 2: {
                        if (!(message.footerMessages && message.footerMessages.length))
                            message.footerMessages = [];
                        message.footerMessages.push(reader.string());
                        break;
                    }
                case 3: {
                        message.scrollSpeed = reader.int32();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DepotDisplayConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.DepotDisplayConfig} DepotDisplayConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DepotDisplayConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DepotDisplayConfig message.
         * @function verify
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DepotDisplayConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.fontSize != null && message.hasOwnProperty("fontSize"))
                if (!$util.isInteger(message.fontSize))
                    return "fontSize: integer expected";
            if (message.footerMessages != null && message.hasOwnProperty("footerMessages")) {
                if (!Array.isArray(message.footerMessages))
                    return "footerMessages: array expected";
                for (var i = 0; i < message.footerMessages.length; ++i)
                    if (!$util.isString(message.footerMessages[i]))
                        return "footerMessages: string[] expected";
            }
            if (message.scrollSpeed != null && message.hasOwnProperty("scrollSpeed"))
                if (!$util.isInteger(message.scrollSpeed))
                    return "scrollSpeed: integer expected";
            return null;
        };

        /**
         * Creates a DepotDisplayConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.DepotDisplayConfig} DepotDisplayConfig
         */
        DepotDisplayConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.DepotDisplayConfig)
                return object;
            var message = new $root.busable.DepotDisplayConfig();
            if (object.fontSize != null)
                message.fontSize = object.fontSize | 0;
            if (object.footerMessages) {
                if (!Array.isArray(object.footerMessages))
                    throw TypeError(".busable.DepotDisplayConfig.footerMessages: array expected");
                message.footerMessages = [];
                for (var i = 0; i < object.footerMessages.length; ++i)
                    message.footerMessages[i] = String(object.footerMessages[i]);
            }
            if (object.scrollSpeed != null)
                message.scrollSpeed = object.scrollSpeed | 0;
            return message;
        };

        /**
         * Creates a plain object from a DepotDisplayConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {busable.DepotDisplayConfig} message DepotDisplayConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DepotDisplayConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.footerMessages = [];
            if (options.defaults) {
                object.fontSize = 0;
                object.scrollSpeed = 0;
            }
            if (message.fontSize != null && message.hasOwnProperty("fontSize"))
                object.fontSize = message.fontSize;
            if (message.footerMessages && message.footerMessages.length) {
                object.footerMessages = [];
                for (var j = 0; j < message.footerMessages.length; ++j)
                    object.footerMessages[j] = message.footerMessages[j];
            }
            if (message.scrollSpeed != null && message.hasOwnProperty("scrollSpeed"))
                object.scrollSpeed = message.scrollSpeed;
            return object;
        };

        /**
         * Converts this DepotDisplayConfig to JSON.
         * @function toJSON
         * @memberof busable.DepotDisplayConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DepotDisplayConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for DepotDisplayConfig
         * @function getTypeUrl
         * @memberof busable.DepotDisplayConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        DepotDisplayConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.DepotDisplayConfig";
        };

        return DepotDisplayConfig;
    })();

    busable.OperatorOptions = (function() {

        /**
         * Properties of an OperatorOptions.
         * @memberof busable
         * @interface IOperatorOptions
         * @property {busable.IOtrConfig|null} [otrConfig] OperatorOptions otrConfig
         * @property {busable.IExternalConfig|null} [external] OperatorOptions external
         * @property {busable.IXeroConfig|null} [xero] OperatorOptions xero
         * @property {busable.ICharterConfig|null} [charter] OperatorOptions charter
         * @property {busable.IComplianceConfig|null} [compliance] OperatorOptions compliance
         * @property {busable.IBrandingConfig|null} [branding] OperatorOptions branding
         * @property {busable.IDepotDisplayConfig|null} [depotDisplay] OperatorOptions depotDisplay
         */

        /**
         * Constructs a new OperatorOptions.
         * @memberof busable
         * @classdesc Represents an OperatorOptions.
         * @implements IOperatorOptions
         * @constructor
         * @param {busable.IOperatorOptions=} [properties] Properties to set
         */
        function OperatorOptions(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OperatorOptions otrConfig.
         * @member {busable.IOtrConfig|null|undefined} otrConfig
         * @memberof busable.OperatorOptions
         * @instance
         */
        OperatorOptions.prototype.otrConfig = null;

        /**
         * OperatorOptions external.
         * @member {busable.IExternalConfig|null|undefined} external
         * @memberof busable.OperatorOptions
         * @instance
         */
        OperatorOptions.prototype.external = null;

        /**
         * OperatorOptions xero.
         * @member {busable.IXeroConfig|null|undefined} xero
         * @memberof busable.OperatorOptions
         * @instance
         */
        OperatorOptions.prototype.xero = null;

        /**
         * OperatorOptions charter.
         * @member {busable.ICharterConfig|null|undefined} charter
         * @memberof busable.OperatorOptions
         * @instance
         */
        OperatorOptions.prototype.charter = null;

        /**
         * OperatorOptions compliance.
         * @member {busable.IComplianceConfig|null|undefined} compliance
         * @memberof busable.OperatorOptions
         * @instance
         */
        OperatorOptions.prototype.compliance = null;

        /**
         * OperatorOptions branding.
         * @member {busable.IBrandingConfig|null|undefined} branding
         * @memberof busable.OperatorOptions
         * @instance
         */
        OperatorOptions.prototype.branding = null;

        /**
         * OperatorOptions depotDisplay.
         * @member {busable.IDepotDisplayConfig|null|undefined} depotDisplay
         * @memberof busable.OperatorOptions
         * @instance
         */
        OperatorOptions.prototype.depotDisplay = null;

        /**
         * Creates a new OperatorOptions instance using the specified properties.
         * @function create
         * @memberof busable.OperatorOptions
         * @static
         * @param {busable.IOperatorOptions=} [properties] Properties to set
         * @returns {busable.OperatorOptions} OperatorOptions instance
         */
        OperatorOptions.create = function create(properties) {
            return new OperatorOptions(properties);
        };

        /**
         * Encodes the specified OperatorOptions message. Does not implicitly {@link busable.OperatorOptions.verify|verify} messages.
         * @function encode
         * @memberof busable.OperatorOptions
         * @static
         * @param {busable.IOperatorOptions} message OperatorOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperatorOptions.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.otrConfig != null && Object.hasOwnProperty.call(message, "otrConfig"))
                $root.busable.OtrConfig.encode(message.otrConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.external != null && Object.hasOwnProperty.call(message, "external"))
                $root.busable.ExternalConfig.encode(message.external, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.xero != null && Object.hasOwnProperty.call(message, "xero"))
                $root.busable.XeroConfig.encode(message.xero, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.charter != null && Object.hasOwnProperty.call(message, "charter"))
                $root.busable.CharterConfig.encode(message.charter, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.compliance != null && Object.hasOwnProperty.call(message, "compliance"))
                $root.busable.ComplianceConfig.encode(message.compliance, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.branding != null && Object.hasOwnProperty.call(message, "branding"))
                $root.busable.BrandingConfig.encode(message.branding, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.depotDisplay != null && Object.hasOwnProperty.call(message, "depotDisplay"))
                $root.busable.DepotDisplayConfig.encode(message.depotDisplay, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OperatorOptions message, length delimited. Does not implicitly {@link busable.OperatorOptions.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.OperatorOptions
         * @static
         * @param {busable.IOperatorOptions} message OperatorOptions message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperatorOptions.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OperatorOptions message from the specified reader or buffer.
         * @function decode
         * @memberof busable.OperatorOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.OperatorOptions} OperatorOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperatorOptions.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.OperatorOptions();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.otrConfig = $root.busable.OtrConfig.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.external = $root.busable.ExternalConfig.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.xero = $root.busable.XeroConfig.decode(reader, reader.uint32());
                        break;
                    }
                case 4: {
                        message.charter = $root.busable.CharterConfig.decode(reader, reader.uint32());
                        break;
                    }
                case 5: {
                        message.compliance = $root.busable.ComplianceConfig.decode(reader, reader.uint32());
                        break;
                    }
                case 6: {
                        message.branding = $root.busable.BrandingConfig.decode(reader, reader.uint32());
                        break;
                    }
                case 7: {
                        message.depotDisplay = $root.busable.DepotDisplayConfig.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OperatorOptions message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.OperatorOptions
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.OperatorOptions} OperatorOptions
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperatorOptions.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OperatorOptions message.
         * @function verify
         * @memberof busable.OperatorOptions
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OperatorOptions.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.otrConfig != null && message.hasOwnProperty("otrConfig")) {
                var error = $root.busable.OtrConfig.verify(message.otrConfig);
                if (error)
                    return "otrConfig." + error;
            }
            if (message.external != null && message.hasOwnProperty("external")) {
                var error = $root.busable.ExternalConfig.verify(message.external);
                if (error)
                    return "external." + error;
            }
            if (message.xero != null && message.hasOwnProperty("xero")) {
                var error = $root.busable.XeroConfig.verify(message.xero);
                if (error)
                    return "xero." + error;
            }
            if (message.charter != null && message.hasOwnProperty("charter")) {
                var error = $root.busable.CharterConfig.verify(message.charter);
                if (error)
                    return "charter." + error;
            }
            if (message.compliance != null && message.hasOwnProperty("compliance")) {
                var error = $root.busable.ComplianceConfig.verify(message.compliance);
                if (error)
                    return "compliance." + error;
            }
            if (message.branding != null && message.hasOwnProperty("branding")) {
                var error = $root.busable.BrandingConfig.verify(message.branding);
                if (error)
                    return "branding." + error;
            }
            if (message.depotDisplay != null && message.hasOwnProperty("depotDisplay")) {
                var error = $root.busable.DepotDisplayConfig.verify(message.depotDisplay);
                if (error)
                    return "depotDisplay." + error;
            }
            return null;
        };

        /**
         * Creates an OperatorOptions message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.OperatorOptions
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.OperatorOptions} OperatorOptions
         */
        OperatorOptions.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.OperatorOptions)
                return object;
            var message = new $root.busable.OperatorOptions();
            if (object.otrConfig != null) {
                if (typeof object.otrConfig !== "object")
                    throw TypeError(".busable.OperatorOptions.otrConfig: object expected");
                message.otrConfig = $root.busable.OtrConfig.fromObject(object.otrConfig);
            }
            if (object.external != null) {
                if (typeof object.external !== "object")
                    throw TypeError(".busable.OperatorOptions.external: object expected");
                message.external = $root.busable.ExternalConfig.fromObject(object.external);
            }
            if (object.xero != null) {
                if (typeof object.xero !== "object")
                    throw TypeError(".busable.OperatorOptions.xero: object expected");
                message.xero = $root.busable.XeroConfig.fromObject(object.xero);
            }
            if (object.charter != null) {
                if (typeof object.charter !== "object")
                    throw TypeError(".busable.OperatorOptions.charter: object expected");
                message.charter = $root.busable.CharterConfig.fromObject(object.charter);
            }
            if (object.compliance != null) {
                if (typeof object.compliance !== "object")
                    throw TypeError(".busable.OperatorOptions.compliance: object expected");
                message.compliance = $root.busable.ComplianceConfig.fromObject(object.compliance);
            }
            if (object.branding != null) {
                if (typeof object.branding !== "object")
                    throw TypeError(".busable.OperatorOptions.branding: object expected");
                message.branding = $root.busable.BrandingConfig.fromObject(object.branding);
            }
            if (object.depotDisplay != null) {
                if (typeof object.depotDisplay !== "object")
                    throw TypeError(".busable.OperatorOptions.depotDisplay: object expected");
                message.depotDisplay = $root.busable.DepotDisplayConfig.fromObject(object.depotDisplay);
            }
            return message;
        };

        /**
         * Creates a plain object from an OperatorOptions message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.OperatorOptions
         * @static
         * @param {busable.OperatorOptions} message OperatorOptions
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OperatorOptions.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.otrConfig = null;
                object.external = null;
                object.xero = null;
                object.charter = null;
                object.compliance = null;
                object.branding = null;
                object.depotDisplay = null;
            }
            if (message.otrConfig != null && message.hasOwnProperty("otrConfig"))
                object.otrConfig = $root.busable.OtrConfig.toObject(message.otrConfig, options);
            if (message.external != null && message.hasOwnProperty("external"))
                object.external = $root.busable.ExternalConfig.toObject(message.external, options);
            if (message.xero != null && message.hasOwnProperty("xero"))
                object.xero = $root.busable.XeroConfig.toObject(message.xero, options);
            if (message.charter != null && message.hasOwnProperty("charter"))
                object.charter = $root.busable.CharterConfig.toObject(message.charter, options);
            if (message.compliance != null && message.hasOwnProperty("compliance"))
                object.compliance = $root.busable.ComplianceConfig.toObject(message.compliance, options);
            if (message.branding != null && message.hasOwnProperty("branding"))
                object.branding = $root.busable.BrandingConfig.toObject(message.branding, options);
            if (message.depotDisplay != null && message.hasOwnProperty("depotDisplay"))
                object.depotDisplay = $root.busable.DepotDisplayConfig.toObject(message.depotDisplay, options);
            return object;
        };

        /**
         * Converts this OperatorOptions to JSON.
         * @function toJSON
         * @memberof busable.OperatorOptions
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OperatorOptions.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OperatorOptions
         * @function getTypeUrl
         * @memberof busable.OperatorOptions
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OperatorOptions.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.OperatorOptions";
        };

        return OperatorOptions;
    })();

    busable.GtfsConfig = (function() {

        /**
         * Properties of a GtfsConfig.
         * @memberof busable
         * @interface IGtfsConfig
         * @property {string|null} [action] GtfsConfig action
         * @property {Array.<string>|null} [exts] GtfsConfig exts
         * @property {boolean|null} [enabled] GtfsConfig enabled
         */

        /**
         * Constructs a new GtfsConfig.
         * @memberof busable
         * @classdesc Represents a GtfsConfig.
         * @implements IGtfsConfig
         * @constructor
         * @param {busable.IGtfsConfig=} [properties] Properties to set
         */
        function GtfsConfig(properties) {
            this.exts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GtfsConfig action.
         * @member {string} action
         * @memberof busable.GtfsConfig
         * @instance
         */
        GtfsConfig.prototype.action = "";

        /**
         * GtfsConfig exts.
         * @member {Array.<string>} exts
         * @memberof busable.GtfsConfig
         * @instance
         */
        GtfsConfig.prototype.exts = $util.emptyArray;

        /**
         * GtfsConfig enabled.
         * @member {boolean} enabled
         * @memberof busable.GtfsConfig
         * @instance
         */
        GtfsConfig.prototype.enabled = false;

        /**
         * Creates a new GtfsConfig instance using the specified properties.
         * @function create
         * @memberof busable.GtfsConfig
         * @static
         * @param {busable.IGtfsConfig=} [properties] Properties to set
         * @returns {busable.GtfsConfig} GtfsConfig instance
         */
        GtfsConfig.create = function create(properties) {
            return new GtfsConfig(properties);
        };

        /**
         * Encodes the specified GtfsConfig message. Does not implicitly {@link busable.GtfsConfig.verify|verify} messages.
         * @function encode
         * @memberof busable.GtfsConfig
         * @static
         * @param {busable.IGtfsConfig} message GtfsConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GtfsConfig.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.action);
            if (message.exts != null && message.exts.length)
                for (var i = 0; i < message.exts.length; ++i)
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.exts[i]);
            if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.enabled);
            return writer;
        };

        /**
         * Encodes the specified GtfsConfig message, length delimited. Does not implicitly {@link busable.GtfsConfig.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.GtfsConfig
         * @static
         * @param {busable.IGtfsConfig} message GtfsConfig message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GtfsConfig.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GtfsConfig message from the specified reader or buffer.
         * @function decode
         * @memberof busable.GtfsConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.GtfsConfig} GtfsConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GtfsConfig.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.GtfsConfig();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.action = reader.string();
                        break;
                    }
                case 2: {
                        if (!(message.exts && message.exts.length))
                            message.exts = [];
                        message.exts.push(reader.string());
                        break;
                    }
                case 3: {
                        message.enabled = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GtfsConfig message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.GtfsConfig
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.GtfsConfig} GtfsConfig
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GtfsConfig.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GtfsConfig message.
         * @function verify
         * @memberof busable.GtfsConfig
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GtfsConfig.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.action != null && message.hasOwnProperty("action"))
                if (!$util.isString(message.action))
                    return "action: string expected";
            if (message.exts != null && message.hasOwnProperty("exts")) {
                if (!Array.isArray(message.exts))
                    return "exts: array expected";
                for (var i = 0; i < message.exts.length; ++i)
                    if (!$util.isString(message.exts[i]))
                        return "exts: string[] expected";
            }
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                if (typeof message.enabled !== "boolean")
                    return "enabled: boolean expected";
            return null;
        };

        /**
         * Creates a GtfsConfig message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.GtfsConfig
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.GtfsConfig} GtfsConfig
         */
        GtfsConfig.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.GtfsConfig)
                return object;
            var message = new $root.busable.GtfsConfig();
            if (object.action != null)
                message.action = String(object.action);
            if (object.exts) {
                if (!Array.isArray(object.exts))
                    throw TypeError(".busable.GtfsConfig.exts: array expected");
                message.exts = [];
                for (var i = 0; i < object.exts.length; ++i)
                    message.exts[i] = String(object.exts[i]);
            }
            if (object.enabled != null)
                message.enabled = Boolean(object.enabled);
            return message;
        };

        /**
         * Creates a plain object from a GtfsConfig message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.GtfsConfig
         * @static
         * @param {busable.GtfsConfig} message GtfsConfig
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GtfsConfig.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.exts = [];
            if (options.defaults) {
                object.action = "";
                object.enabled = false;
            }
            if (message.action != null && message.hasOwnProperty("action"))
                object.action = message.action;
            if (message.exts && message.exts.length) {
                object.exts = [];
                for (var j = 0; j < message.exts.length; ++j)
                    object.exts[j] = message.exts[j];
            }
            if (message.enabled != null && message.hasOwnProperty("enabled"))
                object.enabled = message.enabled;
            return object;
        };

        /**
         * Converts this GtfsConfig to JSON.
         * @function toJSON
         * @memberof busable.GtfsConfig
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GtfsConfig.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for GtfsConfig
         * @function getTypeUrl
         * @memberof busable.GtfsConfig
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        GtfsConfig.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.GtfsConfig";
        };

        return GtfsConfig;
    })();

    busable.TransportFeatures = (function() {

        /**
         * Properties of a TransportFeatures.
         * @memberof busable
         * @interface ITransportFeatures
         * @property {boolean|null} [acs] TransportFeatures acs
         */

        /**
         * Constructs a new TransportFeatures.
         * @memberof busable
         * @classdesc Represents a TransportFeatures.
         * @implements ITransportFeatures
         * @constructor
         * @param {busable.ITransportFeatures=} [properties] Properties to set
         */
        function TransportFeatures(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TransportFeatures acs.
         * @member {boolean} acs
         * @memberof busable.TransportFeatures
         * @instance
         */
        TransportFeatures.prototype.acs = false;

        /**
         * Creates a new TransportFeatures instance using the specified properties.
         * @function create
         * @memberof busable.TransportFeatures
         * @static
         * @param {busable.ITransportFeatures=} [properties] Properties to set
         * @returns {busable.TransportFeatures} TransportFeatures instance
         */
        TransportFeatures.create = function create(properties) {
            return new TransportFeatures(properties);
        };

        /**
         * Encodes the specified TransportFeatures message. Does not implicitly {@link busable.TransportFeatures.verify|verify} messages.
         * @function encode
         * @memberof busable.TransportFeatures
         * @static
         * @param {busable.ITransportFeatures} message TransportFeatures message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TransportFeatures.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.acs != null && Object.hasOwnProperty.call(message, "acs"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.acs);
            return writer;
        };

        /**
         * Encodes the specified TransportFeatures message, length delimited. Does not implicitly {@link busable.TransportFeatures.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.TransportFeatures
         * @static
         * @param {busable.ITransportFeatures} message TransportFeatures message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TransportFeatures.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TransportFeatures message from the specified reader or buffer.
         * @function decode
         * @memberof busable.TransportFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.TransportFeatures} TransportFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TransportFeatures.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.TransportFeatures();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.acs = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TransportFeatures message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.TransportFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.TransportFeatures} TransportFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TransportFeatures.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TransportFeatures message.
         * @function verify
         * @memberof busable.TransportFeatures
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TransportFeatures.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.acs != null && message.hasOwnProperty("acs"))
                if (typeof message.acs !== "boolean")
                    return "acs: boolean expected";
            return null;
        };

        /**
         * Creates a TransportFeatures message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.TransportFeatures
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.TransportFeatures} TransportFeatures
         */
        TransportFeatures.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.TransportFeatures)
                return object;
            var message = new $root.busable.TransportFeatures();
            if (object.acs != null)
                message.acs = Boolean(object.acs);
            return message;
        };

        /**
         * Creates a plain object from a TransportFeatures message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.TransportFeatures
         * @static
         * @param {busable.TransportFeatures} message TransportFeatures
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TransportFeatures.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.acs = false;
            if (message.acs != null && message.hasOwnProperty("acs"))
                object.acs = message.acs;
            return object;
        };

        /**
         * Converts this TransportFeatures to JSON.
         * @function toJSON
         * @memberof busable.TransportFeatures
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TransportFeatures.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for TransportFeatures
         * @function getTypeUrl
         * @memberof busable.TransportFeatures
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        TransportFeatures.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.TransportFeatures";
        };

        return TransportFeatures;
    })();

    busable.OperatorFeatures = (function() {

        /**
         * Properties of an OperatorFeatures.
         * @memberof busable
         * @interface IOperatorFeatures
         * @property {busable.ITransportFeatures|null} [tp] OperatorFeatures tp
         * @property {boolean|null} [all] OperatorFeatures all
         */

        /**
         * Constructs a new OperatorFeatures.
         * @memberof busable
         * @classdesc Represents an OperatorFeatures.
         * @implements IOperatorFeatures
         * @constructor
         * @param {busable.IOperatorFeatures=} [properties] Properties to set
         */
        function OperatorFeatures(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OperatorFeatures tp.
         * @member {busable.ITransportFeatures|null|undefined} tp
         * @memberof busable.OperatorFeatures
         * @instance
         */
        OperatorFeatures.prototype.tp = null;

        /**
         * OperatorFeatures all.
         * @member {boolean} all
         * @memberof busable.OperatorFeatures
         * @instance
         */
        OperatorFeatures.prototype.all = false;

        /**
         * Creates a new OperatorFeatures instance using the specified properties.
         * @function create
         * @memberof busable.OperatorFeatures
         * @static
         * @param {busable.IOperatorFeatures=} [properties] Properties to set
         * @returns {busable.OperatorFeatures} OperatorFeatures instance
         */
        OperatorFeatures.create = function create(properties) {
            return new OperatorFeatures(properties);
        };

        /**
         * Encodes the specified OperatorFeatures message. Does not implicitly {@link busable.OperatorFeatures.verify|verify} messages.
         * @function encode
         * @memberof busable.OperatorFeatures
         * @static
         * @param {busable.IOperatorFeatures} message OperatorFeatures message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperatorFeatures.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.tp != null && Object.hasOwnProperty.call(message, "tp"))
                $root.busable.TransportFeatures.encode(message.tp, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.all != null && Object.hasOwnProperty.call(message, "all"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.all);
            return writer;
        };

        /**
         * Encodes the specified OperatorFeatures message, length delimited. Does not implicitly {@link busable.OperatorFeatures.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.OperatorFeatures
         * @static
         * @param {busable.IOperatorFeatures} message OperatorFeatures message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OperatorFeatures.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OperatorFeatures message from the specified reader or buffer.
         * @function decode
         * @memberof busable.OperatorFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.OperatorFeatures} OperatorFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperatorFeatures.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.OperatorFeatures();
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.tp = $root.busable.TransportFeatures.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.all = reader.bool();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OperatorFeatures message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.OperatorFeatures
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.OperatorFeatures} OperatorFeatures
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OperatorFeatures.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OperatorFeatures message.
         * @function verify
         * @memberof busable.OperatorFeatures
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OperatorFeatures.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.tp != null && message.hasOwnProperty("tp")) {
                var error = $root.busable.TransportFeatures.verify(message.tp);
                if (error)
                    return "tp." + error;
            }
            if (message.all != null && message.hasOwnProperty("all"))
                if (typeof message.all !== "boolean")
                    return "all: boolean expected";
            return null;
        };

        /**
         * Creates an OperatorFeatures message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.OperatorFeatures
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.OperatorFeatures} OperatorFeatures
         */
        OperatorFeatures.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.OperatorFeatures)
                return object;
            var message = new $root.busable.OperatorFeatures();
            if (object.tp != null) {
                if (typeof object.tp !== "object")
                    throw TypeError(".busable.OperatorFeatures.tp: object expected");
                message.tp = $root.busable.TransportFeatures.fromObject(object.tp);
            }
            if (object.all != null)
                message.all = Boolean(object.all);
            return message;
        };

        /**
         * Creates a plain object from an OperatorFeatures message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.OperatorFeatures
         * @static
         * @param {busable.OperatorFeatures} message OperatorFeatures
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OperatorFeatures.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.tp = null;
                object.all = false;
            }
            if (message.tp != null && message.hasOwnProperty("tp"))
                object.tp = $root.busable.TransportFeatures.toObject(message.tp, options);
            if (message.all != null && message.hasOwnProperty("all"))
                object.all = message.all;
            return object;
        };

        /**
         * Converts this OperatorFeatures to JSON.
         * @function toJSON
         * @memberof busable.OperatorFeatures
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OperatorFeatures.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for OperatorFeatures
         * @function getTypeUrl
         * @memberof busable.OperatorFeatures
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        OperatorFeatures.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.OperatorFeatures";
        };

        return OperatorFeatures;
    })();

    busable.BankDetails = (function() {

        /**
         * Properties of a BankDetails.
         * @memberof busable
         * @interface IBankDetails
         * @property {Object.<string,string>|null} [details] BankDetails details
         */

        /**
         * Constructs a new BankDetails.
         * @memberof busable
         * @classdesc Represents a BankDetails.
         * @implements IBankDetails
         * @constructor
         * @param {busable.IBankDetails=} [properties] Properties to set
         */
        function BankDetails(properties) {
            this.details = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BankDetails details.
         * @member {Object.<string,string>} details
         * @memberof busable.BankDetails
         * @instance
         */
        BankDetails.prototype.details = $util.emptyObject;

        /**
         * Creates a new BankDetails instance using the specified properties.
         * @function create
         * @memberof busable.BankDetails
         * @static
         * @param {busable.IBankDetails=} [properties] Properties to set
         * @returns {busable.BankDetails} BankDetails instance
         */
        BankDetails.create = function create(properties) {
            return new BankDetails(properties);
        };

        /**
         * Encodes the specified BankDetails message. Does not implicitly {@link busable.BankDetails.verify|verify} messages.
         * @function encode
         * @memberof busable.BankDetails
         * @static
         * @param {busable.IBankDetails} message BankDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                for (var keys = Object.keys(message.details), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.details[keys[i]]).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BankDetails message, length delimited. Does not implicitly {@link busable.BankDetails.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.BankDetails
         * @static
         * @param {busable.IBankDetails} message BankDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BankDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BankDetails message from the specified reader or buffer.
         * @function decode
         * @memberof busable.BankDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.BankDetails} BankDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankDetails.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.BankDetails(), key, value;
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        if (message.details === $util.emptyObject)
                            message.details = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = "";
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = reader.string();
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.details[key] = value;
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BankDetails message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.BankDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.BankDetails} BankDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BankDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BankDetails message.
         * @function verify
         * @memberof busable.BankDetails
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BankDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.details != null && message.hasOwnProperty("details")) {
                if (!$util.isObject(message.details))
                    return "details: object expected";
                var key = Object.keys(message.details);
                for (var i = 0; i < key.length; ++i)
                    if (!$util.isString(message.details[key[i]]))
                        return "details: string{k:string} expected";
            }
            return null;
        };

        /**
         * Creates a BankDetails message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.BankDetails
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.BankDetails} BankDetails
         */
        BankDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.BankDetails)
                return object;
            var message = new $root.busable.BankDetails();
            if (object.details) {
                if (typeof object.details !== "object")
                    throw TypeError(".busable.BankDetails.details: object expected");
                message.details = {};
                for (var keys = Object.keys(object.details), i = 0; i < keys.length; ++i)
                    message.details[keys[i]] = String(object.details[keys[i]]);
            }
            return message;
        };

        /**
         * Creates a plain object from a BankDetails message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.BankDetails
         * @static
         * @param {busable.BankDetails} message BankDetails
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BankDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.details = {};
            var keys2;
            if (message.details && (keys2 = Object.keys(message.details)).length) {
                object.details = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.details[keys2[j]] = message.details[keys2[j]];
            }
            return object;
        };

        /**
         * Converts this BankDetails to JSON.
         * @function toJSON
         * @memberof busable.BankDetails
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BankDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for BankDetails
         * @function getTypeUrl
         * @memberof busable.BankDetails
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        BankDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.BankDetails";
        };

        return BankDetails;
    })();

    busable.Operator = (function() {

        /**
         * Properties of an Operator.
         * @memberof busable
         * @interface IOperator
         * @property {string|null} [operatorId] Operator operatorId
         * @property {string|null} [companyId] Operator companyId
         * @property {string|null} [regionId] Operator regionId
         * @property {string|null} [orgId] Operator orgId
         * @property {string|null} [accreditationId] Operator accreditationId
         * @property {string|null} [accreditationName] Operator accreditationName
         * @property {string|null} [operatorName] Operator operatorName
         * @property {string|null} [operatorEmail] Operator operatorEmail
         * @property {string|null} [operatorPhone] Operator operatorPhone
         * @property {string|null} [operatorUrl] Operator operatorUrl
         * @property {string|null} [operatorAddress] Operator operatorAddress
         * @property {string|null} [operatorPostalAddress] Operator operatorPostalAddress
         * @property {string|null} [notificationEmail] Operator notificationEmail
         * @property {busable.IOperatorOptions|null} [opts] Operator opts
         * @property {busable.IGtfsConfig|null} [gtfs] Operator gtfs
         * @property {busable.IOperatorFeatures|null} [features] Operator features
         * @property {busable.IBankDetails|null} [bankDetails] Operator bankDetails
         * @property {Object.<string,string>|null} [aliases] Operator aliases
         * @property {string|null} [tier] Operator tier
         * @property {string|null} [userIdKey] Operator userIdKey
         * @property {string|null} [username] Operator username
         * @property {number|Long|null} [createdAt] Operator createdAt
         * @property {number|Long|null} [updatedAt] Operator updatedAt
         * @property {string|null} [author] Operator author
         * @property {string|null} [editor] Operator editor
         * @property {string|null} [lastEditor] Operator lastEditor
         * @property {string|null} [source] Operator source
         * @property {string|null} [userId] Operator userId
         */

        /**
         * Constructs a new Operator.
         * @memberof busable
         * @classdesc Represents an Operator.
         * @implements IOperator
         * @constructor
         * @param {busable.IOperator=} [properties] Properties to set
         */
        function Operator(properties) {
            this.aliases = {};
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Operator operatorId.
         * @member {string} operatorId
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.operatorId = "";

        /**
         * Operator companyId.
         * @member {string} companyId
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.companyId = "";

        /**
         * Operator regionId.
         * @member {string} regionId
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.regionId = "";

        /**
         * Operator orgId.
         * @member {string} orgId
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.orgId = "";

        /**
         * Operator accreditationId.
         * @member {string} accreditationId
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.accreditationId = "";

        /**
         * Operator accreditationName.
         * @member {string} accreditationName
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.accreditationName = "";

        /**
         * Operator operatorName.
         * @member {string} operatorName
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.operatorName = "";

        /**
         * Operator operatorEmail.
         * @member {string} operatorEmail
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.operatorEmail = "";

        /**
         * Operator operatorPhone.
         * @member {string} operatorPhone
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.operatorPhone = "";

        /**
         * Operator operatorUrl.
         * @member {string} operatorUrl
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.operatorUrl = "";

        /**
         * Operator operatorAddress.
         * @member {string} operatorAddress
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.operatorAddress = "";

        /**
         * Operator operatorPostalAddress.
         * @member {string} operatorPostalAddress
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.operatorPostalAddress = "";

        /**
         * Operator notificationEmail.
         * @member {string} notificationEmail
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.notificationEmail = "";

        /**
         * Operator opts.
         * @member {busable.IOperatorOptions|null|undefined} opts
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.opts = null;

        /**
         * Operator gtfs.
         * @member {busable.IGtfsConfig|null|undefined} gtfs
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.gtfs = null;

        /**
         * Operator features.
         * @member {busable.IOperatorFeatures|null|undefined} features
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.features = null;

        /**
         * Operator bankDetails.
         * @member {busable.IBankDetails|null|undefined} bankDetails
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.bankDetails = null;

        /**
         * Operator aliases.
         * @member {Object.<string,string>} aliases
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.aliases = $util.emptyObject;

        /**
         * Operator tier.
         * @member {string} tier
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.tier = "";

        /**
         * Operator userIdKey.
         * @member {string} userIdKey
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.userIdKey = "";

        /**
         * Operator username.
         * @member {string} username
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.username = "";

        /**
         * Operator createdAt.
         * @member {number|Long} createdAt
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.createdAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Operator updatedAt.
         * @member {number|Long} updatedAt
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.updatedAt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Operator author.
         * @member {string} author
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.author = "";

        /**
         * Operator editor.
         * @member {string} editor
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.editor = "";

        /**
         * Operator lastEditor.
         * @member {string} lastEditor
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.lastEditor = "";

        /**
         * Operator source.
         * @member {string} source
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.source = "";

        /**
         * Operator userId.
         * @member {string} userId
         * @memberof busable.Operator
         * @instance
         */
        Operator.prototype.userId = "";

        /**
         * Creates a new Operator instance using the specified properties.
         * @function create
         * @memberof busable.Operator
         * @static
         * @param {busable.IOperator=} [properties] Properties to set
         * @returns {busable.Operator} Operator instance
         */
        Operator.create = function create(properties) {
            return new Operator(properties);
        };

        /**
         * Encodes the specified Operator message. Does not implicitly {@link busable.Operator.verify|verify} messages.
         * @function encode
         * @memberof busable.Operator
         * @static
         * @param {busable.IOperator} message Operator message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Operator.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.operatorId != null && Object.hasOwnProperty.call(message, "operatorId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.operatorId);
            if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.companyId);
            if (message.regionId != null && Object.hasOwnProperty.call(message, "regionId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.regionId);
            if (message.orgId != null && Object.hasOwnProperty.call(message, "orgId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.orgId);
            if (message.accreditationId != null && Object.hasOwnProperty.call(message, "accreditationId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.accreditationId);
            if (message.accreditationName != null && Object.hasOwnProperty.call(message, "accreditationName"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.accreditationName);
            if (message.operatorName != null && Object.hasOwnProperty.call(message, "operatorName"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.operatorName);
            if (message.operatorEmail != null && Object.hasOwnProperty.call(message, "operatorEmail"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.operatorEmail);
            if (message.operatorPhone != null && Object.hasOwnProperty.call(message, "operatorPhone"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.operatorPhone);
            if (message.operatorUrl != null && Object.hasOwnProperty.call(message, "operatorUrl"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.operatorUrl);
            if (message.operatorAddress != null && Object.hasOwnProperty.call(message, "operatorAddress"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.operatorAddress);
            if (message.operatorPostalAddress != null && Object.hasOwnProperty.call(message, "operatorPostalAddress"))
                writer.uint32(/* id 12, wireType 2 =*/98).string(message.operatorPostalAddress);
            if (message.notificationEmail != null && Object.hasOwnProperty.call(message, "notificationEmail"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.notificationEmail);
            if (message.opts != null && Object.hasOwnProperty.call(message, "opts"))
                $root.busable.OperatorOptions.encode(message.opts, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
            if (message.gtfs != null && Object.hasOwnProperty.call(message, "gtfs"))
                $root.busable.GtfsConfig.encode(message.gtfs, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
            if (message.features != null && Object.hasOwnProperty.call(message, "features"))
                $root.busable.OperatorFeatures.encode(message.features, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.bankDetails != null && Object.hasOwnProperty.call(message, "bankDetails"))
                $root.busable.BankDetails.encode(message.bankDetails, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
            if (message.aliases != null && Object.hasOwnProperty.call(message, "aliases"))
                for (var keys = Object.keys(message.aliases), i = 0; i < keys.length; ++i)
                    writer.uint32(/* id 18, wireType 2 =*/146).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.aliases[keys[i]]).ldelim();
            if (message.tier != null && Object.hasOwnProperty.call(message, "tier"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.tier);
            if (message.userIdKey != null && Object.hasOwnProperty.call(message, "userIdKey"))
                writer.uint32(/* id 20, wireType 2 =*/162).string(message.userIdKey);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 21, wireType 2 =*/170).string(message.username);
            if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
                writer.uint32(/* id 22, wireType 0 =*/176).int64(message.createdAt);
            if (message.updatedAt != null && Object.hasOwnProperty.call(message, "updatedAt"))
                writer.uint32(/* id 23, wireType 0 =*/184).int64(message.updatedAt);
            if (message.author != null && Object.hasOwnProperty.call(message, "author"))
                writer.uint32(/* id 24, wireType 2 =*/194).string(message.author);
            if (message.editor != null && Object.hasOwnProperty.call(message, "editor"))
                writer.uint32(/* id 25, wireType 2 =*/202).string(message.editor);
            if (message.lastEditor != null && Object.hasOwnProperty.call(message, "lastEditor"))
                writer.uint32(/* id 26, wireType 2 =*/210).string(message.lastEditor);
            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                writer.uint32(/* id 27, wireType 2 =*/218).string(message.source);
            if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                writer.uint32(/* id 28, wireType 2 =*/226).string(message.userId);
            return writer;
        };

        /**
         * Encodes the specified Operator message, length delimited. Does not implicitly {@link busable.Operator.verify|verify} messages.
         * @function encodeDelimited
         * @memberof busable.Operator
         * @static
         * @param {busable.IOperator} message Operator message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Operator.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Operator message from the specified reader or buffer.
         * @function decode
         * @memberof busable.Operator
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {busable.Operator} Operator
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Operator.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.busable.Operator(), key, value;
            while (reader.pos < end) {
                var tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.operatorId = reader.string();
                        break;
                    }
                case 2: {
                        message.companyId = reader.string();
                        break;
                    }
                case 3: {
                        message.regionId = reader.string();
                        break;
                    }
                case 4: {
                        message.orgId = reader.string();
                        break;
                    }
                case 5: {
                        message.accreditationId = reader.string();
                        break;
                    }
                case 6: {
                        message.accreditationName = reader.string();
                        break;
                    }
                case 7: {
                        message.operatorName = reader.string();
                        break;
                    }
                case 8: {
                        message.operatorEmail = reader.string();
                        break;
                    }
                case 9: {
                        message.operatorPhone = reader.string();
                        break;
                    }
                case 10: {
                        message.operatorUrl = reader.string();
                        break;
                    }
                case 11: {
                        message.operatorAddress = reader.string();
                        break;
                    }
                case 12: {
                        message.operatorPostalAddress = reader.string();
                        break;
                    }
                case 13: {
                        message.notificationEmail = reader.string();
                        break;
                    }
                case 14: {
                        message.opts = $root.busable.OperatorOptions.decode(reader, reader.uint32());
                        break;
                    }
                case 15: {
                        message.gtfs = $root.busable.GtfsConfig.decode(reader, reader.uint32());
                        break;
                    }
                case 16: {
                        message.features = $root.busable.OperatorFeatures.decode(reader, reader.uint32());
                        break;
                    }
                case 17: {
                        message.bankDetails = $root.busable.BankDetails.decode(reader, reader.uint32());
                        break;
                    }
                case 18: {
                        if (message.aliases === $util.emptyObject)
                            message.aliases = {};
                        var end2 = reader.uint32() + reader.pos;
                        key = "";
                        value = "";
                        while (reader.pos < end2) {
                            var tag2 = reader.uint32();
                            switch (tag2 >>> 3) {
                            case 1:
                                key = reader.string();
                                break;
                            case 2:
                                value = reader.string();
                                break;
                            default:
                                reader.skipType(tag2 & 7);
                                break;
                            }
                        }
                        message.aliases[key] = value;
                        break;
                    }
                case 19: {
                        message.tier = reader.string();
                        break;
                    }
                case 20: {
                        message.userIdKey = reader.string();
                        break;
                    }
                case 21: {
                        message.username = reader.string();
                        break;
                    }
                case 22: {
                        message.createdAt = reader.int64();
                        break;
                    }
                case 23: {
                        message.updatedAt = reader.int64();
                        break;
                    }
                case 24: {
                        message.author = reader.string();
                        break;
                    }
                case 25: {
                        message.editor = reader.string();
                        break;
                    }
                case 26: {
                        message.lastEditor = reader.string();
                        break;
                    }
                case 27: {
                        message.source = reader.string();
                        break;
                    }
                case 28: {
                        message.userId = reader.string();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Operator message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof busable.Operator
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {busable.Operator} Operator
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Operator.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Operator message.
         * @function verify
         * @memberof busable.Operator
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Operator.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                if (!$util.isString(message.operatorId))
                    return "operatorId: string expected";
            if (message.companyId != null && message.hasOwnProperty("companyId"))
                if (!$util.isString(message.companyId))
                    return "companyId: string expected";
            if (message.regionId != null && message.hasOwnProperty("regionId"))
                if (!$util.isString(message.regionId))
                    return "regionId: string expected";
            if (message.orgId != null && message.hasOwnProperty("orgId"))
                if (!$util.isString(message.orgId))
                    return "orgId: string expected";
            if (message.accreditationId != null && message.hasOwnProperty("accreditationId"))
                if (!$util.isString(message.accreditationId))
                    return "accreditationId: string expected";
            if (message.accreditationName != null && message.hasOwnProperty("accreditationName"))
                if (!$util.isString(message.accreditationName))
                    return "accreditationName: string expected";
            if (message.operatorName != null && message.hasOwnProperty("operatorName"))
                if (!$util.isString(message.operatorName))
                    return "operatorName: string expected";
            if (message.operatorEmail != null && message.hasOwnProperty("operatorEmail"))
                if (!$util.isString(message.operatorEmail))
                    return "operatorEmail: string expected";
            if (message.operatorPhone != null && message.hasOwnProperty("operatorPhone"))
                if (!$util.isString(message.operatorPhone))
                    return "operatorPhone: string expected";
            if (message.operatorUrl != null && message.hasOwnProperty("operatorUrl"))
                if (!$util.isString(message.operatorUrl))
                    return "operatorUrl: string expected";
            if (message.operatorAddress != null && message.hasOwnProperty("operatorAddress"))
                if (!$util.isString(message.operatorAddress))
                    return "operatorAddress: string expected";
            if (message.operatorPostalAddress != null && message.hasOwnProperty("operatorPostalAddress"))
                if (!$util.isString(message.operatorPostalAddress))
                    return "operatorPostalAddress: string expected";
            if (message.notificationEmail != null && message.hasOwnProperty("notificationEmail"))
                if (!$util.isString(message.notificationEmail))
                    return "notificationEmail: string expected";
            if (message.opts != null && message.hasOwnProperty("opts")) {
                var error = $root.busable.OperatorOptions.verify(message.opts);
                if (error)
                    return "opts." + error;
            }
            if (message.gtfs != null && message.hasOwnProperty("gtfs")) {
                var error = $root.busable.GtfsConfig.verify(message.gtfs);
                if (error)
                    return "gtfs." + error;
            }
            if (message.features != null && message.hasOwnProperty("features")) {
                var error = $root.busable.OperatorFeatures.verify(message.features);
                if (error)
                    return "features." + error;
            }
            if (message.bankDetails != null && message.hasOwnProperty("bankDetails")) {
                var error = $root.busable.BankDetails.verify(message.bankDetails);
                if (error)
                    return "bankDetails." + error;
            }
            if (message.aliases != null && message.hasOwnProperty("aliases")) {
                if (!$util.isObject(message.aliases))
                    return "aliases: object expected";
                var key = Object.keys(message.aliases);
                for (var i = 0; i < key.length; ++i)
                    if (!$util.isString(message.aliases[key[i]]))
                        return "aliases: string{k:string} expected";
            }
            if (message.tier != null && message.hasOwnProperty("tier"))
                if (!$util.isString(message.tier))
                    return "tier: string expected";
            if (message.userIdKey != null && message.hasOwnProperty("userIdKey"))
                if (!$util.isString(message.userIdKey))
                    return "userIdKey: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (!$util.isInteger(message.createdAt) && !(message.createdAt && $util.isInteger(message.createdAt.low) && $util.isInteger(message.createdAt.high)))
                    return "createdAt: integer|Long expected";
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (!$util.isInteger(message.updatedAt) && !(message.updatedAt && $util.isInteger(message.updatedAt.low) && $util.isInteger(message.updatedAt.high)))
                    return "updatedAt: integer|Long expected";
            if (message.author != null && message.hasOwnProperty("author"))
                if (!$util.isString(message.author))
                    return "author: string expected";
            if (message.editor != null && message.hasOwnProperty("editor"))
                if (!$util.isString(message.editor))
                    return "editor: string expected";
            if (message.lastEditor != null && message.hasOwnProperty("lastEditor"))
                if (!$util.isString(message.lastEditor))
                    return "lastEditor: string expected";
            if (message.source != null && message.hasOwnProperty("source"))
                if (!$util.isString(message.source))
                    return "source: string expected";
            if (message.userId != null && message.hasOwnProperty("userId"))
                if (!$util.isString(message.userId))
                    return "userId: string expected";
            return null;
        };

        /**
         * Creates an Operator message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof busable.Operator
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {busable.Operator} Operator
         */
        Operator.fromObject = function fromObject(object) {
            if (object instanceof $root.busable.Operator)
                return object;
            var message = new $root.busable.Operator();
            if (object.operatorId != null)
                message.operatorId = String(object.operatorId);
            if (object.companyId != null)
                message.companyId = String(object.companyId);
            if (object.regionId != null)
                message.regionId = String(object.regionId);
            if (object.orgId != null)
                message.orgId = String(object.orgId);
            if (object.accreditationId != null)
                message.accreditationId = String(object.accreditationId);
            if (object.accreditationName != null)
                message.accreditationName = String(object.accreditationName);
            if (object.operatorName != null)
                message.operatorName = String(object.operatorName);
            if (object.operatorEmail != null)
                message.operatorEmail = String(object.operatorEmail);
            if (object.operatorPhone != null)
                message.operatorPhone = String(object.operatorPhone);
            if (object.operatorUrl != null)
                message.operatorUrl = String(object.operatorUrl);
            if (object.operatorAddress != null)
                message.operatorAddress = String(object.operatorAddress);
            if (object.operatorPostalAddress != null)
                message.operatorPostalAddress = String(object.operatorPostalAddress);
            if (object.notificationEmail != null)
                message.notificationEmail = String(object.notificationEmail);
            if (object.opts != null) {
                if (typeof object.opts !== "object")
                    throw TypeError(".busable.Operator.opts: object expected");
                message.opts = $root.busable.OperatorOptions.fromObject(object.opts);
            }
            if (object.gtfs != null) {
                if (typeof object.gtfs !== "object")
                    throw TypeError(".busable.Operator.gtfs: object expected");
                message.gtfs = $root.busable.GtfsConfig.fromObject(object.gtfs);
            }
            if (object.features != null) {
                if (typeof object.features !== "object")
                    throw TypeError(".busable.Operator.features: object expected");
                message.features = $root.busable.OperatorFeatures.fromObject(object.features);
            }
            if (object.bankDetails != null) {
                if (typeof object.bankDetails !== "object")
                    throw TypeError(".busable.Operator.bankDetails: object expected");
                message.bankDetails = $root.busable.BankDetails.fromObject(object.bankDetails);
            }
            if (object.aliases) {
                if (typeof object.aliases !== "object")
                    throw TypeError(".busable.Operator.aliases: object expected");
                message.aliases = {};
                for (var keys = Object.keys(object.aliases), i = 0; i < keys.length; ++i)
                    message.aliases[keys[i]] = String(object.aliases[keys[i]]);
            }
            if (object.tier != null)
                message.tier = String(object.tier);
            if (object.userIdKey != null)
                message.userIdKey = String(object.userIdKey);
            if (object.username != null)
                message.username = String(object.username);
            if (object.createdAt != null)
                if ($util.Long)
                    (message.createdAt = $util.Long.fromValue(object.createdAt)).unsigned = false;
                else if (typeof object.createdAt === "string")
                    message.createdAt = parseInt(object.createdAt, 10);
                else if (typeof object.createdAt === "number")
                    message.createdAt = object.createdAt;
                else if (typeof object.createdAt === "object")
                    message.createdAt = new $util.LongBits(object.createdAt.low >>> 0, object.createdAt.high >>> 0).toNumber();
            if (object.updatedAt != null)
                if ($util.Long)
                    (message.updatedAt = $util.Long.fromValue(object.updatedAt)).unsigned = false;
                else if (typeof object.updatedAt === "string")
                    message.updatedAt = parseInt(object.updatedAt, 10);
                else if (typeof object.updatedAt === "number")
                    message.updatedAt = object.updatedAt;
                else if (typeof object.updatedAt === "object")
                    message.updatedAt = new $util.LongBits(object.updatedAt.low >>> 0, object.updatedAt.high >>> 0).toNumber();
            if (object.author != null)
                message.author = String(object.author);
            if (object.editor != null)
                message.editor = String(object.editor);
            if (object.lastEditor != null)
                message.lastEditor = String(object.lastEditor);
            if (object.source != null)
                message.source = String(object.source);
            if (object.userId != null)
                message.userId = String(object.userId);
            return message;
        };

        /**
         * Creates a plain object from an Operator message. Also converts values to other types if specified.
         * @function toObject
         * @memberof busable.Operator
         * @static
         * @param {busable.Operator} message Operator
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Operator.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.objects || options.defaults)
                object.aliases = {};
            if (options.defaults) {
                object.operatorId = "";
                object.companyId = "";
                object.regionId = "";
                object.orgId = "";
                object.accreditationId = "";
                object.accreditationName = "";
                object.operatorName = "";
                object.operatorEmail = "";
                object.operatorPhone = "";
                object.operatorUrl = "";
                object.operatorAddress = "";
                object.operatorPostalAddress = "";
                object.notificationEmail = "";
                object.opts = null;
                object.gtfs = null;
                object.features = null;
                object.bankDetails = null;
                object.tier = "";
                object.userIdKey = "";
                object.username = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createdAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createdAt = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.updatedAt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.updatedAt = options.longs === String ? "0" : 0;
                object.author = "";
                object.editor = "";
                object.lastEditor = "";
                object.source = "";
                object.userId = "";
            }
            if (message.operatorId != null && message.hasOwnProperty("operatorId"))
                object.operatorId = message.operatorId;
            if (message.companyId != null && message.hasOwnProperty("companyId"))
                object.companyId = message.companyId;
            if (message.regionId != null && message.hasOwnProperty("regionId"))
                object.regionId = message.regionId;
            if (message.orgId != null && message.hasOwnProperty("orgId"))
                object.orgId = message.orgId;
            if (message.accreditationId != null && message.hasOwnProperty("accreditationId"))
                object.accreditationId = message.accreditationId;
            if (message.accreditationName != null && message.hasOwnProperty("accreditationName"))
                object.accreditationName = message.accreditationName;
            if (message.operatorName != null && message.hasOwnProperty("operatorName"))
                object.operatorName = message.operatorName;
            if (message.operatorEmail != null && message.hasOwnProperty("operatorEmail"))
                object.operatorEmail = message.operatorEmail;
            if (message.operatorPhone != null && message.hasOwnProperty("operatorPhone"))
                object.operatorPhone = message.operatorPhone;
            if (message.operatorUrl != null && message.hasOwnProperty("operatorUrl"))
                object.operatorUrl = message.operatorUrl;
            if (message.operatorAddress != null && message.hasOwnProperty("operatorAddress"))
                object.operatorAddress = message.operatorAddress;
            if (message.operatorPostalAddress != null && message.hasOwnProperty("operatorPostalAddress"))
                object.operatorPostalAddress = message.operatorPostalAddress;
            if (message.notificationEmail != null && message.hasOwnProperty("notificationEmail"))
                object.notificationEmail = message.notificationEmail;
            if (message.opts != null && message.hasOwnProperty("opts"))
                object.opts = $root.busable.OperatorOptions.toObject(message.opts, options);
            if (message.gtfs != null && message.hasOwnProperty("gtfs"))
                object.gtfs = $root.busable.GtfsConfig.toObject(message.gtfs, options);
            if (message.features != null && message.hasOwnProperty("features"))
                object.features = $root.busable.OperatorFeatures.toObject(message.features, options);
            if (message.bankDetails != null && message.hasOwnProperty("bankDetails"))
                object.bankDetails = $root.busable.BankDetails.toObject(message.bankDetails, options);
            var keys2;
            if (message.aliases && (keys2 = Object.keys(message.aliases)).length) {
                object.aliases = {};
                for (var j = 0; j < keys2.length; ++j)
                    object.aliases[keys2[j]] = message.aliases[keys2[j]];
            }
            if (message.tier != null && message.hasOwnProperty("tier"))
                object.tier = message.tier;
            if (message.userIdKey != null && message.hasOwnProperty("userIdKey"))
                object.userIdKey = message.userIdKey;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.createdAt != null && message.hasOwnProperty("createdAt"))
                if (typeof message.createdAt === "number")
                    object.createdAt = options.longs === String ? String(message.createdAt) : message.createdAt;
                else
                    object.createdAt = options.longs === String ? $util.Long.prototype.toString.call(message.createdAt) : options.longs === Number ? new $util.LongBits(message.createdAt.low >>> 0, message.createdAt.high >>> 0).toNumber() : message.createdAt;
            if (message.updatedAt != null && message.hasOwnProperty("updatedAt"))
                if (typeof message.updatedAt === "number")
                    object.updatedAt = options.longs === String ? String(message.updatedAt) : message.updatedAt;
                else
                    object.updatedAt = options.longs === String ? $util.Long.prototype.toString.call(message.updatedAt) : options.longs === Number ? new $util.LongBits(message.updatedAt.low >>> 0, message.updatedAt.high >>> 0).toNumber() : message.updatedAt;
            if (message.author != null && message.hasOwnProperty("author"))
                object.author = message.author;
            if (message.editor != null && message.hasOwnProperty("editor"))
                object.editor = message.editor;
            if (message.lastEditor != null && message.hasOwnProperty("lastEditor"))
                object.lastEditor = message.lastEditor;
            if (message.source != null && message.hasOwnProperty("source"))
                object.source = message.source;
            if (message.userId != null && message.hasOwnProperty("userId"))
                object.userId = message.userId;
            return object;
        };

        /**
         * Converts this Operator to JSON.
         * @function toJSON
         * @memberof busable.Operator
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Operator.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for Operator
         * @function getTypeUrl
         * @memberof busable.Operator
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        Operator.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/busable.Operator";
        };

        return Operator;
    })();

    return busable;
})();

module.exports = $root;
